export const CasinoNew = [
  {
    name: "24D Spin",
    img: "/assets/Casino/PP-LIVE-190.24D Spin.webp?v=1764405191092",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-190",
    platFormCode: "PP",
  },
  {
    name: "Mega Roulette 3000",
    img: "/assets/Casino/PP-LIVE-189.Mega Roulette 3000.webp?v=1764408332952",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-189",
    platFormCode: "PP",
  },
  {
    name: "Money Time",
    img: "/assets/Casino/PP-LIVE-188.Money Time.webp?v=1764408167157",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-188",
    platFormCode: "PP",
  },
  {
    name: "2 Hand Casino Hold'em",
    img: "/assets/Casino/EVOLUTION-LIVE-021.webp?v=1765933237412",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-021",
    platFormCode: "EVOLUTION",
  },
  {
    name: "3 Card Brag",
    img: "/assets/Casino/PT-LIVE-016.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-016",
    platFormCode: "PT",
  },
  // {
  //   name: "500X Auto Roulette",
  //   img: "/assets/Casino/WINFINITY-LIVE-007.500x-auto-roulette.webp?v=1764402162047",
  //   platForm: "WINFINITY",
  //   type: "Casino",
  // },
  {
    name: "Adventures Beyond Wonderland",
    img: "/assets/Casino/PT-LIVE-011.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-011",
    platFormCode: "PT",
  },
  {
    name: "Agent Spinity",
    img: "/assets/Casino/WINFINITY-LIVE-031.Agent Spinity.webp?v=1764402083653",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "All Bets Blackjack",
    img: "/assets/Casino/PT-LIVE-007.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-007",
    platFormCode: "PT",
  },
  {
    name: "All Bets Blackjack Brasileira",
    img: "/assets/Casino/PT-LIVE-126.webp?v=1761308344134",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-126",
    platFormCode: "PT",
  },
  {
    name: "Always 8 Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-410.webp?v=1765933237719",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-410",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Always 9 Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-454.webp?v=1765933237751",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-454",
    platFormCode: "EVOLUTION",
  },
  {
    name: "American Roulette",
    img: "/assets/Casino/PT-LIVE-021.American Roulette.webp?v=1764324415712",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-021",
    platFormCode: "PT",
  },
  {
    name: "American Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-020.webp?v=1765933237411",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-020",
    platFormCode: "EVOLUTION",
  },
  {
    name: "American Roulette",
    img: "/assets/Casino/PP-LIVE-176.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-176",
    platFormCode: "PP",
  },
  {
    name: "Andar Bahar",
    img: "/assets/Casino/WINFINITY-LIVE-034.Andar Bahar.webp?v=1764402049834",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Andar Bahar Live",
    img: "/assets/Casino/PT-LIVE-004.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-004",
    platFormCode: "PT",
  },
  {
    name: "Andar Bahar x5000",
    img: "/assets/Casino/WINFINITY-LIVE-035.Andar Bahar x5000.webp?v=1764402004788",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "AndarBahar A15",
    img: "/assets/Casino/DREAMGAMING-LIVE-029.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Arabic Roulette",
    img: "/assets/Casino/PT-LIVE-078.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-078",
    platFormCode: "PT",
  },
  {
    name: "Auto Mega Roulette",
    img: "/assets/Casino/PP-LIVE-075.Auto-Mega-Roulette.webp?v=1764405105976",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-075",
    platFormCode: "PP",
  },
  {
    name: "Auto Roulette",
    img: "/assets/Casino/WINFINITY-LIVE-006.auto-roulette.webp?v=1764401947817",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Auto Roulette 2",
    img: "/assets/Casino/PT-LIVE-100.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-100",
    platFormCode: "PT",
  },
  {
    name: "Auto-Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-170.webp?v=1765933237542",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-170",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Auto-Roulette 1",
    img: "/assets/Casino/PP-LIVE-026.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
  },
  {
    name: "Auto-Roulette VIP",
    img: "/assets/Casino/EVOLUTION-LIVE-171.webp?v=1765933237544",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-171",
    platFormCode: "EVOLUTION",
  },
  {
    name: "BACCARAT",
    img: "/assets/Casino/HOTROAD-LIVE-001.webp?v=1751418030552",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-001",
    platFormCode: "HOTROAD",
  },
  {
    name: "Bac Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-172.webp?v=1765933237544",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-172",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Baccarat",
    img: "/assets/Casino/DREAMGAMING-LIVE-087.webp?v=1769054172974",
    platForm: "DREAMGAMING",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "DREAMGAMING-LIVE-001",
    platFormCode: "DREAMGAMING",
  },
  {
    name: "Baccarat",
    img: "/assets/Casino/PT-LIVE-001.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-001",
    platFormCode: "PT",
  },
  {
    name: "Baccarat 1",
    img: "/assets/Casino/PP-LIVE-001.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-001",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 11",
    img: "/assets/Casino/PP-LIVE-010.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
  },
  {
    name: "Baccarat 2",
    img: "/assets/Casino/PP-LIVE-002.Baccarat 2.webp?v=1764404982627",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-002",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 5",
    img: "/assets/Casino/PP-LIVE-004.Baccarat 5.webp?v=1764404914436",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-004",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 6",
    img: "/assets/Casino/PP-LIVE-005.Baccarat 6.webp?v=1764404841203",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-005",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 7",
    img: "/assets/Casino/PP-LIVE-006.Baccarat 7.webp?v=1764404769590",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-006",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 8",
    img: "/assets/Casino/PP-LIVE-007.Baccarat 8.webp?v=1764404708051",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-007",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 9",
    img: "/assets/Casino/PP-LIVE-052.Baccarat 9.webp?v=1764404577909",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-052",
    platFormCode: "PP",
  },
  {
    name: "Baccarat A",
    img: "/assets/Casino/EVOLUTION-LIVE-120.webp?v=1765933237496",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-120",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Baccarat A01",
    img: "/assets/Casino/DREAMGAMING-LIVE-021.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat A02",
    img: "/assets/Casino/DREAMGAMING-LIVE-022.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat A03",
    img: "/assets/Casino/DREAMGAMING-LIVE-023.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat A05",
    img: "/assets/Casino/DREAMGAMING-LIVE-024.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-122.webp?v=1765933237497",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-122",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Baccarat Brasileira",
    img: "/assets/Casino/PT-LIVE-097.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-097",
    platFormCode: "PT",
  },
  {
    name: "Baccarat Brasileira NC",
    img: "/assets/Casino/PT-LIVE-098.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-098",
    platFormCode: "PT",
  },
  {
    name: "Baccarat Classic",
    img: "/assets/Casino/MX-LIVE-001.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
    platFormCode: "SEXYBCRT",
  },
  {
    name: "Baccarat Classic-SEXY hall",
    img: "/assets/Casino/MX-LIVE-001_SEXY.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Baccarat Classic-SEXY hall-Table1",
    img: "/assets/Casino/MX-LIVE-001_SEXY_1.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Baccarat Classic-SEXY hall-Table2",
    img: "/assets/Casino/MX-LIVE-001_SEXY_2.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Baccarat Classic-SEXY hall-Table3",
    img: "/assets/Casino/MX-LIVE-001_SEXY_3.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Baccarat Classic-SEXY hall-Table4",
    img: "/assets/Casino/MX-LIVE-001_SEXY_4.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Baccarat Classic-SEXY hall-Table5",
    img: "/assets/Casino/MX-LIVE-001_SEXY_5.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Baccarat Classic-SEXY hall-Table6",
    img: "/assets/Casino/MX-LIVE-001_SEXY_6.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Baccarat Control Squeeze",
    img: "/assets/Casino/EVOLUTION-LIVE-041.webp?v=1765933237428",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-041",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Baccarat D01",
    img: "/assets/Casino/DREAMGAMING-LIVE-001.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat D02",
    img: "/assets/Casino/DREAMGAMING-LIVE-002.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat D03",
    img: "/assets/Casino/DREAMGAMING-LIVE-003.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat D05",
    img: "/assets/Casino/DREAMGAMING-LIVE-004.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat D06",
    img: "/assets/Casino/DREAMGAMING-LIVE-005.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat D07",
    img: "/assets/Casino/DREAMGAMING-LIVE-006.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat D08",
    img: "/assets/Casino/DREAMGAMING-LIVE-007.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat D09",
    img: "/assets/Casino/DREAMGAMING-LIVE-008.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat D10",
    img: "/assets/Casino/DREAMGAMING-LIVE-009.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat NC",
    img: "/assets/Casino/PT-LIVE-075.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-075",
    platFormCode: "PT",
  },
  {
    name: "Baccarat S01",
    img: "/assets/Casino/DREAMGAMING-LIVE-037.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat S02",
    img: "/assets/Casino/DREAMGAMING-LIVE-038.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat S03",
    img: "/assets/Casino/DREAMGAMING-LIVE-039.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat S05",
    img: "/assets/Casino/DREAMGAMING-LIVE-040.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat S06",
    img: "/assets/Casino/DREAMGAMING-LIVE-041.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat Soirée",
    img: "/assets/Casino/PT-LIVE-115.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-115",
    platFormCode: "PT",
  },
  {
    name: "Baccarat Soirée NC",
    img: "/assets/Casino/PT-LIVE-129.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-129",
    platFormCode: "PT",
  },
  {
    name: "Baccarat Squeeze",
    img: "/assets/Casino/EVOLUTION-LIVE-036.webp?v=1765933237423",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-036",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Baccarat V01",
    img: "/assets/Casino/DREAMGAMING-LIVE-081.baccarat.webp?v=1764344644783",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Baccarat V02",
    img: "/assets/Casino/DREAMGAMING-LIVE-082.baccarat.webp?v=1764344594028",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Balloon Race",
    img: "/assets/Casino/EVOLUTION-LIVE-363.webp?v=1765933237694",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-363",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Bar Black Jack 3",
    img: "/assets/Casino/WINFINITY-LIVE-026.Bar Black Jack 3.webp?v=1764401884810",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Bar Black Jack 4",
    img: "/assets/Casino/WINFINITY-LIVE-027.Bar Black Jack 4.webp?v=1764401851110",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Bar Black Jack 5",
    img: "/assets/Casino/WINFINITY-LIVE-001.Bar Black Jack 5.webp?v=1764401812120",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Bar Instant Blackjack",
    img: "/assets/Casino/WINFINITY-LIVE-046.webp?v=1767778904515",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Bar Roulette 2000X",
    img: "/assets/Casino/WINFINITY-LIVE-004.bar-roulette-2000x.webp?v=1764401700323",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Bet Behind Pro Blackjack",
    img: "/assets/Casino/PP-LIVE-143.Bet Behind Pro Blackjack_.webp?v=1764404510389",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-143",
    platFormCode: "PP",
  },
  {
    name: "Bet On Dragon Tiger Live",
    img: "/assets/Casino/PT-LIVE-030.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-030",
    platFormCode: "PT",
  },
  {
    name: "Bet on Baccarat Live",
    img: "/assets/Casino/PT-LIVE-005.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-005",
    platFormCode: "PT",
  },
  {
    name: "Bet on Poker Live",
    img: "/assets/Casino/PT-LIVE-019.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-019",
    platFormCode: "PT",
  },
  {
    name: "Bid Baccarat D11",
    img: "/assets/Casino/DREAMGAMING-LIVE-010.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Bid Baccarat D12",
    img: "/assets/Casino/DREAMGAMING-LIVE-011.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Big Bang Roulette",
    img: "/assets/Casino/WINFINITY-LIVE-009.big-bang-roulette.webp?v=1764401646832",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "BigBang INSTANT Roulette",
    img: "/assets/Casino/WINFINITY-LIVE-045.webp?v=1765954402908",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "BlackJack Atrium A",
    img: "/assets/Casino/CREEDROOMZ-LIVE-032.webp?v=1757466006239",
    platForm: "CREEDROOMZ",
    type: "Casino",
  },
  {
    name: "BlackJack Atrium B",
    img: "/assets/Casino/CREEDROOMZ-LIVE-033.webp?v=1757466006240",
    platForm: "CREEDROOMZ",
    type: "Casino",
  },
  {
    name: "BlackJack Creed P",
    img: "/assets/Casino/CREEDROOMZ-LIVE-034.webp?v=1757466006240",
    platForm: "CREEDROOMZ",
    type: "Casino",
  },
  {
    name: "BlackJack Persian D",
    img: "/assets/Casino/CREEDROOMZ-LIVE-037.webp?v=1757466006241",
    platForm: "CREEDROOMZ",
    type: "Casino",
  },
  {
    name: "BlackJack Premium",
    img: "/assets/Casino/CREEDROOMZ-LIVE-038.webp?v=1757466006242",
    platForm: "CREEDROOMZ",
    type: "Casino",
  },
  {
    name: "BlackJack Turkish B",
    img: "/assets/Casino/CREEDROOMZ-LIVE-039.webp?v=1757466006243",
    platForm: "CREEDROOMZ",
    type: "Casino",
  },
  {
    name: "BlackJack Turkish C",
    img: "/assets/Casino/CREEDROOMZ-LIVE-040.webp?v=1757466006244",
    platForm: "CREEDROOMZ",
    type: "Casino",
  },
  {
    name: "BlackJack VIP A",
    img: "/assets/Casino/CREEDROOMZ-LIVE-041.webp?v=1757466006245",
    platForm: "CREEDROOMZ",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-100",
    platFormCode: "EVOLUTION",
  },
  {
    name: "BlackJack VIP B",
    img: "/assets/Casino/CREEDROOMZ-LIVE-042.webp?v=1757466006246",
    platForm: "CREEDROOMZ",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-039",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack 10",
    img: "/assets/Casino/PT-LIVE-127.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-127",
    platFormCode: "PT",
  },
  {
    name: "Blackjack A",
    img: "/assets/Casino/EVOLUTION-LIVE-002.webp?v=1765933237394",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-002",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack A16",
    img: "/assets/Casino/DREAMGAMING-LIVE-076.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blackjack B",
    img: "/assets/Casino/EVOLUTION-LIVE-082.webp?v=1765933237463",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-082",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack C",
    img: "/assets/Casino/EVOLUTION-LIVE-083.webp?v=1765933237464",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-083",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Diamond VIP",
    img: "/assets/Casino/EVOLUTION-LIVE-118.webp?v=1765933237495",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-118",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Fortune VIP",
    img: "/assets/Casino/EVOLUTION-LIVE-115.webp?v=1765933237492",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-115",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Grand VIP",
    img: "/assets/Casino/EVOLUTION-LIVE-116.webp?v=1765933237493",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-116",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Party",
    img: "/assets/Casino/EVOLUTION-LIVE-042.webp?v=1765933237429",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-042",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Platinum VIP",
    img: "/assets/Casino/EVOLUTION-LIVE-117.webp?v=1765933237494",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-117",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver A",
    img: "/assets/Casino/EVOLUTION-LIVE-075.webp?v=1765933237457",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-075",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver B",
    img: "/assets/Casino/EVOLUTION-LIVE-053.webp?v=1765933237438",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-053",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver C",
    img: "/assets/Casino/EVOLUTION-LIVE-056.webp?v=1765933237441",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-056",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver D",
    img: "/assets/Casino/EVOLUTION-LIVE-074.webp?v=1765933237456",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-074",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver E",
    img: "/assets/Casino/EVOLUTION-LIVE-051.webp?v=1765933237437",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-051",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver F",
    img: "/assets/Casino/EVOLUTION-LIVE-070.webp?v=1765933237452",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-070",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Silver G",
    img: "/assets/Casino/EVOLUTION-LIVE-068.webp?v=1765933237451",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-068",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack Soirée 1",
    img: "/assets/Casino/PT-LIVE-111.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-111",
    platFormCode: "PT",
  },
  {
    name: "Blackjack Soirée 2",
    img: "/assets/Casino/PT-LIVE-112.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-112",
    platFormCode: "PT",
  },
  {
    name: "Blackjack Soirée 3",
    img: "/assets/Casino/PT-LIVE-113.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-113",
    platFormCode: "PT",
  },
  {
    name: "Blackjack Soirée Gold 1",
    img: "/assets/Casino/PT-LIVE-121.webp?v=1761308003871",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-121",
    platFormCode: "PT",
  },
  {
    name: "Blackjack Soirée Gold 2",
    img: "/assets/Casino/PT-LIVE-122.webp?v=1761307883402",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-122",
    platFormCode: "PT",
  },
  {
    name: "Blackjack Soirée Gold 3",
    img: "/assets/Casino/PT-LIVE-123.Blackjack Soirée Gold 3.webp?v=1762323427295",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-123",
    platFormCode: "PT",
  },
  {
    name: "Blackjack Soirée Gold 4",
    img: "/assets/Casino/PT-LIVE-124.webp?v=1761307331754",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-124",
    platFormCode: "PT",
  },
  {
    name: "Blackjack VIP 1",
    img: "/assets/Casino/EVOLUTION-LIVE-050.webp?v=1765933237435",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-050",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 10",
    img: "/assets/Casino/EVOLUTION-LIVE-073.webp?v=1765933237455",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-073",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 11",
    img: "/assets/Casino/EVOLUTION-LIVE-084.webp?v=1765933237464",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-084",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 12",
    img: "/assets/Casino/EVOLUTION-LIVE-054.webp?v=1765933237439",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-054",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 13",
    img: "/assets/Casino/EVOLUTION-LIVE-085.webp?v=1765933237465",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-085",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 14",
    img: "/assets/Casino/EVOLUTION-LIVE-072.webp?v=1765933237454",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-072",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 15",
    img: "/assets/Casino/EVOLUTION-LIVE-055.webp?v=1765933237440",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-055",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 16",
    img: "/assets/Casino/EVOLUTION-LIVE-066.webp?v=1765933237449",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-066",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 17",
    img: "/assets/Casino/EVOLUTION-LIVE-086.webp?v=1765933237466",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-086",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 19",
    img: "/assets/Casino/EVOLUTION-LIVE-088.webp?v=1765933237468",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-088",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 2",
    img: "/assets/Casino/EVOLUTION-LIVE-089.webp?v=1765933237469",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-089",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 22",
    img: "/assets/Casino/EVOLUTION-LIVE-091.webp?v=1765933237470",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-091",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 25",
    img: "/assets/Casino/EVOLUTION-LIVE-052.webp?v=1765933237438",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-052",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 26",
    img: "/assets/Casino/EVOLUTION-LIVE-092.webp?v=1765933237471",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-092",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 27",
    img: "/assets/Casino/EVOLUTION-LIVE-093.webp?v=1765933237472",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-093",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 28",
    img: "/assets/Casino/EVOLUTION-LIVE-234.webp?v=1765933237610",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-234",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 3",
    img: "/assets/Casino/EVOLUTION-LIVE-094.webp?v=1765933237473",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-094",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 30",
    img: "/assets/Casino/EVOLUTION-LIVE-243.webp?v=1765933237618",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-243",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 31",
    img: "/assets/Casino/EVOLUTION-LIVE-275.webp?v=1765933237648",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-275",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 32",
    img: "/assets/Casino/EVOLUTION-LIVE-276.webp?v=1765933237649",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-276",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 33",
    img: "/assets/Casino/EVOLUTION-LIVE-281.webp?v=1765933237653",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-281",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 34",
    img: "/assets/Casino/EVOLUTION-LIVE-282.webp?v=1765933237654",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-282",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 35",
    img: "/assets/Casino/EVOLUTION-LIVE-283.webp?v=1765933237655",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-283",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 36",
    img: "/assets/Casino/EVOLUTION-LIVE-332.webp?v=1765933237669",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-332",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 37",
    img: "/assets/Casino/EVOLUTION-LIVE-333.webp?v=1765933237670",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-333",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 38",
    img: "/assets/Casino/EVOLUTION-LIVE-286.webp?v=1765933237656",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-286",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 4",
    img: "/assets/Casino/EVOLUTION-LIVE-095.webp?v=1765933237473",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-095",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 41",
    img: "/assets/Casino/EVOLUTION-LIVE-287.webp?v=1765933237657",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-287",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 5",
    img: "/assets/Casino/EVOLUTION-LIVE-096.webp?v=1765933237475",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-096",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 6",
    img: "/assets/Casino/EVOLUTION-LIVE-097.webp?v=1765933237476",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-097",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 7",
    img: "/assets/Casino/EVOLUTION-LIVE-064.webp?v=1765933237447",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-064",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 8",
    img: "/assets/Casino/EVOLUTION-LIVE-098.webp?v=1765933237477",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-098",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 9",
    img: "/assets/Casino/EVOLUTION-LIVE-099.webp?v=1765933237478",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-099",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP A",
    img: "/assets/Casino/EVOLUTION-LIVE-100.webp?v=1765933237479",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-100",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP B",
    img: "/assets/Casino/EVOLUTION-LIVE-039.webp?v=1765933237426",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-039",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP Beta",
    img: "/assets/Casino/EVOLUTION-LIVE-067.webp?v=1765933237450",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-067",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP C",
    img: "/assets/Casino/EVOLUTION-LIVE-101.webp?v=1765933237480",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-101",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP D",
    img: "/assets/Casino/EVOLUTION-LIVE-059.webp?v=1765933237443",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-059",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP E",
    img: "/assets/Casino/EVOLUTION-LIVE-069.webp?v=1765933237452",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-069",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP G",
    img: "/assets/Casino/EVOLUTION-LIVE-061.webp?v=1765933237445",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-061",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP Gamma",
    img: "/assets/Casino/EVOLUTION-LIVE-060.webp?v=1765933237444",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-060",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP H",
    img: "/assets/Casino/EVOLUTION-LIVE-103.webp?v=1765933237482",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-103",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP I",
    img: "/assets/Casino/EVOLUTION-LIVE-065.webp?v=1765933237448",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-065",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP K",
    img: "/assets/Casino/EVOLUTION-LIVE-105.webp?v=1765933237483",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-105",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP M",
    img: "/assets/Casino/EVOLUTION-LIVE-071.webp?v=1765933237453",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-071",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP N",
    img: "/assets/Casino/EVOLUTION-LIVE-107.webp?v=1765933237485",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-107",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP O",
    img: "/assets/Casino/EVOLUTION-LIVE-108.webp?v=1765933237486",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-108",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP P",
    img: "/assets/Casino/EVOLUTION-LIVE-109.webp?v=1765933237487",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-109",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP Q",
    img: "/assets/Casino/EVOLUTION-LIVE-110.webp?v=1765933237488",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-110",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP R",
    img: "/assets/Casino/EVOLUTION-LIVE-111.webp?v=1765933237489",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-111",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP T",
    img: "/assets/Casino/EVOLUTION-LIVE-113.webp?v=1765933237490",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-113",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP U",
    img: "/assets/Casino/EVOLUTION-LIVE-049.webp?v=1765933237435",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-049",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP X",
    img: "/assets/Casino/EVOLUTION-LIVE-057.webp?v=1765933237442",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-057",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack VIP Z",
    img: "/assets/Casino/EVOLUTION-LIVE-076.webp?v=1765933237458",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-076",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Blackjack X 1",
    img: "/assets/Casino/PP-LIVE-082.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-082",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 10",
    img: "/assets/Casino/PP-LIVE-091.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-091",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 14",
    img: "/assets/Casino/PP-LIVE-092.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-092",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 15",
    img: "/assets/Casino/PP-LIVE-093.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-093",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 16",
    img: "/assets/Casino/PP-LIVE-094.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-094",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 17",
    img: "/assets/Casino/PP-LIVE-095.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-095",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 18",
    img: "/assets/Casino/PP-LIVE-096.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-096",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 19",
    img: "/assets/Casino/PP-LIVE-097.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-097",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 2",
    img: "/assets/Casino/PP-LIVE-083.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-083",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 20",
    img: "/assets/Casino/PP-LIVE-098.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-098",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 3",
    img: "/assets/Casino/PP-LIVE-084.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-084",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 4",
    img: "/assets/Casino/PP-LIVE-085.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-085",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 5",
    img: "/assets/Casino/PP-LIVE-086.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-086",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 6",
    img: "/assets/Casino/PP-LIVE-087.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-087",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 7",
    img: "/assets/Casino/PP-LIVE-088.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-088",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 8",
    img: "/assets/Casino/PP-LIVE-089.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-089",
    platFormCode: "PP",
  },
  {
    name: "Blackjack X 9",
    img: "/assets/Casino/PP-LIVE-090.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-090",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 11",
    img: "/assets/Casino/PP-LIVE-112.BlackjackX 11.webp?v=1764404185843",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-112",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 12",
    img: "/assets/Casino/PP-LIVE-111.BlackjackX 12.webp?v=1764403999031",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-111",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 13",
    img: "/assets/Casino/PP-LIVE-110.BlackjackX 13.webp?v=1764403934245",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-110",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 21",
    img: "/assets/Casino/PP-LIVE-120.BlackjackX 21.webp?v=1764403866947",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-120",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 22",
    img: "/assets/Casino/PP-LIVE-109.BlackjackX 22.webp?v=1764403765848",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-109",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 23",
    img: "/assets/Casino/PP-LIVE-108.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-108",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 24",
    img: "/assets/Casino/PP-LIVE-121.BlackjackX 24.webp?v=1764402812353",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-121",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 25",
    img: "/assets/Casino/PP-LIVE-122.BlackjackX 25.webp?v=1764403641440",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-122",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 26",
    img: "/assets/Casino/PP-LIVE-107.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-107",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 27",
    img: "/assets/Casino/PP-LIVE-106.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-106",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 28",
    img: "/assets/Casino/PP-LIVE-105.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-105",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 29",
    img: "/assets/Casino/PP-LIVE-104.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-104",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 30",
    img: "/assets/Casino/PP-LIVE-103.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-103",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX31",
    img: "/assets/Casino/PP-LIVE-152.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-152",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX32",
    img: "/assets/Casino/PP-LIVE-153.BlackjackX 32.webp?v=1764403455403",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-153",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX33",
    img: "/assets/Casino/PP-LIVE-154.BlackjackX 33.webp?v=1764403363296",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-154",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX34",
    img: "/assets/Casino/PP-LIVE-155.BlackjackX 34.webp?v=1764403213890",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-155",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX35",
    img: "/assets/Casino/PP-LIVE-156.BlackjackX 35.webp?v=1764403157875",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-156",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX36",
    img: "/assets/Casino/PP-LIVE-157.BlackjackX 36.webp?v=1764403098539",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-157",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX37",
    img: "/assets/Casino/PP-LIVE-158.BlackjackX 37.webp?v=1764403028892",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-158",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX38",
    img: "/assets/Casino/PP-LIVE-159.BlackjackX 38.webp?v=1764402960921",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-159",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX39",
    img: "/assets/Casino/PP-LIVE-160.BlackjackX 39.webp?v=1764402899102",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-160",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX40",
    img: "/assets/Casino/PP-LIVE-161.BlackjackX 40_.webp?v=1764410757952",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-161",
    platFormCode: "PP",
  },
  {
    name: "Blockchain AndarBahar QC13",
    img: "/assets/Casino/DREAMGAMING-LIVE-066.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain AndarBahar QD13",
    img: "/assets/Casino/DREAMGAMING-LIVE-053.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Baccarat QC01",
    img: "/assets/Casino/DREAMGAMING-LIVE-055.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Baccarat QC02",
    img: "/assets/Casino/DREAMGAMING-LIVE-056.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Baccarat QC03",
    img: "/assets/Casino/DREAMGAMING-LIVE-057.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Baccarat QC05",
    img: "/assets/Casino/DREAMGAMING-LIVE-058.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Baccarat QC06",
    img: "/assets/Casino/DREAMGAMING-LIVE-059.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Baccarat QC07",
    img: "/assets/Casino/DREAMGAMING-LIVE-060.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Baccarat QD01",
    img: "/assets/Casino/DREAMGAMING-LIVE-042.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Baccarat QD02",
    img: "/assets/Casino/DREAMGAMING-LIVE-043.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Baccarat QD03",
    img: "/assets/Casino/DREAMGAMING-LIVE-044.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Baccarat QD05",
    img: "/assets/Casino/DREAMGAMING-LIVE-045.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Baccarat QD06",
    img: "/assets/Casino/DREAMGAMING-LIVE-046.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Baccarat QD07",
    img: "/assets/Casino/DREAMGAMING-LIVE-047.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Blackjack QC17",
    img: "/assets/Casino/DREAMGAMING-LIVE-074.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Blackjack QC18",
    img: "/assets/Casino/DREAMGAMING-LIVE-075.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Blackjack QC19",
    img: "/assets/Casino/DREAMGAMING-LIVE-079.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Blackjack QC20",
    img: "/assets/Casino/DREAMGAMING-LIVE-080.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Blackjack QD17",
    img: "/assets/Casino/DREAMGAMING-LIVE-072.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Blackjack QD18",
    img: "/assets/Casino/DREAMGAMING-LIVE-073.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Blackjack QD19",
    img: "/assets/Casino/DREAMGAMING-LIVE-077.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Blackjack QD20",
    img: "/assets/Casino/DREAMGAMING-LIVE-078.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Bull bull QC11",
    img: "/assets/Casino/DREAMGAMING-LIVE-064.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Bull bull QD11",
    img: "/assets/Casino/DREAMGAMING-LIVE-051.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Classic Sic Bo",
    img: "/assets/Casino/VIACASINO-LIVE-017.blockchain-classic-sic-bo.webp?v=1765269039053",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-017",
    platFormCode: "VIACASINO",
  },
  {
    name: "Blockchain Color Game",
    img: "/assets/Casino/VIACASINO-LIVE-030.blockchain-color-game.webp?v=1765268994849",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-030",
    platFormCode: "VIACASINO",
  },
  {
    name: "Blockchain DragonTiger QC08",
    img: "/assets/Casino/DREAMGAMING-LIVE-061.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain DragonTiger QC09",
    img: "/assets/Casino/DREAMGAMING-LIVE-062.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain DragonTiger QD08",
    img: "/assets/Casino/DREAMGAMING-LIVE-048.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain DragonTiger QD09",
    img: "/assets/Casino/DREAMGAMING-LIVE-049.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Roulette QC15",
    img: "/assets/Casino/DREAMGAMING-LIVE-071.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Roulette QD15",
    img: "/assets/Casino/DREAMGAMING-LIVE-070.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Sedie QD21",
    img: "/assets/Casino/DREAMGAMING-LIVE-086.Blockchain Sedie.webp?v=1764852601845",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Sicbo QC16",
    img: "/assets/Casino/DREAMGAMING-LIVE-068.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Sicbo QD16",
    img: "/assets/Casino/DREAMGAMING-LIVE-067.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Tai Xiu",
    img: "/assets/Casino/VIACASINO-LIVE-019.blockchain-tai-xiu.webp?v=1765268955238",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-019",
    platFormCode: "VIACASINO",
  },
  {
    name: "Blockchain Thai FishShrimpCrab",
    img: "/assets/Casino/VIACASINO-LIVE-027.blockchain-thai-fish-shrimp-crab.webp?v=1765268906233",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-027",
    platFormCode: "VIACASINO",
  },
  {
    name: "Blockchain Three Cards QC10",
    img: "/assets/Casino/DREAMGAMING-LIVE-063.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Three Cards QD10",
    img: "/assets/Casino/DREAMGAMING-LIVE-050.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain ThreeFace QC12",
    img: "/assets/Casino/DREAMGAMING-LIVE-065.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain ThreeFace QD12",
    img: "/assets/Casino/DREAMGAMING-LIVE-052.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Blockchain Viet FishShrimpCrab",
    img: "/assets/Casino/VIACASINO-LIVE-028.blockchain-viet-fish-shrimp-crab.webp?v=1765268849907",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-028",
    platFormCode: "VIACASINO",
  },
  {
    name: "Blockchain Xoc Dia",
    img: "/assets/Casino/VIACASINO-LIVE-029.blockchain-xoc-dia.webp?v=1765268719104",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-029",
    platFormCode: "VIACASINO",
  },
  {
    name: "BlockchainThai Hi Lo",
    img: "/assets/Casino/VIACASINO-LIVE-018.blockchain-thai-hi-lo.webp?v=1765268417136",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-018",
    platFormCode: "VIACASINO",
  },
  {
    name: "Bonsai Speed Baccarat A",
    img: "/assets/Casino/EVOLUTION-LIVE-231.webp?v=1765933237606",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-231",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Bonsai Speed Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-232.webp?v=1765933237607",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-232",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Bonsai Speed Baccarat C",
    img: "/assets/Casino/EVOLUTION-LIVE-233.webp?v=1765933237609",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-233",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Brazilian Roulette",
    img: "/assets/Casino/PP-LIVE-074.Brazilian Roulette.webp?v=1764410690851",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-074",
    platFormCode: "PP",
  },
  {
    name: "Bucharest French Roulette",
    img: "/assets/Casino/PT-LIVE-066.webp?v=1761376634897",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-066",
    platFormCode: "PT",
  },
  {
    name: "Bucharest Roulette",
    img: "/assets/Casino/PT-LIVE-063.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-063",
    platFormCode: "PT",
  },
  {
    name: "Bull D18",
    img: "/assets/Casino/DREAMGAMING-LIVE-018.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Cabaret Roulette",
    img: "/assets/Casino/WINFINITY-LIVE-019.cabaret-roulette.webp?v=1764401610165",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Caribbean Stud Poker",
    img: "/assets/Casino/EVOLUTION-LIVE-024.webp?v=1765933237414",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-024",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Cash Collect Roulette Live",
    img: "/assets/Casino/PT-LIVE-131.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-131",
    platFormCode: "PT",
  },
  {
    name: "Casino Hold'em",
    img: "/assets/Casino/EVOLUTION-LIVE-015.webp?v=1765933237407",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-015",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Casino HoldÂ´em",
    img: "/assets/Casino/PT-LIVE-017.Casino HoldÂ´em.webp?v=1764324493496",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-017",
    platFormCode: "PT",
  },
  {
    name: "Casino Hold’em",
    img: "/assets/Casino/PP-LIVE-182.webp?v=1751532461155",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-182",
    platFormCode: "PP",
  },
  {
    name: "Casino Malta Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-350.webp?v=1771552333425",
    platForm: "EVOLUTION",
    type: "Casino",
  },
  {
    name: "Chinese Speed Baccarat 1",
    img: "/assets/Casino/PP-LIVE-080.Chinese Speed Baccarat 1.webp?v=1764410626165",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-080",
    platFormCode: "PP",
  },
  {
    name: "Chinese Speed Baccarat 2",
    img: "/assets/Casino/PP-LIVE-114.Chinese Speed Baccarat 2.webp?v=1764410582975",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-114",
    platFormCode: "PP",
  },
  {
    name: "Chinese Speed Baccarat 3",
    img: "/assets/Casino/PP-LIVE-139.Chinese Speed Baccarat 3.webp?v=1764410503268",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-139",
    platFormCode: "PP",
  },
  {
    name: "Classic Baccarat",
    img: "/assets/Casino/VIACASINO-LIVE-001.classic-baccarat.webp?v=1765268357771",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-001",
    platFormCode: "VIACASINO",
  },
  {
    name: "Classic Sic Bo",
    img: "/assets/Casino/VIACASINO-LIVE-007.classic-sic-bo.webp?v=1765268309215",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-007",
    platFormCode: "VIACASINO",
  },
  {
    name: "Craps",
    img: "/assets/Casino/EVOLUTION-LIVE-003.webp?v=1765933237395",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-003",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Crazy Balls",
    img: "/assets/Casino/EVOLUTION-LIVE-409.webp?v=1765933237718",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-409",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Crazy Coin Flip",
    img: "/assets/Casino/EVOLUTION-LIVE-014.webp?v=1765933237406",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-014",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Crazy Marbles",
    img: "/assets/Casino/VIACASINO-LIVE-025.crazy-marbles.webp?v=1765268259891",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-025",
    platFormCode: "VIACASINO",
  },
  {
    name: "Crazy Pachinko",
    img: "/assets/Casino/EVOLUTION-LIVE-261.webp?v=1765933237634",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-261",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Crazy Time",
    img: "/assets/Casino/EVOLUTION-LIVE-006.webp?v=1765933237399",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Crazy Time A",
    img: "/assets/Casino/EVOLUTION-LIVE-114.webp?v=1765933237491",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-114",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dead or Alive: Saloon",
    img: "/assets/Casino/EVOLUTION-LIVE-176.webp?v=1765933237547",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-176",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Deutsches Roulette",
    img: "/assets/Casino/PT-LIVE-022.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
  },
  {
    name: "Dice City",
    img: "/assets/Casino/PP-LIVE-049.Dice City_.webp?v=1764410434298",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-049",
    platFormCode: "PP",
  },
  {
    name: "Double Ball Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-043.webp?v=1765933237430",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-043",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dragon Tiger",
    img: "/assets/Casino/PT-LIVE-002.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-002",
    platFormCode: "PT",
  },
  {
    name: "Dragon Tiger",
    img: "/assets/Casino/EVOLUTION-LIVE-004.webp?v=1765933237397",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-004",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dragon Tiger",
    img: "/assets/Casino/WINFINITY-LIVE-018.dragon-tiger.webp?v=1764401558546",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Dragon Tiger",
    img: "/assets/Casino/PP-LIVE-042.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-042",
    platFormCode: "PP",
  },
  {
    name: "Dragon Tiger",
    img: "/assets/Casino/HOTROAD-LIVE-003.webp?v=1751418030552",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-003",
    platFormCode: "HOTROAD",
  },
  {
    name: "Dragon Tiger",
    img: "/assets/Casino/MX-LIVE-006.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Dragon Tiger Phoenix",
    img: "/assets/Casino/EVOLUTION-LIVE-453.webp?v=1765933237750",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-453",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dragon Tiger-SEXY hall",
    img: "/assets/Casino/MX-LIVE-006_SEXY.webp?v=1761310589605",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Dragon Tiger-SEXY hall-Table1",
    img: "/assets/Casino/MX-LIVE-006_SEXY_31.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Dragon Tiger-SEXY hall-Table2",
    img: "/assets/Casino/MX-LIVE-006_SEXY_32.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "DragonTiger A09",
    img: "/assets/Casino/DREAMGAMING-LIVE-026.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "DragonTiger D16",
    img: "/assets/Casino/DREAMGAMING-LIVE-014.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "DragonTiger D17",
    img: "/assets/Casino/DREAMGAMING-LIVE-015.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Dream Catcher",
    img: "/assets/Casino/EVOLUTION-LIVE-035.webp?v=1765933237422",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-035",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dynasty Lightning Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-450.webp?v=1765933237748",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-450",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 1",
    img: "/assets/Casino/EVOLUTION-LIVE-441.webp?v=1765933237741",
    platForm: "EVOLUTION",
    type: "Casino",
  },
  {
    name: "Dynasty Speed Baccarat 2",
    img: "/assets/Casino/EVOLUTION-LIVE-442.webp?v=1765933237742",
    platForm: "EVOLUTION",
    type: "Casino",
  },
  {
    name: "Dynasty Speed Baccarat 3",
    img: "/assets/Casino/EVOLUTION-LIVE-443.webp?v=1765933237743",
    platForm: "EVOLUTION",
    type: "Casino",
  },
  {
    name: "Dynasty Speed Baccarat 4",
    img: "/assets/Casino/EVOLUTION-LIVE-444.webp?v=1765933237744",
    platForm: "EVOLUTION",
    type: "Casino",
  },
  {
    name: "Dynasty Speed Baccarat 5",
    img: "/assets/Casino/EVOLUTION-LIVE-445.webp?v=1765933237744",
    platForm: "EVOLUTION",
    type: "Casino",
  },
  {
    name: "Dynasty Speed Baccarat 6",
    img: "/assets/Casino/EVOLUTION-LIVE-446.webp?v=1765933237745",
    platForm: "EVOLUTION",
    type: "Casino",
  },
  {
    name: "Dynasty Speed Baccarat 7",
    img: "/assets/Casino/EVOLUTION-LIVE-447.webp?v=1765933237746",
    platForm: "EVOLUTION",
    type: "Casino",
  },
  {
    name: "Dynasty Speed Baccarat 8",
    img: "/assets/Casino/EVOLUTION-LIVE-448.webp?v=1765933237747",
    platForm: "EVOLUTION",
    type: "Casino",
  },
  {
    name: "Easy Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-413.webp?v=1765933237721",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-413",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Bac Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-230.webp?v=1765933237605",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-230",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Baccarat",
    img: "/assets/Casino/PT-LIVE-119.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-119",
    platFormCode: "PT",
  },
  {
    name: "Emperor Baccarat NC",
    img: "/assets/Casino/PT-LIVE-120.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-120",
    platFormCode: "PT",
  },
  {
    name: "Emperor Dragon Tiger",
    img: "/assets/Casino/EVOLUTION-LIVE-077.webp?v=1765933237459",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-077",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Golden Wealth Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-414.webp?v=1765933237722",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-414",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-080.webp?v=1765933237461",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-080",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Sic Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-047.webp?v=1765933237434",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-047",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Sic Bo A",
    img: "/assets/Casino/EVOLUTION-LIVE-211.webp?v=1765933237588",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-211",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Speed Baccarat A",
    img: "/assets/Casino/EVOLUTION-LIVE-150.webp?v=1765933237523",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-150",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Speed Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-147.webp?v=1765933237520",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-147",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Speed Baccarat C",
    img: "/assets/Casino/EVOLUTION-LIVE-153.webp?v=1765933237526",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-153",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Emperor Speed Baccarat D",
    img: "/assets/Casino/EVOLUTION-LIVE-210.webp?v=1765933237587",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-210",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 1",
    img: "/assets/Casino/EVOLUTION-LIVE-263.webp?v=1765933237636",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-263",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 10",
    img: "/assets/Casino/EVOLUTION-LIVE-279.webp?v=1765933237652",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-279",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 11",
    img: "/assets/Casino/EVOLUTION-LIVE-280.webp?v=1765933237653",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-280",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 2",
    img: "/assets/Casino/EVOLUTION-LIVE-264.webp?v=1765933237637",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-264",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 3",
    img: "/assets/Casino/EVOLUTION-LIVE-265.webp?v=1765933237638",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-265",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 4",
    img: "/assets/Casino/EVOLUTION-LIVE-266.webp?v=1765933237639",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-266",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 5",
    img: "/assets/Casino/EVOLUTION-LIVE-267.webp?v=1765933237640",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-267",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 6",
    img: "/assets/Casino/EVOLUTION-LIVE-268.webp?v=1765933237641",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-268",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 7",
    img: "/assets/Casino/EVOLUTION-LIVE-269.webp?v=1765933237643",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-269",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Extra Chili Epic Spins",
    img: "/assets/Casino/EVOLUTION-LIVE-168.webp?v=1765933237541",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-168",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Extra Sicbo",
    img: "/assets/Casino/MX-LIVE-016.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-016",
    platFormCode: "SEXYBCRT",
  },
  {
    name: "Extreme Texas Hold'em",
    img: "/assets/Casino/EVOLUTION-LIVE-032.webp?v=1765933237419",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-032",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Fan Tan",
    img: "/assets/Casino/EVOLUTION-LIVE-178.webp?v=1765933237549",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-178",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Fireball Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-436.webp?v=1765933237740",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-436",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person American Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-206.webp?v=1765933237582",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-206",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-029.webp?v=1765933237417",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-029",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Craps",
    img: "/assets/Casino/EVOLUTION-LIVE-031.webp?v=1765933237419",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-031",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Dragon Tiger",
    img: "/assets/Casino/EVOLUTION-LIVE-033.webp?v=1765933237420",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-033",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Dream Catcher",
    img: "/assets/Casino/EVOLUTION-LIVE-023.webp?v=1765933237412",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-023",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Golden Wealth Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-046.webp?v=1765933237433",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-046",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person HiLo",
    img: "/assets/Casino/EVOLUTION-LIVE-364.webp?v=1768216195140",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-364",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Lightning Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-207.webp?v=1765933237583",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-207",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Lightning Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-208.webp?v=1765933237585",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-208",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Lightning Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-209.webp?v=1765933237586",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-209",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Mega Ball",
    img: "/assets/Casino/EVOLUTION-LIVE-034.webp?v=1765933237421",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-034",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Prosperity Tree Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-244.webp?v=1765933237619",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-244",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-013.webp?v=1765933237405",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-013",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Super Sic Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-259.webp?v=1765933237632",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-259",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First Person Top Card",
    img: "/assets/Casino/EVOLUTION-LIVE-030.webp?v=1770892780819",
    platForm: "EVOLUTION",
    type: "Casino",
  },
  {
    name: "First Person XXXtreme Lightning Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-226.webp?v=1765933237601",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-226",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First person Video Poker",
    img: "/assets/Casino/EVOLUTION-LIVE-258.webp?v=1765933237631",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-258",
    platFormCode: "EVOLUTION",
  },
  {
    name: "First person XXXtreme lightning Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-256.webp?v=1765933237629",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-256",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Football French Roulette",
    img: "/assets/Casino/PT-LIVE-023.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-023",
    platFormCode: "PT",
  },
  {
    name: "Football Roulette",
    img: "/assets/Casino/PT-LIVE-024.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-024",
    platFormCode: "PT",
  },
  {
    name: "Football Studio",
    img: "/assets/Casino/EVOLUTION-LIVE-045.webp?v=1765933237432",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-045",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Football Studio Dice",
    img: "/assets/Casino/EVOLUTION-LIVE-044.webp?v=1765933237430",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-044",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Football Studio Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-214.webp?v=1765933237590",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-214",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Fortune 6 Baccarat",
    img: "/assets/Casino/PP-LIVE-047.Fortune 6 Baccarat.webp?v=1764410366343",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-047",
    platFormCode: "PP",
  },
  {
    name: "Fortune Roulette",
    img: "/assets/Casino/PP-LIVE-163.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-163",
    platFormCode: "PP",
  },
  {
    name: "Free Bet VIP Blackjack A",
    img: "/assets/Casino/EVOLUTION-LIVE-314.webp?v=1765933237664",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-314",
    platFormCode: "EVOLUTION",
  },
  {
    name: "French Roulette",
    img: "/assets/Casino/PT-LIVE-025.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-025",
    platFormCode: "PT",
  },
  {
    name: "French Roulette",
    img: "/assets/Casino/PP-LIVE-181.French Roulette.webp?v=1764410296937",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-181",
    platFormCode: "PP",
  },
  {
    name: "Funky Time",
    img: "/assets/Casino/EVOLUTION-LIVE-183.webp?v=1765933237553",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-183",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Game Lobby",
    img: "/assets/Casino/VIACASINO-LIVE-001_GameLobby.webp?v=1770779018359",
    platForm: "VIACASINO",
    type: "Casino",
  },
  {
    name: "Game Lobby",
    img: "/assets/Casino/WINFINITY-LIVE-001_GameLobby.webp?v=1770779093099",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Game Lobby",
    img: "/assets/Casino/CREEDROOMZ-LIVE-001_GameLobby.webp?v=1770779039318",
    platForm: "CREEDROOMZ",
    type: "Casino",
  },
  {
    name: "Game Lobby",
    img: "/assets/Casino/EVOLUTION-LIVE-001_GameLobby.webp?v=1770778975191",
    platForm: "EVOLUTION",
    type: "Casino",
  },
  {
    name: "Game Lobby",
    img: "/assets/Casino/DREAMGAMING-LIVE-001_GameLobby.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Game Lobby",
    img: "/assets/Casino/PT-LIVE-001_GameLobby.webp?v=1770771639480",
    platForm: "PT",
    type: "Casino",
  },
  {
    name: "Gangnam Speed Baccarat",
    img: "/assets/Casino/PT-LIVE-117.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-117",
    platFormCode: "PT",
  },
  {
    name: "Gangnam Speed Baccarat NC",
    img: "/assets/Casino/PT-LIVE-118.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-118",
    platFormCode: "PT",
  },
  {
    name: "German Roulette",
    img: "/assets/Casino/PP-LIVE-031.German Roulette.webp?v=1764410254534",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-031",
    platFormCode: "PP",
  },
  {
    name: "Gold Vault Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-228.webp?v=1765933237603",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-228",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Golden Wealth Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-179.webp?v=1765933237550",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-179",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Grand Baccarat",
    img: "/assets/Casino/PT-LIVE-034.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-034",
    platFormCode: "PT",
  },
  {
    name: "Grand Baccarat NC",
    img: "/assets/Casino/PT-LIVE-037.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-037",
    platFormCode: "PT",
  },
  {
    name: "Greek Quantum Roulette",
    img: "/assets/Casino/PT-LIVE-076.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-076",
    platFormCode: "PT",
  },
  {
    name: "Greek Roulette",
    img: "/assets/Casino/PT-LIVE-055.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-055",
    platFormCode: "PT",
  },
  {
    name: "HOT 7up 7down",
    img: "/assets/Casino/HOTROAD-LIVE-008.HOT 7UP 7DOWN.webp?v=1764336800993",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-008",
    platFormCode: "HOTROAD",
  },
  {
    name: "HOT 8 Baccarat",
    img: "/assets/Casino/HOTROAD-LIVE-012.HOT 8 BACCARAT.webp?v=1764336849992",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-012",
    platFormCode: "HOTROAD",
  },
  {
    name: "HOT Baccarat",
    img: "/assets/Casino/HOTROAD-LIVE-007.webp?v=1751418030552",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-007",
    platFormCode: "HOTROAD",
  },
  {
    name: "HOT COLOR GAME",
    img: "/assets/Casino/HOTROAD-LIVE-005.webp?v=1751418030552",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-005",
    platFormCode: "HOTROAD",
  },
  {
    name: "HOT ROULETTE",
    img: "/assets/Casino/HOTROAD-LIVE-004.webp?v=1761390862733",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-004",
    platFormCode: "HOTROAD",
  },
  {
    name: "HOT SICBO",
    img: "/assets/Casino/HOTROAD-LIVE-006.webp?v=1751418030552",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-006",
    platFormCode: "HOTROAD",
  },
  {
    name: "HOT Thai HI-LO",
    img: "/assets/Casino/HOTROAD-LIVE-009.webp?v=1751418030552",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-009",
    platFormCode: "HOTROAD",
  },
  {
    name: "Hanguk Auto Roulette",
    img: "/assets/Casino/WINFINITY-LIVE-030.Hanguk Auto Roulette.webp?v=1764401247448",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Hindi Lightning Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-429.webp?v=1765933237733",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-429",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Hindi Roulette",
    img: "/assets/Casino/PT-LIVE-056.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-056",
    platFormCode: "PT",
  },
  {
    name: "Hindi Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-430.webp?v=1765933237734",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-430",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Hindi Speed Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-229.webp?v=1765933237604",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-229",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Hindi Speed Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-277.webp?v=1765933237650",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-277",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Ice Fishing",
    img: "/assets/Casino/EVOLUTION-LIVE-449.webp?v=1765933237748",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-449",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Immersive Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-180.webp?v=1765933237551",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-180",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Immersive Roulette Deluxe",
    img: "/assets/Casino/PP-LIVE-175.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-175",
    platFormCode: "PP",
  },
  {
    name: "Imperial Quest",
    img: "/assets/Casino/EVOLUTION-LIVE-169.webp?v=1765933237542",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-169",
    platFormCode: "EVOLUTION",
  },
  {
    name: "InBaccarat A08",
    img: "/assets/Casino/DREAMGAMING-LIVE-025.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "InBaccarat D13",
    img: "/assets/Casino/DREAMGAMING-LIVE-012.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "InBaccarat D15",
    img: "/assets/Casino/DREAMGAMING-LIVE-013.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Indonesia Speed Baccarat 1",
    img: "/assets/Casino/PP-LIVE-072.Indonesian Speed Baccarat 1.webp?v=1764410189179",
    platForm: "PP",
    type: "Casino",
  },
  {
    name: "Indonesian BlackjackX1",
    img: "/assets/Casino/PP-LIVE-147.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-147",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX10",
    img: "/assets/Casino/PP-LIVE-168.Indonesian BlackjackX10.webp?v=1764410108844",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-168",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX11",
    img: "/assets/Casino/PP-LIVE-169.Indonesian BlackjackX11.webp?v=1764410031647",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-169",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX12",
    img: "/assets/Casino/PP-LIVE-170.Indonesian BlackjackX12.webp?v=1764409959495",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-170",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX13",
    img: "/assets/Casino/PP-LIVE-171.Indonesian BlackjackX13.webp?v=1764409895095",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-171",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX14",
    img: "/assets/Casino/PP-LIVE-172.Indonesian BlackjackX14.webp?v=1764409761370",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-172",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX15",
    img: "/assets/Casino/PP-LIVE-173.Indonesian BlackjackX15.webp?v=1764409703404",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-173",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX2",
    img: "/assets/Casino/PP-LIVE-148.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-148",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX3",
    img: "/assets/Casino/PP-LIVE-149.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-149",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX4",
    img: "/assets/Casino/PP-LIVE-150.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-150",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX5",
    img: "/assets/Casino/PP-LIVE-151.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-151",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX6",
    img: "/assets/Casino/PP-LIVE-164.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-164",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX7",
    img: "/assets/Casino/PP-LIVE-165.Indonesian BlackjackX7.webp?v=1764409542173",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-165",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX8",
    img: "/assets/Casino/PP-LIVE-166.Indonesian BlackjackX8_.webp?v=1764409478532",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-166",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX9",
    img: "/assets/Casino/PP-LIVE-167.Indonesian BlackjackX9.webp?v=1764409403251",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-167",
    platFormCode: "PP",
  },
  {
    name: "Infinite Bet Stacker Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-412.webp?v=1765933237720",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-412",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Infinite Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-012.webp?v=1765933237404",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-012",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Infinite Free Bet Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-037.webp?v=1765933237424",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-037",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Infinite Fun Fun 21 Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-397.webp?v=1765933237715",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-397",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Instant Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-008.webp?v=1765933237401",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-008",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Italian Cashback Blackjack",
    img: "/assets/Casino/PT-LIVE-031.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-031",
    platFormCode: "PT",
  },
  {
    name: "Jacks or Better Draw Poker",
    img: "/assets/Casino/PP-LIVE-183.Jacks or Better Draw Poker.webp?v=1764409296646",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-183",
    platFormCode: "PP",
  },
  {
    name: "Japanese Speed Baccarat 1",
    img: "/assets/Casino/PP-LIVE-118.Japanese Speed Baccarat 1.webp?v=1764409219083",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-118",
    platFormCode: "PP",
  },
  {
    name: "Japanese Speed Baccarat 2",
    img: "/assets/Casino/PP-LIVE-119.Japanese Speed Baccarat 2.webp?v=1764409165583",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-119",
    platFormCode: "PP",
  },
  {
    name: "Japanese Squeeze Baccarat",
    img: "/assets/Casino/PT-LIVE-091.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-091",
    platFormCode: "PT",
  },
  {
    name: "Japanese Squeeze Baccarat NC",
    img: "/assets/Casino/PT-LIVE-092.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-092",
    platFormCode: "PT",
  },
  {
    name: "Japanses Speed baccarat 3",
    img: "/assets/Casino/PP-LIVE-099.Japanese Speed Baccarat 3.webp?v=1764409089433",
    platForm: "PP",
    type: "Casino",
  },
  {
    name: "Korean Baccarat 1",
    img: "/assets/Casino/PP-LIVE-071.webp?v=1754377759337",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-071",
    platFormCode: "PP",
  },
  {
    name: "Korean Baccarat 2",
    img: "/assets/Casino/PP-LIVE-180.webp?v=1754377916999",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-180",
    platFormCode: "PP",
  },
  {
    name: "Korean Roulette",
    img: "/assets/Casino/PP-LIVE-073.Korean Roulette.webp?v=1764408880591",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-073",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat",
    img: "/assets/Casino/PT-LIVE-095.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
  },
  {
    name: "Korean Speed Baccarat 1",
    img: "/assets/Casino/PP-LIVE-056.Korean Speed Baccarat 1.webp?v=1764408833701",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-056",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat 2",
    img: "/assets/Casino/PP-LIVE-057.Korean Speed Baccarat 2.webp?v=1764408785169",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-057",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat 3",
    img: "/assets/Casino/PP-LIVE-070.Korean Speed Baccarat 3.webp?v=1764408718658",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-070",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat 5",
    img: "/assets/Casino/PP-LIVE-117.Korean Speed Baccarat 5.webp?v=1764408646962",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-117",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat 6",
    img: "/assets/Casino/PP-LIVE-113.Korean Speed Baccarat 6.webp?v=1764408585580",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-113",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat NC",
    img: "/assets/Casino/PT-LIVE-096.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
  },
  {
    name: "Le Rouge Blackjack 1",
    img: "/assets/Casino/WINFINITY-LIVE-049.webp?v=1769055957590",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Lightning Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-133.webp?v=1765933237507",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-133",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Ball",
    img: "/assets/Casino/EVOLUTION-LIVE-376.webp?v=1765933237705",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-376",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-181.webp?v=1765933237552",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-181",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Dice",
    img: "/assets/Casino/EVOLUTION-LIVE-011.webp?v=1765933237404",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-011",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Dragon Tiger",
    img: "/assets/Casino/EVOLUTION-LIVE-344.webp?v=1765933237677",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-344",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-040.webp?v=1765933237427",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-040",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Sic Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-362.webp?v=1765933237693",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-362",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lightning Storm",
    img: "/assets/Casino/EVOLUTION-LIVE-369.webp?v=1765933237699",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-369",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lotto Baccarat",
    img: "/assets/Casino/VIACASINO-LIVE-020.lotto-baccarat.webp?v=1765268206684",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-020",
    platFormCode: "VIACASINO",
  },
  {
    name: "Lotto Lucky Natural",
    img: "/assets/Casino/VIACASINO-LIVE-022.lotto-lucky-natural.webp?v=1765268147231",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-022",
    platFormCode: "VIACASINO",
  },
  {
    name: "Lotto Lucky Wheel",
    img: "/assets/Casino/VIACASINO-LIVE-024.lotto-lucky-wheel.webp?v=1765267924041",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-024",
    platFormCode: "VIACASINO",
  },
  {
    name: "Lotto Super Six",
    img: "/assets/Casino/VIACASINO-LIVE-021.lotto-super-six.webp?v=1765267870703",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-021",
    platFormCode: "VIACASINO",
  },
  {
    name: "Lotto Xoc Dia",
    img: "/assets/Casino/VIACASINO-LIVE-023.lotto-xoc-dia.webp?v=1765267773716",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-023",
    platFormCode: "VIACASINO",
  },
  {
    name: "Lotus Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-417.webp?v=1765933237725",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-417",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lotus Sic Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-411.webp?v=1765933237720",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-411",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lotus Speed Baccarat A",
    img: "/assets/Casino/EVOLUTION-LIVE-416.webp?v=1765933237724",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-416",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lotus Speed Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-420.webp?v=1765933237726",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-420",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lotus Speed Baccarat C",
    img: "/assets/Casino/EVOLUTION-LIVE-421.webp?v=1765933237726",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-421",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Lucky 6 Roulette",
    img: "/assets/Casino/PP-LIVE-077.Lucky 6 Roulette.webp?v=1764408516141",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-077",
    platFormCode: "PP",
  },
  {
    name: "Lucky 7 Baccarat",
    img: "/assets/Casino/HOTROAD-LIVE-013.LUCKY 7 BACCARAT.webp?v=1764336954926",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-013",
    platFormCode: "HOTROAD",
  },
  {
    name: "Lucky Ball Roulette Live",
    img: "/assets/Casino/PT-LIVE-130.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-130",
    platFormCode: "PT",
  },
  {
    name: "Lucky Natural",
    img: "/assets/Casino/VIACASINO-LIVE-003.lucky-natural.webp?v=1765267723842",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-003",
    platFormCode: "VIACASINO",
  },
  {
    name: "MONOPOLY Big Baller",
    img: "/assets/Casino/EVOLUTION-LIVE-018.webp?v=1765933237410",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-018",
    platFormCode: "EVOLUTION",
  },
  {
    name: "MONOPOLY Live",
    img: "/assets/Casino/EVOLUTION-LIVE-007.webp?v=1765933237400",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-007",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Marble Race",
    img: "/assets/Casino/EVOLUTION-LIVE-434.webp?v=1765933237738",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-434",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Mega Baccarat",
    img: "/assets/Casino/PP-LIVE-061.Mega-Baccarat.webp?v=1764408470795",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-061",
    platFormCode: "PP",
  },
  {
    name: "Mega Ball",
    img: "/assets/Casino/EVOLUTION-LIVE-010.webp?v=1765933237403",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-010",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Mega Fire Blaze Blackjack Live",
    img: "/assets/Casino/PT-LIVE-106.webp?v=1761376482919",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-106",
    platFormCode: "PT",
  },
  {
    name: "Mega Fire Blaze Lucky Ball Brasileiro",
    img: "/assets/Casino/PT-LIVE-108.Mega Fire Blaze Lucky Ball Brasileiro.webp?v=1764325214615",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-108",
    platFormCode: "PT",
  },
  {
    name: "Mega Fire Blaze Lucky Ball Live",
    img: "/assets/Casino/PT-LIVE-110.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-110",
    platFormCode: "PT",
  },
  {
    name: "Mega Fire Blaze Roulette Live",
    img: "/assets/Casino/PT-LIVE-028.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-028",
    platFormCode: "PT",
  },
  {
    name: "Mega Roulette",
    img: "/assets/Casino/PP-LIVE-039.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-039",
    platFormCode: "PP",
  },
  {
    name: "Mega Roulette - Brazilian",
    img: "/assets/Casino/PP-LIVE-141.Mega Roulette - Brazilian.webp?v=1764408410179",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-141",
    platFormCode: "PP",
  },
  {
    name: "Mega Sic Bac",
    img: "/assets/Casino/PP-LIVE-140.Mega Sic Bac.webp?v=1764408284695",
    platForm: "PP",
    type: "Casino",
  },
  {
    name: "Mega Sic Bo",
    img: "/assets/Casino/PP-LIVE-025.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-025",
    platFormCode: "PP",
  },
  {
    name: "Mega Wheel",
    img: "/assets/Casino/PP-LIVE-038.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-038",
    platFormCode: "PP",
  },
  {
    name: "Monaco Blackjack 1",
    img: "/assets/Casino/WINFINITY-LIVE-036.Monaco Blackjack 1.webp?v=1764401203886",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Monaco Blackjack 2",
    img: "/assets/Casino/WINFINITY-LIVE-037.Monaco Blackjack 2.webp?v=1764401150711",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Monaco Instant Blackjack",
    img: "/assets/Casino/WINFINITY-LIVE-048.webp?v=1768445245535",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Monaco VIP Blackjack 6",
    img: "/assets/Casino/WINFINITY-LIVE-041.Monaco VIP Blackjack 6.webp?v=1764400896395",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "No Commission Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-038.webp?v=1765933237425",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-038",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Pair Baccarat",
    img: "/assets/Casino/VIACASINO-LIVE-004.pair-baccarat.webp?v=1765267677938",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-004",
    platFormCode: "VIACASINO",
  },
  {
    name: "Peek Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-182.webp?v=1765933237552",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-182",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 1",
    img: "/assets/Casino/EVOLUTION-LIVE-377.webp?v=1765933237706",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-377",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 2",
    img: "/assets/Casino/EVOLUTION-LIVE-378.webp?v=1765933237707",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-378",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 3",
    img: "/assets/Casino/EVOLUTION-LIVE-379.webp?v=1765933237708",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-379",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 4",
    img: "/assets/Casino/EVOLUTION-LIVE-380.webp?v=1765933237708",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-380",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 5",
    img: "/assets/Casino/EVOLUTION-LIVE-381.webp?v=1765933237710",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-381",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 6",
    img: "/assets/Casino/EVOLUTION-LIVE-382.webp?v=1765933237711",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-382",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Pok Deng",
    img: "/assets/Casino/MX-LIVE-018.Pok Deng.webp?v=1764335053969",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-018",
    platFormCode: "SEXYBCRT",
  },
  {
    name: "Power Blackjack",
    img: "/assets/Casino/EVOLUTION-LIVE-016.webp?v=1765933237408",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-016",
    platFormCode: "EVOLUTION",
  },
  {
    name: "PowerUp Roulette",
    img: "/assets/Casino/PP-LIVE-055.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-055",
    platFormCode: "PP",
  },
  {
    name: "Privé Lounge Baccarat with Squeeze 1",
    img: "/assets/Casino/PP-LIVE-192.webp?v=1766711113592",
    platForm: "PP",
    type: "Casino",
  },
  {
    name: "Privé Lounge Roulette Deluxe",
    img: "/assets/Casino/PP-LIVE-184.Privé Lounge Roulette Deluxe.webp?v=1764408068820",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-184",
    platFormCode: "PP",
  },
  {
    name: "Prosperity Tree Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-245.webp?v=1765933237620",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-245",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Punto Banco Soirée Gold",
    img: "/assets/Casino/PT-LIVE-125.webp?v=1761307036357",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-125",
    platFormCode: "PT",
  },
  {
    name: "Quantum Auto Roulette",
    img: "/assets/Casino/PT-LIVE-026.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-026",
    platFormCode: "PT",
  },
  {
    name: "Quantum Roulette Live",
    img: "/assets/Casino/PT-LIVE-067.webp?v=1761376238370",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-067",
    platFormCode: "PT",
  },
  {
    name: "Quantum Ruleta España",
    img: "/assets/Casino/PT-LIVE-079.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-079",
    platFormCode: "PT",
  },
  {
    name: "Race Track A",
    img: "/assets/Casino/EVOLUTION-LIVE-427.webp?v=1765933237731",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-427",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Red Door Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-257.webp?v=1765933237630",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-257",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Rocket HiLo Baccarat",
    img: "/assets/Casino/VIACASINO-LIVE-016.rocket-hilo-baccarat.webp?v=1765267618051",
    platForm: "VIACASINO",
    type: "Casino",
  },
  {
    name: "Roleta Brasileira",
    img: "/assets/Casino/PT-LIVE-059.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-059",
    platFormCode: "PT",
  },
  {
    name: "Romanian Roulette",
    img: "/assets/Casino/PP-LIVE-048.Romanian Roulett.webp?v=1764408006250",
    platForm: "PP",
    type: "Casino",
  },
  {
    name: "Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-001.webp?v=1765933237384",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-001",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Roulette",
    img: "/assets/Casino/HOTROAD-LIVE-002.webp?v=1751418030552",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-002",
    platFormCode: "HOTROAD",
  },
  {
    name: "Roulette",
    img: "/assets/Casino/MX-LIVE-009.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-009",
    platFormCode: "SEXYBCRT",
  },
  {
    name: "Roulette",
    img: "/assets/Casino/PT-LIVE-032.webp?v=1761380364511",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-032",
    platFormCode: "PT",
  },
  {
    name: "Roulette 1",
    img: "/assets/Casino/PP-LIVE-028.Roulette 1.webp?v=1764407962916",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-028",
    platFormCode: "PP",
  },
  {
    name: "Roulette 2 Extra Time",
    img: "/assets/Casino/PP-LIVE-029.Roulette 2 Extra Time.webp?v=1764407909678",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-029",
    platFormCode: "PP",
  },
  {
    name: "Roulette A11",
    img: "/assets/Casino/DREAMGAMING-LIVE-027.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Roulette D21",
    img: "/assets/Casino/DREAMGAMING-LIVE-016.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Roulette Italia Tricolore",
    img: "/assets/Casino/PP-LIVE-032.Roulette Italia Tricolore.webp?v=1764407826039",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-032",
    platFormCode: "PP",
  },
  {
    name: "Roulette Italiana",
    img: "/assets/Casino/PT-LIVE-060.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-060",
    platFormCode: "PT",
  },
  {
    name: "Roulette Latina",
    img: "/assets/Casino/PP-LIVE-053.Roulette Latina.webp?v=1764407778108",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-053",
    platFormCode: "PP",
  },
  {
    name: "Roulette Macao",
    img: "/assets/Casino/PP-LIVE-034.Roulette Macao.webp?v=1764407636914",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-034",
    platFormCode: "PP",
  },
  {
    name: "Roulette Ruby",
    img: "/assets/Casino/PP-LIVE-037.Roulette Ruby.webp?v=1764838203349",
    platForm: "PP",
    type: "Casino",
  },
  {
    name: "Roulette-SEXY hall",
    img: "/assets/Casino/MX-LIVE-009_SEXY.webp?v=1761310711498",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Roulette-SEXY hall-Table1",
    img: "/assets/Casino/MX-LIVE-009_SEXY_71.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Ru Yi Speed Baccarat NC",
    img: "/assets/Casino/PT-LIVE-094.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-094",
    platFormCode: "PT",
  },
  {
    name: "Ruleta Automatica Cuantica",
    img: "/assets/Casino/PT-LIVE-077.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-077",
    platFormCode: "PT",
  },
  {
    name: "Russian Roulette",
    img: "/assets/Casino/PP-LIVE-030.Russian Roulette.webp?v=1764407491013",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-030",
    platFormCode: "PP",
  },
  {
    name: "Ruyi French Roulette",
    img: "/assets/Casino/PT-LIVE-080.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-080",
    platFormCode: "PT",
  },
  {
    name: "Ruyi Roulette",
    img: "/assets/Casino/PT-LIVE-081.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-081",
    platFormCode: "PT",
  },
  {
    name: "Salon Privé Baccarat A",
    img: "/assets/Casino/EVOLUTION-LIVE-125.webp?v=1765933237500",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-125",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-124.webp?v=1765933237499",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-124",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat C",
    img: "/assets/Casino/EVOLUTION-LIVE-126.webp?v=1765933237501",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-126",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat D",
    img: "/assets/Casino/EVOLUTION-LIVE-127.webp?v=1765933237502",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-127",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat E",
    img: "/assets/Casino/EVOLUTION-LIVE-128.webp?v=1765933237503",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-128",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat F",
    img: "/assets/Casino/EVOLUTION-LIVE-129.webp?v=1765933237503",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-129",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat G",
    img: "/assets/Casino/EVOLUTION-LIVE-121.webp?v=1765933237496",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-121",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat H",
    img: "/assets/Casino/EVOLUTION-LIVE-130.webp?v=1765933237504",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-130",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat I",
    img: "/assets/Casino/EVOLUTION-LIVE-131.webp?v=1765933237505",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-131",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat J",
    img: "/assets/Casino/EVOLUTION-LIVE-132.webp?v=1765933237506",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-132",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat K",
    img: "/assets/Casino/EVOLUTION-LIVE-236.webp?v=1765933237611",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-236",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat L",
    img: "/assets/Casino/EVOLUTION-LIVE-237.webp?v=1765933237612",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-237",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat M",
    img: "/assets/Casino/EVOLUTION-LIVE-271.webp?v=1765933237645",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-271",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat N",
    img: "/assets/Casino/EVOLUTION-LIVE-272.webp?v=1765933237646",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-272",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack A",
    img: "/assets/Casino/EVOLUTION-LIVE-215.webp?v=1765933237591",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-215",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack B",
    img: "/assets/Casino/EVOLUTION-LIVE-216.webp?v=1765933237592",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-216",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack C",
    img: "/assets/Casino/EVOLUTION-LIVE-217.webp?v=1765933237593",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-217",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack D",
    img: "/assets/Casino/EVOLUTION-LIVE-218.webp?v=1765933237594",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-218",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack E",
    img: "/assets/Casino/EVOLUTION-LIVE-219.webp?v=1765933237595",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-219",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack F",
    img: "/assets/Casino/EVOLUTION-LIVE-220.webp?v=1765933237595",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-220",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack G",
    img: "/assets/Casino/EVOLUTION-LIVE-221.webp?v=1765933237596",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-221",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack H",
    img: "/assets/Casino/EVOLUTION-LIVE-222.webp?v=1765933237597",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-222",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack I",
    img: "/assets/Casino/EVOLUTION-LIVE-223.webp?v=1765933237598",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-223",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack J",
    img: "/assets/Casino/EVOLUTION-LIVE-224.webp?v=1765933237599",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-224",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack K",
    img: "/assets/Casino/EVOLUTION-LIVE-365.webp?v=1765933237696",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-365",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack L",
    img: "/assets/Casino/EVOLUTION-LIVE-366.webp?v=1765933237697",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-366",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack M",
    img: "/assets/Casino/EVOLUTION-LIVE-367.webp?v=1765933237698",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-367",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack N",
    img: "/assets/Casino/EVOLUTION-LIVE-368.webp?v=1765933237698",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-368",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack O",
    img: "/assets/Casino/EVOLUTION-LIVE-386.webp?v=1765933237713",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-386",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Salon Privé Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-081.webp?v=1765933237462",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-081",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Sedie",
    img: "/assets/Casino/MX-LIVE-017.webp?v=1770809156289",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-017",
    platFormCode: "SEXYBCRT",
  },
  {
    name: "Sedie A13",
    img: "/assets/Casino/DREAMGAMING-LIVE-028.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Sedie V03",
    img: "/assets/Casino/DREAMGAMING-LIVE-083.sedie.webp?v=1764343335462",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Sedie V04",
    img: "/assets/Casino/DREAMGAMING-LIVE-084.sedie.webp?v=1764343107562",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Sette E Mezzo",
    img: "/assets/Casino/PT-LIVE-009.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-009",
    platFormCode: "PT",
  },
  {
    name: "Sexy Baccarat",
    img: "/assets/Casino/MX-LIVE-002.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Shangrila Baccarat 5",
    img: "/assets/Casino/WINFINITY-LIVE-016.Shangrila Baccarat 5.webp?v=1764400855116",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Shangrila Baccarat 6",
    img: "/assets/Casino/WINFINITY-LIVE-017.Shangrila Baccarat 6.webp?v=1762330568837",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Shangrila Baccarat 7",
    img: "/assets/Casino/WINFINITY-LIVE-028.Shangrila-Baccarat-7.webp?v=1764400796973",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Shangrila Baccarat 8",
    img: "/assets/Casino/WINFINITY-LIVE-029.Shangrila-Baccarat-8.webp?v=1764400763754",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Sic Bo",
    img: "/assets/Casino/PP-LIVE-079.Sic-Bo.webp?v=1764407444762",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-079",
    platFormCode: "PP",
  },
  {
    name: "Sic Bo",
    img: "/assets/Casino/WINFINITY-LIVE-033.Sic Bo.webp?v=1764400694436",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Sic Bo-SEXY hall",
    img: "/assets/Casino/MX-LIVE-016_SEXY.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Sic Bo-SEXY hall-Table1",
    img: "/assets/Casino/MX-LIVE-016_SEXY_51.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "SicBo Deluxe",
    img: "/assets/Casino/PT-LIVE-003.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-003",
    platFormCode: "PT",
  },
  {
    name: "Sicbo A12",
    img: "/assets/Casino/DREAMGAMING-LIVE-069.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Sicbo D22",
    img: "/assets/Casino/DREAMGAMING-LIVE-017.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Site Baccarat C01",
    img: "/assets/Casino/DREAMGAMING-LIVE-030.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Site Baccarat C02",
    img: "/assets/Casino/DREAMGAMING-LIVE-031.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Site Baccarat C03",
    img: "/assets/Casino/DREAMGAMING-LIVE-032.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Site Baccarat C05",
    img: "/assets/Casino/DREAMGAMING-LIVE-033.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Site Baccarat C06",
    img: "/assets/Casino/DREAMGAMING-LIVE-054.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Site DragonTiger C07",
    img: "/assets/Casino/DREAMGAMING-LIVE-034.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Site Roulette C08",
    img: "/assets/Casino/DREAMGAMING-LIVE-035.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Slingshot Ruleta Espana",
    img: "/assets/Casino/PT-LIVE-083.Slingshot Ruleta Espana.webp?v=1764325902652",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-083",
    platFormCode: "PT",
  },
  {
    name: "Snakes & Ladders Live",
    img: "/assets/Casino/PP-LIVE-062.Snakes-&-Ladders-Live.webp?v=1764407402990",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-062",
    platFormCode: "PP",
  },
  {
    name: "Soirée Privée Blackjack",
    img: "/assets/Casino/PT-LIVE-114.webp?v=1761306884707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-114",
    platFormCode: "PT",
  },
  {
    name: "Speed 6 Scanner Baccarat",
    img: "/assets/Casino/PT-LIVE-035.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-035",
    platFormCode: "PT",
  },
  {
    name: "Speed 6 Scanner Baccarat NC",
    img: "/assets/Casino/PT-LIVE-038.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-038",
    platFormCode: "PT",
  },
  {
    name: "Speed Auto Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-212.webp?v=1765933237589",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-212",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Auto Roulette",
    img: "/assets/Casino/PT-LIVE-058.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-058",
    platFormCode: "PT",
  },
  {
    name: "Speed Auto-Roulette 1",
    img: "/assets/Casino/PP-LIVE-060.Speed Auto-Roulette 1.webp?v=1764407358457",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-060",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat",
    img: "/assets/Casino/VIACASINO-LIVE-002.speed-baccarat.webp?v=1765267564130",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-002",
    platFormCode: "VIACASINO",
  },
  {
    name: "Speed Baccarat",
    img: "/assets/Casino/PT-LIVE-109.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-109",
    platFormCode: "PT",
  },
  {
    name: "Speed Baccarat 1",
    img: "/assets/Casino/EVOLUTION-LIVE-159.webp?v=1765933237532",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-159",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat 1",
    img: "/assets/Casino/PP-LIVE-013.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-013",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 10",
    img: "/assets/Casino/PP-LIVE-021.Speed Baccarat 10.webp?v=1764407284309",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-021",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 11",
    img: "/assets/Casino/PP-LIVE-022.Speed Baccarat 11.webp?v=1764407188602",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-022",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 12",
    img: "/assets/Casino/PP-LIVE-023.Speed Baccarat 12.webp?v=1764407088573",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-023",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 13",
    img: "/assets/Casino/PP-LIVE-024.Speed Baccarat 13.webp?v=1764407013590",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-024",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 14",
    img: "/assets/Casino/PP-LIVE-003.Speed Baccarat 14.webp?v=1764406902947",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-003",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 15",
    img: "/assets/Casino/PP-LIVE-008.Speed Baccarat 15.webp?v=1764406831103",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-008",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 16",
    img: "/assets/Casino/PP-LIVE-050.Speed Baccarat 16.webp?v=1764406748184",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-050",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 17",
    img: "/assets/Casino/PP-LIVE-051.Speed Baccarat 17.webp?v=1764406687633",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-051",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 2",
    img: "/assets/Casino/EVOLUTION-LIVE-160.webp?v=1765933237532",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-160",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat 2",
    img: "/assets/Casino/PP-LIVE-014.Speed Baccarat 2.webp?v=1764406599562",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-014",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 2",
    img: "/assets/Casino/PT-LIVE-145.webp?v=1752129354309",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-145",
    platFormCode: "PT",
  },
  {
    name: "Speed Baccarat 3",
    img: "/assets/Casino/EVOLUTION-LIVE-161.webp?v=1765933237533",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-161",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat 3",
    img: "/assets/Casino/PP-LIVE-015.Speed Baccarat 3.webp?v=1764406523845",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-015",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 5",
    img: "/assets/Casino/PP-LIVE-016.Speed Baccarat 5.webp?v=1764406450165",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-016",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 6",
    img: "/assets/Casino/PP-LIVE-017.Speed Baccarat 6.webp?v=1764406386518",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-017",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 7",
    img: "/assets/Casino/PP-LIVE-018.Speed Baccarat 7.webp?v=1764406323554",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-018",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 8",
    img: "/assets/Casino/PP-LIVE-019.Speed Baccarat 8.webp?v=1764406263608",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-019",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 9",
    img: "/assets/Casino/PP-LIVE-020.Speed Baccarat 9.webp?v=1764406199816",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-020",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat A",
    img: "/assets/Casino/EVOLUTION-LIVE-145.webp?v=1765933237518",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-145",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-139.webp?v=1765933237512",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-139",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat C",
    img: "/assets/Casino/EVOLUTION-LIVE-146.webp?v=1765933237519",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-146",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat D",
    img: "/assets/Casino/EVOLUTION-LIVE-158.webp?v=1765933237531",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-158",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat E",
    img: "/assets/Casino/EVOLUTION-LIVE-148.webp?v=1765933237521",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-148",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat F",
    img: "/assets/Casino/EVOLUTION-LIVE-137.webp?v=1765933237510",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-137",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat G",
    img: "/assets/Casino/EVOLUTION-LIVE-154.webp?v=1765933237527",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-154",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat H",
    img: "/assets/Casino/EVOLUTION-LIVE-140.webp?v=1765933237513",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-140",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat I",
    img: "/assets/Casino/EVOLUTION-LIVE-138.webp?v=1765933237511",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-138",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat J",
    img: "/assets/Casino/EVOLUTION-LIVE-157.webp?v=1765933237529",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-157",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat L",
    img: "/assets/Casino/EVOLUTION-LIVE-155.webp?v=1765933237527",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-155",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat N",
    img: "/assets/Casino/EVOLUTION-LIVE-156.webp?v=1765933237528",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-156",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat Q",
    img: "/assets/Casino/EVOLUTION-LIVE-141.webp?v=1765933237514",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-141",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat R",
    img: "/assets/Casino/EVOLUTION-LIVE-162.webp?v=1765933237535",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-162",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat S",
    img: "/assets/Casino/EVOLUTION-LIVE-163.webp?v=1765933237535",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-163",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat T",
    img: "/assets/Casino/EVOLUTION-LIVE-164.webp?v=1765933237536",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-164",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat U",
    img: "/assets/Casino/EVOLUTION-LIVE-165.webp?v=1765933237537",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-165",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat V",
    img: "/assets/Casino/EVOLUTION-LIVE-166.webp?v=1765933237539",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-166",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat W",
    img: "/assets/Casino/EVOLUTION-LIVE-152.webp?v=1765933237525",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-152",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat X",
    img: "/assets/Casino/EVOLUTION-LIVE-143.webp?v=1765933237516",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-143",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Baccarat Z",
    img: "/assets/Casino/EVOLUTION-LIVE-167.webp?v=1765933237540",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-167",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-078.webp?v=1765933237460",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-078",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed Roulette 1",
    img: "/assets/Casino/PP-LIVE-027.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-027",
    platFormCode: "PP",
  },
  {
    name: "Speed Roulette 2",
    img: "/assets/Casino/PP-LIVE-054.Speed Roulette 2.webp?v=1764406085425",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-054",
    platFormCode: "PP",
  },
  {
    name: "Speed Roulette Latina",
    img: "/assets/Casino/PP-LIVE-191.webp?v=1766711113586",
    platForm: "PP",
    type: "Casino",
  },
  {
    name: "Speed SicBo",
    img: "/assets/Casino/PT-LIVE-099.webp?v=1761306824466",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-099",
    platFormCode: "PT",
  },
  {
    name: "Speed Super Sic Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-260.webp?v=1765933237633",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-260",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack A",
    img: "/assets/Casino/EVOLUTION-LIVE-191.webp?v=1765933237561",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-191",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack B",
    img: "/assets/Casino/EVOLUTION-LIVE-192.webp?v=1765933237562",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-192",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack C",
    img: "/assets/Casino/EVOLUTION-LIVE-193.webp?v=1765933237563",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-193",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack D",
    img: "/assets/Casino/EVOLUTION-LIVE-194.webp?v=1765933237564",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-194",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack E",
    img: "/assets/Casino/EVOLUTION-LIVE-195.webp?v=1765933237565",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-195",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack F",
    img: "/assets/Casino/EVOLUTION-LIVE-196.webp?v=1765933237569",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-196",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack G",
    img: "/assets/Casino/EVOLUTION-LIVE-197.webp?v=1765933237570",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-197",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack H",
    img: "/assets/Casino/EVOLUTION-LIVE-198.webp?v=1765933237570",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-198",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack I",
    img: "/assets/Casino/EVOLUTION-LIVE-199.webp?v=1765933237571",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-199",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack J",
    img: "/assets/Casino/EVOLUTION-LIVE-200.webp?v=1765933237572",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-200",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack K",
    img: "/assets/Casino/EVOLUTION-LIVE-201.webp?v=1765933237578",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-201",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack L",
    img: "/assets/Casino/EVOLUTION-LIVE-202.webp?v=1765933237579",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-202",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack M",
    img: "/assets/Casino/EVOLUTION-LIVE-203.webp?v=1765933237580",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-203",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack N",
    img: "/assets/Casino/EVOLUTION-LIVE-238.webp?v=1765933237613",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-238",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack Q",
    img: "/assets/Casino/EVOLUTION-LIVE-241.webp?v=1765933237616",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-241",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack R",
    img: "/assets/Casino/EVOLUTION-LIVE-242.webp?v=1765933237617",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-242",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Spin a Win",
    img: "/assets/Casino/PT-LIVE-015.Spin a Win.webp?v=1764324310005",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-015",
    platFormCode: "PT",
  },
  {
    name: "Spin a Win Wild Live",
    img: "/assets/Casino/PT-LIVE-088.webp?v=1761376163925",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-088",
    platFormCode: "PT",
  },
  {
    name: "Spread Bet Roulette",
    img: "/assets/Casino/PT-LIVE-027.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-027",
    platFormCode: "PT",
  },
  {
    name: "Squeeze Baccarat",
    img: "/assets/Casino/PP-LIVE-179.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-179",
    platFormCode: "PP",
  },
  {
    name: "Sticky Bandits Roulette Live",
    img: "/assets/Casino/PT-LIVE-128.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-128",
    platFormCode: "PT",
  },
  {
    name: "Stock Market",
    img: "/assets/Casino/EVOLUTION-LIVE-291.webp?v=1765933237661",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-291",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Stock Market A",
    img: "/assets/Casino/EVOLUTION-LIVE-292.webp?v=1770892628348",
    platForm: "EVOLUTION",
    type: "Casino",
  },
  {
    name: "Super 8 Baccarat",
    img: "/assets/Casino/PP-LIVE-045.Super 8 Baccarat.webp?v=1764405987916",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-045",
    platFormCode: "PP",
  },
  {
    name: "Super Andar Bahar",
    img: "/assets/Casino/EVOLUTION-LIVE-204.webp?v=1765933237580",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-204",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Super Color Game",
    img: "/assets/Casino/EVOLUTION-LIVE-435.webp?v=1765933237739",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-435",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Super Sic Bo",
    img: "/assets/Casino/EVOLUTION-LIVE-005.webp?v=1765933237398",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-005",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Super Speed Baccarat",
    img: "/assets/Casino/PT-LIVE-146.webp?v=1754449947683",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-146",
    platFormCode: "PT",
  },
  {
    name: "Super Speed Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-398.webp?v=1765933237716",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-398",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Super Speed Dragon Tiger",
    img: "/assets/Casino/EVOLUTION-LIVE-451.webp?v=1765933237749",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-451",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Super Trunfo (Football Blitz Top Card)",
    img: "/assets/Casino/PP-LIVE-123.Super-Trunfo.webp?v=1764405936060",
    platForm: "PP",
    type: "Casino",
  },
  {
    name: "Sweet Bonanza Candyland",
    img: "/assets/Casino/PP-LIVE-044.Sweet-Bonanza-CandyLand.webp?v=1764405889106",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-044",
    platFormCode: "PP",
  },
  {
    name: "Symphony Blackjack 1",
    img: "/assets/Casino/WINFINITY-LIVE-043.Symphony Blackjack 1.webp?v=1764854507006",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "TIGER BACCARAT",
    img: "/assets/Casino/HOTROAD-LIVE-011.TIGER BACCARAT.webp?v=1764337077277",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-011",
    platFormCode: "HOTROAD",
  },
  {
    name: "Tai Xiu",
    img: "/assets/Casino/VIACASINO-LIVE-009.tai-xiu.webp?v=1765267516086",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-009",
    platFormCode: "VIACASINO",
  },
  {
    name: "Tao Yuan Baccarat 1",
    img: "/assets/Casino/WINFINITY-LIVE-010.Tao Yuan Baccarat 1.webp?v=1764400580001",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Tao Yuan Baccarat 2",
    img: "/assets/Casino/WINFINITY-LIVE-011.Tao Yuan Baccarat 2.webp?v=1764400545420",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Tao Yuan Baccarat 3",
    img: "/assets/Casino/WINFINITY-LIVE-032.Tao Yuan Baccarat 3.webp?v=1764400488765",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Tao Yuan Baccarat 5",
    img: "/assets/Casino/WINFINITY-LIVE-012.Tao Yuan Baccarat 5.webp?v=1764400446904",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Tao Yuan Baccarat 6",
    img: "/assets/Casino/WINFINITY-LIVE-013.Tao Yuan Baccarat 6.webp?v=1764400405456",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Tao Yuan Baccarat 7",
    img: "/assets/Casino/WINFINITY-LIVE-014.Tao Yuan Baccarat 7.webp?v=1764400373034",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Tao Yuan Baccarat 8",
    img: "/assets/Casino/WINFINITY-LIVE-015.tao-yuan-bacarrat-8.webp?v=1764400320049",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Teen Patti",
    img: "/assets/Casino/EVOLUTION-LIVE-026.webp?v=1765933237415",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-026",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Texas Hold'em Bonus Poker",
    img: "/assets/Casino/EVOLUTION-LIVE-027.webp?v=1765933237416",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-027",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Thai Fish Prawn Crab",
    img: "/assets/Casino/MX-LIVE-015.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-015",
    platFormCode: "SEXYBCRT",
  },
  {
    name: "Thai Fish Prawn Crab-SEXY hall",
    img: "/assets/Casino/MX-LIVE-015_SEXY.webp?v=1761310921467",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Thai Fish Prawn Crab-SEXY hall-Table1",
    img: "/assets/Casino/MX-LIVE-015_SEXY_126.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Thai Hi Lo",
    img: "/assets/Casino/MX-LIVE-014.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "MX-LIVE-014",
    platFormCode: "SEXYBCRT",
  },
  {
    name: "Thai Hi Lo",
    img: "/assets/Casino/VIACASINO-LIVE-008.thai-hi-lo.webp?v=1765267465866",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-008",
    platFormCode: "VIACASINO",
  },
  {
    name: "Thai Hi Lo-SEXY hall",
    img: "/assets/Casino/MX-LIVE-014_SEXY.webp?v=1761310815167",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Thai Hi Lo-SEXY hall-Table1",
    img: "/assets/Casino/MX-LIVE-014_SEXY_121.webp?v=1751418030778",
    platForm: "SEXYBCRT",
    type: "Casino",
  },
  {
    name: "Thai Speed Baccarat 1",
    img: "/assets/Casino/PP-LIVE-069.Thai Speed Baccarat 1.webp?v=1764405812322",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-069",
    platFormCode: "PP",
  },
  {
    name: "Thai Speed Baccarat 2",
    img: "/assets/Casino/PP-LIVE-162.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-162",
    platFormCode: "PP",
  },
  {
    name: "Thai Speed Baccarat A",
    img: "/assets/Casino/EVOLUTION-LIVE-415.webp?v=1765933237723",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-415",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Thai Speed Baccarat B",
    img: "/assets/Casino/EVOLUTION-LIVE-432.webp?v=1765933237736",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-432",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Thai Speed Baccarat C",
    img: "/assets/Casino/EVOLUTION-LIVE-433.webp?v=1765933237737",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-433",
    platFormCode: "EVOLUTION",
  },
  {
    name: "The Bingo Spot",
    img: "/assets/Casino/PP-LIVE-076.webp?v=1766376295552",
    platForm: "PP",
    type: "Casino",
  },
  {
    name: "The Greatest Cards Show",
    img: "/assets/Casino/PT-LIVE-086.webp?v=1761376323607",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-086",
    platFormCode: "PT",
  },
  {
    name: "Three Face D20",
    img: "/assets/Casino/DREAMGAMING-LIVE-020.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "ThreeCard D19",
    img: "/assets/Casino/DREAMGAMING-LIVE-019.webp?v=1751418030499",
    platForm: "DREAMGAMING",
    type: "Casino",
  },
  {
    name: "Top Card",
    img: "/assets/Casino/WINFINITY-LIVE-020.top-card.webp?v=1764400256350",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Tornado Marbles",
    img: "/assets/Casino/VIACASINO-LIVE-026.tornado-marbles.webp?v=1765267414616",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-026",
    platFormCode: "VIACASINO",
  },
  {
    name: "Treasure Island",
    img: "/assets/Casino/PP-LIVE-078.webp?v=1754874264634",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-078",
    platFormCode: "PP",
  },
  {
    name: "Triple Card Poker",
    img: "/assets/Casino/EVOLUTION-LIVE-009.webp?v=1765933237402",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-009",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Turkish Mega Roulette",
    img: "/assets/Casino/PP-LIVE-081.Turkish Mega Roulette.webp?v=1764405709082",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-081",
    platFormCode: "PP",
  },
  {
    name: "Turkish Roulette",
    img: "/assets/Casino/PP-LIVE-033.Turkish Roulette.webp?v=1764405662503",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-033",
    platFormCode: "PP",
  },
  {
    name: "Turkish Roulette",
    img: "/assets/Casino/PT-LIVE-064.Turkish Roulette.webp?v=1764325786727",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-064",
    platFormCode: "PT",
  },
  {
    name: "Unlimited Blackjack",
    img: "/assets/Casino/PT-LIVE-010.webp?v=1751418030707",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-010",
    platFormCode: "PT",
  },
  {
    name: "VIP Auto Roulette",
    img: "/assets/Casino/WINFINITY-LIVE-008.vip-auto-roulette.webp?v=1764400173696",
    platForm: "WINFINITY",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-142",
    platFormCode: "PP",
  },
  {
    name: "VIP Auto Roulette",
    img: "/assets/Casino/PP-LIVE-142.VIP-Auto-Roulette.webp?v=1764405619143",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-142",
    platFormCode: "PP",
  },
  {
    name: "VIP Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-079.webp?v=1765933237460",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-079",
    platFormCode: "EVOLUTION",
  },
  {
    name: "VIP Roulette",
    img: "/assets/Casino/PP-LIVE-036.VIP Roulette.webp?v=1764405553904",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-036",
    platFormCode: "PP",
  },
  {
    name: "Venice Black Jack 2 (Private)",
    img: "/assets/Casino/WINFINITY-LIVE-003.venice-blackjack-2-private.webp?v=1762319638036",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Venice Black Jack 4",
    img: "/assets/Casino/WINFINITY-LIVE-002.venice-blackjack-4.webp?v=1764400128499",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Venice INSTANT Roulette",
    img: "/assets/Casino/WINFINITY-LIVE-042.Venice INSTANT Roulette.webp?v=1764400082946",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Venice Roulette",
    img: "/assets/Casino/WINFINITY-LIVE-005.venice-roulette.webp?v=1764400055801",
    platForm: "WINFINITY",
    type: "Casino",
  },
  {
    name: "Vietnamese Speed Baccarat 1",
    img: "/assets/Casino/PP-LIVE-115.Vietnamese Speed Baccarat 1.webp?v=1764405376312",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-115",
    platFormCode: "PP",
  },
  {
    name: "Vietnamese Speed Baccarat 2",
    img: "/assets/Casino/PP-LIVE-174.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-174",
    platFormCode: "PP",
  },
  {
    name: "Vietnamese Speed Baccarat 3",
    img: "/assets/Casino/PP-LIVE-177.webp?v=1751418030744",
    platForm: "PP",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PP-LIVE-177",
    platFormCode: "PP",
  },
  {
    name: "War",
    img: "/assets/Casino/EVOLUTION-LIVE-431.webp?v=1765933237734",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-431",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Wealth SuperSix",
    img: "/assets/Casino/VIACASINO-LIVE-005.wealth-supersix.webp?v=1765267352125",
    platForm: "VIACASINO",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-005",
    platFormCode: "VIACASINO",
  },
  {
    name: "XXXtreme Lightning Roulette",
    img: "/assets/Casino/EVOLUTION-LIVE-205.webp?v=1765933237581",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-205",
    platFormCode: "EVOLUTION",
  },
  {
    name: "XXXtreme lightning Baccarat",
    img: "/assets/Casino/EVOLUTION-LIVE-255.webp?v=1765933237628",
    platForm: "EVOLUTION",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-255",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Xoc Dia",
    img: "/assets/Casino/HOTROAD-LIVE-010.webp?v=1751418030552",
    platForm: "HOTROAD",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "HOTROAD-LIVE-010",
    platFormCode: "HOTROAD",
  },
  {
    name: "x1000 Quantum Roulette",
    img: "/assets/Casino/PT-LIVE-102.webp?v=1761376394380",
    platForm: "PT",
    type: "Casino",
    gameType: "LIVE",
    casinoType: "PT-LIVE-102",
    platFormCode: "PT",
  },
];
export const SlotNew = [
  {
    name: "SUPER ELEMENTS",
    img: "/assets/Slot/FC-SLOT-049.webp?v=1770273832253",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-033",
    platFormCode: "FC",
  },
  {
    name: "Fortune Ace Super Scatter",
    img: "/assets/Slot/PP-SLOT-598.Fortune Ace Super Scatter.webp?v=1768297807931",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-598",
    platFormCode: "PP",
  },
  {
    name: "SUPER ELEMENTS",
    img: "/assets/Slot/FC-SLOT-033.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-033",
    platFormCode: "FC",
  },
  {
    name: "Safari King",
    img: "/assets/Slot/JILI-SLOT-154.Safari King.webp?v=1764310843843",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-154",
    platFormCode: "JILI",
  },
  {
    name: "Super Ace",
    img: "/assets/Slot/JILI-SLOT-027.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
    platFormCode: "JILI",
  },
  {
    name: "Big Bass Christmas - Frozen Lake",
    img: "/assets/Slot/PP-SLOT-612.Big Bass Christmas - Frozen Lake.webp?v=1764398422437",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-612",
    platFormCode: "PP",
  },
  {
    name: "GOLDEN GENIE",
    img: "/assets/Slot/FC-SLOT-028.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-028",
    platFormCode: "FC",
  },
  {
    name: "Boxing King",
    img: "/assets/Slot/JILI-SLOT-031.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-031",
    platFormCode: "JILI",
  },
  {
    name: "Mermaid's Treasure Trove",
    img: "/assets/Slot/PP-SLOT-602.Mermaid_s Treasure Trove.webp?v=1764331938706",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-602",
    platFormCode: "PP",
  },
  {
    name: "TREASURE RAIDERS",
    img: "/assets/Slot/FC-SLOT-024.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-024",
    platFormCode: "FC",
  },
  {
    name: "CHINESE NEW YEAR MOREWAYS",
    img: "/assets/Slot/FC-SLOT-043.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-043",
    platFormCode: "FC",
  },
  {
    name: "Gates of Olympus Super Scatter",
    img: "/assets/Slot/PP-SLOT-562.webp?v=1755572377209",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-562",
    platFormCode: "PP",
  },
  {
    name: "Super Ace Deluxe",
    img: "/assets/Slot/JILI-SLOT-102.webp?v=1755510499511",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-102",
    platFormCode: "JILI",
  },
  {
    name: "SUGAR BANG BANG 2",
    img: "/assets/Slot/FC-SLOT-048.webp?v=1753170620713",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-048",
    platFormCode: "FC",
  },
  {
    name: "Super Ace Speed",
    img: "/assets/Slot/JILI-SLOT-142.webp?v=1761895788159",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-142",
    platFormCode: "JILI",
  },
  {
    name: "Sweet Bonanza Super Scatter",
    img: "/assets/Slot/PP-SLOT-586.Sweet Bonanza Super Scatter.webp?v=1764322022550",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-586",
    platFormCode: "PP",
  },
  {
    name: "GRAND BLUE",
    img: "/assets/Slot/FC-SLOT-023.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-023",
    platFormCode: "FC",
  },
  {
    name: "Gates of Olympus",
    img: "/assets/Slot/PP-SLOT-002.Gates of Olympus.webp?v=1764386148493",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-002",
    platFormCode: "PP",
  },
  {
    name: "Money Coming",
    img: "/assets/Slot/JILI-SLOT-029.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-029",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Gems 2",
    img: "/assets/Slot/JILI-SLOT-076.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-076",
    platFormCode: "JILI",
  },
  {
    name: "SUGAR BANG BANG",
    img: "/assets/Slot/FC-SLOT-025.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-025",
    platFormCode: "FC",
  },
  {
    name: "Fortune Gems 3",
    img: "/assets/Slot/JILI-SLOT-096.webp?v=1755510394735",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-096",
    platFormCode: "JILI",
  },
  {
    name: "QUEEN OF INCA",
    img: "/assets/Slot/FC-SLOT-040.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-040",
    platFormCode: "FC",
  },
  {
    name: "CRAZY BUFFALO",
    img: "/assets/Slot/FC-SLOT-026.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-026",
    platFormCode: "FC",
  },
  {
    name: "Fortune Gems",
    img: "/assets/Slot/JILI-SLOT-043.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-043",
    platFormCode: "JILI",
  },
  {
    name: "CHILIHUAHUA",
    img: "/assets/Slot/FC-SLOT-036.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-036",
    platFormCode: "FC",
  },
  {
    name: "Crazy777",
    img: "/assets/Slot/JILI-SLOT-014.webp?v=1755509218609",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-014",
    platFormCode: "JILI",
  },
  {
    name: "Zeus' Lightning Power Reels",
    img: "/assets/Slot/RT-SLOT-110.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-110",
    platFormCode: "RT",
  },
  {
    name: "10 Sparkling Crown",
    img: "/assets/Slot/JILI-SLOT-133.10-sparkling-crown.webp?v=1764311680540",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-133",
    platFormCode: "JILI",
  },
  {
    name: "10,000 Wonders",
    img: "/assets/Slot/RELAX-SLOT-091.webp?v=1761884901148",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-091",
    platFormCode: "RELAX",
  },
  {
    name: "10000 BC 2 DoubleMax",
    img: "/assets/Slot/YGG-SLOT-308.webp?v=1767056428809",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-308",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "10000 BC DoubleMax",
    img: "/assets/Slot/YGG-SLOT-211.webp?v=1767056428559",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-211",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "10000 Years Before Cash",
    img: "/assets/Slot/RELAX-SLOT-248.webp?v=1761884942485",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-248",
    platFormCode: "RELAX",
  },
  {
    name: "10001 Nights",
    img: "/assets/Slot/RT-SLOT-107.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-107",
    platFormCode: "RT",
  },
  {
    name: "101 Candies",
    img: "/assets/Slot/NETENT-SLOT-177.101-candies.webp?v=1764962805178",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-177",
    platFormCode: "NETENT",
  },
  {
    name: "10x Rewind",
    img: "/assets/Slot/YGG-SLOT-081.webp?v=1767056428423",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-081",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "12 Treasures: Aztec Riches",
    img: "/assets/Slot/OCTOPLAY-SLOT-067.12 Treasures of Actec Riches.webp?v=1764929679046",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-067",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "12 Trojan Mysteries",
    img: "/assets/Slot/YGG-SLOT-067.webp?v=1767056428404",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-067",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "123 Boom!",
    img: "/assets/Slot/RELAX-SLOT-002.webp?v=1761884984096",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-002",
    platFormCode: "RELAX",
  },
  {
    name: "1942: Sky Warrior",
    img: "/assets/Slot/RT-SLOT-221.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-221",
    platFormCode: "RT",
  },
  {
    name: "1c JuFuNaCai-Blooming Riches",
    img: "/assets/Slot/CG-SLOT-016.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-016",
    platFormCode: "CG",
  },
  {
    name: "1c JuFuNaCai-Eternal Diamond",
    img: "/assets/Slot/CG-SLOT-014.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-014",
    platFormCode: "CG",
  },
  {
    name: "1c JuFuNaCai-Fountain Of Wealth",
    img: "/assets/Slot/CG-SLOT-015.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-015",
    platFormCode: "CG",
  },
  {
    name: "1c JuFuNaCai-Golden Tale",
    img: "/assets/Slot/CG-SLOT-013.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-013",
    platFormCode: "CG",
  },
  {
    name: "1c JuFuNaCai-Rhythm Of Fortune",
    img: "/assets/Slot/CG-SLOT-017.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-017",
    platFormCode: "CG",
  },
  {
    name: "1c dafudacai-5Treasures",
    img: "/assets/Slot/CG-SLOT-007.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-007",
    platFormCode: "CG",
  },
  {
    name: "1c dafudacai-88Fortunes",
    img: "/assets/Slot/CG-SLOT-008.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-008",
    platFormCode: "CG",
  },
  {
    name: "1c dafudacai-DancingDrum",
    img: "/assets/Slot/CG-SLOT-010.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-010",
    platFormCode: "CG",
  },
  {
    name: "1c dafudacai-DiamondEternity",
    img: "/assets/Slot/CG-SLOT-009.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-009",
    platFormCode: "CG",
  },
  {
    name: "1c dafudacai-FlowerOfRiches",
    img: "/assets/Slot/CG-SLOT-011.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-011",
    platFormCode: "CG",
  },
  {
    name: "2 Fast 2 Fruity",
    img: "/assets/Slot/YGG-SLOT-326.webp?v=1767056428826",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-326",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "2 Sweet 4 U",
    img: "/assets/Slot/YGG-SLOT-291.webp?v=1767056428795",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-291",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "20 Stars Ablaze",
    img: "/assets/Slot/PT-SLOT-450.webp?v=1756275771665",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-450",
    platFormCode: "PT",
  },
  {
    name: "20 Times Casino",
    img: "/assets/Slot/YGG-SLOT-365.webp?v=1767056428872",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-365",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "21 Thor Lightning Ways",
    img: "/assets/Slot/RELAX-SLOT-216.webp?v=1761885013844",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-216",
    platFormCode: "RELAX",
  },
  {
    name: "24 Hour Grand Prix",
    img: "/assets/Slot/RT-SLOT-114.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-114",
    platFormCode: "RT",
  },
  {
    name: "24k Gold JailBreak",
    img: "/assets/Slot/YGG-SLOT-281.webp?v=1767056428787",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-281",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "24k Gold ShamRock On!",
    img: "/assets/Slot/YGG-SLOT-335.webp?v=1767056428834",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-335",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "28 Mansions",
    img: "/assets/Slot/PT-SLOT-186.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-186",
    platFormCode: "PT",
  },
  {
    name: "3 Bears",
    img: "/assets/Slot/RELAX-SLOT-270.webp?v=1761885041590",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-270",
    platFormCode: "RELAX",
  },
  {
    name: "3 Buzzing Wilds",
    img: "/assets/Slot/PP-SLOT-365.3-Buzzing-Wilds.webp?v=1764402281497",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-365",
    platFormCode: "PP",
  },
  {
    name: "3 Charge Buffalo",
    img: "/assets/Slot/JILI-SLOT-131.webp?v=1755510941053",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-131",
    platFormCode: "JILI",
  },
  {
    name: "3 Coin Golden OX",
    img: "/assets/Slot/JILI-SLOT-165.webp?v=1769054172936",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "TADA-SLOT-058",
    platFormCode: "TADA",
  },
  {
    name: "3 Coin Treasures",
    img: "/assets/Slot/JILI-SLOT-101.webp?v=1755510476242",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-101",
    platFormCode: "JILI",
  },
  {
    name: "3 Coin Treasures 2",
    img: "/assets/Slot/JILI-SLOT-134.webp?v=1755510967830",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-134",
    platFormCode: "JILI",
  },
  {
    name: "3 Coin Wild Horse",
    img: "/assets/Slot/JILI-SLOT-126.webp?v=1755510896701",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-126",
    platFormCode: "JILI",
  },
  {
    name: "3 Dancing Monkeys",
    img: "/assets/Slot/PP-SLOT-334.3-Dancing-Monkey.webp?v=1764402212166",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-334",
    platFormCode: "PP",
  },
  {
    name: "3 Energy Diamonds: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-100.Energy Diamonds Hold & Win.webp?v=1764929703134",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-100",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "3 Genie Wishes",
    img: "/assets/Slot/PP-SLOT-133.3-Genie-Wishes.webp?v=1764402147168",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-133",
    platFormCode: "PP",
  },
  {
    name: "3 Gladiators vs Caesar",
    img: "/assets/Slot/YGG-SLOT-297.webp?v=1767056428800",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-297",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "3 Gods Unleashed: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-120.webp?v=1767778776453",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-120",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "3 Golden Baskets: Treasure Tides",
    img: "/assets/Slot/OCTOPLAY-SLOT-091.3 Golden Baskets Treasure Tides.webp?v=1764929721923",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-091",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "3 Kingdoms - Battle of Red Cliffs",
    img: "/assets/Slot/PP-SLOT-126.3-Kingdoms.webp?v=1764402096729",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-126",
    platFormCode: "PP",
  },
  {
    name: "3 LUCKY LION",
    img: "/assets/Slot/JILI-SLOT-140.3-lucky-lion.webp?v=1764311540574",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-140",
    platFormCode: "JILI",
  },
  {
    name: "3 Lucky Baozhu",
    img: "/assets/Slot/JILI-SLOT-168.webp?v=1770775159492",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-168",
    platFormCode: "JILI",
  },
  {
    name: "3 Lucky Leprechauns",
    img: "/assets/Slot/YGG-SLOT-182.webp?v=1767056428520",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-182",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "3 Lucky Piggy",
    img: "/assets/Slot/JILI-SLOT-109.webp?v=1755510688898",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-109",
    platFormCode: "JILI",
  },
  {
    name: "3 Lucky Witches",
    img: "/assets/Slot/YGG-SLOT-222.webp?v=1767056428568",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-222",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "3 Mummy Treasures",
    img: "/assets/Slot/JILI-SLOT-159.3 Mummy Treasures.webp?v=1764311913126",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-159",
    platFormCode: "JILI",
  },
  {
    name: "3 Pot Dragons",
    img: "/assets/Slot/JILI-SLOT-106.webp?v=1755510584279",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-106",
    platFormCode: "JILI",
  },
  {
    name: "3 Pyramids of Gold: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-088.Pyramids of Gold Hold & Win.webp?v=1764929806188",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-088",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "3 Rail Express: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-114.Rail Express Hold & Win.webp?v=1764929842202",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-114",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "3 Secret Cities",
    img: "/assets/Slot/RELAX-SLOT-059.webp?v=1761885077201",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-059",
    platFormCode: "RELAX",
  },
  {
    name: "3 Witch's Lamp",
    img: "/assets/Slot/JILI-SLOT-164.webp?v=1768442346371",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "TADA-SLOT-054",
    platFormCode: "TADA",
  },
  {
    name: "3 Wonders Monster Pays",
    img: "/assets/Slot/YGG-SLOT-415.webp?v=1767056428923",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-415",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "3 Wonders New year Carnival",
    img: "/assets/Slot/YGG-SLOT-322.webp?v=1767056428823",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-322",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "3 Wonders Zoo",
    img: "/assets/Slot/YGG-SLOT-423.webp?v=1767056428931",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-423",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4 Crazy Cluckers",
    img: "/assets/Slot/PT-SLOT-471.4 Crazy Cluckers.webp?v=1764941193690",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-471",
    platFormCode: "PT",
  },
  {
    name: "4 Deals With The Devil",
    img: "/assets/Slot/RELAX-SLOT-138.webp?v=1761885144941",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-138",
    platFormCode: "RELAX",
  },
  {
    name: "4 Fantastic Fish",
    img: "/assets/Slot/YGG-SLOT-141.webp?v=1767056428475",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-141",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4 Fantastic Fish Amazon Adventure",
    img: "/assets/Slot/YGG-SLOT-361.webp?v=1767056428869",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-361",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4 Fantastic Fish Gigablox",
    img: "/assets/Slot/YGG-SLOT-241.webp?v=1767056428592",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-241",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4 Fantastic Fish In Egypt",
    img: "/assets/Slot/YGG-SLOT-196.webp?v=1767056428544",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-196",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4 Fantastic Vikings Go Fishing",
    img: "/assets/Slot/YGG-SLOT-296.webp?v=1767056428799",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-296",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4 Leaf Fortune: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-098.Leaf Fortune Hold & Win.webp?v=1764929906050",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-098",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "4 Secret Pyramids",
    img: "/assets/Slot/RELAX-SLOT-130.webp?v=1761885181602",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-130",
    platFormCode: "RELAX",
  },
  {
    name: "4 Squad",
    img: "/assets/Slot/RT-SLOT-111.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-111",
    platFormCode: "RT",
  },
  {
    name: "4 Wolves of Fortune",
    img: "/assets/Slot/YGG-SLOT-397.webp?v=1767056428906",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-397",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "40 Crown Hotfire",
    img: "/assets/Slot/YGG-SLOT-394.webp?v=1767056428902",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-394",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "40 Sparkling Crown",
    img: "/assets/Slot/JILI-SLOT-145.40 Sparkling Crown.webp?v=1764311460451",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-145",
    platFormCode: "JILI",
  },
  {
    name: "4K Ultra Gold",
    img: "/assets/Slot/YGG-SLOT-252.webp?v=1767056428757",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-252",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "4TP Guns N’ Gold",
    img: "/assets/Slot/YGG-SLOT-406.webp?v=1767056428916",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-406",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "5 Crown Hotfire",
    img: "/assets/Slot/YGG-SLOT-383.webp?v=1767056428889",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-383",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "5 Dealers",
    img: "/assets/Slot/CG-SLOT-049.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-049",
    platFormCode: "CG",
  },
  {
    name: "5 Doggy Dollars",
    img: "/assets/Slot/RELAX-SLOT-187.webp?v=1761885211705",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-187",
    platFormCode: "RELAX",
  },
  {
    name: "5 Dragons",
    img: "/assets/Slot/CG-SLOT-045.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-045",
    platFormCode: "CG",
  },
  {
    name: "5 Families",
    img: "/assets/Slot/RT-SLOT-115.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-115",
    platFormCode: "RT",
  },
  {
    name: "5 Fortune Dragons",
    img: "/assets/Slot/SG-SLOT-039.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-039",
    platFormCode: "SPADE",
  },
  {
    name: "5 Fortune SA",
    img: "/assets/Slot/SG-SLOT-030.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-030",
    platFormCode: "SPADE",
  },
  {
    name: "5 Frozen Charms Megaways",
    img: "/assets/Slot/PP-SLOT-418.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-418",
    platFormCode: "PP",
  },
  {
    name: "5 God Beast",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-021.5-god-beast.webp?v=1765277197394",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-021",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "5 Lions",
    img: "/assets/Slot/PP-SLOT-104.5-Lions.webp?v=1764402015890",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-104",
    platFormCode: "PP",
  },
  {
    name: "5 Lions Dance",
    img: "/assets/Slot/PP-SLOT-028.5-Lion-Dance.webp?v=1764401955657",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-028",
    platFormCode: "PP",
  },
  {
    name: "5 Lions Gold",
    img: "/assets/Slot/PP-SLOT-080.5-Lion-Gold.webp?v=1764401898249",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-080",
    platFormCode: "PP",
  },
  {
    name: "5 Lions Megaways",
    img: "/assets/Slot/PP-SLOT-183.5-Lions-Megaways.webp?v=1764401699587",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-183",
    platFormCode: "PP",
  },
  {
    name: "5 Lions Reborn",
    img: "/assets/Slot/PP-SLOT-559.webp?v=1755572137731",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-559",
    platFormCode: "PP",
  },
  {
    name: "5 Monsters",
    img: "/assets/Slot/RELAX-SLOT-192.webp?v=1761885278596",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-192",
    platFormCode: "RELAX",
  },
  {
    name: "5 Rabbits Megaways",
    img: "/assets/Slot/PP-SLOT-306.5-Rabbits-Megaways.webp?v=1764401616802",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-306",
    platFormCode: "PP",
  },
  {
    name: "5 Relics of Power: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-106.5 Relics of Power Hold & Win.webp?v=1764929922197",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-106",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "5 Rings of Darkness",
    img: "/assets/Slot/OCTOPLAY-SLOT-075.5 rings of Darkness.webp?v=1764929961059",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-075",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "5 Sevens Hold and Win",
    img: "/assets/Slot/YGG-SLOT-246.webp?v=1767056428596",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-246",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "5 Star Coins: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-072.5 Star Coins Hold & Win.webp?v=1764930001809",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-072",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "50 Jokers Hotfire",
    img: "/assets/Slot/YGG-SLOT-262.webp?v=1767056428770",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-262",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "50 Lions",
    img: "/assets/Slot/CG-SLOT-031.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-031",
    platFormCode: "CG",
  },
  {
    name: "5K Gold Mine",
    img: "/assets/Slot/RELAX-SLOT-174.webp?v=1761890083459",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-174",
    platFormCode: "RELAX",
  },
  {
    name: "6 Jokers",
    img: "/assets/Slot/PP-SLOT-477.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-477",
    platFormCode: "PP",
  },
  {
    name: "6 Wild Sharks",
    img: "/assets/Slot/RELAX-SLOT-001.webp?v=1761885411679",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-001",
    platFormCode: "RELAX",
  },
  {
    name: "60 Second Heist",
    img: "/assets/Slot/YGG-SLOT-133.webp?v=1767056428469",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-133",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "7 Clovers of Fortune",
    img: "/assets/Slot/PP-SLOT-507.7 Clovers of Fortune.webp?v=1764401416161",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-507",
    platFormCode: "PP",
  },
  {
    name: "7 Elements",
    img: "/assets/Slot/RELAX-SLOT-115.webp?v=1761885484956",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-115",
    platFormCode: "RELAX",
  },
  {
    name: "7 Gold Fruits",
    img: "/assets/Slot/RELAX-SLOT-253.webp?v=1761885526190",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-253",
    platFormCode: "RELAX",
  },
  {
    name: "7 Gold Gigablox",
    img: "/assets/Slot/YGG-SLOT-166.webp?v=1767056428504",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-166",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "7 Monkeys",
    img: "/assets/Slot/PP-SLOT-163.7-Monkeys.webp?v=1764401338230",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-163",
    platFormCode: "PP",
  },
  {
    name: "7 Piggies",
    img: "/assets/Slot/PP-SLOT-117.7-Piggies.webp?v=1764401273712",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-117",
    platFormCode: "PP",
  },
  {
    name: "7's Luck",
    img: "/assets/Slot/RT-SLOT-337.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-337",
    platFormCode: "RT",
  },
  {
    name: "777",
    img: "/assets/Slot/CG-SLOT-021.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-021",
    platFormCode: "CG",
  },
  {
    name: "777",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-003.777.webp?v=1765277143729",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-003",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "777 Diamond Strike",
    img: "/assets/Slot/RT-SLOT-352.webp?v=1753341328010",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-352",
    platFormCode: "RT",
  },
  {
    name: "777 FRUIT",
    img: "/assets/Slot/2J-SLOT-003.777 FRUIT.webp?v=1763551127538",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-003",
    platFormCode: "JJ",
  },
  {
    name: "777 Hot Reels",
    img: "/assets/Slot/OCTOPLAY-SLOT-055.777 Hot reels.webp?v=1764930054355",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-055",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "777 Hot Reels: Supercharged",
    img: "/assets/Slot/OCTOPLAY-SLOT-085.777 Hot Reels Supercharged.webp?v=1764930073726",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-085",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "777 Rush",
    img: "/assets/Slot/PP-SLOT-629.777 Rush.webp?v=1764401219579",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-629",
    platFormCode: "PP",
  },
  {
    name: "777 Streak",
    img: "/assets/Slot/OCTOPLAY-SLOT-083.777 Streak.webp?v=1764930114206",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-083",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "777 Streak: Supercharged",
    img: "/assets/Slot/OCTOPLAY-SLOT-123.777 Streak_ Supercharged.webp?v=1764930146368",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-123",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "777 Strike",
    img: "/assets/Slot/RT-SLOT-103.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-103",
    platFormCode: "RT",
  },
  {
    name: "777 Super Strike",
    img: "/assets/Slot/RT-SLOT-286.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-286",
    platFormCode: "RT",
  },
  {
    name: "777 Super Wheel: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-121.777 Super Wheel_ Hold & Win.webp?v=1764930169851",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-121",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "777 Volt",
    img: "/assets/Slot/YGG-SLOT-271.webp?v=1767056428778",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-271",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "7x7 Zeus",
    img: "/assets/Slot/YGG-SLOT-279.webp?v=1767056428785",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-279",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "8 Balls of Fire",
    img: "/assets/Slot/YGG-SLOT-223.webp?v=1767056428569",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-223",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "8 Balls of Fire Blazing Bounty",
    img: "/assets/Slot/YGG-SLOT-421.webp?v=1767056428929",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-421",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "8 Dragons",
    img: "/assets/Slot/PP-SLOT-125.8-Dragons.webp?v=1764401182645",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-125",
    platFormCode: "PP",
  },
  {
    name: "8 Golden Dragon Challenge",
    img: "/assets/Slot/PP-SLOT-379.8-Golden-Dragon-Challenge.webp?v=1764401122659",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-379",
    platFormCode: "PP",
  },
  {
    name: "80s Spins",
    img: "/assets/Slot/RT-SLOT-290.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-290",
    platFormCode: "RT",
  },
  {
    name: "88 FORTUNES",
    img: "/assets/Slot/2J-SLOT-026.88 FORTUNES.webp?v=1763551080411",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-026",
    platFormCode: "JJ",
  },
  {
    name: "88 Fortunes",
    img: "/assets/Slot/SlotFortunes.88 FORTUNES.webp?v=1764776971722",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-026",
    platFormCode: "JJ",
  },
  {
    name: "888",
    img: "/assets/Slot/SG-SLOT-069.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-069",
    platFormCode: "SPADE",
  },
  {
    name: "888 Bonanza",
    img: "/assets/Slot/PP-SLOT-391.888-Bonanza.webp?v=1764400994862",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-391",
    platFormCode: "PP",
  },
  {
    name: "888 Dragons",
    img: "/assets/Slot/PP-SLOT-167.888 Dragons.webp?v=1764400942135",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-167",
    platFormCode: "PP",
  },
  {
    name: "888 Gold",
    img: "/assets/Slot/PP-SLOT-169.888 Gold.webp?v=1764400873439",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-169",
    platFormCode: "PP",
  },
  {
    name: "8K Ultra Gold Ultimate",
    img: "/assets/Slot/YGG-SLOT-381.webp?v=1767056428887",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-381",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "9 Arrows of Odysseus",
    img: "/assets/Slot/YGG-SLOT-336.webp?v=1767056428835",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-336",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "90k Yeti Gigablox",
    img: "/assets/Slot/YGG-SLOT-073.webp?v=1767056428411",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-073",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "98 Bounty Hot 1",
    img: "/assets/Slot/RELAX-SLOT-113.webp?v=1761885559902",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-113",
    platFormCode: "RELAX",
  },
  {
    name: "9K Kong in Vegas",
    img: "/assets/Slot/RELAX-SLOT-149.webp?v=1761890173533",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-149",
    platFormCode: "RELAX",
  },
  {
    name: "9kYeti",
    img: "/assets/Slot/YGG-SLOT-001.webp?v=1767056428319",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-001",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "A Night Out",
    img: "/assets/Slot/P8-SLOT-015.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-015",
    platFormCode: "PLAY8",
  },
  {
    name: "A Night Out",
    img: "/assets/Slot/PT-SLOT-059.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-059",
    platFormCode: "PT",
  },
  {
    name: "ALMIGHTY GREEK",
    img: "/assets/Slot/KM-SLOT-007.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-007",
    platFormCode: "KINGMAKER",
  },
  {
    name: "ANIMAL RACING",
    img: "/assets/Slot/FC-SLOT-011.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-011",
    platFormCode: "FC",
  },
  {
    name: "ARRR! 10K Ways",
    img: "/assets/Slot/YGG-SLOT-144.webp?v=1767056428478",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-144",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Abrakadabra",
    img: "/assets/Slot/RELAX-SLOT-190.webp?v=1761889964654",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-190",
    platFormCode: "RELAX",
  },
  {
    name: "Absolutely Mammoth",
    img: "/assets/Slot/PT-SLOT-155.absolutely-mammoth.webp?v=1764330658822",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-155",
    platFormCode: "PT",
  },
  {
    name: "Adventure Trail",
    img: "/assets/Slot/PT-SLOT-198.Adventure Trail.webp?v=1764326677272",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-198",
    platFormCode: "PT",
  },
  {
    name: "Adventures Beyond Wonderland Magical Maze",
    img: "/assets/Slot/PT-SLOT-426.adventures-beyond-wonderland-magical-maze.webp?v=1764333041471",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-426",
    platFormCode: "PT",
  },
  {
    name: "Adventures of Captain Cash",
    img: "/assets/Slot/YGG-SLOT-343.webp?v=1767056428840",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-343",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "African Elephant",
    img: "/assets/Slot/PP-SLOT-335.African-Elephant.webp?v=1764400799182",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-335",
    platFormCode: "PP",
  },
  {
    name: "Age Of Akkadia",
    img: "/assets/Slot/RT-SLOT-131.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-131",
    platFormCode: "RT",
  },
  {
    name: "Age of Asgard",
    img: "/assets/Slot/YGG-SLOT-040.webp?v=1767056428366",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-040",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Age of Beasts Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-129.webp?v=1767056428466",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-129",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Age of Egypt",
    img: "/assets/Slot/PT-SLOT-113.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-113",
    platFormCode: "PT",
  },
  {
    name: "Agent Ace",
    img: "/assets/Slot/JILI-SLOT-048.webp?v=1755509687090",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-048",
    platFormCode: "JILI",
  },
  {
    name: "Agent Royale",
    img: "/assets/Slot/RT-SLOT-112.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-112",
    platFormCode: "RT",
  },
  {
    name: "Aladdin",
    img: "/assets/Slot/CG-SLOT-077.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-077",
    platFormCode: "CG",
  },
  {
    name: "Aladdin and the Sorcerer",
    img: "/assets/Slot/PP-SLOT-065.Aladdin-and-the-Sorcerer.webp?v=1764400551941",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-065",
    platFormCode: "PP",
  },
  {
    name: "Aladdin2",
    img: "/assets/Slot/CG-SLOT-087.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-087",
    platFormCode: "CG",
  },
  {
    name: "Alchemy Gold",
    img: "/assets/Slot/PG-SLOT-108.webp?v=1765933237834",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-108",
    platFormCode: "PG",
  },
  {
    name: "Alchymedes",
    img: "/assets/Slot/YGG-SLOT-029.webp?v=1767056428358",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-029",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Aldo's Journey",
    img: "/assets/Slot/YGG-SLOT-043.webp?v=1767056428370",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-043",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Alexander The Great World Conqueror",
    img: "/assets/Slot/RT-SLOT-245.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-245",
    platFormCode: "RT",
  },
  {
    name: "Ali Baba's Luck",
    img: "/assets/Slot/RT-SLOT-247.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-247",
    platFormCode: "RT",
  },
  {
    name: "Ali Baba's Luck Megaways",
    img: "/assets/Slot/RT-SLOT-291.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-291",
    platFormCode: "RT",
  },
  {
    name: "Ali Baba's Luck Power Reels",
    img: "/assets/Slot/RT-SLOT-292.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-292",
    platFormCode: "RT",
  },
  {
    name: "Alibaba",
    img: "/assets/Slot/JILI-SLOT-049.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-049",
    platFormCode: "JILI",
  },
  {
    name: "Alibaba's Cave of Fortune",
    img: "/assets/Slot/PG-SLOT-167.webp?v=1765933237890",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-167",
    platFormCode: "PG",
  },
  {
    name: "Alice",
    img: "/assets/Slot/CG-SLOT-068.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-068",
    platFormCode: "CG",
  },
  {
    name: "Alice In Lollyland",
    img: "/assets/Slot/YGG-SLOT-333.webp?v=1767056428832",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-333",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Alice In Wonderland",
    img: "/assets/Slot/6po7ddrpokbay.Alice-In-Wonderland.webp?v=1765037367701",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-004",
    platFormCode: "JOKER",
  },
  {
    name: "Alice in Adventureland",
    img: "/assets/Slot/RELAX-SLOT-114.webp?v=1761890321596",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-114",
    platFormCode: "RELAX",
  },
  {
    name: "Alien Invaders",
    img: "/assets/Slot/PP-SLOT-580.Alien Invaders.webp?v=1764400488487",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-580",
    platFormCode: "PP",
  },
  {
    name: "Amazing Circus",
    img: "/assets/Slot/CG-SLOT-004.Amazing Circus.webp?v=1764331473339",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-004",
    platFormCode: "CG",
  },
  {
    name: "Amazon Island Megaways",
    img: "/assets/Slot/RT-SLOT-293.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-293",
    platFormCode: "RT",
  },
  {
    name: "American Outlaws Multimax",
    img: "/assets/Slot/YGG-SLOT-307.webp?v=1767056428808",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-307",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Anaconda Uncoiled",
    img: "/assets/Slot/PT-SLOT-103.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-103",
    platFormCode: "PT",
  },
  {
    name: "Anaconda Wild",
    img: "/assets/Slot/PT-SLOT-120.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-120",
    platFormCode: "PT",
  },
  {
    name: "Anaconda Wild II",
    img: "/assets/Slot/PT-SLOT-179.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-179",
    platFormCode: "PT",
  },
  {
    name: "Ancient Artifact",
    img: "/assets/Slot/ie9eti6w4zfcs.Ancient-Artifact.webp?v=1765041252090",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-005",
    platFormCode: "JOKER",
  },
  {
    name: "Ancient Disco",
    img: "/assets/Slot/RT-SLOT-232.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-232",
    platFormCode: "RT",
  },
  {
    name: "Ancient Eclipse",
    img: "/assets/Slot/YGG-SLOT-007.webp?v=1767056428327",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-007",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Ancient Egypt",
    img: "/assets/Slot/PP-SLOT-112.Ancient-Egypt.webp?v=1764400426897",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-112",
    platFormCode: "PP",
  },
  {
    name: "Ancient Egypt Classic",
    img: "/assets/Slot/PP-SLOT-095.Ancient-Egypt-Classic.webp?v=1764400370161",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-095",
    platFormCode: "PP",
  },
  {
    name: "Ancient Rome Deluxe",
    img: "/assets/Slot/c96w4rytnamte.Ancient-Rome-Deluxe.webp?v=1765044599025",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-007",
    platFormCode: "JOKER",
  },
  {
    name: "Ancient Tumble",
    img: "/assets/Slot/RELAX-SLOT-251.webp?v=1761890346195",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-251",
    platFormCode: "RELAX",
  },
  {
    name: "Angel vs Sinner",
    img: "/assets/Slot/PP-SLOT-491.Angel-vs-Sinner.webp?v=1764400256243",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-491",
    platFormCode: "PP",
  },
  {
    name: "Animafia",
    img: "/assets/Slot/YGG-SLOT-227.webp?v=1767056428575",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-227",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Animal Carnival",
    img: "/assets/Slot/RELAX-SLOT-135.webp?v=1761890382703",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-135",
    platFormCode: "RELAX",
  },
  {
    name: "Anubis Wrath",
    img: "/assets/Slot/PG-SLOT-138.webp?v=1765933237860",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-138",
    platFormCode: "PG",
  },
  {
    name: "Apache Way",
    img: "/assets/Slot/RT-SLOT-187.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-187",
    platFormCode: "RT",
  },
  {
    name: "Aphrodite Goes Wild RushingWilds",
    img: "/assets/Slot/YGG-SLOT-290.webp?v=1767056428794",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-290",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Apocalypse Super xNudge®",
    img: "/assets/Slot/NLC-SLOT-092.Apocalypse Super xNudge®_.webp?v=1764392821391",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-092",
    platFormCode: "NLC",
  },
  {
    name: "Apollo Pays",
    img: "/assets/Slot/BTG-SLOT-001.webp?v=1756256536920",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-001",
    platFormCode: "BTG",
  },
  {
    name: "Arab",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-023.arab.webp?v=1765276995869",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-023",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Arc Of Zeus",
    img: "/assets/Slot/RT-SLOT-369.Arc Of Zeus.webp?v=1765033028902",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-369",
    platFormCode: "RT",
  },
  {
    name: "Arcadia",
    img: "/assets/Slot/CG-SLOT-023.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-023",
    platFormCode: "CG",
  },
  {
    name: "Archer",
    img: "/assets/Slot/PT-SLOT-073.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-073",
    platFormCode: "PT",
  },
  {
    name: "Arctic Catch",
    img: "/assets/Slot/YGG-SLOT-233.webp?v=1767056428584",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-233",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Arctic Sorcerer Gigablox",
    img: "/assets/Slot/YGG-SLOT-161.webp?v=1767056428492",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-161",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Arctic Treasure",
    img: "/assets/Slot/7rw3tfwz11kaw.Arctic-Treasure.webp?v=1765036450262",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-009",
    platFormCode: "JOKER",
  },
  {
    name: "Arena Fighter",
    img: "/assets/Slot/JILI-SLOT-092.webp?v=1761374566102",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-092",
    platFormCode: "JILI",
  },
  {
    name: "Argonauts",
    img: "/assets/Slot/PP-SLOT-587.Argonauts.webp?v=1764400177590",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-587",
    platFormCode: "PP",
  },
  {
    name: "Armageddon 10K Ways",
    img: "/assets/Slot/YGG-SLOT-264.webp?v=1767056428772",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-264",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Arowanas Luck",
    img: "/assets/Slot/PT-SLOT-002.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-002",
    platFormCode: "PT",
  },
  {
    name: "Arthur's Fortune",
    img: "/assets/Slot/YGG-SLOT-114.webp?v=1767056428451",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-114",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Artificial Girl",
    img: "/assets/Slot/CG-SLOT-064.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-064",
    platFormCode: "CG",
  },
  {
    name: "Arto And The Seven Deadly Spins",
    img: "/assets/Slot/RELAX-SLOT-104.webp?v=1761890690136",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-104",
    platFormCode: "RELAX",
  },
  {
    name: "As The Gods Will",
    img: "/assets/Slot/CG-SLOT-026.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-026",
    platFormCode: "CG",
  },
  {
    name: "Asgard",
    img: "/assets/Slot/PP-SLOT-103.Asgard.webp?v=1764399960768",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-103",
    platFormCode: "PP",
  },
  {
    name: "Asgardian Rising",
    img: "/assets/Slot/PG-SLOT-110.webp?v=1765933237837",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-110",
    platFormCode: "PG",
  },
  {
    name: "Asian Fantasy",
    img: "/assets/Slot/PT-SLOT-043.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-043",
    platFormCode: "PT",
  },
  {
    name: "Asian Fortune",
    img: "/assets/Slot/RT-SLOT-294.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-294",
    platFormCode: "RT",
  },
  {
    name: "Astronaut",
    img: "/assets/Slot/RT-SLOT-253.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-253",
    platFormCode: "RT",
  },
  {
    name: "Atlantis",
    img: "/assets/Slot/RT-SLOT-113.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-113",
    platFormCode: "RT",
  },
  {
    name: "Atlantis Cash Collect",
    img: "/assets/Slot/PT-SLOT-097.Atlantis Cash Collect.webp?v=1764328476196",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-097",
    platFormCode: "PT",
  },
  {
    name: "Atlantis Crush",
    img: "/assets/Slot/RELAX-SLOT-252.webp?v=1761890758100",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-252",
    platFormCode: "RELAX",
  },
  {
    name: "Atlantis Megaways",
    img: "/assets/Slot/RELAX-SLOT-092.webp?v=1761890890141",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-092",
    platFormCode: "RELAX",
  },
  {
    name: "Atlantis Megaways",
    img: "/assets/Slot/YGG-SLOT-003.webp?v=1767056428321",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-003",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Atocha Treasure",
    img: "/assets/Slot/CG-SLOT-109.Atocha Treasure.webp?v=1764665630733",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-109",
    platFormCode: "CG",
  },
  {
    name: "Attack of the Zombees WildEnergy",
    img: "/assets/Slot/YGG-SLOT-277.webp?v=1767056428783",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-277",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Attila The Hun",
    img: "/assets/Slot/RELAX-SLOT-234.webp?v=1761890920009",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-234",
    platFormCode: "RELAX",
  },
  {
    name: "Aurum Codex",
    img: "/assets/Slot/RT-SLOT-104.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-104",
    platFormCode: "RT",
  },
  {
    name: "Aussie vs Emus",
    img: "/assets/Slot/RELAX-SLOT-219.webp?v=1761891001838",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-219",
    platFormCode: "RELAX",
  },
  {
    name: "Avatars: Gateway Guardians",
    img: "/assets/Slot/YGG-SLOT-060.webp?v=1767056428398",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-060",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Aztec Ancients",
    img: "/assets/Slot/OCTOPLAY-SLOT-001.Aztec Ancients.webp?v=1764930252695",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-001",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Aztec Blaze",
    img: "/assets/Slot/PP-SLOT-296.Aztec-Blaze.webp?v=1764399900343",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-296",
    platFormCode: "PP",
  },
  {
    name: "Aztec Bonanza",
    img: "/assets/Slot/PP-SLOT-056.Aztec-Bonanza.webp?v=1764399842776",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-056",
    platFormCode: "PP",
  },
  {
    name: "Aztec Fortune",
    img: "/assets/Slot/KM-SLOT-022.Aztec Fortune.webp?v=1764860551830",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-022",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Aztec Gems",
    img: "/assets/Slot/PP-SLOT-111.Aztec-Gems.webp?v=1764399782520",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-111",
    platFormCode: "PP",
  },
  {
    name: "Aztec Gems Deluxe",
    img: "/assets/Slot/PP-SLOT-035.Aztec-Gems-Deluxe.webp?v=1764399721454",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-035",
    platFormCode: "PP",
  },
  {
    name: "Aztec King",
    img: "/assets/Slot/PP-SLOT-180.Aztec-King.webp?v=1764399503184",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-180",
    platFormCode: "PP",
  },
  {
    name: "Aztec King Megaways",
    img: "/assets/Slot/PP-SLOT-198.Aztec-King-Megaways.webp?v=1764399428237",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-198",
    platFormCode: "PP",
  },
  {
    name: "Aztec Powernudge",
    img: "/assets/Slot/PP-SLOT-447.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-447",
    platFormCode: "PP",
  },
  {
    name: "Aztec Priestess",
    img: "/assets/Slot/JILI-SLOT-083.webp?v=1755510164625",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-083",
    platFormCode: "JILI",
  },
  {
    name: "Aztec Shamans MegaWays",
    img: "/assets/Slot/RT-SLOT-361.Aztec Shamans MegaWays.webp?v=1765034039345",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-361",
    platFormCode: "RT",
  },
  {
    name: "Aztec Smash",
    img: "/assets/Slot/PP-SLOT-531.Aztec Smash.webp?v=1764399353647",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-531",
    platFormCode: "PP",
  },
  {
    name: "Aztec Spins",
    img: "/assets/Slot/RT-SLOT-089.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-089",
    platFormCode: "RT",
  },
  {
    name: "Aztec Temple",
    img: "/assets/Slot/6o5emdcnoqyen.Aztec-Temple.webp?v=1765049761545",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-010",
    platFormCode: "JOKER",
  },
  {
    name: "Aztec Treasure Hunt",
    img: "/assets/Slot/PP-SLOT-488.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-488",
    platFormCode: "PP",
  },
  {
    name: "Azteca",
    img: "/assets/Slot/oqt9p9876m39y.Azteca.webp?v=1765050846135",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-011",
    platFormCode: "JOKER",
  },
  {
    name: "Azticons Chaos Clusters",
    img: "/assets/Slot/PT-SLOT-428.azticons-chaos-clusters.webp?v=1764332907017",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-428",
    platFormCode: "PT",
  },
  {
    name: "BAKI",
    img: "/assets/Slot/CG-SLOT-104.BAKI.webp?v=1764850333064",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-104",
    platFormCode: "CG",
  },
  {
    name: "BELL DEER",
    img: "/assets/Slot/2J-SLOT-049.BELL DEER.webp?v=1763551033521",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-049",
    platFormCode: "JJ",
  },
  {
    name: "BINGO LUCKY CLOVER",
    img: "/assets/Slot/2J-SLOT-004.BINGO LUCKY CLOVER.webp?v=1763550986461",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-004",
    platFormCode: "JJ",
  },
  {
    name: "BOXING RICHES",
    img: "/assets/Slot/FC-SLOT-045.webp?v=1753170598339",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-045",
    platFormCode: "FC",
  },
  {
    name: "BUFFALO WAYS",
    img: "/assets/Slot/FC-SLOT-054.BUFFALO WAYS.webp?v=1764319305714",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-054",
    platFormCode: "FC",
  },
  {
    name: "Baby Cai Shen",
    img: "/assets/Slot/SG-SLOT-031.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-031",
    platFormCode: "SPADE",
  },
  {
    name: "Babylon Riches",
    img: "/assets/Slot/NETENT-SLOT-212.Babylon-Riches.webp?v=1764962573150",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-212",
    platFormCode: "NETENT",
  },
  {
    name: "Badge Blitz",
    img: "/assets/Slot/PP-SLOT-497.Badge-Blitz.webp?v=1764399281619",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-497",
    platFormCode: "PP",
  },
  {
    name: "Badger Miners",
    img: "/assets/Slot/YGG-SLOT-205.webp?v=1767056428555",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-205",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bagua",
    img: "/assets/Slot/gn1bc1kqj7gr4.Bagua.webp?v=1765036260606",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-012",
    platFormCode: "JOKER",
  },
  {
    name: "Bagua 2",
    img: "/assets/Slot/quofrdenycyyn.Bagua-2.webp?v=1765052057981",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-013",
    platFormCode: "JOKER",
  },
  {
    name: "Bai Shi",
    img: "/assets/Slot/PT-SLOT-122.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-122",
    platFormCode: "PT",
  },
  {
    name: "Bakery Bonanza",
    img: "/assets/Slot/PG-SLOT-115.webp?v=1765933237841",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-115",
    platFormCode: "PG",
  },
  {
    name: "Bakufu Shogun",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-062.bakufu-shogun.webp?v=1765276941196",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-062",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Bali",
    img: "/assets/Slot/rg5oqz19mtqir.Bali.webp?v=1765046150834",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-014",
    platFormCode: "JOKER",
  },
  {
    name: "Bali Vacation",
    img: "/assets/Slot/PG-SLOT-071.webp?v=1765933237804",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-071",
    platFormCode: "PG",
  },
  {
    name: "Banana Saga",
    img: "/assets/Slot/JDB-SLOT-019.BANANA SAGA.webp?v=1765264465360",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-019",
    platFormCode: "JDB",
  },
  {
    name: "Banana Town",
    img: "/assets/Slot/RELAX-SLOT-128.webp?v=1761891036243",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-128",
    platFormCode: "RELAX",
  },
  {
    name: "Bananaz 10K Ways",
    img: "/assets/Slot/YGG-SLOT-087.webp?v=1767056428430",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-087",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bandit Megaways",
    img: "/assets/Slot/PP-SLOT-556.webp?v=1755572050025",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-556",
    platFormCode: "PP",
  },
  {
    name: "Bangla Beauty",
    img: "/assets/Slot/JILI-SLOT-086.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-086",
    platFormCode: "JILI",
  },
  {
    name: "Bank Busters: The Big Score",
    img: "/assets/Slot/OCTOPLAY-SLOT-090.The Big Score.webp?v=1764930345030",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-090",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Bao boon chin",
    img: "/assets/Slot/JILI-SLOT-016.webp?v=1755509249803",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-016",
    platFormCode: "JILI",
  },
  {
    name: "Barbarian Fury",
    img: "/assets/Slot/NLC-SLOT-039.Barbarian Fury.webp?v=1764392766514",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-039",
    platFormCode: "NLC",
  },
  {
    name: "Barbarossa DoubleMax",
    img: "/assets/Slot/YGG-SLOT-194.webp?v=1767056428532",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-194",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Barbarossa Revenge",
    img: "/assets/Slot/YGG-SLOT-288.webp?v=1767056428792",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-288",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Barhalla",
    img: "/assets/Slot/OCTOPLAY-SLOT-052.Barhalla.webp?v=1764930606360",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-052",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Barn Festival",
    img: "/assets/Slot/PP-SLOT-236.Barn Festival.webp?v=1764399220396",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-236",
    platFormCode: "PP",
  },
  {
    name: "Baron Samedi",
    img: "/assets/Slot/YGG-SLOT-037.webp?v=1767056428363",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-037",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Basketball Star ITP",
    img: "/assets/Slot/CG-SLOT-101.Basketball Star ITP.webp?v=1764665859503",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-101",
    platFormCode: "CG",
  },
  {
    name: "Bass Boss",
    img: "/assets/Slot/RT-SLOT-190.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-190",
    platFormCode: "RT",
  },
  {
    name: "Bass Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-030.Bass Smash.webp?v=1764931866545",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-030",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Battleground Royale",
    img: "/assets/Slot/PG-SLOT-099.webp?v=1765933237827",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-099",
    platFormCode: "PG",
  },
  {
    name: "Beach Invaders",
    img: "/assets/Slot/NETENT-SLOT-198.Beach-Invaders.webp?v=1764962539127",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-198",
    platFormCode: "NETENT",
  },
  {
    name: "Beach Life",
    img: "/assets/Slot/y6q14hdtq35ze.Beach-Life.webp?v=1765051885297",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-015",
    platFormCode: "JOKER",
  },
  {
    name: "Bean Stalk",
    img: "/assets/Slot/CG-SLOT-082.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-082",
    platFormCode: "CG",
  },
  {
    name: "Beanstalk",
    img: "/assets/Slot/ne4gq55cpitgg.Beanstalk.webp?v=1765054186242",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-016",
    platFormCode: "JOKER",
  },
  {
    name: "Beanstalk Grows Wild",
    img: "/assets/Slot/RELAX-SLOT-264.webp?v=1761891067544",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-264",
    platFormCode: "RELAX",
  },
  {
    name: "Beast Mode",
    img: "/assets/Slot/RELAX-SLOT-106.webp?v=1761891143246",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-106",
    platFormCode: "RELAX",
  },
  {
    name: "Beastwood",
    img: "/assets/Slot/PT-SLOT-431.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-431",
    platFormCode: "PT",
  },
  {
    name: "Beasty Blox",
    img: "/assets/Slot/YGG-SLOT-202.webp?v=1767056428552",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-202",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Beauty And The Kingdom",
    img: "/assets/Slot/JDB-SLOT-009.beauty_and_the_kingdom.webp?v=1765264338617",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-009",
    platFormCode: "JDB",
  },
  {
    name: "Beauty and the Beast",
    img: "/assets/Slot/YGG-SLOT-030.webp?v=1767056428358",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-030",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bee Frenzy",
    img: "/assets/Slot/PT-SLOT-182.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-182",
    platFormCode: "PT",
  },
  {
    name: "Bee Hive Bonanza",
    img: "/assets/Slot/NETENT-SLOT-128.Bee-Hive-Bonanza.webp?v=1764962497275",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-128",
    platFormCode: "NETENT",
  },
  {
    name: "Bee Keeper",
    img: "/assets/Slot/PP-SLOT-596.Bee Keeper.webp?v=1764399155197",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-596",
    platFormCode: "PP",
  },
  {
    name: "Beef Lightning",
    img: "/assets/Slot/BTG-SLOT-015.webp?v=1756256536937",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-015",
    platFormCode: "BTG",
  },
  {
    name: "Beellionaires",
    img: "/assets/Slot/RELAX-SLOT-170.webp?v=1761891172182",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-170",
    platFormCode: "RELAX",
  },
  {
    name: "Beheaded",
    img: "/assets/Slot/NLC-SLOT-090.Beheaded.webp?v=1764392705595",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-090",
    platFormCode: "NLC",
  },
  {
    name: "Bengal Tiger",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-063.bengal-tiger.webp?v=1765276891802",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-063",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Benji Killed in Vegas",
    img: "/assets/Slot/NLC-SLOT-064.Benji Killed in Vegas.webp?v=1764392647878",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-064",
    platFormCode: "NLC",
  },
  {
    name: "Beriched",
    img: "/assets/Slot/RT-SLOT-217.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-217",
    platFormCode: "RT",
  },
  {
    name: "Bermuda Triangle",
    img: "/assets/Slot/PT-SLOT-119.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-119",
    platFormCode: "PT",
  },
  {
    name: "Berry burst MAX",
    img: "/assets/Slot/NETENT-SLOT-166.Berry-Burst-Max.webp?v=1764962454861",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-166",
    platFormCode: "NETENT",
  },
  {
    name: "Better Wilds",
    img: "/assets/Slot/PT-SLOT-196.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-196",
    platFormCode: "PT",
  },
  {
    name: "Betty Bonkers",
    img: "/assets/Slot/PT-SLOT-429.betty-bonkers.webp?v=1764332735626",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-429",
    platFormCode: "PT",
  },
  {
    name: "Betty, Boris and Boo",
    img: "/assets/Slot/RT-SLOT-142.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-142",
    platFormCode: "RT",
  },
  {
    name: "Beware The Deep Megaways",
    img: "/assets/Slot/PP-SLOT-440.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-440",
    platFormCode: "PP",
  },
  {
    name: "Bicicleta",
    img: "/assets/Slot/YGG-SLOT-026.webp?v=1767056428354",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-026",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Bad Bison",
    img: "/assets/Slot/BTG-SLOT-017.webp?v=1756256536938",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-017",
    platFormCode: "BTG",
  },
  {
    name: "Big Bang Boom",
    img: "/assets/Slot/NETENT-SLOT-178.Big-Bang-Boom.webp?v=1764962381288",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-178",
    platFormCode: "NETENT",
  },
  {
    name: "Big Bass Amazon Xtreme",
    img: "/assets/Slot/PP-SLOT-356.Big-Bass-Amazon-Xtreme.webp?v=1764399086439",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-356",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Bonanza",
    img: "/assets/Slot/PP-SLOT-014.Big Bass Bonanza.webp?v=1764399034452",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-014",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Bonanza",
    img: "/assets/Slot/SlotBigBassBonanza.BIG BASS BONANZA.webp?v=1764776858723",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-014",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Bonanza - Hold & Spinner",
    img: "/assets/Slot/PP-SLOT-333.Big-Bass-Hold-and-Spinner.webp?v=1764398956183",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-333",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Bonanza 1000",
    img: "/assets/Slot/PP-SLOT-560.webp?v=1755572162854",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-560",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Bonanza 3 Reeler",
    img: "/assets/Slot/PP-SLOT-529.Big Bass Bonanza 3 Reeler.webp?v=1764398716967",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-529",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Boxing Bonus Round",
    img: "/assets/Slot/PP-SLOT-572.Big Bass Boxing Bonus Round.webp?v=1764398484021",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-572",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Christmas Bash",
    img: "/assets/Slot/PP-SLOT-401.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-401",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Day at the Races",
    img: "/assets/Slot/PP-SLOT-441.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-441",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Floats My Boat",
    img: "/assets/Slot/PP-SLOT-430.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-430",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Halloween",
    img: "/assets/Slot/PP-SLOT-389.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-389",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Halloween 2",
    img: "/assets/Slot/PP-SLOT-504.Big Bass Halloween 2.webp?v=1764398333795",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-504",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Halloween 3",
    img: "/assets/Slot/PP-SLOT-603.Big Bass Halloween 3.webp?v=1764398270908",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-603",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Hold & Spinner Megaways",
    img: "/assets/Slot/PP-SLOT-376.Big Bass Hold & Spinner Megaways.webp?v=1764398170218",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-376",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Mission Fishin’",
    img: "/assets/Slot/PP-SLOT-469.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-469",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Reel Repeat",
    img: "/assets/Slot/PP-SLOT-585.Big Bass Reel Repeat.webp?v=1764398082583",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-585",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Return to the Races",
    img: "/assets/Slot/PP-SLOT-544.webp?v=1755571912491",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-544",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Secrets of the Golden Lake",
    img: "/assets/Slot/PP-SLOT-450.webp?v=1761309081519",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-450",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Splash",
    img: "/assets/Slot/PP-SLOT-261.Big-Bass-Splash.webp?v=1764397983574",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-261",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Splash 1000",
    img: "/assets/Slot/PP-SLOT-654.webp?v=1765954402894",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-654",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Vegas Double Down Deluxe",
    img: "/assets/Slot/PP-SLOT-493.Big-Bass-Vegas-Double-Down-Deluxe.webp?v=1764397926258",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-493",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Xmas Xtreme",
    img: "/assets/Slot/PP-SLOT-521.Big Bass Xmas Xtreme.webp?v=1764397858193",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-521",
    platFormCode: "PP",
  },
  {
    name: "Big Benji Bonanza",
    img: "/assets/Slot/YGG-SLOT-140.webp?v=1767056428474",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-140",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Benji's Back WildWays",
    img: "/assets/Slot/YGG-SLOT-304.webp?v=1767056428805",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-304",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Blox",
    img: "/assets/Slot/YGG-SLOT-027.webp?v=1767056428356",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-027",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Bucks Bandits MegaWays",
    img: "/assets/Slot/YGG-SLOT-005.webp?v=1767056428323",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-005",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Bucks Bandits Megaways",
    img: "/assets/Slot/RELAX-SLOT-093.webp?v=1761891200482",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-093",
    platFormCode: "RELAX",
  },
  {
    name: "Big Bucks Bison 10K Ways",
    img: "/assets/Slot/RELAX-SLOT-273.webp?v=1761891250220",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-273",
    platFormCode: "RELAX",
  },
  {
    name: "Big Bucks Buffalo GigaBlox",
    img: "/assets/Slot/YGG-SLOT-185.webp?v=1767056428523",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-185",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Bucks Deluxe",
    img: "/assets/Slot/BTG-SLOT-061.webp?v=1756256536973",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-061",
    platFormCode: "BTG",
  },
  {
    name: "Big Bucks Deluxe Tapcards",
    img: "/assets/Slot/BTG-SLOT-063.webp?v=1756256536975",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-063",
    platFormCode: "BTG",
  },
  {
    name: "Big Burger Load it up with Xtra Cheese",
    img: "/assets/Slot/PP-SLOT-448.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-448",
    platFormCode: "PP",
  },
  {
    name: "Big Diamond",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-053.big-diamond.webp?v=1765276833795",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-053",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Big Gains",
    img: "/assets/Slot/RT-SLOT-358.webp?v=1753341482154",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-358",
    platFormCode: "RT",
  },
  {
    name: "Big Game Fishing Golden Catch",
    img: "/assets/Slot/YGG-SLOT-357.webp?v=1767056428866",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-357",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Game Fishing TopHit",
    img: "/assets/Slot/YGG-SLOT-315.webp?v=1767056428814",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-315",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Big Game Safari",
    img: "/assets/Slot/96k1k6d3x39za.Big-Game-Safari.webp?v=1765042106426",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-017",
    platFormCode: "JOKER",
  },
  {
    name: "Big Juan",
    img: "/assets/Slot/PP-SLOT-209.Big-Juan.webp?v=1764397785692",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-209",
    platFormCode: "PP",
  },
  {
    name: "Big Money Wheel",
    img: "/assets/Slot/NETENT-SLOT-209.Big-Money-Wheel.webp?v=1764962331287",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-209",
    platFormCode: "NETENT",
  },
  {
    name: "Big Prosperity SA",
    img: "/assets/Slot/SG-SLOT-021.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-021",
    platFormCode: "SPADE",
  },
  {
    name: "Big Shot",
    img: "/assets/Slot/P8-SLOT-013.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-013",
    platFormCode: "PLAY8",
  },
  {
    name: "Big Top Terror",
    img: "/assets/Slot/YGG-SLOT-272.webp?v=1767056428779",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-272",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "BigThreeDragons",
    img: "/assets/Slot/JDB-SLOT-117.big-three-dragons.webp?v=1767691606971",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-117",
    platFormCode: "JDB",
  },
  {
    name: "Bigger Barn House Bonanza",
    img: "/assets/Slot/PP-SLOT-599.Bigger Barn House Bonanza.webp?v=1764397733614",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-599",
    platFormCode: "PP",
  },
  {
    name: "Bigger Bass Blizzard - Christmas Catch",
    img: "/assets/Slot/PP-SLOT-292.Bigger-Bass-Blizzard-Christmas-Catch.webp?v=1764397663399",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-292",
    platFormCode: "PP",
  },
  {
    name: "Bigger Bass Bonanza",
    img: "/assets/Slot/PP-SLOT-190.Bigger-Bass-Bonanza.webp?v=1764397592819",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-190",
    platFormCode: "PP",
  },
  {
    name: "Bigger Bass Splash",
    img: "/assets/Slot/PP-SLOT-543.Bigger Bass Splash.webp?v=1764397539457",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-543",
    platFormCode: "PP",
  },
  {
    name: "Bikini Lady",
    img: "/assets/Slot/JILI-SLOT-127.webp?v=1755510904752",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-127",
    platFormCode: "JILI",
  },
  {
    name: "Bikini Paradise",
    img: "/assets/Slot/PG-SLOT-049.webp?v=1765933237790",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-049",
    platFormCode: "PG",
  },
  {
    name: "Bill & Coin",
    img: "/assets/Slot/RELAX-SLOT-220.webp?v=1761891336948",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-220",
    platFormCode: "RELAX",
  },
  {
    name: "Billionaire",
    img: "/assets/Slot/JDB-SLOT-031.billionaire.webp?v=1765264229636",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-031",
    platFormCode: "JDB",
  },
  {
    name: "Bingo Mania",
    img: "/assets/Slot/PP-SLOT-607.Bingo Mania.webp?v=1764397483924",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-607",
    platFormCode: "PP",
  },
  {
    name: "BingoFortune",
    img: "/assets/Slot/ACEWIN-SLOT-015.Bingo Fortune.webp?v=1764853864898",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-015",
    platFormCode: "ACEWIN",
  },
  {
    name: "Birds Party",
    img: "/assets/Slot/JDB-SLOT-066.birds_party.webp?v=1765507281074",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-066",
    platFormCode: "JDB",
  },
  {
    name: "Birds Party Deluxe",
    img: "/assets/Slot/JDB-SLOT-109.BIRDS PARTY DELUXE.webp?v=1767691555636",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-109",
    platFormCode: "JDB",
  },
  {
    name: "Bison Wilds",
    img: "/assets/Slot/YGG-SLOT-284.webp?v=1767056428789",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-284",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Black Beard Legacy",
    img: "/assets/Slot/swt38osdadyhc.Black-Beard-Legacy.webp?v=1765044801712",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-018",
    platFormCode: "JOKER",
  },
  {
    name: "Black Bull",
    img: "/assets/Slot/PP-SLOT-282.Black-Bull.webp?v=1764397453321",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-282",
    platFormCode: "PP",
  },
  {
    name: "Black Knight",
    img: "/assets/Slot/1bwmp4xq79sq4.Black Knight.webp?v=1765046733455",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-213",
    platFormCode: "JOKER",
  },
  {
    name: "Black Sheep",
    img: "/assets/Slot/CG-SLOT-053.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-053",
    platFormCode: "CG",
  },
  {
    name: "Blackbeard Battle Of The Seas",
    img: "/assets/Slot/YGG-SLOT-217.webp?v=1767056428564",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-217",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Blackbeard’s Hoard Cash Sacks",
    img: "/assets/Slot/PT-SLOT-468.Blackbeard’s Hoard Cash Sacks.webp?v=1764326207681",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-468",
    platFormCode: "PT",
  },
  {
    name: "Blade & Fangs",
    img: "/assets/Slot/PP-SLOT-414.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-414",
    platFormCode: "PP",
  },
  {
    name: "Blarney's Gold",
    img: "/assets/Slot/OCTOPLAY-SLOT-002.Blarney_s Gold.webp?v=1764931916869",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-002",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Blazing Bells",
    img: "/assets/Slot/PT-SLOT-199.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-199",
    platFormCode: "PT",
  },
  {
    name: "Blazing Clusters",
    img: "/assets/Slot/RT-SLOT-172.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-172",
    platFormCode: "RT",
  },
  {
    name: "Blazing Inferno Chaos Reels",
    img: "/assets/Slot/OCTOPLAY-SLOT-076.Blazing Inferno Chaos Reels.webp?v=1765034333815",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-076",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Blazing Touch",
    img: "/assets/Slot/OCTOPLAY-SLOT-003.Blazing Touch.webp?v=1764931957224",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-003",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Blazing Wilds Megaways",
    img: "/assets/Slot/PP-SLOT-427.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-427",
    platFormCode: "PP",
  },
  {
    name: "Blender Blitz",
    img: "/assets/Slot/RELAX-SLOT-126.webp?v=1761891366782",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-126",
    platFormCode: "RELAX",
  },
  {
    name: "Blitz Super Wheel",
    img: "/assets/Slot/PP-SLOT-555.webp?v=1755572019088",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-555",
    platFormCode: "PP",
  },
  {
    name: "Blood & Shadow",
    img: "/assets/Slot/NLC-SLOT-065.Blood & Shadow.webp?v=1764392596841",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-065",
    platFormCode: "NLC",
  },
  {
    name: "Blood & Shadow 2",
    img: "/assets/Slot/NLC-SLOT-100.Blood & Shadow 2.webp?v=1765033753605",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-100",
    platFormCode: "NLC",
  },
  {
    name: "Blood Diamond",
    img: "/assets/Slot/NLC-SLOT-109.Blood Diamond.webp?v=1764392483926",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-109",
    platFormCode: "NLC",
  },
  {
    name: "Blood Moon Wilds",
    img: "/assets/Slot/YGG-SLOT-115.webp?v=1767056428452",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-115",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bloodaxe",
    img: "/assets/Slot/RELAX-SLOT-207.webp?v=1761891439828",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-207",
    platFormCode: "RELAX",
  },
  {
    name: "Bloody Murder",
    img: "/assets/Slot/RT-SLOT-371.Bloody Murder.webp?v=1765033100084",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-371",
    platFormCode: "RT",
  },
  {
    name: "Bloody Pesos",
    img: "/assets/Slot/YGG-SLOT-417.webp?v=1767056428925",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-417",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "BlossomOfWealth",
    img: "/assets/Slot/JDB-SLOT-101.blossom_of_wealth.webp?v=1765263775132",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-101",
    platFormCode: "JDB",
  },
  {
    name: "Blue Wizard",
    img: "/assets/Slot/PT-SLOT-008.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-008",
    platFormCode: "PT",
  },
  {
    name: "Blue Wizard: Cash Collect & Link",
    img: "/assets/Slot/PT-SLOT-425.blue-wizard-cash-collect-&-link.webp?v=1764333105408",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-425",
    platFormCode: "PT",
  },
  {
    name: "Bob Marlin Goes Deep",
    img: "/assets/Slot/YGG-SLOT-374.webp?v=1767056428880",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-374",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Boilin' Pots",
    img: "/assets/Slot/YGG-SLOT-147.webp?v=1767056428481",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-147",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bollywood Story",
    img: "/assets/Slot/NETENT-SLOT-137.Bollywood-Story.webp?v=1764962184156",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-137",
    platFormCode: "NETENT",
  },
  {
    name: "Bomb Bonanza",
    img: "/assets/Slot/PP-SLOT-259.Bomb-Bonanza.webp?v=1764397356574",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-259",
    platFormCode: "PP",
  },
  {
    name: "Bombuster",
    img: "/assets/Slot/RT-SLOT-143.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-143",
    platFormCode: "RT",
  },
  {
    name: "Bonanza",
    img: "/assets/Slot/BTG-SLOT-004.webp?v=1756256536928",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-004",
    platFormCode: "BTG",
  },
  {
    name: "Bonanza Falls",
    img: "/assets/Slot/BTG-SLOT-022.webp?v=1756256536942",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-022",
    platFormCode: "BTG",
  },
  {
    name: "Bonanza Gold",
    img: "/assets/Slot/PP-SLOT-015.Bonanza-Gold.webp?v=1764397293969",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-015",
    platFormCode: "PP",
  },
  {
    name: "Bonanza Tapcards",
    img: "/assets/Slot/BTG-SLOT-064.webp?v=1756256536975",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-064",
    platFormCode: "BTG",
  },
  {
    name: "Bone Fortune",
    img: "/assets/Slot/JILI-SLOT-059.webp?v=1755509815485",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-059",
    platFormCode: "JILI",
  },
  {
    name: "Bone Raiders",
    img: "/assets/Slot/RELAX-SLOT-260.webp?v=1761891471261",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-260",
    platFormCode: "RELAX",
  },
  {
    name: "Bonus Bear",
    img: "/assets/Slot/bwwza4umpbwsh.Bonus-Bear.webp?v=1765052497569",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-019",
    platFormCode: "JOKER",
  },
  {
    name: "Bonus Bears",
    img: "/assets/Slot/PT-SLOT-018.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-018",
    platFormCode: "PT",
  },
  {
    name: "Bonus Bunnies",
    img: "/assets/Slot/NLC-SLOT-020.Bonus Bunnies.webp?v=1764392426474",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-020",
    platFormCode: "NLC",
  },
  {
    name: "Bonus Cat",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-061.bonus-cat.webp?v=1765276690995",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-061",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Bonus Hunter",
    img: "/assets/Slot/JILI-SLOT-062.webp?v=1755509849913",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-062",
    platFormCode: "JILI",
  },
  {
    name: "Boo",
    img: "/assets/Slot/BTG-SLOT-054.webp?v=1756256536967",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-054",
    platFormCode: "BTG",
  },
  {
    name: "Book Extreme",
    img: "/assets/Slot/YGG-SLOT-292.webp?v=1767056428795",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-292",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Book HOTFIRE",
    img: "/assets/Slot/YGG-SLOT-154.webp?v=1767056428487",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-154",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Book Of Desert Legends",
    img: "/assets/Slot/RT-SLOT-367.Book Of Desert Legends.webp?v=1765033199315",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-367",
    platFormCode: "RT",
  },
  {
    name: "Book Of Ra",
    img: "/assets/Slot/ioheiiqk3xrc1.Book-Of-Ra.webp?v=1765048845159",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-020",
    platFormCode: "JOKER",
  },
  {
    name: "Book Of Ra Deluxe",
    img: "/assets/Slot/hf5hx8w9u1q3r.Book-Of-Ra-Deluxe.webp?v=1765047029285",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-021",
    platFormCode: "JOKER",
  },
  {
    name: "Book Of Shadows",
    img: "/assets/Slot/NLC-SLOT-016.Book Of Shadows.webp?v=1764392379103",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-016",
    platFormCode: "NLC",
  },
  {
    name: "Book of 99",
    img: "/assets/Slot/RELAX-SLOT-052.webp?v=1761891500476",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-052",
    platFormCode: "RELAX",
  },
  {
    name: "Book of Aztec King",
    img: "/assets/Slot/PP-SLOT-241.Book-of-Aztec-King.webp?v=1764397242945",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-241",
    platFormCode: "PP",
  },
  {
    name: "Book of Blarney Gigablox",
    img: "/assets/Slot/YGG-SLOT-245.webp?v=1767056428596",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-245",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Book of Books",
    img: "/assets/Slot/YGG-SLOT-183.webp?v=1767056428521",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-183",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Book of Dead",
    img: "/assets/Slot/SlotBookOfDead.BOOK OF DEAD.webp?v=1764776789591",
    platForm: "PLAYNGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PLAYNGO-SLOT-017",
    platFormCode: "PLAYNGO",
  },
  {
    name: "Book of Destiny",
    img: "/assets/Slot/RELAX-SLOT-086.webp?v=1761891533481",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-086",
    platFormCode: "RELAX",
  },
  {
    name: "Book of Evil",
    img: "/assets/Slot/YGG-SLOT-286.webp?v=1767056428791",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-286",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Book of Gods",
    img: "/assets/Slot/BTG-SLOT-053.webp?v=1756256536966",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-053",
    platFormCode: "BTG",
  },
  {
    name: "Book of Gold",
    img: "/assets/Slot/JILI-SLOT-053.webp?v=1755509725618",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-053",
    platFormCode: "JILI",
  },
  {
    name: "Book of Golden Sands",
    img: "/assets/Slot/PP-SLOT-288.Book-of-Golden-Sands.webp?v=1764397116626",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-288",
    platFormCode: "PP",
  },
  {
    name: "Book of Kingdoms",
    img: "/assets/Slot/PP-SLOT-023.Book-of-Kingdoms.webp?v=1764845512548",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-023",
    platFormCode: "PP",
  },
  {
    name: "Book of Kings",
    img: "/assets/Slot/PT-SLOT-202.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-202",
    platFormCode: "PT",
  },
  {
    name: "Book of Monsters",
    img: "/assets/Slot/PP-SLOT-554.webp?v=1755571999273",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-554",
    platFormCode: "PP",
  },
  {
    name: "Book of Power",
    img: "/assets/Slot/RELAX-SLOT-159.webp?v=1761891562111",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-159",
    platFormCode: "RELAX",
  },
  {
    name: "BookOfMystery",
    img: "/assets/Slot/JDB-SLOT-105.book_of_mystery.webp?v=1767691525814",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-105",
    platFormCode: "JDB",
  },
  {
    name: "Boom Boom Marmot",
    img: "/assets/Slot/YesBingo-SLOT-018.Boom Boom Marmot.webp?v=1765106323760",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-018",
    platFormCode: "YESBINGO",
  },
  {
    name: "Boom the Buffoon",
    img: "/assets/Slot/OCTOPLAY-SLOT-025.Boom The Buffoon.webp?v=1764931999910",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-025",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Booming Gems",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-042.booming-gems.webp?v=1765276640145",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-042",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Bounty Clash",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-084.bounty-clash.webp?v=1765276588399",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-084",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Bounty Hunter",
    img: "/assets/Slot/PP-SLOT-597.Bounty Hunter.webp?v=1764396861375",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-597",
    platFormCode: "PP",
  },
  {
    name: "Bounty Hunter MultiBoost",
    img: "/assets/Slot/YGG-SLOT-356.webp?v=1767056428865",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-356",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bounty Hunters xNudge",
    img: "/assets/Slot/NLC-SLOT-070.Bounty Hunters xNudge.webp?v=1764392323890",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-070",
    platFormCode: "NLC",
  },
  {
    name: "Bounty Raid",
    img: "/assets/Slot/RT-SLOT-124.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-124",
    platFormCode: "RT",
  },
  {
    name: "Bounty Raid 2",
    img: "/assets/Slot/RT-SLOT-254.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-254",
    platFormCode: "RT",
  },
  {
    name: "Bounty Showdown",
    img: "/assets/Slot/RELAX-SLOT-081.webp?v=1761891602193",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-081",
    platFormCode: "RELAX",
  },
  {
    name: "Bounty Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-031.Bounty Smash.webp?v=1764932049134",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-031",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Bow of Artemis",
    img: "/assets/Slot/PP-SLOT-481.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-481",
    platFormCode: "PP",
  },
  {
    name: "Boxing King Title Match",
    img: "/assets/Slot/JILI-SLOT-161.Boxing King Title Match.webp?v=1764474438046",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-161",
    platFormCode: "JILI",
  },
  {
    name: "Brazil Bomba",
    img: "/assets/Slot/YGG-SLOT-045.webp?v=1767056428372",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-045",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Breach the Vault",
    img: "/assets/Slot/PT-SLOT-354.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-354",
    platFormCode: "PT",
  },
  {
    name: "Break the Piggy Bank",
    img: "/assets/Slot/OCTOPLAY-SLOT-093.Break the Piggy Bank.webp?v=1764932074241",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-093",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "BreakAway",
    img: "/assets/Slot/CG-SLOT-006.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-006",
    platFormCode: "CG",
  },
  {
    name: "Breakout",
    img: "/assets/Slot/NLC-SLOT-119.breakout.webp?v=1764392274490",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-119",
    platFormCode: "NLC",
  },
  {
    name: "Breakout Bob",
    img: "/assets/Slot/PT-SLOT-170.webp?v=1762261391898",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-170",
    platFormCode: "PT",
  },
  {
    name: "Brick House Bonanza",
    img: "/assets/Slot/PP-SLOT-534.Brick House Bonanza.webp?v=1764396785432",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-534",
    platFormCode: "PP",
  },
  {
    name: "Brick Snake 2000",
    img: "/assets/Slot/NLC-SLOT-075.Brick Snake 2000.webp?v=1764392234497",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-075",
    platFormCode: "NLC",
  },
  {
    name: "Bright & Abyss",
    img: "/assets/Slot/CG-SLOT-067.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-067",
    platFormCode: "CG",
  },
  {
    name: "Brothers Kingdom 2",
    img: "/assets/Slot/SG-SLOT-143.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-143",
    platFormCode: "SPADE",
  },
  {
    name: "Brute Force",
    img: "/assets/Slot/NLC-SLOT-097.Brute Force.webp?v=1764392172370",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-097",
    platFormCode: "NLC",
  },
  {
    name: "Brute Force: Alien Onslaught",
    img: "/assets/Slot/NLC-SLOT-114.Brute Force Alien Onslaught.webp?v=1764392107732",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-114",
    platFormCode: "NLC",
  },
  {
    name: "Bubble Beauty",
    img: "/assets/Slot/JILI-SLOT-015.webp?v=1755509234342",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-015",
    platFormCode: "JILI",
  },
  {
    name: "Bubblegum Burst",
    img: "/assets/Slot/PT-SLOT-449.webp?v=1756275771663",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-449",
    platFormCode: "PT",
  },
  {
    name: "Buccaneer Deluxe",
    img: "/assets/Slot/bsp1s4umpbwsh.Buccaneer-Deluxe.webp?v=1765042466116",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-023",
    platFormCode: "JOKER",
  },
  {
    name: "Bucks and Doe 10K Ways",
    img: "/assets/Slot/RELAX-SLOT-215.webp?v=1761891628058",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-215",
    platFormCode: "RELAX",
  },
  {
    name: "Bucks and Doe 10K Ways",
    img: "/assets/Slot/YGG-SLOT-206.webp?v=1767056428556",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-206",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Buckshot Wilds",
    img: "/assets/Slot/NETENT-SLOT-184.Buckshot-Wilds.webp?v=1764962147073",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-184",
    platFormCode: "NETENT",
  },
  {
    name: "Buddha Spin",
    img: "/assets/Slot/ACEWIN-SLOT-029.Buddha Spin.webp?v=1764853892167",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-029",
    platFormCode: "ACEWIN",
  },
  {
    name: "Buffalo Blaze: Wild Wealth",
    img: "/assets/Slot/OCTOPLAY-SLOT-068.buffalo Blaze Wild Wealth.webp?v=1764932120422",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-068",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Buffalo Blitz",
    img: "/assets/Slot/PT-SLOT-003.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-003",
    platFormCode: "PT",
  },
  {
    name: "Buffalo Blitz Cash Collect",
    img: "/assets/Slot/PT-SLOT-436.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-436",
    platFormCode: "PT",
  },
  {
    name: "Buffalo Blitz II",
    img: "/assets/Slot/PT-SLOT-017.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-017",
    platFormCode: "PT",
  },
  {
    name: "Buffalo Blow",
    img: "/assets/Slot/RELAX-SLOT-274.webp?v=1761891654030",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-274",
    platFormCode: "RELAX",
  },
  {
    name: "Buffalo Blox",
    img: "/assets/Slot/YGG-SLOT-151.webp?v=1767056428484",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-151",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Buffalo Burst",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-065.buffalo-burst.webp?v=1765276540170",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-065",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Buffalo Collector",
    img: "/assets/Slot/RT-SLOT-321.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-321",
    platFormCode: "RT",
  },
  {
    name: "Buffalo Hunter",
    img: "/assets/Slot/NLC-SLOT-033.Buffalo Hunter.webp?v=1764392070831",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-033",
    platFormCode: "NLC",
  },
  {
    name: "Buffalo King",
    img: "/assets/Slot/PP-SLOT-062.Buffalo-King.webp?v=1764840375598",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-062",
    platFormCode: "PP",
  },
  {
    name: "Buffalo King MEGAWAYS",
    img: "/assets/Slot/SlotBuffaloKing.Buffalo King MEGAWAYS.webp?v=1764776746870",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-176",
    platFormCode: "PP",
  },
  {
    name: "Buffalo King Megaways",
    img: "/assets/Slot/PP-SLOT-176.Buffalo-King-Megaways.webp?v=1764396614073",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-176",
    platFormCode: "PP",
  },
  {
    name: "Buffalo King Untamed Megaways",
    img: "/assets/Slot/PP-SLOT-470.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-470",
    platFormCode: "PP",
  },
  {
    name: "Buffalo Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-038.Buffalo Smash.webp?v=1764932159294",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-038",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Buffalo Smash: Supercharged",
    img: "/assets/Slot/OCTOPLAY-SLOT-097.Buffalo Smash Supercharged.webp?v=1764932191914",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-097",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Buffalo Super Stars",
    img: "/assets/Slot/YGG-SLOT-352.webp?v=1767056428859",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-352",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Buffalo Win",
    img: "/assets/Slot/PG-SLOT-085.webp?v=1765933237816",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-085",
    platFormCode: "PG",
  },
  {
    name: "Bugs Money",
    img: "/assets/Slot/YGG-SLOT-184.webp?v=1767056428522",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-184",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bugsy’s Bar",
    img: "/assets/Slot/RT-SLOT-235.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-235",
    platFormCode: "RT",
  },
  {
    name: "Bull Fiesta",
    img: "/assets/Slot/PP-SLOT-242.Bull-Fiesta.webp?v=1764396542562",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-242",
    platFormCode: "PP",
  },
  {
    name: "Bull Street",
    img: "/assets/Slot/xkbfobaryz7xs.Bull Street.webp?v=1765049030077",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-205",
    platFormCode: "JOKER",
  },
  {
    name: "Bull Treasure",
    img: "/assets/Slot/JDB-SLOT-126.Bull Treasure.webp?v=1765263660421",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-126",
    platFormCode: "JDB",
  },
  {
    name: "Bullet Bonanza",
    img: "/assets/Slot/OCTOPLAY-SLOT-004.Bullet Bonanza.webp?v=1764932235646",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-004",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Bulls Run Wild",
    img: "/assets/Slot/RT-SLOT-180.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-180",
    platFormCode: "RT",
  },
  {
    name: "Bunny VIP Night",
    img: "/assets/Slot/KM-SLOT-024.Bunny VIP Night.webp?v=1764860746591",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-024",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Burgers",
    img: "/assets/Slot/BTG-SLOT-058.webp?v=1756256536970",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-058",
    platFormCode: "BTG",
  },
  {
    name: "Burning Blox",
    img: "/assets/Slot/YGG-SLOT-220.webp?v=1767056428567",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-220",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Burning Pearl",
    img: "/assets/Slot/ur8593z8hu17w.Burning-Pearl.webp?v=1765052393983",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-024",
    platFormCode: "JOKER",
  },
  {
    name: "Burning Riot",
    img: "/assets/Slot/YGG-SLOT-346.webp?v=1767056428849",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-346",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Bushido Blade",
    img: "/assets/Slot/86burqb38a9ua.Bushido-Blade.webp?v=1765054140622",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-025",
    platFormCode: "JOKER",
  },
  {
    name: "Bushido Way xNudge",
    img: "/assets/Slot/NLC-SLOT-028.Bushido Way xNudge.webp?v=1764392015727",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-028",
    platFormCode: "NLC",
  },
  {
    name: "Bust Treasury",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-020.bust-treasury.webp?v=1765276489792",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-020",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Buster Hammer Carnival",
    img: "/assets/Slot/YGG-SLOT-008.webp?v=1767056428329",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-008",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Buster's Bones",
    img: "/assets/Slot/NETENT-SLOT-173.Buster_s-Bones.webp?v=1764962097436",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-173",
    platFormCode: "NETENT",
  },
  {
    name: "Busy Bees",
    img: "/assets/Slot/PP-SLOT-162.Busy-Bees.webp?v=1764396487960",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-162",
    platFormCode: "PP",
  },
  {
    name: "Butterfly Blossom",
    img: "/assets/Slot/PG-SLOT-096.webp?v=1765933237825",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-096",
    platFormCode: "PG",
  },
  {
    name: "CAISHEN DELUXE MAXWAYS",
    img: "/assets/Slot/SG-SLOT-121.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-121",
    platFormCode: "SPADE",
  },
  {
    name: "CASHPOWER MANIA",
    img: "/assets/Slot/2J-SLOT-060.CASHPOWER MANIA.webp?v=1763550924722",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-060",
    platFormCode: "JJ",
  },
  {
    name: "CATLA'S MONEY MACHINE",
    img: "/assets/Slot/FC-SLOT-056.CATLA'S MONEY MACHINE.webp?v=1762943835932",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-056",
    platFormCode: "FC",
  },
  {
    name: "CHEESE CLASH",
    img: "/assets/Slot/2J-SLOT-059.CHEESE CLASH.webp?v=1763550870227",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-059",
    platFormCode: "JJ",
  },
  {
    name: "CHINESE NEW YEAR",
    img: "/assets/Slot/FC-SLOT-007.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-007",
    platFormCode: "FC",
  },
  {
    name: "CHINESE NEW YEAR 2",
    img: "/assets/Slot/FC-SLOT-022.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-022",
    platFormCode: "FC",
  },
  {
    name: "CLEOPATRA'S FLAME",
    img: "/assets/Slot/2J-SLOT-044.CLEOPATRA_S FLAME.webp?v=1763550824268",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-044",
    platFormCode: "JJ",
  },
  {
    name: "COSMIC BLITZ",
    img: "/assets/Slot/2J-SLOT-053.COSMIC BLITZ.webp?v=1763550763743",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-053",
    platFormCode: "JJ",
  },
  {
    name: "COWBOYS",
    img: "/assets/Slot/FC-SLOT-014.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-014",
    platFormCode: "FC",
  },
  {
    name: "Cai Shen 168",
    img: "/assets/Slot/RT-SLOT-230.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-230",
    platFormCode: "RT",
  },
  {
    name: "Cai Shen 888",
    img: "/assets/Slot/SG-SLOT-037.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-037",
    platFormCode: "SPADE",
  },
  {
    name: "CaiShen Coming",
    img: "/assets/Slot/JDB-SLOT-113.Caishen Coming.webp?v=1767691590435",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-113",
    platFormCode: "JDB",
  },
  {
    name: "Caishen",
    img: "/assets/Slot/SG-SLOT-109.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-109",
    platFormCode: "SPADE",
  },
  {
    name: "Caishen Coming",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-016.caishen-coming.webp?v=1765276430647",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-016",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Caishen Riches",
    img: "/assets/Slot/zygj7oqga9nck.Caishen-Riches.webp?v=1765053480891",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-026",
    platFormCode: "JOKER",
  },
  {
    name: "Caishen Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-032.Caishen Smash.webp?v=1764932276895",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-032",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Caishen Ways",
    img: "/assets/Slot/PT-SLOT-189.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-189",
    platFormCode: "PT",
  },
  {
    name: "Caishen Wins",
    img: "/assets/Slot/PG-SLOT-047.webp?v=1765933237788",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-047",
    platFormCode: "PG",
  },
  {
    name: "Caishen's Cash",
    img: "/assets/Slot/PP-SLOT-083.Caishen_s-Cash.webp?v=1764396359761",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-083",
    platFormCode: "PP",
  },
  {
    name: "Caishen's Gold",
    img: "/assets/Slot/PP-SLOT-121.Caishen_s-Gold.webp?v=1764396287526",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-121",
    platFormCode: "PP",
  },
  {
    name: "Caishen's Temple of Gold",
    img: "/assets/Slot/OCTOPLAY-SLOT-005.Caishen_s Temple of Gold.webp?v=1764932319720",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-005",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Cake Bonanza",
    img: "/assets/Slot/ACEWIN-SLOT-025.Cake Bonanza.webp?v=1764853949300",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-025",
    platFormCode: "ACEWIN",
  },
  {
    name: "Cake and Ice Cream",
    img: "/assets/Slot/RT-SLOT-129.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-129",
    platFormCode: "RT",
  },
  {
    name: "Calavera Crush",
    img: "/assets/Slot/YGG-SLOT-158.webp?v=1767056428490",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-158",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Candy Baby",
    img: "/assets/Slot/JILI-SLOT-020.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-020",
    platFormCode: "JILI",
  },
  {
    name: "Candy Blitz",
    img: "/assets/Slot/PP-SLOT-381.Candy-Blitz.webp?v=1764396219749",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-381",
    platFormCode: "PP",
  },
  {
    name: "Candy Blitz Bombs",
    img: "/assets/Slot/PP-SLOT-453.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-453",
    platFormCode: "PP",
  },
  {
    name: "Candy Burst",
    img: "/assets/Slot/PG-SLOT-048.webp?v=1765933237789",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-048",
    platFormCode: "PG",
  },
  {
    name: "Candy Candy",
    img: "/assets/Slot/SG-SLOT-101.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-101",
    platFormCode: "SPADE",
  },
  {
    name: "Candy Corner",
    img: "/assets/Slot/PP-SLOT-508.Candy Corner.webp?v=1764396146213",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-508",
    platFormCode: "PP",
  },
  {
    name: "Candy Dynasty",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-017.candy-dynasty.webp?v=1765276366566",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-017",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Candy Pop",
    img: "/assets/Slot/SG-SLOT-001.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-001",
    platFormCode: "SPADE",
  },
  {
    name: "Candy Pop 2",
    img: "/assets/Slot/SG-SLOT-123.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-123",
    platFormCode: "SPADE",
  },
  {
    name: "Candy Stars",
    img: "/assets/Slot/PP-SLOT-281.Candy-Stars.webp?v=1764396073445",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-281",
    platFormCode: "PP",
  },
  {
    name: "Candy Village",
    img: "/assets/Slot/PP-SLOT-204.Candy-Village.webp?v=1764396020403",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-204",
    platFormCode: "PP",
  },
  {
    name: "Candyfinity",
    img: "/assets/Slot/YGG-SLOT-199.webp?v=1767056428549",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-199",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Candyland Jackpots",
    img: "/assets/Slot/OCTOPLAY-SLOT-113.Candyland Jackpots.webp?v=1764932345044",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-113",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Cannonball Cash",
    img: "/assets/Slot/RT-SLOT-314.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-314",
    platFormCode: "RT",
  },
  {
    name: "Captain Cashmap",
    img: "/assets/Slot/YGG-SLOT-422.webp?v=1767056428930",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-422",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Captain Golds Fortune",
    img: "/assets/Slot/SG-SLOT-114.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-114",
    platFormCode: "SPADE",
  },
  {
    name: "Captain Kraken Megaways",
    img: "/assets/Slot/PP-SLOT-594.Captain Kraken Megaways.webp?v=1764395971959",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-594",
    platFormCode: "PP",
  },
  {
    name: "Captain Treasure",
    img: "/assets/Slot/P8-SLOT-012.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-012",
    platFormCode: "PLAY8",
  },
  {
    name: "Captain's Treasure",
    img: "/assets/Slot/bes8675wqiigs.Captain_s-Treasure.webp?v=1765045549355",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-027",
    platFormCode: "JOKER",
  },
  {
    name: "Captains Bounty",
    img: "/assets/Slot/PG-SLOT-034.webp?v=1765933237774",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-034",
    platFormCode: "PG",
  },
  {
    name: "Captains Treasure Progressive",
    img: "/assets/Slot/awn5jciusna5c.Captains-Treasure-PRogressive.webp?v=1765051948670",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-029",
    platFormCode: "JOKER",
  },
  {
    name: "Caravan of Riches",
    img: "/assets/Slot/RELAX-SLOT-108.webp?v=1761891695378",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-108",
    platFormCode: "RELAX",
  },
  {
    name: "Carnaval Do Rio",
    img: "/assets/Slot/xgbi6bo8yon9w.Carnaval Do Rio.webp?v=1765041121359",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-214",
    platFormCode: "JOKER",
  },
  {
    name: "Carol of the Elves",
    img: "/assets/Slot/YGG-SLOT-097.webp?v=1767056428438",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-097",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cascading Cave",
    img: "/assets/Slot/PT-SLOT-228.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-228",
    platFormCode: "PT",
  },
  {
    name: "Case Closed",
    img: "/assets/Slot/CG-SLOT-110.Case Closed.webp?v=1764665927460",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-110",
    platFormCode: "CG",
  },
  {
    name: "Case Closed",
    img: "/assets/Slot/RT-SLOT-255.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-255",
    platFormCode: "RT",
  },
  {
    name: "Cash Bonanza",
    img: "/assets/Slot/PP-SLOT-201.Cash-Bonanza.webp?v=1764392670183",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-201",
    platFormCode: "PP",
  },
  {
    name: "Cash Box",
    img: "/assets/Slot/PP-SLOT-360.Cash-Box_.webp?v=1764392615948",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-360",
    platFormCode: "PP",
  },
  {
    name: "Cash Chips",
    img: "/assets/Slot/PP-SLOT-387.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-387",
    platFormCode: "PP",
  },
  {
    name: "Cash Coin",
    img: "/assets/Slot/JILI-SLOT-157.Cash Coin.webp?v=1764311869289",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-157",
    platFormCode: "JILI",
  },
  {
    name: "Cash Defense",
    img: "/assets/Slot/RELAX-SLOT-181.webp?v=1761891798687",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-181",
    platFormCode: "RELAX",
  },
  {
    name: "Cash Elevator",
    img: "/assets/Slot/PP-SLOT-182.Cash-Elevator.webp?v=1764392556677",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-182",
    platFormCode: "PP",
  },
  {
    name: "Cash Explorer",
    img: "/assets/Slot/RT-SLOT-339.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-339",
    platFormCode: "RT",
  },
  {
    name: "Cash Goddess",
    img: "/assets/Slot/RT-SLOT-353.webp?v=1753341329890",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-353",
    platFormCode: "RT",
  },
  {
    name: "Cash IT",
    img: "/assets/Slot/PT-SLOT-260.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-260",
    platFormCode: "PT",
  },
  {
    name: "Cash Inferno Sizzling Scatters",
    img: "/assets/Slot/OCTOPLAY-SLOT-048.Cash Inferno Sizzling Scatters.webp?v=1764932383099",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-048",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Cash Lamps",
    img: "/assets/Slot/RT-SLOT-366.Cash Lamps.webp?v=1765033729365",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-366",
    platFormCode: "RT",
  },
  {
    name: "Cash Mania",
    img: "/assets/Slot/PG-SLOT-134.webp?v=1765933237857",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-134",
    platFormCode: "PG",
  },
  {
    name: "Cash Maximus: Battle Arena",
    img: "/assets/Slot/OCTOPLAY-SLOT-087.Cash Maximus Battle Arena.webp?v=1764932408301",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-087",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Cash On Wheels: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-064.Cash on Wheels Hold and Win.webp?v=1764932448546",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-064",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Cash Patrol",
    img: "/assets/Slot/PP-SLOT-230.Cash-Patrol.webp?v=1764392507137",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-230",
    platFormCode: "PP",
  },
  {
    name: "Cash Strike",
    img: "/assets/Slot/OCTOPLAY-SLOT-006.Cash Strike.webp?v=1764932489493",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-006",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Cash Surge",
    img: "/assets/Slot/PP-SLOT-561.webp?v=1755572303802",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-561",
    platFormCode: "PP",
  },
  {
    name: "Cash Ultimate",
    img: "/assets/Slot/RT-SLOT-123.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-123",
    platFormCode: "RT",
  },
  {
    name: "Cash Volt",
    img: "/assets/Slot/RT-SLOT-090.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-090",
    platFormCode: "RT",
  },
  {
    name: "Cash or Nothing",
    img: "/assets/Slot/RT-SLOT-179.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-179",
    platFormCode: "RT",
  },
  {
    name: "CashKing",
    img: "/assets/Slot/ACEWIN-SLOT-030.Cash king.webp?v=1764853966005",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-030",
    platFormCode: "ACEWIN",
  },
  {
    name: "Casino Night",
    img: "/assets/Slot/NETENT-SLOT-214.Casino-Night.webp?v=1764961890621",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-214",
    platFormCode: "NETENT",
  },
  {
    name: "Casino Spin",
    img: "/assets/Slot/RT-SLOT-275.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-275",
    platFormCode: "RT",
  },
  {
    name: "Casino Win Spin",
    img: "/assets/Slot/NLC-SLOT-058.Casino Win Spin.webp?v=1764391956834",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-058",
    platFormCode: "NLC",
  },
  {
    name: "Castle Cash Megaways",
    img: "/assets/Slot/YGG-SLOT-334.webp?v=1767056428833",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-334",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Castle of Fire",
    img: "/assets/Slot/PP-SLOT-408.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-408",
    platFormCode: "PP",
  },
  {
    name: "Castle of Terror",
    img: "/assets/Slot/BTG-SLOT-002.webp?v=1756256536926",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-002",
    platFormCode: "BTG",
  },
  {
    name: "Castle of Terror 2",
    img: "/assets/Slot/BTG-SLOT-069.Castle of Terror 2.webp?v=1764410060847",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-069",
    platFormCode: "BTG",
  },
  {
    name: "Cat Queen",
    img: "/assets/Slot/PT-SLOT-058.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-058",
    platFormCode: "PT",
  },
  {
    name: "Cauldron",
    img: "/assets/Slot/YGG-SLOT-014.webp?v=1767056428339",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-014",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Caveman Bob",
    img: "/assets/Slot/RELAX-SLOT-022.webp?v=1761891878037",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-022",
    platFormCode: "RELAX",
  },
  {
    name: "Cazino Cosmos",
    img: "/assets/Slot/YGG-SLOT-106.webp?v=1767056428444",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-106",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cazino Zeppelin",
    img: "/assets/Slot/YGG-SLOT-116.webp?v=1767056428453",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-116",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cazino Zeppelin Reloaded",
    img: "/assets/Slot/YGG-SLOT-126.webp?v=1767056428463",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-126",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cereal Thrillers",
    img: "/assets/Slot/YGG-SLOT-371.webp?v=1767056428878",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-371",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Champion of the Underworld Gigablox Wild Fight",
    img: "/assets/Slot/YGG-SLOT-162.webp?v=1767056428493",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-162",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Champions of Rome",
    img: "/assets/Slot/YGG-SLOT-112.webp?v=1767056428450",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-112",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Chaoji 8",
    img: "/assets/Slot/CG-SLOT-022.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-022",
    platFormCode: "CG",
  },
  {
    name: "Chaoji 888",
    img: "/assets/Slot/PT-SLOT-023.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-023",
    platFormCode: "PT",
  },
  {
    name: "Charge Buffalo",
    img: "/assets/Slot/JILI-SLOT-026.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-026",
    platFormCode: "JILI",
  },
  {
    name: "Charge Buffalo Ascent",
    img: "/assets/Slot/JILI-SLOT-093.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-093",
    platFormCode: "JILI",
  },
  {
    name: "Chase for Glory",
    img: "/assets/Slot/PP-SLOT-399.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-399",
    platFormCode: "PP",
  },
  {
    name: "Cheeky Emperor",
    img: "/assets/Slot/PP-SLOT-264.Cheeky-Emperor.webp?v=1764392402979",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-264",
    platFormCode: "PP",
  },
  {
    name: "Chef Lady",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-006.chef-lady.webp?v=1765276314739",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-006",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Cherry Love",
    img: "/assets/Slot/P8-SLOT-010.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-010",
    platFormCode: "PLAY8",
  },
  {
    name: "Chests of Cai Shen",
    img: "/assets/Slot/PP-SLOT-502.Chests-of-Cai-Shen.webp?v=1764392348722",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-502",
    platFormCode: "PP",
  },
  {
    name: "Chests of Cai Shen 2",
    img: "/assets/Slot/PP-SLOT-605.Chests of Cai Shen 2.webp?v=1764392290871",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-605",
    platFormCode: "PP",
  },
  {
    name: "Chibeasties",
    img: "/assets/Slot/YGG-SLOT-021.webp?v=1767056428347",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-021",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Chicken Chase",
    img: "/assets/Slot/PP-SLOT-237.Chicken-Chase.webp?v=1764392246635",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-237",
    platFormCode: "PP",
  },
  {
    name: "Chicken Dinner",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-050.chicken-dinner.webp?v=1765276168112",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-050",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Chicken Drop",
    img: "/assets/Slot/PP-SLOT-196.Chicken-Drop.webp?v=1764392196093",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-196",
    platFormCode: "PP",
  },
  {
    name: "Chili Eruption Thundershots",
    img: "/assets/Slot/PT-SLOT-100.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-100",
    platFormCode: "PT",
  },
  {
    name: "Chilli Champions UltraHitz",
    img: "/assets/Slot/YGG-SLOT-289.webp?v=1767056428793",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-289",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Chilli Heat",
    img: "/assets/Slot/PP-SLOT-110.Chilli-Heat.webp?v=1764392144633",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-110",
    platFormCode: "PP",
  },
  {
    name: "Chilli Heat Megaways",
    img: "/assets/Slot/PP-SLOT-199.Chilli-Heat-Megaways.webp?v=1764392089746",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-199",
    platFormCode: "PP",
  },
  {
    name: "Chilli Heat Spicy Spins",
    img: "/assets/Slot/PP-SLOT-582.Chilli Heat Spicy Spins.webp?v=1764392044353",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-582",
    platFormCode: "PP",
  },
  {
    name: "Chilli Hunter",
    img: "/assets/Slot/n1ydr5mncpogn.Chilli-Hunter.webp?v=1765035955294",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-030",
    platFormCode: "JOKER",
  },
  {
    name: "Chilli Hunter Bandidos",
    img: "/assets/Slot/uiu5zss55dc7h.Chilli-Hunter-Bandidos.webp?v=1765046383001",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-228",
    platFormCode: "JOKER",
  },
  {
    name: "Chilli Xtreme",
    img: "/assets/Slot/PT-SLOT-104.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-104",
    platFormCode: "PT",
  },
  {
    name: "Chin Shi Huang",
    img: "/assets/Slot/JILI-SLOT-003.webp?v=1755507914254",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-003",
    platFormCode: "JILI",
  },
  {
    name: "China",
    img: "/assets/Slot/dkzdo35rcipfs.China.webp?v=1765036657080",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-031",
    platFormCode: "JOKER",
  },
  {
    name: "Chinese Boss",
    img: "/assets/Slot/7tccifcktqre1.Chinese-Boss.webp?v=1765043020575",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-032",
    platFormCode: "JOKER",
  },
  {
    name: "Chinese Halloween",
    img: "/assets/Slot/CG-SLOT-113.Chinese Halloween.webp?v=1764665987186",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-113",
    platFormCode: "CG",
  },
  {
    name: "Chinese Kitchen",
    img: "/assets/Slot/PT-SLOT-060.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-060",
    platFormCode: "PT",
  },
  {
    name: "Chinese New Year",
    img: "/assets/Slot/CG-SLOT-083.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-083",
    platFormCode: "CG",
  },
  {
    name: "Chinese Wilds",
    img: "/assets/Slot/RT-SLOT-295.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-295",
    platFormCode: "RT",
  },
  {
    name: "Chip Spin",
    img: "/assets/Slot/RELAX-SLOT-057.webp?v=1761891911447",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-057",
    platFormCode: "RELAX",
  },
  {
    name: "Chocolate Deluxe",
    img: "/assets/Slot/PG-SLOT-149.webp?v=1765933237874",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-149",
    platFormCode: "PG",
  },
  {
    name: "Chocolate Shop",
    img: "/assets/Slot/gz8tgo1debywc.Chocolate Shop.webp?v=1765047443904",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-212",
    platFormCode: "JOKER",
  },
  {
    name: "Chocolates",
    img: "/assets/Slot/BTG-SLOT-044.webp?v=1756256536959",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-044",
    platFormCode: "BTG",
  },
  {
    name: "Christmas Big Bass Bonanza",
    img: "/assets/Slot/PP-SLOT-211.Christmas-Big-Bass-Bonanza.webp?v=1764391956460",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-211",
    platFormCode: "PP",
  },
  {
    name: "Christmas Bonanza",
    img: "/assets/Slot/BTG-SLOT-010.webp?v=1756256536933",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-010",
    platFormCode: "BTG",
  },
  {
    name: "Christmas Carol Megaways",
    img: "/assets/Slot/PP-SLOT-018.Christmas-Carol-Megaways.webp?v=1764391905822",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-018",
    platFormCode: "PP",
  },
  {
    name: "Christmas Catch",
    img: "/assets/Slot/BTG-SLOT-021.webp?v=1756256536941",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-021",
    platFormCode: "BTG",
  },
  {
    name: "Christmas Crumble",
    img: "/assets/Slot/OCTOPLAY-SLOT-034.Christmas Crumble.webp?v=1764932530509",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-034",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Christmas Eve",
    img: "/assets/Slot/ddodhamgc71gk.Christmas Eve.webp?v=1765047660859",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-209",
    platFormCode: "JOKER",
  },
  {
    name: "Christmas Link Express: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-059.Christmas Link Express Hold & Win.webp?v=1764932572986",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-059",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Christmas MULTIHOPS",
    img: "/assets/Slot/RT-SLOT-251.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-251",
    platFormCode: "RT",
  },
  {
    name: "Christmas Miracles",
    img: "/assets/Slot/SG-SLOT-119.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-119",
    platFormCode: "SPADE",
  },
  {
    name: "Christmas Plaza DoubleMax",
    img: "/assets/Slot/YGG-SLOT-170.webp?v=1767056428508",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-170",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Christmas Santa",
    img: "/assets/Slot/RELAX-SLOT-085.webp?v=1761892173844",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-085",
    platFormCode: "RELAX",
  },
  {
    name: "Circle of Sylvan",
    img: "/assets/Slot/RELAX-SLOT-257.webp?v=1761892222591",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-257",
    platFormCode: "RELAX",
  },
  {
    name: "Circuit Shock",
    img: "/assets/Slot/PT-SLOT-352.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-352",
    platFormCode: "PT",
  },
  {
    name: "Circus Delight",
    img: "/assets/Slot/PG-SLOT-059.webp?v=1765933237796",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-059",
    platFormCode: "PG",
  },
  {
    name: "Circus Joker 4096",
    img: "/assets/Slot/JILI-SLOT-136.circus-joker-4096.webp?v=1764310876561",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-136",
    platFormCode: "JILI",
  },
  {
    name: "Cirque Dе La Fortune",
    img: "/assets/Slot/RT-SLOT-144.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-144",
    platFormCode: "RT",
  },
  {
    name: "City Of Poli",
    img: "/assets/Slot/CG-SLOT-024.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-024",
    platFormCode: "CG",
  },
  {
    name: "Clash of the Beasts",
    img: "/assets/Slot/RT-SLOT-145.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-145",
    platFormCode: "RT",
  },
  {
    name: "Clash of the Giants",
    img: "/assets/Slot/SG-SLOT-139.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-139",
    platFormCode: "SPADE",
  },
  {
    name: "CleoPatrick",
    img: "/assets/Slot/YGG-SLOT-247.webp?v=1767056428597",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-247",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cleocatra",
    img: "/assets/Slot/PP-SLOT-255.Cleocatra.webp?v=1764391852167",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-255",
    platFormCode: "PP",
  },
  {
    name: "Cleopatra's Treasure",
    img: "/assets/Slot/KM-SLOT-004.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-004",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Cleopatra’s Fortune Ways",
    img: "/assets/Slot/KM-SLOT-025.Cleopatra’s Fortune Ways.webp?v=1764860806393",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-025",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Clover Coins 4x4",
    img: "/assets/Slot/JILI-SLOT-148.Clover Coins 4x4.webp?v=1764311058321",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-148",
    platFormCode: "JILI",
  },
  {
    name: "Clover Craze",
    img: "/assets/Slot/RT-SLOT-287.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-287",
    platFormCode: "RT",
  },
  {
    name: "Clover Fortunes",
    img: "/assets/Slot/RELAX-SLOT-124.webp?v=1761892257315",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-124",
    platFormCode: "RELAX",
  },
  {
    name: "Clover Gold",
    img: "/assets/Slot/PP-SLOT-251.Clover-Gold.webp?v=1764391798669",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-251",
    platFormCode: "PP",
  },
  {
    name: "Club Tropicana",
    img: "/assets/Slot/PP-SLOT-321.Club-Tropicana.webp?v=1764391746435",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-321",
    platFormCode: "PP",
  },
  {
    name: "Cluster Mania",
    img: "/assets/Slot/iw7az1sm3drhh.Cluster-Mania.webp?v=1765049706524",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-033",
    platFormCode: "JOKER",
  },
  {
    name: "Cluster Tumble",
    img: "/assets/Slot/RELAX-SLOT-094.webp?v=1761892285729",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-094",
    platFormCode: "RELAX",
  },
  {
    name: "Cobra Queen",
    img: "/assets/Slot/RT-SLOT-276.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-276",
    platFormCode: "RT",
  },
  {
    name: "Cocktail Nights",
    img: "/assets/Slot/PG-SLOT-090.webp?v=1765933237820",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-090",
    platFormCode: "PG",
  },
  {
    name: "Code of Cairo",
    img: "/assets/Slot/PP-SLOT-631.Code of Cairo.webp?v=1764391553134",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-631",
    platFormCode: "PP",
  },
  {
    name: "Coffee Wild",
    img: "/assets/Slot/PP-SLOT-263.Coffee-Wild.webp?v=1764391518632",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-263",
    platFormCode: "PP",
  },
  {
    name: "Coin Bang Bang: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-111.Coin Bang Bang Hold & Win.webp?v=1764932592830",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-111",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Coin Cat",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-001.coin-cat.webp?v=1765276117572",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-001",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Coin Infinity",
    img: "/assets/Slot/JILI-SLOT-122.webp?v=1755510869140",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-122",
    platFormCode: "JILI",
  },
  {
    name: "Coin Rat",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-046.coin-rat.webp?v=1765276018511",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-046",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Coin Tree",
    img: "/assets/Slot/JILI-SLOT-125.webp?v=1755510887768",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-125",
    platFormCode: "JILI",
  },
  {
    name: "Coins of Fortune",
    img: "/assets/Slot/NLC-SLOT-056.Coins of Fortune.webp?v=1764391894826",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-056",
    platFormCode: "NLC",
  },
  {
    name: "Colossal Cash Zone",
    img: "/assets/Slot/PP-SLOT-232.Colossal Cash Zone.webp?v=1764391463566",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-232",
    platFormCode: "PP",
  },
  {
    name: "Columbus",
    img: "/assets/Slot/aij68ciusna5c.Columbus.webp?v=1765051211805",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-034",
    platFormCode: "JOKER",
  },
  {
    name: "Congo Cash",
    img: "/assets/Slot/PP-SLOT-009.Congo-Cash.webp?v=1764391413306",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-009",
    platFormCode: "PP",
  },
  {
    name: "Congo Cash XL",
    img: "/assets/Slot/PP-SLOT-494.Congo-Cash-XL.webp?v=1764391352840",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-494",
    platFormCode: "PP",
  },
  {
    name: "CooCoo Farm",
    img: "/assets/Slot/JDB-SLOT-112.coocoo-farm.webp?v=1767691582025",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-112",
    platFormCode: "JDB",
  },
  {
    name: "Copy Cats",
    img: "/assets/Slot/NETENT-SLOT-159.Copy-Cats.webp?v=1764961750352",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-159",
    platFormCode: "NETENT",
  },
  {
    name: "Cornelius",
    img: "/assets/Slot/NETENT-SLOT-129.Cornelius.webp?v=1764961717097",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-129",
    platFormCode: "NETENT",
  },
  {
    name: "Cosmic Cash",
    img: "/assets/Slot/PP-SLOT-258.Cosmic-Cash.webp?v=1764391297899",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-258",
    platFormCode: "PP",
  },
  {
    name: "Cosmic Drop",
    img: "/assets/Slot/YGG-SLOT-420.webp?v=1767056428928",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-420",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cotton Gang Affair",
    img: "/assets/Slot/RT-SLOT-277.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-277",
    platFormCode: "RT",
  },
  {
    name: "Cowabunga",
    img: "/assets/Slot/RELAX-SLOT-258.webp?v=1761892313667",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-258",
    platFormCode: "RELAX",
  },
  {
    name: "Cowboy Coins",
    img: "/assets/Slot/PP-SLOT-339.Cowboy-Coins.webp?v=1764391244953",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-339",
    platFormCode: "PP",
  },
  {
    name: "Cowboys Gold",
    img: "/assets/Slot/PP-SLOT-019.Cowboys-Gold.webp?v=1764391193123",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-019",
    platFormCode: "PP",
  },
  {
    name: "Crab Chaos",
    img: "/assets/Slot/YGG-SLOT-380.webp?v=1767056428886",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-380",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Crack the Pumpkin Bank",
    img: "/assets/Slot/OCTOPLAY-SLOT-122.Crack the Pumpkin Bank.webp?v=1764932611948",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-122",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Crank It Up",
    img: "/assets/Slot/PP-SLOT-474.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-474",
    platFormCode: "PP",
  },
  {
    name: "Crazy 7",
    img: "/assets/Slot/PT-SLOT-124.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-124",
    platFormCode: "PT",
  },
  {
    name: "Crazy FaFaFa",
    img: "/assets/Slot/JILI-SLOT-017.webp?v=1755509264855",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-017",
    platFormCode: "JILI",
  },
  {
    name: "Crazy Money",
    img: "/assets/Slot/YesBingo-SLOT-029.Crazy Money.webp?v=1765106176645",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-029",
    platFormCode: "YESBINGO",
  },
  {
    name: "Crazy Pusher",
    img: "/assets/Slot/JILI-SLOT-054.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-054",
    platFormCode: "JILI",
  },
  {
    name: "Crazy777 2",
    img: "/assets/Slot/JILI-SLOT-149.Crazy777 2.webp?v=1764310911330",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-149",
    platFormCode: "JILI",
  },
  {
    name: "CrazyMonkey",
    img: "/assets/Slot/P8-SLOT-029.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-029",
    platFormCode: "PLAY8",
  },
  {
    name: "Cricket King 18",
    img: "/assets/Slot/JILI-SLOT-078.webp?v=1755510097666",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-078",
    platFormCode: "JILI",
  },
  {
    name: "Cricket Sah 75",
    img: "/assets/Slot/JILI-SLOT-082.webp?v=1755510148194",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-082",
    platFormCode: "JILI",
  },
  {
    name: "Cricket Star ITP",
    img: "/assets/Slot/CG-SLOT-100.Cricket Star ITP.webp?v=1764666039712",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-100",
    platFormCode: "CG",
  },
  {
    name: "Critter Mania Deluxe",
    img: "/assets/Slot/zowjitp4zqhm1.Critter-Mania-deluxe.webp?v=1765048279649",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-035",
    platFormCode: "JOKER",
  },
  {
    name: "Crop of the Dead",
    img: "/assets/Slot/OCTOPLAY-SLOT-057.Crop of The Dead.webp?v=1764932648567",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-057",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Crossy Road",
    img: "/assets/Slot/CG-SLOT-062.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-062",
    platFormCode: "CG",
  },
  {
    name: "Crown of Fire",
    img: "/assets/Slot/PP-SLOT-284.Crown-of-Fire.webp?v=1764391137544",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-284",
    platFormCode: "PP",
  },
  {
    name: "Cruise Royale",
    img: "/assets/Slot/PG-SLOT-121.webp?v=1765933237846",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-121",
    platFormCode: "PG",
  },
  {
    name: "Crypto Gold",
    img: "/assets/Slot/PG-SLOT-072.webp?v=1765933237805",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-072",
    platFormCode: "PG",
  },
  {
    name: "Cryptomania",
    img: "/assets/Slot/4akkze7ywgukq.Crypto-mania.webp?v=1765042271376",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-036",
    platFormCode: "JOKER",
  },
  {
    name: "Crystal 777 DELUXE",
    img: "/assets/Slot/JILI-SLOT-128.webp?v=1755510914395",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-128",
    platFormCode: "JILI",
  },
  {
    name: "Crystal Caverns Megaways",
    img: "/assets/Slot/PP-SLOT-221.Crystal-Caverns-Megaways.webp?v=1764391083571",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-221",
    platFormCode: "PP",
  },
  {
    name: "Crystal Falls",
    img: "/assets/Slot/YGG-SLOT-075.webp?v=1767056428415",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-075",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Crystal Fruits",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-025.crystal-fruits.webp?v=1765275952931",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-025",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Crystal Golem",
    img: "/assets/Slot/RELAX-SLOT-087.webp?v=1761892340024",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-087",
    platFormCode: "RELAX",
  },
  {
    name: "Crystal Mirror",
    img: "/assets/Slot/RT-SLOT-134.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-134",
    platFormCode: "RT",
  },
  {
    name: "Crystal Towers",
    img: "/assets/Slot/BTG-SLOT-062.webp?v=1756256536974",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-062",
    platFormCode: "BTG",
  },
  {
    name: "Cthulhu",
    img: "/assets/Slot/YGG-SLOT-123.webp?v=1767056428461",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-123",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cupid Archery",
    img: "/assets/Slot/KM-SLOT-017.webp?v=1762123476272",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-017",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Curse of Anubis",
    img: "/assets/Slot/PT-SLOT-150.Curse-of-Anubis.webp?v=1765032994731",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-150",
    platFormCode: "PT",
  },
  {
    name: "Curse of Ra",
    img: "/assets/Slot/RELAX-SLOT-245.webp?v=1761892376799",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-245",
    platFormCode: "RELAX",
  },
  {
    name: "Curse of the Mummies",
    img: "/assets/Slot/RELAX-SLOT-125.webp?v=1761892427331",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-125",
    platFormCode: "RELAX",
  },
  {
    name: "Curse of the Werewolf Megaways",
    img: "/assets/Slot/PP-SLOT-033.Curse-of-the-Werewolf-Megaways.webp?v=1764391030069",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-033",
    platFormCode: "PP",
  },
  {
    name: "Cursed Deluxe",
    img: "/assets/Slot/ue8mt39rhzpps.Cursed-Deluxe.webp?v=1765053061265",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-037",
    platFormCode: "JOKER",
  },
  {
    name: "Cursed treasure",
    img: "/assets/Slot/NETENT-SLOT-187.Cursed-Treasure.webp?v=1764961518199",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-187",
    platFormCode: "NETENT",
  },
  {
    name: "Cyber Attack",
    img: "/assets/Slot/RT-SLOT-256.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-256",
    platFormCode: "RT",
  },
  {
    name: "Cyber Doom",
    img: "/assets/Slot/YGG-SLOT-404.webp?v=1767056428915",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-404",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Cyber Race",
    img: "/assets/Slot/nqyun5dpcjtsy.Cyber-Race.webp?v=1765050556292",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-038",
    platFormCode: "JOKER",
  },
  {
    name: "Cyber Vault",
    img: "/assets/Slot/RELAX-SLOT-224.webp?v=1761892455322",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-224",
    platFormCode: "RELAX",
  },
  {
    name: "Cyberslot Megaclusters",
    img: "/assets/Slot/BTG-SLOT-049.webp?v=1756256536963",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-049",
    platFormCode: "BTG",
  },
  {
    name: "Cyclops Smash",
    img: "/assets/Slot/PP-SLOT-375.Cyclops-Smash.webp?v=1764390979655",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-375",
    platFormCode: "PP",
  },
  {
    name: "D Day",
    img: "/assets/Slot/NLC-SLOT-076.D Day.webp?v=1764391839279",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-076",
    platFormCode: "NLC",
  },
  {
    name: "DA LE MEN",
    img: "/assets/Slot/FC-SLOT-010.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-010",
    platFormCode: "FC",
  },
  {
    name: "DJ Neko",
    img: "/assets/Slot/PP-SLOT-636.DJ Neko.webp?v=1764840283321",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-636",
    platFormCode: "PP",
  },
  {
    name: "DJ Psycho",
    img: "/assets/Slot/NLC-SLOT-071.DJ Psycho.webp?v=1764391746657",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-071",
    platFormCode: "NLC",
  },
  {
    name: "DJ Remix",
    img: "/assets/Slot/CG-SLOT-119.DJ Remix.webp?v=1764666085464",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-119",
    platFormCode: "CG",
  },
  {
    name: "DRAGON & TIGER",
    img: "/assets/Slot/2J-SLOT-022.DRAGON & TIGER.webp?v=1763550711308",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-022",
    platFormCode: "JJ",
  },
  {
    name: "Da Fu Xiao Fu",
    img: "/assets/Slot/SG-SLOT-055.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-055",
    platFormCode: "SPADE",
  },
  {
    name: "Da Vinci's Mystery",
    img: "/assets/Slot/RT-SLOT-146.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-146",
    platFormCode: "RT",
  },
  {
    name: "Da Vinci's Treasure",
    img: "/assets/Slot/PP-SLOT-098.Da-Vincis-Treasure.webp?v=1764390891519",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-098",
    platFormCode: "PP",
  },
  {
    name: "Dabanggg",
    img: "/assets/Slot/JILI-SLOT-088.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-088",
    platFormCode: "JILI",
  },
  {
    name: "Dance Party",
    img: "/assets/Slot/PP-SLOT-051.Dance-Party.webp?v=1764390805887",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-051",
    platFormCode: "PP",
  },
  {
    name: "Dancing Samba",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-078.dancing-samba.webp?v=1765275893694",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-078",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Danger High Voltage",
    img: "/assets/Slot/BTG-SLOT-009.webp?v=1756256536932",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-009",
    platFormCode: "BTG",
  },
  {
    name: "Danger High Voltage 2",
    img: "/assets/Slot/BTG-SLOT-056.webp?v=1756256536968",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-056",
    platFormCode: "BTG",
  },
  {
    name: "Darkness",
    img: "/assets/Slot/RELAX-SLOT-204.webp?v=1761892507263",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-204",
    platFormCode: "RELAX",
  },
  {
    name: "Das xBoot",
    img: "/assets/Slot/NLC-SLOT-001.Das xBoot.webp?v=1764391697996",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-001",
    platFormCode: "NLC",
  },
  {
    name: "Date With Miyo",
    img: "/assets/Slot/4py9dmfpwkt4y.Date-With-Miyo.webp?v=1765049481967",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-186",
    platFormCode: "JOKER",
  },
  {
    name: "Dawn of Anubis",
    img: "/assets/Slot/YGG-SLOT-342.webp?v=1767056428839",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-342",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Day of Dead",
    img: "/assets/Slot/PP-SLOT-203.Day-of-Dead.webp?v=1764390759966",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-203",
    platFormCode: "PP",
  },
  {
    name: "Dazzle Me™ Christmas",
    img: "/assets/Slot/NETENT-SLOT-224.dazzle-me-christmas.webp?v=1764961419269",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-224",
    platFormCode: "NETENT",
  },
  {
    name: "Dead Canary",
    img: "/assets/Slot/NLC-SLOT-009.webp?v=1762002940648",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-009",
    platFormCode: "NLC",
  },
  {
    name: "Dead Man's Riches",
    img: "/assets/Slot/PG-SLOT-157.webp?v=1765933237881",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-157",
    platFormCode: "PG",
  },
  {
    name: "Dead Man's Trail",
    img: "/assets/Slot/RELAX-SLOT-065.webp?v=1761892636041",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-065",
    platFormCode: "RELAX",
  },
  {
    name: "Dead Mans Fingers",
    img: "/assets/Slot/YGG-SLOT-132.webp?v=1767056428468",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-132",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dead Men Walking",
    img: "/assets/Slot/NLC-SLOT-118.dead men walking.webp?v=1764391580695",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-118",
    platFormCode: "NLC",
  },
  {
    name: "Dead Riders Trail",
    img: "/assets/Slot/RELAX-SLOT-134.webp?v=1761892674718",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-134",
    platFormCode: "RELAX",
  },
  {
    name: "Dead West",
    img: "/assets/Slot/NETENT-SLOT-232.Dead West.webp?v=1764961355861",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-232",
    platFormCode: "NETENT",
  },
  {
    name: "Dead or Alive 2™ Feature Buy",
    img: "/assets/Slot/NETENT-SLOT-005.Dead-or-Alive-2-Feature-Buy.webp?v=1764961270469",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-005",
    platFormCode: "NETENT",
  },
  {
    name: "Dead, Dead, or Deader",
    img: "/assets/Slot/NLC-SLOT-106.Dead, Dead, or Deader.webp?v=1765643343613",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-106",
    platFormCode: "NLC",
  },
  {
    name: "Deadly West",
    img: "/assets/Slot/YGG-SLOT-370.webp?v=1767056428877",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-370",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Deadwood R.I.P",
    img: "/assets/Slot/NLC-SLOT-091.Deadwood R.I.P.webp?v=1764391463888",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-091",
    platFormCode: "NLC",
  },
  {
    name: "Deadwood xNudge",
    img: "/assets/Slot/NLC-SLOT-010.Deadwood xNudge.webp?v=1764391390616",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-010",
    platFormCode: "NLC",
  },
  {
    name: "Dear Santa",
    img: "/assets/Slot/RT-SLOT-336.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-336",
    platFormCode: "RT",
  },
  {
    name: "Dear Senpai",
    img: "/assets/Slot/KM-SLOT-020.Dear Senpai.webp?v=1764860964288",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-020",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Deep Descent",
    img: "/assets/Slot/RELAX-SLOT-061.webp?v=1761892715863",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-061",
    platFormCode: "RELAX",
  },
  {
    name: "Defenders of Mystica",
    img: "/assets/Slot/YGG-SLOT-225.webp?v=1767056428571",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-225",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Demon Pots",
    img: "/assets/Slot/PP-SLOT-393.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-393",
    platFormCode: "PP",
  },
  {
    name: "Desert Legends",
    img: "/assets/Slot/RT-SLOT-257.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-257",
    platFormCode: "RT",
  },
  {
    name: "Desert Shark",
    img: "/assets/Slot/RELAX-SLOT-073.webp?v=1761892745628",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-073",
    platFormCode: "RELAX",
  },
  {
    name: "Desert Treasure",
    img: "/assets/Slot/PT-SLOT-066.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-066",
    platFormCode: "PT",
  },
  {
    name: "Desperate Dawgs",
    img: "/assets/Slot/YGG-SLOT-012.webp?v=1767056428336",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-012",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Desperate Dawgs 2 Gigablox",
    img: "/assets/Slot/YGG-SLOT-165.webp?v=1767056428503",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-165",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Destiny of sun and moon",
    img: "/assets/Slot/PG-SLOT-095.webp?v=1765933237824",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-095",
    platFormCode: "PG",
  },
  {
    name: "Devil Fire",
    img: "/assets/Slot/JILI-SLOT-085.webp?v=1755510194476",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-085",
    platFormCode: "JILI",
  },
  {
    name: "Devil Fire 2",
    img: "/assets/Slot/JILI-SLOT-094.devil_fire_2.webp?v=1764311632936",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-094",
    platFormCode: "JILI",
  },
  {
    name: "Devil Wilds",
    img: "/assets/Slot/PT-SLOT-262.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-262",
    platFormCode: "PT",
  },
  {
    name: "Devil's 13",
    img: "/assets/Slot/PP-SLOT-160.Devil_s-13.webp?v=1764390697533",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-160",
    platFormCode: "PP",
  },
  {
    name: "Devil's Crossroad",
    img: "/assets/Slot/NLC-SLOT-077.Devil_s Crossroad.webp?v=1764391343252",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-077",
    platFormCode: "NLC",
  },
  {
    name: "Devilicious",
    img: "/assets/Slot/PP-SLOT-466.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-466",
    platFormCode: "PP",
  },
  {
    name: "Devil’s Delight",
    img: "/assets/Slot/YGG-SLOT-410.webp?v=1767056428919",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-410",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Devour the Weak",
    img: "/assets/Slot/YGG-SLOT-191.webp?v=1767056428529",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-191",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dia De Los Muertos Deluxe",
    img: "/assets/Slot/b6nuk4djp3zsa.Dia_De_Los_Muertos_Deluxe_.webp?v=1765054446761",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-039",
    platFormCode: "JOKER",
  },
  {
    name: "Diamond 7",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-060.diamond-7.webp?v=1765275772462",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-060",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Diamond Blitz",
    img: "/assets/Slot/RT-SLOT-133.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-133",
    platFormCode: "RT",
  },
  {
    name: "Diamond Blitz 2",
    img: "/assets/Slot/RT-SLOT-323.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-323",
    platFormCode: "RT",
  },
  {
    name: "Diamond Cascade",
    img: "/assets/Slot/PP-SLOT-367.Diamond-Cascade.webp?v=1764390621550",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-367",
    platFormCode: "PP",
  },
  {
    name: "Diamond Delirium",
    img: "/assets/Slot/YGG-SLOT-331.webp?v=1767056428830",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-331",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Diamond Doggies",
    img: "/assets/Slot/RT-SLOT-332.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-332",
    platFormCode: "RT",
  },
  {
    name: "Diamond Fruits",
    img: "/assets/Slot/BTG-SLOT-034.webp?v=1756256536952",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-034",
    platFormCode: "BTG",
  },
  {
    name: "Diamond Match",
    img: "/assets/Slot/PT-SLOT-267.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-267",
    platFormCode: "PT",
  },
  {
    name: "Diamond Match Deluxe",
    img: "/assets/Slot/PT-SLOT-360.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-360",
    platFormCode: "PT",
  },
  {
    name: "Diamond Miner DuoMax",
    img: "/assets/Slot/YGG-SLOT-260.webp?v=1767056428767",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-260",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Diamond Mogul",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-011.diamond-mogul.webp?v=1765275725893",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-011",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Diamond Party",
    img: "/assets/Slot/JILI-SLOT-021.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-021",
    platFormCode: "JILI",
  },
  {
    name: "Diamond Rise",
    img: "/assets/Slot/PT-SLOT-088.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-088",
    platFormCode: "PT",
  },
  {
    name: "Diamond Royale",
    img: "/assets/Slot/RT-SLOT-183.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-183",
    platFormCode: "RT",
  },
  {
    name: "Diamond Slot",
    img: "/assets/Slot/CG-SLOT-030.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-030",
    platFormCode: "CG",
  },
  {
    name: "Diamond Strike",
    img: "/assets/Slot/PP-SLOT-118.Diamond-Strike.webp?v=1764390557465",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-118",
    platFormCode: "PP",
  },
  {
    name: "Diamond Symphony DoubleMax",
    img: "/assets/Slot/YGG-SLOT-201.webp?v=1767056428551",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-201",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Diamonds",
    img: "/assets/Slot/RELAX-SLOT-141.webp?v=1761892782080",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-141",
    platFormCode: "RELAX",
  },
  {
    name: "Diamonds Up",
    img: "/assets/Slot/RT-SLOT-346.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-346",
    platFormCode: "RT",
  },
  {
    name: "Diamonds are Forever 3 Lines",
    img: "/assets/Slot/PP-SLOT-170.Diamonds are Forever 3 Lines.webp?v=1764390415783",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-170",
    platFormCode: "PP",
  },
  {
    name: "Diamonds of Egypt",
    img: "/assets/Slot/PP-SLOT-342.Diamonds-of-Egypt.webp?v=1764390352782",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-342",
    platFormCode: "PP",
  },
  {
    name: "Dice Dice Dice",
    img: "/assets/Slot/RT-SLOT-127.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-127",
    platFormCode: "RT",
  },
  {
    name: "Dick the Farmer",
    img: "/assets/Slot/YGG-SLOT-363.webp?v=1767056428870",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-363",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Diggin for Diamonds",
    img: "/assets/Slot/YGG-SLOT-230.webp?v=1767056428578",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-230",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Diggin for Diamonds 2",
    img: "/assets/Slot/YGG-SLOT-395.webp?v=1767056428903",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-395",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Diner Delights",
    img: "/assets/Slot/PG-SLOT-109.webp?v=1765933237836",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-109",
    platFormCode: "PG",
  },
  {
    name: "Diner Frenzy Spins",
    img: "/assets/Slot/PG-SLOT-159.webp?v=1765933237883",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-159",
    platFormCode: "PG",
  },
  {
    name: "Ding Dong Christmas Bells",
    img: "/assets/Slot/PP-SLOT-417.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-417",
    platFormCode: "PP",
  },
  {
    name: "Dino Drop",
    img: "/assets/Slot/PP-SLOT-630.Dino Drop.webp?v=1764390284792",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-630",
    platFormCode: "PP",
  },
  {
    name: "Disco Dive",
    img: "/assets/Slot/OCTOPLAY-SLOT-007.Disco Dive.webp?v=1764932686804",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-007",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Disco Lady",
    img: "/assets/Slot/PP-SLOT-247.Disco-Lady.webp?v=1764390252942",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-247",
    platFormCode: "PP",
  },
  {
    name: "Disturbed",
    img: "/assets/Slot/NLC-SLOT-067.Disturbed.webp?v=1764391282745",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-067",
    platFormCode: "NLC",
  },
  {
    name: "Divine 9",
    img: "/assets/Slot/PT-SLOT-332.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-332",
    platFormCode: "PT",
  },
  {
    name: "Divine Fortune Black",
    img: "/assets/Slot/NETENT-SLOT-230.Divine Fortune Black.webp?v=1764961162250",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-230",
    platFormCode: "NETENT",
  },
  {
    name: "Dog Fighters - Their Finest Hour",
    img: "/assets/Slot/YGG-SLOT-318.webp?v=1767056428818",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-318",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Doge Life",
    img: "/assets/Slot/OCTOPLAY-SLOT-047.Doge Life.webp?v=1764932723774",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-047",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Doggy Wealth",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-007.doggy-wealth.webp?v=1765275675285",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-007",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Dolphin Hot 1",
    img: "/assets/Slot/YGG-SLOT-287.webp?v=1767056428792",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-287",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dolphin Reef",
    img: "/assets/Slot/PT-SLOT-032.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-032",
    platFormCode: "PT",
  },
  {
    name: "Dolphin Reef",
    img: "/assets/Slot/P8-SLOT-006.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-006",
    platFormCode: "PLAY8",
  },
  {
    name: "Dolphin Treasure",
    img: "/assets/Slot/ateqfxp1sqamn.Dolphin-Treasure.webp?v=1765048728672",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-041",
    platFormCode: "JOKER",
  },
  {
    name: "Dolphins Pearl Deluxe",
    img: "/assets/Slot/43bx3e7ywgukq.Dolphins-Pearl-Deluxe.webp?v=1765042912088",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-042",
    platFormCode: "JOKER",
  },
  {
    name: "Donkey & The GOATS",
    img: "/assets/Slot/RELAX-SLOT-263.webp?v=1761892864989",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-263",
    platFormCode: "RELAX",
  },
  {
    name: "Dont Hit Plz",
    img: "/assets/Slot/RT-SLOT-296.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-296",
    platFormCode: "RT",
  },
  {
    name: "Donuts",
    img: "/assets/Slot/BTG-SLOT-035.webp?v=1756256536953",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-035",
    platFormCode: "BTG",
  },
  {
    name: "Doom's Digging Machine",
    img: "/assets/Slot/OCTOPLAY-SLOT-078.Doom_s Digging Machine.webp?v=1764932765709",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-078",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Doomsday Rampage",
    img: "/assets/Slot/PG-SLOT-155.webp?v=1765933237879",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-155",
    platFormCode: "PG",
  },
  {
    name: "Double Dragons",
    img: "/assets/Slot/YGG-SLOT-028.webp?v=1767056428357",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-028",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Double Fortune",
    img: "/assets/Slot/PG-SLOT-030.webp?v=1765933237772",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-030",
    platFormCode: "PG",
  },
  {
    name: "Double Fortunes",
    img: "/assets/Slot/SG-SLOT-038.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-038",
    platFormCode: "SPADE",
  },
  {
    name: "Double Fruit Frenzy DoubleMax",
    img: "/assets/Slot/YGG-SLOT-316.webp?v=1767056428816",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-316",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Double Lucky Mushrooms DoubleMax",
    img: "/assets/Slot/YGG-SLOT-176.webp?v=1767056428515",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-176",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Double Wilds",
    img: "/assets/Slot/JDB-SLOT-087.double_wilds.webp?v=1767691419778",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-087",
    platFormCode: "JDB",
  },
  {
    name: "Down The Rails",
    img: "/assets/Slot/PP-SLOT-278.Down-the-Rails.webp?v=1764390205362",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-278",
    platFormCode: "PP",
  },
  {
    name: "DrFrancashstein",
    img: "/assets/Slot/RT-SLOT-297.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-297",
    platFormCode: "RT",
  },
  {
    name: "Dracula",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-008.dracula.webp?v=1765275619339",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-008",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Dracula Awakening",
    img: "/assets/Slot/RT-SLOT-220.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-220",
    platFormCode: "RT",
  },
  {
    name: "Dragon",
    img: "/assets/Slot/JDB-SLOT-025.dragon.webp?v=1765263466344",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-025",
    platFormCode: "JDB",
  },
  {
    name: "Dragon Ball",
    img: "/assets/Slot/bnqnhhmsq748k.Dragon Ball.webp?v=1765041542544",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-231",
    platFormCode: "JOKER",
  },
  {
    name: "Dragon Black Gold",
    img: "/assets/Slot/CG-SLOT-106.Dragon Black Gold.webp?v=1764666139230",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-106",
    platFormCode: "CG",
  },
  {
    name: "Dragon Blox Gigablox",
    img: "/assets/Slot/YGG-SLOT-174.webp?v=1767056428513",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-174",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dragon Bond",
    img: "/assets/Slot/PT-SLOT-205.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-205",
    platFormCode: "PT",
  },
  {
    name: "Dragon Born",
    img: "/assets/Slot/BTG-SLOT-067.webp?v=1756256536978",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-067",
    platFormCode: "BTG",
  },
  {
    name: "Dragon Champions",
    img: "/assets/Slot/PT-SLOT-136.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-136",
    platFormCode: "PT",
  },
  {
    name: "Dragon Chi",
    img: "/assets/Slot/PT-SLOT-191.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-191",
    platFormCode: "PT",
  },
  {
    name: "Dragon Gems",
    img: "/assets/Slot/YesBingo-SLOT-032.dragon-gems.webp?v=1765105486483",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-032",
    platFormCode: "YESBINGO",
  },
  {
    name: "Dragon Gems Super Buy",
    img: "/assets/Slot/YesBingo-SLOT-036.dragon-gems-super-buy.webp?v=1765105288627",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-036",
    platFormCode: "YESBINGO",
  },
  {
    name: "Dragon Gems Wheel",
    img: "/assets/Slot/YesBingo-SLOT-038.Dragon Gems Wheel.webp?v=1765105082019",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-038",
    platFormCode: "YESBINGO",
  },
  {
    name: "Dragon Gold 88",
    img: "/assets/Slot/PP-SLOT-489.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-489",
    platFormCode: "PP",
  },
  {
    name: "Dragon Gold SA",
    img: "/assets/Slot/SG-SLOT-019.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-019",
    platFormCode: "SPADE",
  },
  {
    name: "Dragon Hatch",
    img: "/assets/Slot/PG-SLOT-042.webp?v=1765933237782",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-042",
    platFormCode: "PG",
  },
  {
    name: "Dragon Hatch 2",
    img: "/assets/Slot/PG-SLOT-131.webp?v=1765933237854",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-131",
    platFormCode: "PG",
  },
  {
    name: "Dragon Hero",
    img: "/assets/Slot/PP-SLOT-307.Dragon-Hero.webp?v=1764390100045",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-307",
    platFormCode: "PP",
  },
  {
    name: "Dragon Hot Hold and Spin",
    img: "/assets/Slot/PP-SLOT-184.Dragon-Hot-Hold-and-Spin.webp?v=1764390046600",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-184",
    platFormCode: "PP",
  },
  {
    name: "Dragon King Hot Pots",
    img: "/assets/Slot/PP-SLOT-527.Dragon King Hot Pots.webp?v=1764389996661",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-527",
    platFormCode: "PP",
  },
  {
    name: "Dragon King: Legend of the Seas",
    img: "/assets/Slot/RT-SLOT-120.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-120",
    platFormCode: "RT",
  },
  {
    name: "Dragon Kingdom",
    img: "/assets/Slot/PP-SLOT-131.Dragon-Kingdom.webp?v=1764389944548",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-131",
    platFormCode: "PP",
  },
  {
    name: "Dragon Legend",
    img: "/assets/Slot/PG-SLOT-016.webp?v=1765933237762",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-016",
    platFormCode: "PG",
  },
  {
    name: "Dragon Lore Gigarise",
    img: "/assets/Slot/YGG-SLOT-169.webp?v=1767056428507",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-169",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dragon Of The Eastern Sea",
    img: "/assets/Slot/fqho1inijjfwo.Dragon-Of-The-Eastern.webp?v=1765050956788",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-043",
    platFormCode: "JOKER",
  },
  {
    name: "Dragon Pearl",
    img: "/assets/Slot/RT-SLOT-121.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-121",
    platFormCode: "RT",
  },
  {
    name: "Dragon Phoenix",
    img: "/assets/Slot/w4ypzw6o48mpq.Dragon-Phoenix.webp?v=1765049815809",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-044",
    platFormCode: "JOKER",
  },
  {
    name: "Dragon Power Flame",
    img: "/assets/Slot/3yfmucpss64mk.Dragon-Power-Flame.webp?v=1765036956645",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-045",
    platFormCode: "JOKER",
  },
  {
    name: "Dragon Skies",
    img: "/assets/Slot/CG-SLOT-025.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-025",
    platFormCode: "CG",
  },
  {
    name: "Dragon Soar",
    img: "/assets/Slot/JDB-SLOT-121.dragon_soars.webp?v=1765263421509",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-121",
    platFormCode: "JDB",
  },
  {
    name: "Dragon Soar - Hyper Wild",
    img: "/assets/Slot/JDB-SLOT-125.dragon-soar-hyper-wild.webp?v=1765263383094",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-125",
    platFormCode: "JDB",
  },
  {
    name: "Dragon Spark",
    img: "/assets/Slot/PT-SLOT-195.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-195",
    platFormCode: "PT",
  },
  {
    name: "Dragon Tiger Luck",
    img: "/assets/Slot/PG-SLOT-035.webp?v=1765933237775",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-035",
    platFormCode: "PG",
  },
  {
    name: "Dragon Treasure",
    img: "/assets/Slot/JILI-SLOT-025.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-025",
    platFormCode: "JILI",
  },
  {
    name: "Dragon Tribe",
    img: "/assets/Slot/NLC-SLOT-041.Dragon Tribe.webp?v=1764391137733",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-041",
    platFormCode: "NLC",
  },
  {
    name: "Dragon Warrior",
    img: "/assets/Slot/JDB-SLOT-032.dragon_warrior.webp?v=1765263295153",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-032",
    platFormCode: "JDB",
  },
  {
    name: "Dragon Wish",
    img: "/assets/Slot/SG-SLOT-141.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-141",
    platFormCode: "SPADE",
  },
  {
    name: "Dragon's Fire INFINIREELS",
    img: "/assets/Slot/RT-SLOT-119.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-119",
    platFormCode: "RT",
  },
  {
    name: "Dragon's Fire MegaWays",
    img: "/assets/Slot/RT-SLOT-091.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-091",
    platFormCode: "RT",
  },
  {
    name: "Dragon's Luck Deluxe",
    img: "/assets/Slot/RT-SLOT-116.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-116",
    platFormCode: "RT",
  },
  {
    name: "Dragon's Luck MegaWays",
    img: "/assets/Slot/RT-SLOT-092.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-092",
    platFormCode: "RT",
  },
  {
    name: "Dragon's Mirror",
    img: "/assets/Slot/RT-SLOT-273.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-273",
    platFormCode: "RT",
  },
  {
    name: "Dragon's Realm",
    img: "/assets/Slot/4eekxm7cistkg.Dragon_s-Realm.webp?v=1765054343476",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-046",
    platFormCode: "JOKER",
  },
  {
    name: "Dragon's Treasure",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-056.dragon_s-treasure.webp?v=1765275571536",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-056",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Dragon's Treasure Quest",
    img: "/assets/Slot/PG-SLOT-160.webp?v=1765933237884",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-160",
    platFormCode: "PG",
  },
  {
    name: "DragonBaoBao",
    img: "/assets/Slot/ACEWIN-SLOT-005.Dragon Bao Bao.webp?v=1764853982137",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-005",
    platFormCode: "ACEWIN",
  },
  {
    name: "Dragonburst",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-064.dragonburst.webp?v=1765275516782",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-064",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Dragons Awakening",
    img: "/assets/Slot/RELAX-SLOT-023.webp?v=1761892892029",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-023",
    platFormCode: "RELAX",
  },
  {
    name: "Dragons Gate",
    img: "/assets/Slot/JDB-SLOT-092.dragons_gate.webp?v=1767691445570",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-092",
    platFormCode: "JDB",
  },
  {
    name: "Dragons Hall: Thundershots",
    img: "/assets/Slot/PT-SLOT-158.dragon_s-hall-thunder-shots.webp?v=1764330069657",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-158",
    platFormCode: "PT",
  },
  {
    name: "Dragons Legend",
    img: "/assets/Slot/ACEWIN-SLOT-012.5 Dragons Legend.webp?v=1764853999510",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-012",
    platFormCode: "ACEWIN",
  },
  {
    name: "Dragons Vs Gigablox",
    img: "/assets/Slot/YGG-SLOT-273.webp?v=1767056428780",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-273",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dragons World",
    img: "/assets/Slot/JDB-SLOT-069.dragons_world.webp?v=1765263184524",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-069",
    platFormCode: "JDB",
  },
  {
    name: "Dragons’ Lock",
    img: "/assets/Slot/RT-SLOT-338.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-338",
    platFormCode: "RT",
  },
  {
    name: "Dreadworks",
    img: "/assets/Slot/RELAX-SLOT-268.webp?v=1761892920781",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-268",
    platFormCode: "RELAX",
  },
  {
    name: "Dream Destiny",
    img: "/assets/Slot/RT-SLOT-278.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-278",
    platFormCode: "RT",
  },
  {
    name: "Dream of Macau",
    img: "/assets/Slot/PG-SLOT-054.webp?v=1765933237793",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-054",
    platFormCode: "PG",
  },
  {
    name: "Drill that Gold",
    img: "/assets/Slot/PP-SLOT-250.Drill-That-Gold.webp?v=1764389846068",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-250",
    platFormCode: "PP",
  },
  {
    name: "Drop for Top",
    img: "/assets/Slot/PT-SLOT-417.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-417",
    platFormCode: "PT",
  },
  {
    name: "Druid's Magic",
    img: "/assets/Slot/NETENT-SLOT-206.Druid_s-Magic.webp?v=1764960931249",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-206",
    platFormCode: "NETENT",
  },
  {
    name: "Dublin Up",
    img: "/assets/Slot/YGG-SLOT-150.webp?v=1767056428483",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-150",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Duck Hunters",
    img: "/assets/Slot/NLC-SLOT-103.Duck Hunters.webp?v=1764391079494",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-103",
    platFormCode: "NLC",
  },
  {
    name: "Duel of Night & Day",
    img: "/assets/Slot/PP-SLOT-656.Duel of Night & Day.webp?v=1764840486514",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-656",
    platFormCode: "PP",
  },
  {
    name: "Dueling Jokers",
    img: "/assets/Slot/RELAX-SLOT-180.webp?v=1761892972069",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-180",
    platFormCode: "RELAX",
  },
  {
    name: "Dungeon Quest",
    img: "/assets/Slot/NLC-SLOT-054.Dungeon Quest.webp?v=1764391029022",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-054",
    platFormCode: "NLC",
  },
  {
    name: "Dungeon Tower",
    img: "/assets/Slot/YGG-SLOT-167.webp?v=1767056428505",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-167",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dwarf & Dragon",
    img: "/assets/Slot/PP-SLOT-459.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-459",
    platFormCode: "PP",
  },
  {
    name: "Dwarf Mine",
    img: "/assets/Slot/YGG-SLOT-099.webp?v=1767056428439",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-099",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Dwarven Gold Deluxe",
    img: "/assets/Slot/PP-SLOT-139.Dwarven-Gold-Deluxe.webp?v=1764389729976",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-139",
    platFormCode: "PP",
  },
  {
    name: "Dynamite Diggin Doug",
    img: "/assets/Slot/PP-SLOT-478.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-478",
    platFormCode: "PP",
  },
  {
    name: "Dynamite Reels",
    img: "/assets/Slot/8u9r4tj48chd1.Dynamite-Reels.webp?v=1765041073435",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-047",
    platFormCode: "JOKER",
  },
  {
    name: "Dynamite Riches",
    img: "/assets/Slot/RT-SLOT-093.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-093",
    platFormCode: "RT",
  },
  {
    name: "Dynamite Riches MW + PowerWheel",
    img: "/assets/Slot/RT-SLOT-212.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-212",
    platFormCode: "RT",
  },
  {
    name: "Dynamite Trail: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-092.Dynamite Trail Hold & Win.webp?v=1764932816331",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-092",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Dystopia: Rebel Road",
    img: "/assets/Slot/OCTOPLAY-SLOT-053.Dystopia Rebel Road.webp?v=1764932855249",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-053",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "E-Force",
    img: "/assets/Slot/YGG-SLOT-186.webp?v=1767056428524",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-186",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "EGYPT BONANZA",
    img: "/assets/Slot/FC-SLOT-035.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-035",
    platFormCode: "FC",
  },
  {
    name: "ELVES",
    img: "/assets/Slot/2J-SLOT-002.ELVES.webp?v=1763550667271",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-002",
    platFormCode: "JJ",
  },
  {
    name: "ENDLESS TREASURE",
    img: "/assets/Slot/2J-SLOT-030.ENDLESS TREASURE.webp?v=1763550614895",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-030",
    platFormCode: "JJ",
  },
  {
    name: "EPICAPE",
    img: "/assets/Slot/CG-SLOT-107.EPICAPE.webp?v=1764666210663",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-107",
    platFormCode: "CG",
  },
  {
    name: "Eagle Riches",
    img: "/assets/Slot/RT-SLOT-147.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-147",
    platFormCode: "RT",
  },
  {
    name: "East Coast Vs West Coast",
    img: "/assets/Slot/NLC-SLOT-029.East Coast Vs West Coast.webp?v=1764390980115",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-029",
    platFormCode: "NLC",
  },
  {
    name: "Easter Island",
    img: "/assets/Slot/YGG-SLOT-078.webp?v=1767056428419",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-078",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Easter Island 2",
    img: "/assets/Slot/YGG-SLOT-050.webp?v=1767056428380",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-050",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Easter Surprise",
    img: "/assets/Slot/PT-SLOT-067.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-067",
    platFormCode: "PT",
  },
  {
    name: "Easy Gold",
    img: "/assets/Slot/RT-SLOT-258.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-258",
    platFormCode: "RT",
  },
  {
    name: "Eggsponential",
    img: "/assets/Slot/OCTOPLAY-SLOT-033.Egg Sponential.webp?v=1764932901861",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-033",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Egypt Dynasty",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-055.egypt-dynasty.webp?v=1765275468104",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-055",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Egypt Oracle",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-015.egypt-oracle.webp?v=1765275428100",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-015",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Egypt Queen",
    img: "/assets/Slot/igg7tisz4ukhw.Egypt-Queen.webp?v=1765043924655",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-048",
    platFormCode: "JOKER",
  },
  {
    name: "Egypt's Book of Mystery",
    img: "/assets/Slot/PG-SLOT-051.webp?v=1765933237791",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-051",
    platFormCode: "PG",
  },
  {
    name: "Egypt's Glow",
    img: "/assets/Slot/JILI-SLOT-108.webp?v=1755510671883",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-108",
    platFormCode: "JILI",
  },
  {
    name: "Egyptian Emeralds",
    img: "/assets/Slot/PT-SLOT-204.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-204",
    platFormCode: "PT",
  },
  {
    name: "Egyptian Fortunes",
    img: "/assets/Slot/PP-SLOT-086.Egyptians-Fortune.webp?v=1764389669480",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-086",
    platFormCode: "PP",
  },
  {
    name: "El Dorado Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-006.webp?v=1767056428325",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-006",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "El Paso Gunfight xNudge",
    img: "/assets/Slot/NLC-SLOT-027.El Paso Gunfight xNudge.webp?v=1764390905074",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-027",
    platFormCode: "NLC",
  },
  {
    name: "El Ranchero Cash Collect Diamond Path",
    img: "/assets/Slot/PT-SLOT-415.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-415",
    platFormCode: "PT",
  },
  {
    name: "Eldritch Dungeon",
    img: "/assets/Slot/RELAX-SLOT-256.webp?v=1761893000212",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-256",
    platFormCode: "RELAX",
  },
  {
    name: "Electro Rebel",
    img: "/assets/Slot/CG-SLOT-095.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-095",
    platFormCode: "CG",
  },
  {
    name: "Elemental Gems Megaways",
    img: "/assets/Slot/PP-SLOT-228.Elemental-Gems-Megaways.webp?v=1764389616599",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-228",
    platFormCode: "PP",
  },
  {
    name: "Elemental Link Fire",
    img: "/assets/Slot/JDB-SLOT-110.elemental-link-fire.webp?v=1767691563708",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-110",
    platFormCode: "JDB",
  },
  {
    name: "Elemental Link Water",
    img: "/assets/Slot/JDB-SLOT-111.Elemental Link Water.webp?v=1767691572894",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-111",
    platFormCode: "JDB",
  },
  {
    name: "Elemento",
    img: "/assets/Slot/RELAX-SLOT-078.webp?v=1761893030240",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-078",
    platFormCode: "RELAX",
  },
  {
    name: "Elephant Treasure",
    img: "/assets/Slot/RT-SLOT-298.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-298",
    platFormCode: "RT",
  },
  {
    name: "Elf Bingo",
    img: "/assets/Slot/JILI-SLOT-081.elf_bingo.webp?v=1764311744575",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-081",
    platFormCode: "JILI",
  },
  {
    name: "Elixir of Wealth MultiBoost",
    img: "/assets/Slot/YGG-SLOT-299.webp?v=1767056428801",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-299",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Emerald King",
    img: "/assets/Slot/PP-SLOT-021.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-021",
    platFormCode: "PP",
  },
  {
    name: "Emerald King Rainbow Road",
    img: "/assets/Slot/PP-SLOT-010.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-010",
    platFormCode: "PP",
  },
  {
    name: "Emerald's Infinity Reels",
    img: "/assets/Slot/RELAX-SLOT-024.webp?v=1761893094484",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-024",
    platFormCode: "RELAX",
  },
  {
    name: "Emoji Riches",
    img: "/assets/Slot/PG-SLOT-089.webp?v=1765933237819",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-089",
    platFormCode: "PG",
  },
  {
    name: "Emotiwins",
    img: "/assets/Slot/PP-SLOT-614.Emotiwins.webp?v=1764389544851",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-614",
    platFormCode: "PP",
  },
  {
    name: "Emperor Caishen",
    img: "/assets/Slot/PP-SLOT-220.Emperor-Caishen.webp?v=1764389498655",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-220",
    platFormCode: "PP",
  },
  {
    name: "Emperor Gate",
    img: "/assets/Slot/P8-SLOT-017.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-017",
    platFormCode: "PLAY8",
  },
  {
    name: "Emperor of India",
    img: "/assets/Slot/RT-SLOT-315.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-315",
    platFormCode: "RT",
  },
  {
    name: "Emperors Favour",
    img: "/assets/Slot/PG-SLOT-028.webp?v=1765933237772",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-028",
    platFormCode: "PG",
  },
  {
    name: "Empress Regnant",
    img: "/assets/Slot/o7f9ih8t6559e.Empress-Regnant.webp?v=1765054742916",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-049",
    platFormCode: "JOKER",
  },
  {
    name: "Empty the Bank",
    img: "/assets/Slot/PP-SLOT-193.Empty-the-Bank.webp?v=1764389449191",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-193",
    platFormCode: "PP",
  },
  {
    name: "Enchanted Forest",
    img: "/assets/Slot/kxyznmbpret1y.Enchanted-Forest.webp?v=1765037446269",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-050",
    platFormCode: "JOKER",
  },
  {
    name: "Enchanted Water",
    img: "/assets/Slot/YGG-SLOT-214.webp?v=1767056428562",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-214",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Enter The KTV",
    img: "/assets/Slot/srd3xusx3ughr.Enter-The-KTV.webp?v=1765043393886",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-051",
    platFormCode: "JOKER",
  },
  {
    name: "Epic Ape",
    img: "/assets/Slot/PT-SLOT-021.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-021",
    platFormCode: "PT",
  },
  {
    name: "Epic Dreams",
    img: "/assets/Slot/RELAX-SLOT-244.webp?v=1761893191369",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-244",
    platFormCode: "RELAX",
  },
  {
    name: "Epic Fish: Marlin Madness",
    img: "/assets/Slot/PT-SLOT-477.Epic Fish Marlin Madness.webp?v=1764996518227",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-477",
    platFormCode: "PT",
  },
  {
    name: "Epic Joker",
    img: "/assets/Slot/RELAX-SLOT-025.webp?v=1761893220489",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-025",
    platFormCode: "RELAX",
  },
  {
    name: "Epic Treasure",
    img: "/assets/Slot/RT-SLOT-279.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-279",
    platFormCode: "RT",
  },
  {
    name: "Epic Treasure 2",
    img: "/assets/Slot/RT-SLOT-319.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-319",
    platFormCode: "RT",
  },
  {
    name: "Erik the Red",
    img: "/assets/Slot/RELAX-SLOT-026.webp?v=1761893245301",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-026",
    platFormCode: "RELAX",
  },
  {
    name: "Escape the Pyramid - Fire & Ice",
    img: "/assets/Slot/PP-SLOT-539.Escape the Pyramid - Fire & Ice.webp?v=1764389398593",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-539",
    platFormCode: "PP",
  },
  {
    name: "Eskimo Riches",
    img: "/assets/Slot/YGG-SLOT-393.webp?v=1767056428900",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-393",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Eternal Clash",
    img: "/assets/Slot/OCTOPLAY-SLOT-040.Eternal Clash.webp?v=1764932946311",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-040",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Eternal Clash Reloaded",
    img: "/assets/Slot/OCTOPLAY-SLOT-046.Eternal Clash Reloaded.webp?v=1764932984955",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-046",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Eternal Empress - Freeze Time",
    img: "/assets/Slot/PP-SLOT-520.Eternal Empress – Freeze Time.webp?v=1764389342986",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-520",
    platFormCode: "PP",
  },
  {
    name: "Eternal Lady",
    img: "/assets/Slot/PT-SLOT-025.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-025",
    platFormCode: "PT",
  },
  {
    name: "Everest",
    img: "/assets/Slot/RELAX-SLOT-184.webp?v=1761893272389",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-184",
    platFormCode: "RELAX",
  },
  {
    name: "Evil Cat",
    img: "/assets/Slot/CG-SLOT-094.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-094",
    platFormCode: "CG",
  },
  {
    name: "Evil Goblins xBomb",
    img: "/assets/Slot/NLC-SLOT-011.Evil Goblins xBomb.webp?v=1764390855785",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-011",
    platFormCode: "NLC",
  },
  {
    name: "Excalibur Unleashed",
    img: "/assets/Slot/PP-SLOT-344.Excalibur-Unleashed.webp?v=1764389259856",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-344",
    platFormCode: "PP",
  },
  {
    name: "Extra Chili Tapcards",
    img: "/assets/Slot/BTG-SLOT-065.webp?v=1756256536976",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-065",
    platFormCode: "BTG",
  },
  {
    name: "Extra Chilli",
    img: "/assets/Slot/BTG-SLOT-005.webp?v=1756256536929",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-005",
    platFormCode: "BTG",
  },
  {
    name: "Extra Juicy",
    img: "/assets/Slot/PP-SLOT-087.Extra Juicy.webp?v=1764389204393",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-087",
    platFormCode: "PP",
  },
  {
    name: "Extra Juicy Megaways",
    img: "/assets/Slot/PP-SLOT-224.Extra-Juicy-Megaways.webp?v=1764389152391",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-224",
    platFormCode: "PP",
  },
  {
    name: "Extreme Hot Gems",
    img: "/assets/Slot/YGG-SLOT-345.webp?v=1767056428841",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-345",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Eye of Cleopatra",
    img: "/assets/Slot/PP-SLOT-239.Eye-of-Cleopatra.webp?v=1764389099524",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-239",
    platFormCode: "PP",
  },
  {
    name: "Eye of Anubis",
    img: "/assets/Slot/PT-SLOT-162.Eye of Anubis.webp?v=1764327093870",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-162",
    platFormCode: "PT",
  },
  {
    name: "Eye of Persia 2",
    img: "/assets/Slot/YGG-SLOT-145.webp?v=1767056428478",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-145",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Eye of Spartacus",
    img: "/assets/Slot/PP-SLOT-570.Eye of Spartacus.webp?v=1764389045130",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-570",
    platFormCode: "PP",
  },
  {
    name: "Eye of the Storm",
    img: "/assets/Slot/PP-SLOT-006.Eye-of-the-Storm.webp?v=1764388991259",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-006",
    platFormCode: "PP",
  },
  {
    name: "FAFAFA",
    img: "/assets/Slot/2J-SLOT-027.FAFAFA.webp?v=1763550567473",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-027",
    platFormCode: "JJ",
  },
  {
    name: "FATHER KIM",
    img: "/assets/Slot/2J-SLOT-057.FATHER KIM.webp?v=1763550520119",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-057",
    platFormCode: "JJ",
  },
  {
    name: "FIRE 4: Cash Collect Quattro",
    img: "/assets/Slot/PT-SLOT-245.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-245",
    platFormCode: "PT",
  },
  {
    name: "FISH ON! BASS HUNTER",
    img: "/assets/Slot/2J-SLOT-052.FISH ON! BASS HUNTER.webp?v=1763550466856",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-052",
    platFormCode: "JJ",
  },
  {
    name: "FOOTBALL",
    img: "/assets/Slot/2J-SLOT-005.FOOTBALL.webp?v=1763550406997",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-005",
    platFormCode: "JJ",
  },
  {
    name: "FORTUNE BAMBOO PANDA",
    img: "/assets/Slot/2J-SLOT-018.FORTUNE BAMBOO PANDA.webp?v=1763550339340",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-018",
    platFormCode: "JJ",
  },
  {
    name: "FORTUNE DRAGON",
    img: "/assets/Slot/2J-SLOT-019.FORTUNE DRAGON.webp?v=1763550278941",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-019",
    platFormCode: "JJ",
  },
  {
    name: "FORTUNE EGG",
    img: "/assets/Slot/FC-SLOT-031.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-031",
    platFormCode: "FC",
  },
  {
    name: "FORTUNE GEMS",
    img: "/assets/Slot/2J-SLOT-050.FORTUNE GEMS.webp?v=1763550111414",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-050",
    platFormCode: "JJ",
  },
  {
    name: "FORTUNE GODDESS",
    img: "/assets/Slot/FC-SLOT-041.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-041",
    platFormCode: "FC",
  },
  {
    name: "FORTUNE KOI",
    img: "/assets/Slot/FC-SLOT-008.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-008",
    platFormCode: "FC",
  },
  {
    name: "FORTUNE MONEY BOOM",
    img: "/assets/Slot/FC-SLOT-039.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-039",
    platFormCode: "FC",
  },
  {
    name: "FORTUNE MOUSE",
    img: "/assets/Slot/2J-SLOT-042.FORTUNE MOUSE.webp?v=1763550055360",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-042",
    platFormCode: "JJ",
  },
  {
    name: "FORTUNE RABBIT",
    img: "/assets/Slot/2J-SLOT-039.FORTUNE RABBIT.webp?v=1763549979910",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-039",
    platFormCode: "JJ",
  },
  {
    name: "FORTUNE SHEEP",
    img: "/assets/Slot/FC-SLOT-037.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-037",
    platFormCode: "FC",
  },
  {
    name: "FORTUNE TIGER",
    img: "/assets/Slot/2J-SLOT-028.FORTUNE TIGER.webp?v=1763549866475",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-028",
    platFormCode: "JJ",
  },
  {
    name: "FRUIT MARY",
    img: "/assets/Slot/2J-SLOT-012.FRUIT MARY.webp?v=1763549760344",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-012",
    platFormCode: "JJ",
  },
  {
    name: "Fa Fa Babies",
    img: "/assets/Slot/RT-SLOT-175.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-175",
    platFormCode: "RT",
  },
  {
    name: "Fa Fa Babies 2",
    img: "/assets/Slot/RT-SLOT-322.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-322",
    platFormCode: "RT",
  },
  {
    name: "Fa Fa Fa",
    img: "/assets/Slot/JILI-SLOT-009.webp?v=1755509076960",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-009",
    platFormCode: "JILI",
  },
  {
    name: "Fa Fa Fa",
    img: "/assets/Slot/CG-SLOT-020.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-020",
    platFormCode: "CG",
  },
  {
    name: "FaFaDragon",
    img: "/assets/Slot/YesBingo-SLOT-007.Fa Fa Dragon.webp?v=1765104969955",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-007",
    platFormCode: "YESBINGO",
  },
  {
    name: "FaFaFa",
    img: "/assets/Slot/SG-SLOT-045.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-045",
    platFormCode: "SPADE",
  },
  {
    name: "FaFaFa2",
    img: "/assets/Slot/SG-SLOT-003.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-003",
    platFormCode: "SPADE",
  },
  {
    name: "Fabulous Eights",
    img: "/assets/Slot/5cx47jffukp3o.Fabulous-Eights.webp?v=1765054289656",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-052",
    platFormCode: "JOKER",
  },
  {
    name: "Fairytale Fortune",
    img: "/assets/Slot/PP-SLOT-108.Fairytale-Fortune.webp?v=1764388936963",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-108",
    platFormCode: "PP",
  },
  {
    name: "Falling Sakura",
    img: "/assets/Slot/CG-SLOT-065.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-065",
    platFormCode: "CG",
  },
  {
    name: "Fancy Egypt",
    img: "/assets/Slot/YesBingo-SLOT-013.Fancy Egypt.webp?v=1765104805744",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-013",
    platFormCode: "YESBINGO",
  },
  {
    name: "Fangtastic Freespins",
    img: "/assets/Slot/PP-SLOT-506.Fangtastic Freespins.webp?v=1764388866175",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-506",
    platFormCode: "PP",
  },
  {
    name: "Fantasy Falls",
    img: "/assets/Slot/YGG-SLOT-339.webp?v=1767056428837",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-339",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Farm Family",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-051.Farm Family.webp?v=1765275349363",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-051",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Farmland Frenzy Maxways",
    img: "/assets/Slot/SG-SLOT-122.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-122",
    platFormCode: "SPADE",
  },
  {
    name: "Fast Fruits Doublemax",
    img: "/assets/Slot/YGG-SLOT-207.webp?v=1767056428557",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-207",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fat Choy Choy Sun",
    img: "/assets/Slot/PT-SLOT-206.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-206",
    platFormCode: "PT",
  },
  {
    name: "Fat Panda",
    img: "/assets/Slot/PP-SLOT-355.Fat-Panda.webp?v=1764388812080",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-355",
    platFormCode: "PP",
  },
  {
    name: "Fatz's Diner",
    img: "/assets/Slot/YGG-SLOT-219.webp?v=1767056428566",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-219",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Feather Fury",
    img: "/assets/Slot/RELAX-SLOT-267.webp?v=1761893296949",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-267",
    platFormCode: "RELAX",
  },
  {
    name: "Fei Long Zai Tian",
    img: "/assets/Slot/PT-SLOT-027.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-027",
    platFormCode: "PT",
  },
  {
    name: "Feng Huang",
    img: "/assets/Slot/d4fyes4amfxf6.Feng-Huang.webp?v=1765044240012",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-055",
    platFormCode: "JOKER",
  },
  {
    name: "Feng Kuang Ma Jiang",
    img: "/assets/Slot/PT-SLOT-020.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-020",
    platFormCode: "PT",
  },
  {
    name: "Feng Shui Flip",
    img: "/assets/Slot/PT-SLOT-348.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-348",
    platFormCode: "PT",
  },
  {
    name: "Fengshen",
    img: "/assets/Slot/JILI-SLOT-022.webp?v=1755509312899",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-022",
    platFormCode: "JILI",
  },
  {
    name: "Festival 10K Ways",
    img: "/assets/Slot/YGG-SLOT-175.webp?v=1767056428514",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-175",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fiery Sevens Exclusive",
    img: "/assets/Slot/SG-SLOT-106.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-106",
    platFormCode: "SPADE",
  },
  {
    name: "Fiery Sevens Hot 100",
    img: "/assets/Slot/SG-SLOT-156.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-156",
    platFormCode: "SPADE",
  },
  {
    name: "Fiery Sevens Hot 20",
    img: "/assets/Slot/SG-SLOT-154.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-154",
    platFormCode: "SPADE",
  },
  {
    name: "Fiery Sevens Hot 5",
    img: "/assets/Slot/SG-SLOT-153.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-153",
    platFormCode: "SPADE",
  },
  {
    name: "Fiery Sevens Hot 50",
    img: "/assets/Slot/SG-SLOT-155.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-155",
    platFormCode: "SPADE",
  },
  {
    name: "Fiesta Explosiva DuoMax",
    img: "/assets/Slot/YGG-SLOT-298.webp?v=1767056428801",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-298",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fiesta Fortune",
    img: "/assets/Slot/PP-SLOT-565.Fiesta Fortune.webp?v=1764388761881",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-565",
    platFormCode: "PP",
  },
  {
    name: "Fifty Dragons",
    img: "/assets/Slot/k9gz4ebbrau1e.Fifty-Dragons.webp?v=1765043133778",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-056",
    platFormCode: "JOKER",
  },
  {
    name: "Fifty Lions",
    img: "/assets/Slot/fk9yoi4wkifrs.Fifty-Lions.webp?v=1765053544828",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-057",
    platFormCode: "JOKER",
  },
  {
    name: "Finn and The Candy Spin",
    img: "/assets/Slot/NETENT-SLOT-186.Finn-and-the-Candy-Spin.webp?v=1764960490160",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-186",
    platFormCode: "NETENT",
  },
  {
    name: "Finn and the Dragon Tales",
    img: "/assets/Slot/NETENT-SLOT-226.finn-and-the-dragon-tales.webp?v=1764960464857",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-226",
    platFormCode: "NETENT",
  },
  {
    name: "Fire 88",
    img: "/assets/Slot/PP-SLOT-109.Fire-88.webp?v=1764845613691",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-109",
    platFormCode: "PP",
  },
  {
    name: "Fire Archer",
    img: "/assets/Slot/PP-SLOT-322.Fire-Archer.webp?v=1764388531714",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-322",
    platFormCode: "PP",
  },
  {
    name: "Fire Ball Blaze Phoenix",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-080.fire-ball-blaze-phoenix.webp?v=1765275289450",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-080",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Fire Blaze Golden: Amazing Factory",
    img: "/assets/Slot/PT-SLOT-181.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-181",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze Golden: Buccaneer Bells",
    img: "/assets/Slot/PT-SLOT-165.Fire Blaze-Golden-Buccaneer-Bells.webp?v=1764328249072",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-165",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze Golden: Tundra Wolf",
    img: "/assets/Slot/PT-SLOT-157.fire,blaze-tundra-wolf.webp?v=1764330528802",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-157",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze Quattro: Celtic Charm",
    img: "/assets/Slot/PT-SLOT-074.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-074",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: Blue Wizard Megaways",
    img: "/assets/Slot/PT-SLOT-094.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-094",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: Fire Fighter",
    img: "/assets/Slot/PT-SLOT-232.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-232",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: Green Wizard",
    img: "/assets/Slot/PT-SLOT-336.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-336",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: Red Wizard",
    img: "/assets/Slot/PT-SLOT-167.fire blaze-red-wizard.webp?v=1764327974890",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-167",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: River Empress",
    img: "/assets/Slot/PT-SLOT-168.fire blaze-river-empress.webp?v=1764327699023",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-168",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: Sisters Gift",
    img: "/assets/Slot/PT-SLOT-169.fire-blaze-sister-gift.webp?v=1764327534085",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-169",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: Toltec Blocks",
    img: "/assets/Slot/PT-SLOT-264.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-264",
    platFormCode: "PT",
  },
  {
    name: "Fire Blaze: White Witch",
    img: "/assets/Slot/PT-SLOT-470.Fire Blaze White Witch.webp?v=1764940976143",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-470",
    platFormCode: "PT",
  },
  {
    name: "Fire Hot 100",
    img: "/assets/Slot/PP-SLOT-276.Fire Hot 100.webp?v=1764388485717",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-276",
    platFormCode: "PP",
  },
  {
    name: "Fire Hot 20",
    img: "/assets/Slot/PP-SLOT-274.Fire Hot 20.webp?v=1764388229021",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-274",
    platFormCode: "PP",
  },
  {
    name: "Fire Hot 40",
    img: "/assets/Slot/PP-SLOT-275.Fire Hot 40.webp?v=1764388174623",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-275",
    platFormCode: "PP",
  },
  {
    name: "Fire Hot 5",
    img: "/assets/Slot/PP-SLOT-273.Fire Hot 5.webp?v=1764388124013",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-273",
    platFormCode: "PP",
  },
  {
    name: "Fire In The Hole 2",
    img: "/assets/Slot/NLC-SLOT-078.Fire In The Hole 2.webp?v=1764390806253",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-078",
    platFormCode: "NLC",
  },
  {
    name: "Fire In The Hole xBomb",
    img: "/assets/Slot/NLC-SLOT-008.Fire In The Hole xBomb.webp?v=1764390734139",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-008",
    platFormCode: "NLC",
  },
  {
    name: "Fire Master Hold And Win",
    img: "/assets/Slot/aha65cfts455e.Fire Master Hold And Win.webp?v=1765045966501",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-232",
    platFormCode: "JOKER",
  },
  {
    name: "Fire Portals",
    img: "/assets/Slot/PP-SLOT-444.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-444",
    platFormCode: "PP",
  },
  {
    name: "Fire Reel",
    img: "/assets/Slot/yxdzc9d7qj3zy.Fire-Reel.webp?v=1765049587047",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-058",
    platFormCode: "JOKER",
  },
  {
    name: "Fire Reign",
    img: "/assets/Slot/ofy9b9z99u69r.Fire-Reign.webp?v=1765054791282",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-059",
    platFormCode: "JOKER",
  },
  {
    name: "Fire Siege Fortress",
    img: "/assets/Slot/NETENT-SLOT-169.Fire-siege-Fortress.webp?v=1764960329418",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-169",
    platFormCode: "NETENT",
  },
  {
    name: "Fire Stampede",
    img: "/assets/Slot/PP-SLOT-420.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-420",
    platFormCode: "PP",
  },
  {
    name: "Fire Stampede 2",
    img: "/assets/Slot/PP-SLOT-591.Fire Stampede 2.webp?v=1764388012396",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-591",
    platFormCode: "PP",
  },
  {
    name: "Fire Strike",
    img: "/assets/Slot/PP-SLOT-069.Fire-Strike.webp?v=1764387955781",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-069",
    platFormCode: "PP",
  },
  {
    name: "Fire Strike 2",
    img: "/assets/Slot/PP-SLOT-235.Fire-Strike-2.webp?v=1764387899084",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-235",
    platFormCode: "PP",
  },
  {
    name: "Fire Temple",
    img: "/assets/Slot/si838osdadyhc.Fire Temple.webp?v=1765037228005",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-219",
    platFormCode: "JOKER",
  },
  {
    name: "Fire in the Hole 3",
    img: "/assets/Slot/NLC-SLOT-113.Fire In The Hole 3.webp?v=1764390684075",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-113",
    platFormCode: "NLC",
  },
  {
    name: "Firebird Spirit",
    img: "/assets/Slot/PP-SLOT-299.Firebird Spirit.webp?v=1764387821638",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-299",
    platFormCode: "PP",
  },
  {
    name: "Firekick! Multimax",
    img: "/assets/Slot/YGG-SLOT-168.webp?v=1767056428506",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-168",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Firewins Factory",
    img: "/assets/Slot/RELAX-SLOT-227.Firewins Factory.webp?v=1763104867946",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-227",
    platFormCode: "RELAX",
  },
  {
    name: "Fireworks Megaways",
    img: "/assets/Slot/BTG-SLOT-041.webp?v=1756256536957",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-041",
    platFormCode: "BTG",
  },
  {
    name: "Fish Eye",
    img: "/assets/Slot/PP-SLOT-319.Fish-Eye.webp?v=1764387759867",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-319",
    platFormCode: "PP",
  },
  {
    name: "Fish N Fish",
    img: "/assets/Slot/RT-SLOT-363.Fish N Fish.webp?v=1765033308738",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-363",
    platFormCode: "RT",
  },
  {
    name: "Fish Party",
    img: "/assets/Slot/CG-SLOT-041.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-041",
    platFormCode: "CG",
  },
  {
    name: "Fishin' Bonanza",
    img: "/assets/Slot/PT-SLOT-089.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-089",
    platFormCode: "PT",
  },
  {
    name: "Fishin' Fever X-Huge",
    img: "/assets/Slot/JDB-SLOT-131.fishin_-fever-x-huge.webp?v=1767691331846",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-131",
    platFormCode: "JDB",
  },
  {
    name: "Fishing Expert",
    img: "/assets/Slot/CG-SLOT-037.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-037",
    platFormCode: "CG",
  },
  {
    name: "Fishtastic",
    img: "/assets/Slot/RT-SLOT-299.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-299",
    platFormCode: "RT",
  },
  {
    name: "Fist Champion",
    img: "/assets/Slot/ACEWIN-SLOT-009.Fist Champion.webp?v=1764854018746",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-009",
    platFormCode: "ACEWIN",
  },
  {
    name: "Five Clans",
    img: "/assets/Slot/YGG-SLOT-105.webp?v=1767056428443",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-105",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Five Tiger Generals",
    img: "/assets/Slot/j6j1rkbjfaz1a.Five-Tiger-Generals.webp?v=1765044533037",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-060",
    platFormCode: "JOKER",
  },
  {
    name: "Fizzy Pennyslot",
    img: "/assets/Slot/BTG-SLOT-050.webp?v=1756256536964",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-050",
    platFormCode: "BTG",
  },
  {
    name: "Flame & Fortune: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-086.Flame & Fortune Hold & Win.webp?v=1764933005482",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-086",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Flames Of Fortune",
    img: "/assets/Slot/3erm9p7wssiks.Flames-Of-Fortune.webp?v=1765054847391",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-061",
    platFormCode: "JOKER",
  },
  {
    name: "Flaming Frenzy",
    img: "/assets/Slot/OCTOPLAY-SLOT-024.Flaming Frenzy.webp?v=1764933052160",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-024",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Flight Mode",
    img: "/assets/Slot/NLC-SLOT-112.Flight Mode.webp?v=1764390659669",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-112",
    platFormCode: "NLC",
  },
  {
    name: "Flirting Scholar",
    img: "/assets/Slot/PG-SLOT-036.webp?v=1765933237776",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-036",
    platFormCode: "PG",
  },
  {
    name: "Flirting Scholar Tang",
    img: "/assets/Slot/JDB-SLOT-010.flirting_scholar_tang.webp?v=1765262983799",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-010",
    platFormCode: "JDB",
  },
  {
    name: "Floating Dragon",
    img: "/assets/Slot/PP-SLOT-177.Floating-Dragon.webp?v=1764387642656",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-177",
    platFormCode: "PP",
  },
  {
    name: "Floating Dragon - Dragon Boat Festival",
    img: "/assets/Slot/PP-SLOT-347.Floating-Dragon---Dragon-Boat-Festival.webp?v=1764387590844",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-347",
    platFormCode: "PP",
  },
  {
    name: "Floating Dragon - Year of the Snake",
    img: "/assets/Slot/PP-SLOT-533.Floating Dragon – Year of the Snake.webp?v=1764387532260",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-533",
    platFormCode: "PP",
  },
  {
    name: "Floating Dragon Megaways",
    img: "/assets/Slot/PP-SLOT-279.Floating-Dragon-Megaways.webp?v=1764387459042",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-279",
    platFormCode: "PP",
  },
  {
    name: "Floating Dragon New Year Festival Ultra Megaways",
    img: "/assets/Slot/PP-SLOT-423.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-423",
    platFormCode: "PP",
  },
  {
    name: "Flodder",
    img: "/assets/Slot/RT-SLOT-184.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-184",
    platFormCode: "RT",
  },
  {
    name: "Florageddon!",
    img: "/assets/Slot/YGG-SLOT-159.webp?v=1767056428491",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-159",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Flower Fortune Supreme",
    img: "/assets/Slot/RELAX-SLOT-127.webp?v=1761893561055",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-127",
    platFormCode: "RELAX",
  },
  {
    name: "Flowers Christmas Edition",
    img: "/assets/Slot/NETENT-SLOT-162.Flowes-Christmas-Edition.webp?v=1764960279349",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-162",
    platFormCode: "NETENT",
  },
  {
    name: "Fluffy Favourites: Cash Collect",
    img: "/assets/Slot/PT-SLOT-410.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-410",
    platFormCode: "PT",
  },
  {
    name: "Fly Cat$",
    img: "/assets/Slot/RELAX-SLOT-178.webp?v=1761893720638",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-178",
    platFormCode: "RELAX",
  },
  {
    name: "Follow the Cash Rabbit",
    img: "/assets/Slot/OCTOPLAY-SLOT-105.Follow the Cash Rabbit.webp?v=1764933079971",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-105",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Folsom Prison",
    img: "/assets/Slot/NLC-SLOT-007.Folsom Prison.webp?v=1764390621926",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-007",
    platFormCode: "NLC",
  },
  {
    name: "Fonzo’s Feline Fortunes",
    img: "/assets/Slot/PP-SLOT-532.Fonzo’s Feline Fortunes.webp?v=1764387390636",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-532",
    platFormCode: "PP",
  },
  {
    name: "Football Glory",
    img: "/assets/Slot/YGG-SLOT-047.webp?v=1767056428375",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-047",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Football Rules",
    img: "/assets/Slot/PT-SLOT-082.Football Rules.webp?v=1764328523554",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-082",
    platFormCode: "PT",
  },
  {
    name: "Football! Cash Collect",
    img: "/assets/Slot/PT-SLOT-238.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-238",
    platFormCode: "PT",
  },
  {
    name: "Forest Treasure",
    img: "/assets/Slot/wr5axzs95uq7r.Forest-Treasure.webp?v=1765053849527",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-063",
    platFormCode: "JOKER",
  },
  {
    name: "Forever 7's",
    img: "/assets/Slot/RT-SLOT-213.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-213",
    platFormCode: "RT",
  },
  {
    name: "Forge of Olympus",
    img: "/assets/Slot/PP-SLOT-373.Forge-of-Olympus-2.webp?v=1764387338841",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-373",
    platFormCode: "PP",
  },
  {
    name: "Forge of Wealth",
    img: "/assets/Slot/PG-SLOT-127.webp?v=1765933237851",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-127",
    platFormCode: "PG",
  },
  {
    name: "Forging Wilds",
    img: "/assets/Slot/PP-SLOT-486.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-486",
    platFormCode: "PP",
  },
  {
    name: "Formosa Bear",
    img: "/assets/Slot/JDB-SLOT-014.formosa_bear.webp?v=1765262922476",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-014",
    platFormCode: "JDB",
  },
  {
    name: "Fortune",
    img: "/assets/Slot/P8-SLOT-021.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-021",
    platFormCode: "PLAY8",
  },
  {
    name: "Fortune Ace",
    img: "/assets/Slot/PP-SLOT-426.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-426",
    platFormCode: "PP",
  },
  {
    name: "Fortune Coins",
    img: "/assets/Slot/JILI-SLOT-129.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-129",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Crown",
    img: "/assets/Slot/ym7ny95hxi38g.Fortune Crown.webp?v=1765053796287",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-218",
    platFormCode: "JOKER",
  },
  {
    name: "Fortune Crown 25",
    img: "/assets/Slot/m4uregaadrxb6.Fortune Crown 25.webp?v=1765041712340",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-225",
    platFormCode: "JOKER",
  },
  {
    name: "Fortune Crown Gold Gift",
    img: "/assets/Slot/c1qrr8e1ncebn.Fortune-Crown-Gold-Gift.webp?v=1765054531200",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-230",
    platFormCode: "JOKER",
  },
  {
    name: "Fortune Day",
    img: "/assets/Slot/PT-SLOT-046.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-046",
    platFormCode: "PT",
  },
  {
    name: "Fortune Dragon",
    img: "/assets/Slot/PP-SLOT-409.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-409",
    platFormCode: "PP",
  },
  {
    name: "Fortune Dragon",
    img: "/assets/Slot/PG-SLOT-132.webp?v=1765933237855",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-132",
    platFormCode: "PG",
  },
  {
    name: "Fortune Festival",
    img: "/assets/Slot/gqotnunpejbwy.Fortune-Festival.webp?v=1765053699277",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-064",
    platFormCode: "JOKER",
  },
  {
    name: "Fortune Four",
    img: "/assets/Slot/ACEWIN-SLOT-016.Fortune Four.webp?v=1764854044285",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-016",
    platFormCode: "ACEWIN",
  },
  {
    name: "Fortune Gods",
    img: "/assets/Slot/PG-SLOT-003.webp?v=1765933237755",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-003",
    platFormCode: "PG",
  },
  {
    name: "Fortune Hook Boom",
    img: "/assets/Slot/JILI-SLOT-156.Fortune Hook Boom.webp?v=1764310776734",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-156",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Horse",
    img: "/assets/Slot/JDB-SLOT-053.fortune_horse.webp?v=1765262870118",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-053",
    platFormCode: "JDB",
  },
  {
    name: "Fortune Horse",
    img: "/assets/Slot/PG-SLOT-171.webp?v=1770862519059",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-053",
    platFormCode: "JDB",
  },
  {
    name: "Fortune Jewel",
    img: "/assets/Slot/JDB-SLOT-128.fortune-jewel.webp?v=1765262831973",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-128",
    platFormCode: "JDB",
  },
  {
    name: "Fortune Lions",
    img: "/assets/Slot/PT-SLOT-044.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-044",
    platFormCode: "PT",
  },
  {
    name: "Fortune Llama",
    img: "/assets/Slot/RELAX-SLOT-167.webp?v=1761893765503",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-167",
    platFormCode: "RELAX",
  },
  {
    name: "Fortune Monkey",
    img: "/assets/Slot/JILI-SLOT-087.webp?v=1755510211015",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-087",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Mouse",
    img: "/assets/Slot/PG-SLOT-043.webp?v=1765933237783",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-043",
    platFormCode: "PG",
  },
  {
    name: "Fortune Ox",
    img: "/assets/Slot/PG-SLOT-070.webp?v=1765933237804",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-070",
    platFormCode: "PG",
  },
  {
    name: "Fortune Rabbit",
    img: "/assets/Slot/ACEWIN-SLOT-028.Fortune Rabbit.webp?v=1764854072693",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-028",
    platFormCode: "ACEWIN",
  },
  {
    name: "Fortune Rabbit",
    img: "/assets/Slot/PG-SLOT-112.webp?v=1765933237838",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-112",
    platFormCode: "PG",
  },
  {
    name: "Fortune Snake",
    img: "/assets/Slot/PG-SLOT-151.webp?v=1765933237876",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-151",
    platFormCode: "PG",
  },
  {
    name: "Fortune Tai Chi",
    img: "/assets/Slot/ACEWIN-SLOT-006.Fortune Tai Chi.webp?v=1764854095147",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-006",
    platFormCode: "ACEWIN",
  },
  {
    name: "Fortune Tiger",
    img: "/assets/Slot/PG-SLOT-093.webp?v=1765933237822",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-093",
    platFormCode: "PG",
  },
  {
    name: "Fortune Treasure",
    img: "/assets/Slot/JDB-SLOT-072.fortune_treasure.webp?v=1765262769726",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-072",
    platFormCode: "JDB",
  },
  {
    name: "Fortune Tree",
    img: "/assets/Slot/JILI-SLOT-005.webp?v=1755507925436",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-005",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Tree",
    img: "/assets/Slot/ACEWIN-SLOT-018.Fortune Tree.webp?v=1764854117438",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-018",
    platFormCode: "ACEWIN",
  },
  {
    name: "Fortune Twins",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-077.fortune-twins.webp?v=1765275238523",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-077",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Fortune X Ace",
    img: "/assets/Slot/YesBingo-SLOT-043.Fortune X Ace.webp?v=1765104592190",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-043",
    platFormCode: "YESBINGO",
  },
  {
    name: "Fortune of Aztec",
    img: "/assets/Slot/PP-SLOT-626.Fortune of Aztec.webp?v=1764387128380",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-626",
    platFormCode: "PP",
  },
  {
    name: "Fortune of Giza",
    img: "/assets/Slot/PP-SLOT-217.Fortune-of-Giza.webp?v=1764387095707",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-217",
    platFormCode: "PP",
  },
  {
    name: "FortuneArrow",
    img: "/assets/Slot/ACEWIN-SLOT-026.FortuneArrow.webp?v=1764854144703",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-026",
    platFormCode: "ACEWIN",
  },
  {
    name: "FortuneNeko",
    img: "/assets/Slot/JDB-SLOT-106.fortune_neko.webp?v=1767691538810",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-106",
    platFormCode: "JDB",
  },
  {
    name: "FortunePig",
    img: "/assets/Slot/JILI-SLOT-019.webp?v=1755509296329",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-019",
    platFormCode: "JILI",
  },
  {
    name: "Fortunes of Aztec",
    img: "/assets/Slot/PP-SLOT-382.Fortunes of Aztec.webp?v=1764387048538",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-382",
    platFormCode: "PP",
  },
  {
    name: "Fortunes of the Fox",
    img: "/assets/Slot/PT-SLOT-062.Fortunes of the Fox.webp?v=1764326781589",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-062",
    platFormCode: "PT",
  },
  {
    name: "Four Dragons",
    img: "/assets/Slot/wykepsq659qp4.Four-Dragons.webp?v=1765048461092",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-065",
    platFormCode: "JOKER",
  },
  {
    name: "Four Tigers",
    img: "/assets/Slot/rsjogw1ukbeic.Four-Tigers.webp?v=1765042969514",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-066",
    platFormCode: "JOKER",
  },
  {
    name: "Four Treasures",
    img: "/assets/Slot/JDB-SLOT-017.four_treasures.webp?v=1765262662557",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-017",
    platFormCode: "JDB",
  },
  {
    name: "Fourtune 4ever Dragon",
    img: "/assets/Slot/ACEWIN-SLOT-035.Fourtune 4ever Dragon.webp?v=1764854165723",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-035",
    platFormCode: "ACEWIN",
  },
  {
    name: "Fox Spirit",
    img: "/assets/Slot/CG-SLOT-081.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-081",
    platFormCode: "CG",
  },
  {
    name: "Freaked Out Fish",
    img: "/assets/Slot/RELAX-SLOT-266.webp?v=1761893802808",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-266",
    platFormCode: "RELAX",
  },
  {
    name: "Frequent Flyer",
    img: "/assets/Slot/RELAX-SLOT-027.webp?v=1761893826445",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-027",
    platFormCode: "RELAX",
  },
  {
    name: "Frightening Frankie",
    img: "/assets/Slot/PP-SLOT-608.Frightening Frankie.webp?v=1764387000803",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-608",
    platFormCode: "PP",
  },
  {
    name: "Frog's Gift",
    img: "/assets/Slot/PT-SLOT-187.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-187",
    platFormCode: "PT",
  },
  {
    name: "Frogs & Bugs",
    img: "/assets/Slot/PP-SLOT-350.Frogs-&-Bugs.webp?v=1764386968407",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-350",
    platFormCode: "PP",
  },
  {
    name: "Frontier Lock & Load",
    img: "/assets/Slot/YGG-SLOT-384.webp?v=1767056428889",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-384",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Frozen Age",
    img: "/assets/Slot/YGG-SLOT-235.webp?v=1767056428588",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-235",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Frozen Tropics",
    img: "/assets/Slot/PP-SLOT-377.Frozen-Tropics.webp?v=1764386856868",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-377",
    platFormCode: "PP",
  },
  {
    name: "Fruit Combinator",
    img: "/assets/Slot/YGG-SLOT-195.webp?v=1767056428542",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-195",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fruit Flash",
    img: "/assets/Slot/RT-SLOT-312.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-312",
    platFormCode: "RT",
  },
  {
    name: "Fruit Gemz Splitz",
    img: "/assets/Slot/YGG-SLOT-164.webp?v=1767056428503",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-164",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fruit Ninja Fury",
    img: "/assets/Slot/SG-SLOT-150.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-150",
    platFormCode: "SPADE",
  },
  {
    name: "Fruit Paradise",
    img: "/assets/Slot/uh4amsg355x7a.Fruit-Paradise.webp?v=1765043508038",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-067",
    platFormCode: "JOKER",
  },
  {
    name: "Fruit Party",
    img: "/assets/Slot/PP-SLOT-046.Fruit-Party.webp?v=1764386802138",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-046",
    platFormCode: "PP",
  },
  {
    name: "Fruit Party 2",
    img: "/assets/Slot/PP-SLOT-194.Fruit-Party-2.webp?v=1764386749859",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-194",
    platFormCode: "PP",
  },
  {
    name: "Fruit Rainbow",
    img: "/assets/Slot/PP-SLOT-054.Fruit-Rainbow.webp?v=1764386684924",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-054",
    platFormCode: "PP",
  },
  {
    name: "Fruit Shop Frenzy",
    img: "/assets/Slot/NETENT-SLOT-200.fruit-shop-frenzy.webp?v=1764960075229",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-200",
    platFormCode: "NETENT",
  },
  {
    name: "Fruit Snap",
    img: "/assets/Slot/RT-SLOT-094.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-094",
    platFormCode: "RT",
  },
  {
    name: "Fruit Strike",
    img: "/assets/Slot/RELAX-SLOT-083.webp?v=1761893848346",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-083",
    platFormCode: "RELAX",
  },
  {
    name: "FruitPunk",
    img: "/assets/Slot/YGG-SLOT-391.webp?v=1767056428896",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-391",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fruitjitsu",
    img: "/assets/Slot/YGG-SLOT-402.webp?v=1767056428912",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-402",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fruitoids",
    img: "/assets/Slot/YGG-SLOT-019.webp?v=1767056428346",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-019",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fruits",
    img: "/assets/Slot/NLC-SLOT-052.Fruits.webp?v=1764390557694",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-052",
    platFormCode: "NLC",
  },
  {
    name: "Fruits Mania",
    img: "/assets/Slot/SG-SLOT-112.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-112",
    platFormCode: "SPADE",
  },
  {
    name: "Fruits of the Amazon",
    img: "/assets/Slot/PP-SLOT-329.Fruits-of-the-Amazon.webp?v=1764386636066",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-329",
    platFormCode: "PP",
  },
  {
    name: "Fruity Bonanza",
    img: "/assets/Slot/JDB-SLOT-114.fruity-bonanza.webp?v=1765262619290",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-114",
    platFormCode: "JDB",
  },
  {
    name: "Fruity Bonanza Combo",
    img: "/assets/Slot/JDB-SLOT-130.fruity-bonanza-combo.webp?v=1765262571859",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-130",
    platFormCode: "JDB",
  },
  {
    name: "Fruity Candy",
    img: "/assets/Slot/PG-SLOT-120.webp?v=1765933237845",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-120",
    platFormCode: "PG",
  },
  {
    name: "Fruity Treats",
    img: "/assets/Slot/PP-SLOT-461.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-461",
    platFormCode: "PP",
  },
  {
    name: "Fruity Wheel",
    img: "/assets/Slot/JILI-SLOT-111.webp?v=1755510721046",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-111",
    platFormCode: "JILI",
  },
  {
    name: "Fruitylicious",
    img: "/assets/Slot/YGG-SLOT-280.webp?v=1767056428786",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-280",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fu Fu Fu",
    img: "/assets/Slot/PP-SLOT-039.Fu-Fu-Fu.webp?v=1764386517257",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-039",
    platFormCode: "PP",
  },
  {
    name: "Full Moon: White King",
    img: "/assets/Slot/PT-SLOT-359.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-359",
    platFormCode: "PT",
  },
  {
    name: "Full Moon: White Panda",
    img: "/assets/Slot/PT-SLOT-160.Full-Moon-White-Panda.webp?v=1764327351699",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-160",
    platFormCode: "PT",
  },
  {
    name: "Funky King Kong",
    img: "/assets/Slot/JDB-SLOT-076.funky_kingkong.webp?v=1765262515264",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-076",
    platFormCode: "JDB",
  },
  {
    name: "Funky Monkey",
    img: "/assets/Slot/PT-SLOT-010.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-010",
    platFormCode: "PT",
  },
  {
    name: "Funky Monkey",
    img: "/assets/Slot/CG-SLOT-018.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-018",
    platFormCode: "CG",
  },
  {
    name: "Fury Max Lucky Road",
    img: "/assets/Slot/SG-SLOT-146.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-146",
    platFormCode: "SPADE",
  },
  {
    name: "Fury of Hyde Megaways",
    img: "/assets/Slot/YGG-SLOT-180.webp?v=1767056428518",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-180",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Fury of Odin Megaways",
    img: "/assets/Slot/PP-SLOT-313.Fury-of-Odin-Megaways.webp?v=1764386465575",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-313",
    platFormCode: "PP",
  },
  {
    name: "Fushen Coming",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-037.fushen-coming.webp?v=1765275059535",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-037",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Futebol Fever",
    img: "/assets/Slot/PG-SLOT-141.webp?v=1765933237863",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-141",
    platFormCode: "PG",
  },
  {
    name: "GATES OF OLYMPUS",
    img: "/assets/Slot/2J-SLOT-035.GATES OF OLYMPUS.webp?v=1763549713300",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-035",
    platFormCode: "JJ",
  },
  {
    name: "GLORY OF ROME",
    img: "/assets/Slot/FC-SLOT-019.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-019",
    platFormCode: "FC",
  },
  {
    name: "GOD OF FORTUNE",
    img: "/assets/Slot/2J-SLOT-009.GOD OF FORTUNE.webp?v=1763549650145",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-009",
    platFormCode: "JJ",
  },
  {
    name: "GOD OF WEALTH",
    img: "/assets/Slot/2J-SLOT-001.GOD OF WEALTH.webp?v=1763549608509",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-001",
    platFormCode: "JJ",
  },
  {
    name: "GOLD MANIA",
    img: "/assets/Slot/2J-SLOT-034.GOLD MANIA.webp?v=1763549552771",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-034",
    platFormCode: "JJ",
  },
  {
    name: "GOLD RUSH",
    img: "/assets/Slot/FC-SLOT-017.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-017",
    platFormCode: "FC",
  },
  {
    name: "GOLD RUSH BONANZA",
    img: "/assets/Slot/KM-SLOT-010.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-010",
    platFormCode: "KINGMAKER",
  },
  {
    name: "GOLDEN BUFFALO",
    img: "/assets/Slot/2J-SLOT-038.GOLDEN BUFFALO.webp?v=1763549510746",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-038",
    platFormCode: "JJ",
  },
  {
    name: "GOLDEN CENTURY",
    img: "/assets/Slot/2J-SLOT-031.GOLDEN CENTURY.webp?v=1763549438332",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-031",
    platFormCode: "JJ",
  },
  {
    name: "GOLDEN OX",
    img: "/assets/Slot/2J-SLOT-029.GOLDEN OX.webp?v=1763549388285",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-029",
    platFormCode: "JJ",
  },
  {
    name: "GOLDEN PANTHER",
    img: "/assets/Slot/FC-SLOT-001.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-001",
    platFormCode: "FC",
  },
  {
    name: "Gaelic Gold",
    img: "/assets/Slot/NLC-SLOT-038.Gaelic Gold.webp?v=1764390510748",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-038",
    platFormCode: "NLC",
  },
  {
    name: "Gaelic Luck",
    img: "/assets/Slot/PT-SLOT-142.gaelic-luck.webp?v=1764331760291",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-142",
    platFormCode: "PT",
  },
  {
    name: "Galactic Gems",
    img: "/assets/Slot/PG-SLOT-067.webp?v=1765933237801",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-067",
    platFormCode: "PG",
  },
  {
    name: "Galactic Racers",
    img: "/assets/Slot/RELAX-SLOT-214.webp?v=1761893877103",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-214",
    platFormCode: "RELAX",
  },
  {
    name: "Galaxy Guardian",
    img: "/assets/Slot/SG-SLOT-142.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-142",
    platFormCode: "SPADE",
  },
  {
    name: "Galaxy Miner",
    img: "/assets/Slot/PG-SLOT-161.webp?v=1765933237884",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-161",
    platFormCode: "PG",
  },
  {
    name: "Gallina Vince",
    img: "/assets/Slot/JILI-SLOT-141.webp?v=1755511014026",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-141",
    platFormCode: "JILI",
  },
  {
    name: "Ganesha Fortune",
    img: "/assets/Slot/PG-SLOT-052.webp?v=1765933237792",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-052",
    platFormCode: "PG",
  },
  {
    name: "Ganesha Gold",
    img: "/assets/Slot/PG-SLOT-026.webp?v=1765933237771",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-026",
    platFormCode: "PG",
  },
  {
    name: "Gargoyle Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-064.webp?v=1767056428401",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-064",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Garuda Gems",
    img: "/assets/Slot/PG-SLOT-094.webp?v=1765933237823",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-094",
    platFormCode: "PG",
  },
  {
    name: "Gates Of Wealth",
    img: "/assets/Slot/ao6qfxp1sqamn.Gates-Of-Wealth.webp?v=1765046852189",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-201",
    platFormCode: "JOKER",
  },
  {
    name: "Gates of Aztec",
    img: "/assets/Slot/PP-SLOT-312.Gates-of-Aztec.webp?v=1764386404862",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-312",
    platFormCode: "PP",
  },
  {
    name: "Gates of Gatot Kaca",
    img: "/assets/Slot/PP-SLOT-303.Gates-of-Gatotkaca.webp?v=1765791293934",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-303",
    platFormCode: "PP",
  },
  {
    name: "Gates of Gatot Kaca 1000",
    img: "/assets/Slot/PP-SLOT-439.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-439",
    platFormCode: "PP",
  },
  {
    name: "Gates of Gatot Kaca Super Scatter",
    img: "/assets/Slot/PP-SLOT-663.Gates of Gatot Kaca Super Scatter.webp?v=1765423183483",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-663",
    platFormCode: "PP",
  },
  {
    name: "Gates of Hades",
    img: "/assets/Slot/PP-SLOT-569.Gates of Hades.webp?v=1764386207822",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-569",
    platFormCode: "PP",
  },
  {
    name: "Gates of Olympus Dice",
    img: "/assets/Slot/PP-SLOT-436.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-436",
    platFormCode: "PP",
  },
  {
    name: "Gates of Olympus Xmas 1000",
    img: "/assets/Slot/PP-SLOT-524.Gates of Olympus Xmas 1000.webp?v=1764386071967",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-524",
    platFormCode: "PP",
  },
  {
    name: "Gates of Thunder",
    img: "/assets/Slot/YGG-SLOT-283.webp?v=1767056428788",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-283",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gates of Valhalla",
    img: "/assets/Slot/PP-SLOT-226.Gates-of-Valhalla.webp?v=1764386014807",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-226",
    platFormCode: "PP",
  },
  {
    name: "Gates of the Underworld",
    img: "/assets/Slot/OCTOPLAY-SLOT-115.Gates of the Underworld.webp?v=1764933095467",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-115",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Gator Gold Deluxe Gigablox",
    img: "/assets/Slot/YGG-SLOT-118.webp?v=1767056428454",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-118",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gator Gold Gigablox",
    img: "/assets/Slot/YGG-SLOT-052.webp?v=1767056428383",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-052",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gator Hunters",
    img: "/assets/Slot/NLC-SLOT-117.Gator Hunters.webp?v=1764390458111",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-117",
    platFormCode: "NLC",
  },
  {
    name: "Gatot Kaca's Fury",
    img: "/assets/Slot/PP-SLOT-320.Gatot-Kaca_s-Fury.webp?v=1764385967066",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-320",
    platFormCode: "PP",
  },
  {
    name: "Gears of Horus",
    img: "/assets/Slot/PP-SLOT-438.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-438",
    platFormCode: "PP",
  },
  {
    name: "Geisha",
    img: "/assets/Slot/CG-SLOT-075.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-075",
    platFormCode: "CG",
  },
  {
    name: "Geisha Story",
    img: "/assets/Slot/PT-SLOT-061.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-061",
    platFormCode: "PT",
  },
  {
    name: "Geisha's Revenge",
    img: "/assets/Slot/PG-SLOT-150.webp?v=1765933237875",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-150",
    platFormCode: "PG",
  },
  {
    name: "Gem Elevator",
    img: "/assets/Slot/PP-SLOT-490.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-490",
    platFormCode: "PP",
  },
  {
    name: "Gem Fire Fortune",
    img: "/assets/Slot/PP-SLOT-577.webp?v=1755572583624",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-577",
    platFormCode: "PP",
  },
  {
    name: "Gem Heat",
    img: "/assets/Slot/PT-SLOT-128.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-128",
    platFormCode: "PT",
  },
  {
    name: "Gem Pops",
    img: "/assets/Slot/RELAX-SLOT-249.webp?v=1761893904787",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-249",
    platFormCode: "RELAX",
  },
  {
    name: "Gem Rocks",
    img: "/assets/Slot/YGG-SLOT-100.webp?v=1767056428440",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-100",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gem Saviour",
    img: "/assets/Slot/PG-SLOT-002.webp?v=1765933237754",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-002",
    platFormCode: "PG",
  },
  {
    name: "Gem Saviour Conquest",
    img: "/assets/Slot/PG-SLOT-045.webp?v=1765933237785",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-045",
    platFormCode: "PG",
  },
  {
    name: "Gem Saviour Sword",
    img: "/assets/Slot/PG-SLOT-022.webp?v=1765933237767",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-022",
    platFormCode: "PG",
  },
  {
    name: "Gem Trio",
    img: "/assets/Slot/PP-SLOT-583.Gem Trio.webp?v=1764385864767",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-583",
    platFormCode: "PP",
  },
  {
    name: "Gems Bonanza",
    img: "/assets/Slot/PP-SLOT-025.Gems-Bonanza.webp?v=1764385806643",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-025",
    platFormCode: "PP",
  },
  {
    name: "Gems Gone Wild Power Reels",
    img: "/assets/Slot/RT-SLOT-148.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-148",
    platFormCode: "RT",
  },
  {
    name: "Gems Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-125.webp?v=1767056428463",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-125",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gems of Serengeti",
    img: "/assets/Slot/PP-SLOT-301.Gems-of-Serengeti.webp?v=1764385757101",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-301",
    platFormCode: "PP",
  },
  {
    name: "Gems of Valhalla",
    img: "/assets/Slot/KM-SLOT-002.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-002",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Gemstone Guardians",
    img: "/assets/Slot/OCTOPLAY-SLOT-021.Gemstone Guardians.webp?v=1764933133227",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-021",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Gemstone Rush",
    img: "/assets/Slot/SG-SLOT-126.gemstone-rush.webp?v=1764325408425",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-126",
    platFormCode: "SPADE",
  },
  {
    name: "Gemstones Gold",
    img: "/assets/Slot/PG-SLOT-133.webp?v=1765933237856",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-133",
    platFormCode: "PG",
  },
  {
    name: "Gemtastic",
    img: "/assets/Slot/RT-SLOT-024.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-024",
    platFormCode: "RT",
  },
  {
    name: "Genie",
    img: "/assets/Slot/1q36p58phmt6y.Genie.webp?v=1765045495082",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-069",
    platFormCode: "JOKER",
  },
  {
    name: "Genie 2",
    img: "/assets/Slot/b4pde45epfzg6.Genie-2.webp?v=1765036336582",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-070",
    platFormCode: "JOKER",
  },
  {
    name: "Genie Nights",
    img: "/assets/Slot/RT-SLOT-178.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-178",
    platFormCode: "RT",
  },
  {
    name: "Genie's 3 Wishes",
    img: "/assets/Slot/PG-SLOT-057.webp?v=1765933237794",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-057",
    platFormCode: "PG",
  },
  {
    name: "Genie's Gem Bonanza",
    img: "/assets/Slot/PP-SLOT-593.Genie_s Gem Bonanza.webp?v=1764385701585",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-593",
    platFormCode: "PP",
  },
  {
    name: "Get High",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-022.get-high.webp?v=1765275007938",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-022",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Get Money",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-004.get-money.webp?v=1765274935522",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-004",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Ghost Father",
    img: "/assets/Slot/YGG-SLOT-248.webp?v=1767056428598",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-248",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gifts of Fortune",
    img: "/assets/Slot/BTG-SLOT-011.webp?v=1756256536934",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-011",
    platFormCode: "BTG",
  },
  {
    name: "Giga Bass Gigablox",
    img: "/assets/Slot/YGG-SLOT-312.webp?v=1767056428812",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-312",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Giga Blast",
    img: "/assets/Slot/RT-SLOT-249.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-249",
    platFormCode: "RT",
  },
  {
    name: "Giga Match Bunny",
    img: "/assets/Slot/PT-SLOT-430.giga-match-bunny.webp?v=1764332621474",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-430",
    platFormCode: "PT",
  },
  {
    name: "Giga Match Egypt",
    img: "/assets/Slot/PT-SLOT-447.webp?v=1753341291747",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-447",
    platFormCode: "PT",
  },
  {
    name: "Giga Match Gems",
    img: "/assets/Slot/PT-SLOT-459.webp?v=1756275771678",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-459",
    platFormCode: "PT",
  },
  {
    name: "Giga Match Moolah",
    img: "/assets/Slot/PT-SLOT-466.Giga Match Moolah.webp?v=1764326267219",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-466",
    platFormCode: "PT",
  },
  {
    name: "Giga Match Phantasmal",
    img: "/assets/Slot/PT-SLOT-474.Giga Match Phantasmal.webp?v=1764943256990",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-474",
    platFormCode: "PT",
  },
  {
    name: "GigaGong GigaBlox",
    img: "/assets/Slot/YGG-SLOT-215.webp?v=1767056428563",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-215",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gigablox Kingdom",
    img: "/assets/Slot/YGG-SLOT-382.webp?v=1767056428888",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-382",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Giganimals GigaBlox",
    img: "/assets/Slot/YGG-SLOT-188.webp?v=1767056428526",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-188",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Giza Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-004.webp?v=1767056428322",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-004",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gladiator",
    img: "/assets/Slot/YesBingo-SLOT-009.Gladiator.webp?v=1765104392884",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-009",
    platFormCode: "YESBINGO",
  },
  {
    name: "Gladiator Ways",
    img: "/assets/Slot/RT-SLOT-359.webp?v=1753341488197",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-359",
    platFormCode: "RT",
  },
  {
    name: "Gladiator's Glory",
    img: "/assets/Slot/PG-SLOT-123.webp?v=1765933237848",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-123",
    platFormCode: "PG",
  },
  {
    name: "Glamorous Girl",
    img: "/assets/Slot/JDB-SLOT-103.glamorous-girl.webp?v=1767691516245",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-103",
    platFormCode: "JDB",
  },
  {
    name: "Glorious Guardians",
    img: "/assets/Slot/PT-SLOT-098.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-098",
    platFormCode: "PT",
  },
  {
    name: "Glow Dig",
    img: "/assets/Slot/RT-SLOT-324.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-324",
    platFormCode: "RT",
  },
  {
    name: "Gnomes & Giants",
    img: "/assets/Slot/RELAX-SLOT-228.webp?v=1761893924958",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-228",
    platFormCode: "RELAX",
  },
  {
    name: "Go Bananas!",
    img: "/assets/Slot/NETENT-SLOT-163.Go-Bananas.webp?v=1764959755723",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-163",
    platFormCode: "NETENT",
  },
  {
    name: "Go High Safari",
    img: "/assets/Slot/PT-SLOT-465.Go High Safari.webp?v=1764326292764",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-465",
    platFormCode: "PT",
  },
  {
    name: "Go Lai Fu",
    img: "/assets/Slot/JDB-SLOT-067.Go Lai Fu.webp?v=1765262414828",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-067",
    platFormCode: "JDB",
  },
  {
    name: "Goblin Heist Powernudge",
    img: "/assets/Slot/PP-SLOT-238.Goblin-Heist-Powernudge.webp?v=1764385639197",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-238",
    platFormCode: "PP",
  },
  {
    name: "Goblin’s Bargain MultiMax",
    img: "/assets/Slot/YGG-SLOT-258.webp?v=1767056428765",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-258",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "God Of Martial",
    img: "/assets/Slot/JILI-SLOT-010.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-010",
    platFormCode: "JILI",
  },
  {
    name: "God Smash: Eternal Chaos",
    img: "/assets/Slot/OCTOPLAY-SLOT-066.God Smash Eternal Chaos.webp?v=1764933170628",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-066",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Goddess of the Moon MegaWays",
    img: "/assets/Slot/RT-SLOT-261.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-261",
    platFormCode: "RT",
  },
  {
    name: "Gods Gone Wild",
    img: "/assets/Slot/YGG-SLOT-369.webp?v=1767056428877",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-369",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gods Vs Gigablox",
    img: "/assets/Slot/YGG-SLOT-171.webp?v=1767056428509",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-171",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gods of Giza",
    img: "/assets/Slot/PP-SLOT-336.Gods-of-Giza.webp?v=1764385589723",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-336",
    platFormCode: "PP",
  },
  {
    name: "Gods of Troy",
    img: "/assets/Slot/RT-SLOT-105.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-105",
    platFormCode: "RT",
  },
  {
    name: "Going Wild in Vegas",
    img: "/assets/Slot/YGG-SLOT-213.webp?v=1767056428561",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-213",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gold Aynu",
    img: "/assets/Slot/CG-SLOT-117.Gold Aynu.webp?v=1764666271502",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-117",
    platFormCode: "CG",
  },
  {
    name: "Gold Chain",
    img: "/assets/Slot/OCTOPLAY-SLOT-008.Gold Chain.webp?v=1764933220660",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-008",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Gold Fever",
    img: "/assets/Slot/YGG-SLOT-187.webp?v=1767056428525",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-187",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gold Hit & Link: Tiger Jones",
    img: "/assets/Slot/PT-SLOT-357.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-357",
    platFormCode: "PT",
  },
  {
    name: "Gold Hit: Dragon Bonanza",
    img: "/assets/Slot/PT-SLOT-327.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-327",
    platFormCode: "PT",
  },
  {
    name: "Gold Hit: O'Reilly's Riches",
    img: "/assets/Slot/PT-SLOT-076.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-076",
    platFormCode: "PT",
  },
  {
    name: "Gold Hit: Shrine of Anubis",
    img: "/assets/Slot/PT-SLOT-259.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-259",
    platFormCode: "PT",
  },
  {
    name: "Gold Is All Mine 10K Ways",
    img: "/assets/Slot/YGG-SLOT-332.webp?v=1767056428831",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-332",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Gold Megaways",
    img: "/assets/Slot/BTG-SLOT-016.webp?v=1756256536937",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-016",
    platFormCode: "BTG",
  },
  {
    name: "Gold Meow Sushi Legend",
    img: "/assets/Slot/CG-SLOT-114.Gold Meow Sushi Legend.webp?v=1764666324534",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-114",
    platFormCode: "CG",
  },
  {
    name: "Gold Mine Mistress",
    img: "/assets/Slot/RT-SLOT-289.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-289",
    platFormCode: "RT",
  },
  {
    name: "Gold Musa I",
    img: "/assets/Slot/CG-SLOT-112.Gold Musa I.webp?v=1764666376256",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-112",
    platFormCode: "CG",
  },
  {
    name: "Gold Oasis",
    img: "/assets/Slot/PP-SLOT-378.Gold-Oasis.webp?v=1764385527860",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-378",
    platFormCode: "PP",
  },
  {
    name: "Gold Panther Maxways",
    img: "/assets/Slot/SG-SLOT-111.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-111",
    platFormCode: "SPADE",
  },
  {
    name: "Gold Party",
    img: "/assets/Slot/PP-SLOT-227.Gold-Party.webp?v=1764385475104",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-227",
    platFormCode: "PP",
  },
  {
    name: "Gold Pile: New Years Gold",
    img: "/assets/Slot/PT-SLOT-185.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-185",
    platFormCode: "PT",
  },
  {
    name: "Gold Pile: Orangutan",
    img: "/assets/Slot/PT-SLOT-166.Gold Pile Orangutan.webp?v=1764328027974",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-166",
    platFormCode: "PT",
  },
  {
    name: "Gold Pile: Tigers Pride",
    img: "/assets/Slot/PT-SLOT-173.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-173",
    platFormCode: "PT",
  },
  {
    name: "Gold Pile: Toltec Treasure",
    img: "/assets/Slot/PT-SLOT-183.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-183",
    platFormCode: "PT",
  },
  {
    name: "Gold Rush",
    img: "/assets/Slot/PP-SLOT-114.Gold-Rush.webp?v=1764385376770",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-114",
    platFormCode: "PP",
  },
  {
    name: "Gold Rush",
    img: "/assets/Slot/JILI-SLOT-057.webp?v=1755509776443",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-057",
    platFormCode: "JILI",
  },
  {
    name: "Gold Rush Cowboy",
    img: "/assets/Slot/SG-SLOT-100.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-100",
    platFormCode: "SPADE",
  },
  {
    name: "Gold Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-043.Gold Smash.webp?v=1764933285500",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-043",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Gold Trail",
    img: "/assets/Slot/x5ikj69a989x6.Gold-Trail.webp?v=1765048003872",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-071",
    platFormCode: "JOKER",
  },
  {
    name: "Gold Train",
    img: "/assets/Slot/PP-SLOT-123.Gold-Train.webp?v=1764385326161",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-123",
    platFormCode: "PP",
  },
  {
    name: "Gold Trio",
    img: "/assets/Slot/PT-SLOT-347.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-347",
    platFormCode: "PT",
  },
  {
    name: "Gold Trio: Leprechaun's Luck BF",
    img: "/assets/Slot/PT-SLOT-416.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-416",
    platFormCode: "PT",
  },
  {
    name: "Gold Trio: Lil Demon",
    img: "/assets/Slot/PT-SLOT-442.webp?v=1753341210439",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-442",
    platFormCode: "PT",
  },
  {
    name: "Gold Trio: Sinbad’s Riches",
    img: "/assets/Slot/PT-SLOT-268.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-268",
    platFormCode: "PT",
  },
  {
    name: "Gold West",
    img: "/assets/Slot/SG-SLOT-148.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-148",
    platFormCode: "SPADE",
  },
  {
    name: "Gold hit & link: J.P. Bacon & Co",
    img: "/assets/Slot/PT-SLOT-271.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-271",
    platFormCode: "PT",
  },
  {
    name: "GoldStorm Ultra",
    img: "/assets/Slot/YGG-SLOT-411.webp?v=1767056428920",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-411",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Aztec",
    img: "/assets/Slot/YesBingo-SLOT-019.Golden Aztec.webp?v=1765104317906",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-019",
    platFormCode: "YESBINGO",
  },
  {
    name: "Golden Aztec Mega",
    img: "/assets/Slot/YesBingo-SLOT-026.Golden Aztec Mega.webp?v=1765104136988",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-026",
    platFormCode: "YESBINGO",
  },
  {
    name: "Golden Bank",
    img: "/assets/Slot/JILI-SLOT-023.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-023",
    platFormCode: "JILI",
  },
  {
    name: "Golden Bank 2",
    img: "/assets/Slot/JILI-SLOT-116.webp?v=1755510807204",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-116",
    platFormCode: "JILI",
  },
  {
    name: "Golden Castle",
    img: "/assets/Slot/RELAX-SLOT-079.webp?v=1761893950295",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-079",
    platFormCode: "RELAX",
  },
  {
    name: "Golden Catch",
    img: "/assets/Slot/BTG-SLOT-008.webp?v=1756256536931",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-008",
    platFormCode: "BTG",
  },
  {
    name: "Golden Chicken",
    img: "/assets/Slot/SG-SLOT-018.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-018",
    platFormCode: "SPADE",
  },
  {
    name: "Golden Cryptex",
    img: "/assets/Slot/RT-SLOT-095.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-095",
    platFormCode: "RT",
  },
  {
    name: "Golden Disco",
    img: "/assets/Slot/JDB-SLOT-084.golden-disco.webp?v=1765262368667",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-084",
    platFormCode: "JDB",
  },
  {
    name: "Golden Donkey Xmas",
    img: "/assets/Slot/YGG-SLOT-303.webp?v=1767056428804",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-303",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Dragon",
    img: "/assets/Slot/9w6aa6u5xbhzh.Golden-Dragon.webp?v=1765050672925",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-072",
    platFormCode: "JOKER",
  },
  {
    name: "Golden Egg Invaders",
    img: "/assets/Slot/NETENT-SLOT-227.golden-egg-invaders.webp?v=1764959672857",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-227",
    platFormCode: "NETENT",
  },
  {
    name: "Golden Empire",
    img: "/assets/Slot/JILI-SLOT-042.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-042",
    platFormCode: "JILI",
  },
  {
    name: "Golden Empire 2",
    img: "/assets/Slot/JILI-SLOT-143.webp?v=1755511030528",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-143",
    platFormCode: "JILI",
  },
  {
    name: "Golden Eye",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-049.golden-egg.webp?v=1765274876959",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-049",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Golden Fish Tank 2 Gigablox",
    img: "/assets/Slot/YGG-SLOT-055.webp?v=1767056428389",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-055",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Fish Tank Party",
    img: "/assets/Slot/YGG-SLOT-314.webp?v=1767056428814",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-314",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Fish tank",
    img: "/assets/Slot/YGG-SLOT-117.webp?v=1767056428454",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-117",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Genie And The Walking Wilds",
    img: "/assets/Slot/NLC-SLOT-035.Golden Genie And The Walking Wilds.webp?v=1764390400186",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-035",
    platFormCode: "NLC",
  },
  {
    name: "Golden Gods",
    img: "/assets/Slot/RELAX-SLOT-097.webp?v=1761893984401",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-097",
    platFormCode: "RELAX",
  },
  {
    name: "Golden Goose Megaways",
    img: "/assets/Slot/BTG-SLOT-057.webp?v=1756256536970",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-057",
    platFormCode: "BTG",
  },
  {
    name: "Golden Gorgon",
    img: "/assets/Slot/YGG-SLOT-065.webp?v=1767056428402",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-065",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Island",
    img: "/assets/Slot/ywozehuuqbazc.Golden-Island.webp?v=1765046641599",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-073",
    platFormCode: "JOKER",
  },
  {
    name: "Golden Joker",
    img: "/assets/Slot/JILI-SLOT-074.webp?v=1755509943211",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-074",
    platFormCode: "JILI",
  },
  {
    name: "Golden Lamps",
    img: "/assets/Slot/RT-SLOT-300.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-300",
    platFormCode: "RT",
  },
  {
    name: "Golden Lotus SE",
    img: "/assets/Slot/SG-SLOT-032.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-032",
    platFormCode: "SPADE",
  },
  {
    name: "Golden Macaque",
    img: "/assets/Slot/PT-SLOT-026.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-026",
    platFormCode: "PT",
  },
  {
    name: "Golden Monkey King",
    img: "/assets/Slot/9mqe9bhroi78s.Golden Monkey King.webp?v=1765042511425",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-074",
    platFormCode: "JOKER",
  },
  {
    name: "Golden Offer",
    img: "/assets/Slot/RT-SLOT-028.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-028",
    platFormCode: "RT",
  },
  {
    name: "Golden Ox",
    img: "/assets/Slot/PP-SLOT-012.Golden-Ox.webp?v=1764385270957",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-012",
    platFormCode: "PP",
  },
  {
    name: "Golden Pig",
    img: "/assets/Slot/PP-SLOT-089.Golden-Pig.webp?v=1764385221525",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-089",
    platFormCode: "PP",
  },
  {
    name: "Golden Pixiu",
    img: "/assets/Slot/SG-SLOT-158.golden-pixiu.webp?v=1764326654294",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-158",
    platFormCode: "SPADE",
  },
  {
    name: "Golden Queen",
    img: "/assets/Slot/JILI-SLOT-030.webp?v=1755509380517",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-030",
    platFormCode: "JILI",
  },
  {
    name: "Golden Realms",
    img: "/assets/Slot/NETENT-SLOT-191.Golden-Realms.webp?v=1764959611617",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-191",
    platFormCode: "NETENT",
  },
  {
    name: "Golden Rooster",
    img: "/assets/Slot/jpiuhpbifei1o.Golden-Rooster.webp?v=1765035855328",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-075",
    platFormCode: "JOKER",
  },
  {
    name: "Golden Sea",
    img: "/assets/Slot/fmjyoi4wkifrs.Golden Sea.webp?v=1765041453347",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-203",
    platFormCode: "JOKER",
  },
  {
    name: "Golden Suns Chain Collect",
    img: "/assets/Slot/OCTOPLAY-SLOT-058.Golden Suns Chail Collect.webp?v=1764933327636",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-058",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Golden Temple",
    img: "/assets/Slot/JILI-SLOT-080.webp?v=1755510132457",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-080",
    platFormCode: "JILI",
  },
  {
    name: "Golden Toad",
    img: "/assets/Slot/RT-SLOT-301.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-301",
    platFormCode: "RT",
  },
  {
    name: "Golden Tour",
    img: "/assets/Slot/PT-SLOT-009.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-009",
    platFormCode: "PT",
  },
  {
    name: "Golden Triad",
    img: "/assets/Slot/YGG-SLOT-349.webp?v=1767056428855",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-349",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Golden Tsar",
    img: "/assets/Slot/RT-SLOT-150.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-150",
    platFormCode: "RT",
  },
  {
    name: "Golden Ways",
    img: "/assets/Slot/PT-SLOT-190.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-190",
    platFormCode: "PT",
  },
  {
    name: "Golden Whale",
    img: "/assets/Slot/SG-SLOT-058.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-058",
    platFormCode: "SPADE",
  },
  {
    name: "Golden Wheels of Egypt",
    img: "/assets/Slot/NETENT-SLOT-190.Golden-Wheels-of-Egypt.webp?v=1764959583587",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-190",
    platFormCode: "NETENT",
  },
  {
    name: "Golden X Ace",
    img: "/assets/Slot/YesBingo-SLOT-042.Golden X Ace.webp?v=1765104087519",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-042",
    platFormCode: "YESBINGO",
  },
  {
    name: "Golf",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-026.golf.webp?v=1765274822020",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-026",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Golf2",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-073.golf2.webp?v=1765274772153",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-073",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Gonzita's Quest",
    img: "/assets/Slot/RT-SLOT-192.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-192",
    platFormCode: "RT",
  },
  {
    name: "Gonzo's Quest 2",
    img: "/assets/Slot/NETENT-SLOT-233.Gonzo_s Quest 2.webp?v=1764959551212",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-233",
    platFormCode: "NETENT",
  },
  {
    name: "Good Fortune",
    img: "/assets/Slot/CG-SLOT-092.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-092",
    platFormCode: "CG",
  },
  {
    name: "Good Luck & Good Fortune",
    img: "/assets/Slot/PP-SLOT-407.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-407",
    platFormCode: "PP",
  },
  {
    name: "Good Old 7's",
    img: "/assets/Slot/NETENT-SLOT-194.good-old-7_s.webp?v=1764959438301",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-194",
    platFormCode: "NETENT",
  },
  {
    name: "Goood Heavens",
    img: "/assets/Slot/PT-SLOT-409.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-409",
    platFormCode: "PT",
  },
  {
    name: "Gordon Ramsay Hell’s Kitchen",
    img: "/assets/Slot/NETENT-SLOT-039.gordon-ramsay-hell_s-kitchen.webp?v=1764959405568",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-039",
    platFormCode: "NETENT",
  },
  {
    name: "Gorilla Mayhem",
    img: "/assets/Slot/PP-SLOT-272.Gorilla-Mayham.webp?v=1764385160774",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-272",
    platFormCode: "PP",
  },
  {
    name: "Graffiti Rush",
    img: "/assets/Slot/PG-SLOT-154.webp?v=1765933237878",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-154",
    platFormCode: "PG",
  },
  {
    name: "Grand Junction: Mountain Express",
    img: "/assets/Slot/PT-SLOT-263.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-263",
    platFormCode: "PT",
  },
  {
    name: "Grand Link Express: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-081.Grand Link Express Hold & Win.webp?v=1764933370447",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-081",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Grand Sheriff",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-068.grand-sheriff.webp?v=1765274633039",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-068",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Great Blue",
    img: "/assets/Slot/PT-SLOT-006.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-006",
    platFormCode: "PT",
  },
  {
    name: "Great Blue",
    img: "/assets/Slot/CG-SLOT-090.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-090",
    platFormCode: "CG",
  },
  {
    name: "Great Blue",
    img: "/assets/Slot/P8-SLOT-003.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-003",
    platFormCode: "PLAY8",
  },
  {
    name: "Great Gold",
    img: "/assets/Slot/RT-SLOT-193.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-193",
    platFormCode: "RT",
  },
  {
    name: "Great Lagoon",
    img: "/assets/Slot/PP-SLOT-434.Great-Lagoon.webp?v=1764385060003",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-434",
    platFormCode: "PP",
  },
  {
    name: "Great Lion",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-013.great-lion.webp?v=1765274543471",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-013",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Great Reef",
    img: "/assets/Slot/PP-SLOT-156.Great-Reef.webp?v=1764385012283",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-156",
    platFormCode: "PP",
  },
  {
    name: "Great Rhino",
    img: "/assets/Slot/PP-SLOT-106.Great-Rhino.webp?v=1764384961146",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-106",
    platFormCode: "PP",
  },
  {
    name: "Great Rhino Deluxe",
    img: "/assets/Slot/PP-SLOT-030.Great-Rhino-Deluxe.webp?v=1764384916287",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-030",
    platFormCode: "PP",
  },
  {
    name: "Great Rhino Megaways",
    img: "/assets/Slot/PP-SLOT-049.Great-Rhino-Megaways.webp?v=1764384867535",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-049",
    platFormCode: "PP",
  },
  {
    name: "Great Stars SA",
    img: "/assets/Slot/SG-SLOT-022.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-022",
    platFormCode: "SPADE",
  },
  {
    name: "Greatest Circus",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-032.greatest-circus.webp?v=1765274491945",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-032",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Greedy Alice",
    img: "/assets/Slot/YGG-SLOT-310.webp?v=1767056428811",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-310",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Greedy Fortune Pig",
    img: "/assets/Slot/PP-SLOT-547.webp?v=1755571929491",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-547",
    platFormCode: "PP",
  },
  {
    name: "Greedy Wolf",
    img: "/assets/Slot/PP-SLOT-277.Greedy-Wolf.webp?v=1764384809684",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-277",
    platFormCode: "PP",
  },
  {
    name: "Greek Gods",
    img: "/assets/Slot/PP-SLOT-066.Greek-Gods.webp?v=1764384758920",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-066",
    platFormCode: "PP",
  },
  {
    name: "Grim The Splitter",
    img: "/assets/Slot/RELAX-SLOT-160.webp?v=1761894015171",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-160",
    platFormCode: "RELAX",
  },
  {
    name: "Grimms' Bounty: Hansel & Gretel",
    img: "/assets/Slot/PG-SLOT-162.webp?v=1765933237885",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-162",
    platFormCode: "PG",
  },
  {
    name: "Guardian of Gold: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-119.Guardian of Gold Hold & Win.webp?v=1764933388209",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-119",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Guardians of Ice and Fire",
    img: "/assets/Slot/PG-SLOT-068.webp?v=1765933237802",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-068",
    platFormCode: "PG",
  },
  {
    name: "Gunpowder",
    img: "/assets/Slot/YGG-SLOT-257.webp?v=1767056428764",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-257",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "HALLOWEEN",
    img: "/assets/Slot/2J-SLOT-014.HALLOWEEN.webp?v=1763549347583",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-014",
    platFormCode: "JJ",
  },
  {
    name: "HAPPY DUO BAO",
    img: "/assets/Slot/FC-SLOT-009.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-009",
    platFormCode: "FC",
  },
  {
    name: "HEX",
    img: "/assets/Slot/RELAX-SLOT-111.webp?v=1761894038532",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-111",
    platFormCode: "RELAX",
  },
  {
    name: "HOT POT PARTY",
    img: "/assets/Slot/FC-SLOT-003.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-003",
    platFormCode: "FC",
  },
  {
    name: "HUFF N PUFF",
    img: "/assets/Slot/2J-SLOT-045.HUFF N PUFF.webp?v=1763549305638",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-045",
    platFormCode: "JJ",
  },
  {
    name: "Hackers Haven",
    img: "/assets/Slot/YGG-SLOT-388.webp?v=1767056428893",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-388",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hades",
    img: "/assets/Slot/YGG-SLOT-096.webp?v=1767056428436",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-096",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hades River of Souls",
    img: "/assets/Slot/RELAX-SLOT-080.webp?v=1761894069314",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-080",
    platFormCode: "RELAX",
  },
  {
    name: "Hainan Ice",
    img: "/assets/Slot/PT-SLOT-209.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-209",
    platFormCode: "PT",
  },
  {
    name: "Hall of Wealth",
    img: "/assets/Slot/YGG-SLOT-364.webp?v=1767056428871",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-364",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hallo Win Party",
    img: "/assets/Slot/SG-SLOT-163.Hallo Win Party.webp?v=1764324540393",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-163",
    platFormCode: "SPADE",
  },
  {
    name: "Halloween",
    img: "/assets/Slot/CG-SLOT-003.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-003",
    platFormCode: "CG",
  },
  {
    name: "Halloween Fortune",
    img: "/assets/Slot/PT-SLOT-077.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-077",
    platFormCode: "PT",
  },
  {
    name: "Halloween Fortune 2",
    img: "/assets/Slot/PT-SLOT-051.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-051",
    platFormCode: "PT",
  },
  {
    name: "Halloween Party",
    img: "/assets/Slot/CG-SLOT-096.webp?v=1753843874009",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-096",
    platFormCode: "CG",
  },
  {
    name: "Halloween Vacation",
    img: "/assets/Slot/SG-SLOT-117.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-117",
    platFormCode: "SPADE",
  },
  {
    name: "Halloween Win",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-074.halloween-win.webp?v=1765274439036",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-074",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Hammer Gods",
    img: "/assets/Slot/RT-SLOT-136.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-136",
    platFormCode: "RT",
  },
  {
    name: "Hammer of Gods",
    img: "/assets/Slot/YGG-SLOT-085.webp?v=1767056428428",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-085",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hammer of Thunder",
    img: "/assets/Slot/SG-SLOT-124.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-124",
    platFormCode: "SPADE",
  },
  {
    name: "Hand of Midas 2",
    img: "/assets/Slot/PP-SLOT-472.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-472",
    platFormCode: "PP",
  },
  {
    name: "Hansel & Gretel Candyhouse",
    img: "/assets/Slot/RT-SLOT-270.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-270",
    platFormCode: "RT",
  },
  {
    name: "Hanzo's Dojo",
    img: "/assets/Slot/YGG-SLOT-102.webp?v=1767056428442",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-102",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Happy Apples",
    img: "/assets/Slot/RT-SLOT-236.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-236",
    platFormCode: "RT",
  },
  {
    name: "Happy Buddha",
    img: "/assets/Slot/55hj8ghaugxj6.Happy-Buddha.webp?v=1765043291103",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-077",
    platFormCode: "JOKER",
  },
  {
    name: "Happy Honey",
    img: "/assets/Slot/OCTOPLAY-SLOT-026.Happy Honey.webp?v=1764933427023",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-026",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Happy Neko",
    img: "/assets/Slot/SG-SLOT-149.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-149",
    platFormCode: "SPADE",
  },
  {
    name: "Happy Nets",
    img: "/assets/Slot/PP-SLOT-634.Happy Nets.webp?v=1764384703605",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-634",
    platFormCode: "PP",
  },
  {
    name: "Happy Party",
    img: "/assets/Slot/ebudnqj68h6d4.Happy-Party.webp?v=1765053390862",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-078",
    platFormCode: "JOKER",
  },
  {
    name: "Happy Taxi",
    img: "/assets/Slot/JILI-SLOT-056.webp?v=1755509750179",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-056",
    platFormCode: "JILI",
  },
  {
    name: "Harle Coin",
    img: "/assets/Slot/RT-SLOT-200.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-200",
    platFormCode: "RT",
  },
  {
    name: "Harlequin Carnival",
    img: "/assets/Slot/NLC-SLOT-037.Harlequin Carnival.webp?v=1764390353229",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-037",
    platFormCode: "NLC",
  },
  {
    name: "Haunted House",
    img: "/assets/Slot/PT-SLOT-141.webp?v=1762259047758",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-141",
    platFormCode: "PT",
  },
  {
    name: "Hawaii Beauty",
    img: "/assets/Slot/JILI-SLOT-012.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-012",
    platFormCode: "JILI",
  },
  {
    name: "Hawaii Vacay",
    img: "/assets/Slot/zhh6mqf3z495a.Hawaii Vacay.webp?v=1765053898031",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-210",
    platFormCode: "JOKER",
  },
  {
    name: "Hawaiian Tiki",
    img: "/assets/Slot/PG-SLOT-114.webp?v=1765933237840",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-114",
    platFormCode: "PG",
  },
  {
    name: "Hazakura Ways",
    img: "/assets/Slot/RELAX-SLOT-103.webp?v=1761894110736",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-103",
    platFormCode: "RELAX",
  },
  {
    name: "Heart of Cleopatra",
    img: "/assets/Slot/PP-SLOT-457.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-457",
    platFormCode: "PP",
  },
  {
    name: "Heart of Rio",
    img: "/assets/Slot/PP-SLOT-191.Heart-of-Rio.webp?v=1764384665507",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-191",
    platFormCode: "PP",
  },
  {
    name: "Heart of the Frontier",
    img: "/assets/Slot/PT-SLOT-070.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-070",
    platFormCode: "PT",
  },
  {
    name: "Heavenly Ruler",
    img: "/assets/Slot/PT-SLOT-036.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-036",
    platFormCode: "PT",
  },
  {
    name: "Heavy Anchor",
    img: "/assets/Slot/OCTOPLAY-SLOT-009.Heavy Anchor.webp?v=1764933468511",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-009",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Heist Deluxe",
    img: "/assets/Slot/7phhufritkfao.Heist-Deluxe.webp?v=1765036743065",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-080",
    platFormCode: "JOKER",
  },
  {
    name: "Heist Stakes",
    img: "/assets/Slot/PG-SLOT-077.webp?v=1765933237809",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-077",
    platFormCode: "PG",
  },
  {
    name: "Heist for the Golden Nuggets",
    img: "/assets/Slot/PP-SLOT-357.Heist-for-the-Golden-Nuggets.webp?v=1764384611776",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-357",
    platFormCode: "PP",
  },
  {
    name: "Helios Fury",
    img: "/assets/Slot/RELAX-SLOT-067.webp?v=1761894136683",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-067",
    platFormCode: "RELAX",
  },
  {
    name: "Hell Of A Spin",
    img: "/assets/Slot/OCTOPLAY-SLOT-042.Hell of Spin.webp?v=1764933508985",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-042",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Hell's Hogs 2 Squealin' Wheels",
    img: "/assets/Slot/YGG-SLOT-268.webp?v=1767056428776",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-268",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hellcatraz",
    img: "/assets/Slot/RELAX-SLOT-028.webp?v=1761894170594",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-028",
    platFormCode: "RELAX",
  },
  {
    name: "Hellcatraz 2",
    img: "/assets/Slot/RELAX-SLOT-176.webp?v=1761894204516",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-176",
    platFormCode: "RELAX",
  },
  {
    name: "Hells Hogs",
    img: "/assets/Slot/YGG-SLOT-139.webp?v=1767056428473",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-139",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hellvis Wild",
    img: "/assets/Slot/PP-SLOT-359.Hellvis-wild.webp?v=1764384565316",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-359",
    platFormCode: "PP",
  },
  {
    name: "Hercules 10K Ways",
    img: "/assets/Slot/RELAX-SLOT-213.webp?v=1761894255278",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-213",
    platFormCode: "RELAX",
  },
  {
    name: "Hercules 10K Ways",
    img: "/assets/Slot/YGG-SLOT-216.webp?v=1767056428563",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-216",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hercules Son Of Zeus",
    img: "/assets/Slot/PP-SLOT-132.Hercules-Son-of-Zeus.webp?v=1764384514448",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-132",
    platFormCode: "PP",
  },
  {
    name: "Hercules and Pegasus",
    img: "/assets/Slot/PP-SLOT-068.Hercules-and-Pegasus.webp?v=1764384460751",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-068",
    platFormCode: "PP",
  },
  {
    name: "Here Kitty Kitty",
    img: "/assets/Slot/RT-SLOT-262.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-262",
    platFormCode: "RT",
  },
  {
    name: "Heroes Arrow",
    img: "/assets/Slot/PT-SLOT-095.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-095",
    platFormCode: "PT",
  },
  {
    name: "Heroes Hunt 2",
    img: "/assets/Slot/RELAX-SLOT-082.webp?v=1761894287071",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-082",
    platFormCode: "RELAX",
  },
  {
    name: "Heroes' Gathering",
    img: "/assets/Slot/RELAX-SLOT-029.webp?v=1761894310186",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-029",
    platFormCode: "RELAX",
  },
  {
    name: "Heroic Spin",
    img: "/assets/Slot/PP-SLOT-455.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-455",
    platFormCode: "PP",
  },
  {
    name: "Hidden Egypt DoubleMax",
    img: "/assets/Slot/YGG-SLOT-253.webp?v=1767056428759",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-253",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Highroad Kings JP",
    img: "/assets/Slot/P8-SLOT-007.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-007",
    platFormCode: "PLAY8",
  },
  {
    name: "Highway Fortune",
    img: "/assets/Slot/SG-SLOT-049.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-049",
    platFormCode: "SPADE",
  },
  {
    name: "Highway Kings",
    img: "/assets/Slot/PT-SLOT-011.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-011",
    platFormCode: "PT",
  },
  {
    name: "Highway to Hell",
    img: "/assets/Slot/NLC-SLOT-110.Highway to Hell.webp?v=1764390252539",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-110",
    platFormCode: "NLC",
  },
  {
    name: "HighwayKings JP",
    img: "/assets/Slot/nh9swadbc3use.HighwayKings-JP.webp?v=1765041311434",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-083",
    platFormCode: "JOKER",
  },
  {
    name: "Hillbilly Vegas",
    img: "/assets/Slot/YGG-SLOT-156.webp?v=1767056428488",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-156",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Himalayan Wild",
    img: "/assets/Slot/PP-SLOT-519.Himalayan Wild.webp?v=1764384402058",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-519",
    platFormCode: "PP",
  },
  {
    name: "Hip Hop Panda",
    img: "/assets/Slot/PG-SLOT-017.webp?v=1765933237763",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-017",
    platFormCode: "PG",
  },
  {
    name: "Hippo Splash",
    img: "/assets/Slot/KM-SLOT-016.webp?v=1759311961310",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-016",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Hit Bar: Gold",
    img: "/assets/Slot/PT-SLOT-334.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-334",
    platFormCode: "PT",
  },
  {
    name: "Ho Yeah Monkey",
    img: "/assets/Slot/SG-SLOT-017.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-017",
    platFormCode: "SPADE",
  },
  {
    name: "Hoard of Poseidon",
    img: "/assets/Slot/RT-SLOT-152.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-152",
    platFormCode: "RT",
  },
  {
    name: "Hokkaido Wolf",
    img: "/assets/Slot/PP-SLOT-604.Hokkaido-Wolf.webp?v=1764384297889",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-604",
    platFormCode: "PP",
  },
  {
    name: "Holiday Ride",
    img: "/assets/Slot/PP-SLOT-404.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-404",
    platFormCode: "PP",
  },
  {
    name: "Holy Diver Megaways",
    img: "/assets/Slot/BTG-SLOT-051.webp?v=1756256536965",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-051",
    platFormCode: "BTG",
  },
  {
    name: "Holy Hand Grenade",
    img: "/assets/Slot/RELAX-SLOT-166.webp?v=1761894336311",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-166",
    platFormCode: "RELAX",
  },
  {
    name: "Home of the Brave",
    img: "/assets/Slot/NLC-SLOT-108.Home of the Brave.webp?v=1764390205564",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-108",
    platFormCode: "NLC",
  },
  {
    name: "Honey Gems",
    img: "/assets/Slot/PT-SLOT-261.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-261",
    platFormCode: "PT",
  },
  {
    name: "Honey Honey Honey",
    img: "/assets/Slot/PP-SLOT-070.Honey-Honey-Honey.webp?v=1764384233215",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-070",
    platFormCode: "PP",
  },
  {
    name: "Honey Hunters",
    img: "/assets/Slot/RELAX-SLOT-247.webp?v=1761894360760",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-247",
    platFormCode: "RELAX",
  },
  {
    name: "Honey Trap of Diao Chan",
    img: "/assets/Slot/PG-SLOT-001.webp?v=1765933237754",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-001",
    platFormCode: "PG",
  },
  {
    name: "Hood vs Wolf",
    img: "/assets/Slot/PG-SLOT-009.webp?v=1765933237758",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-009",
    platFormCode: "PG",
  },
  {
    name: "Hook's Heroes",
    img: "/assets/Slot/NETENT-SLOT-164.Hook_s-Heroes.webp?v=1764959058272",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-164",
    platFormCode: "NETENT",
  },
  {
    name: "Horizon",
    img: "/assets/Slot/CG-SLOT-084.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-084",
    platFormCode: "CG",
  },
  {
    name: "Horror Hotel",
    img: "/assets/Slot/RELAX-SLOT-161.webp?v=1761894391305",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-161",
    platFormCode: "RELAX",
  },
  {
    name: "Horus Eye",
    img: "/assets/Slot/j9nzkkbjfaz1a.Horus-Eye.webp?v=1765045702822",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-084",
    platFormCode: "JOKER",
  },
  {
    name: "Hot 4 Cash",
    img: "/assets/Slot/NLC-SLOT-045.Hot 4 Cash.webp?v=1764390138292",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-045",
    platFormCode: "NLC",
  },
  {
    name: "Hot Chilli",
    img: "/assets/Slot/PP-SLOT-076.Hot-Chilli.webp?v=1764384182010",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-076",
    platFormCode: "PP",
  },
  {
    name: "Hot Chilli",
    img: "/assets/Slot/JILI-SLOT-002.webp?v=1755507846546",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-002",
    platFormCode: "JILI",
  },
  {
    name: "Hot Fiesta",
    img: "/assets/Slot/PP-SLOT-175.Hot-Fiesta.webp?v=1764384130390",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-175",
    platFormCode: "PP",
  },
  {
    name: "Hot Fruits",
    img: "/assets/Slot/soojfuqnaxycn.Hot-Fruits.webp?v=1765043185291",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-085",
    platFormCode: "JOKER",
  },
  {
    name: "Hot Gems",
    img: "/assets/Slot/PT-SLOT-030.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-030",
    platFormCode: "PT",
  },
  {
    name: "Hot Gems Xtreme Scratch",
    img: "/assets/Slot/PT-SLOT-247.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-247",
    platFormCode: "PT",
  },
  {
    name: "Hot Harvest",
    img: "/assets/Slot/OCTOPLAY-SLOT-010.Hot Harvest.webp?v=1764933548064",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-010",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Hot Hot Chilli Pot",
    img: "/assets/Slot/RT-SLOT-219.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-219",
    platFormCode: "RT",
  },
  {
    name: "Hot KTV",
    img: "/assets/Slot/PT-SLOT-045.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-045",
    platFormCode: "PT",
  },
  {
    name: "Hot Nudge",
    img: "/assets/Slot/NLC-SLOT-055.Hot Nudge.webp?v=1764390086933",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-055",
    platFormCode: "NLC",
  },
  {
    name: "Hot Pepper",
    img: "/assets/Slot/PP-SLOT-311.Hot-Pepper.webp?v=1764384081196",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-311",
    platFormCode: "PP",
  },
  {
    name: "Hot Rod Racers",
    img: "/assets/Slot/RELAX-SLOT-150.webp?v=1761894416164",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-150",
    platFormCode: "RELAX",
  },
  {
    name: "Hot Safari",
    img: "/assets/Slot/PP-SLOT-141.Hot-Safari.webp?v=1764384028181",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-141",
    platFormCode: "PP",
  },
  {
    name: "Hot Shot",
    img: "/assets/Slot/ACEWIN-SLOT-021.Hot Shot.webp?v=1764854190419",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-021",
    platFormCode: "ACEWIN",
  },
  {
    name: "Hot Wheels",
    img: "/assets/Slot/qqgindypyeboy.Hot Wheels.webp?v=1765045746552",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-207",
    platFormCode: "JOKER",
  },
  {
    name: "Hot to Burn",
    img: "/assets/Slot/PP-SLOT-050.Hot-to-Burn.webp?v=1764383974791",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-050",
    platFormCode: "PP",
  },
  {
    name: "Hot to Burn Extreme",
    img: "/assets/Slot/PP-SLOT-265.Hot-To-Burn-Extreme.webp?v=1764383918547",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-265",
    platFormCode: "PP",
  },
  {
    name: "Hot to Burn Hold and Spin",
    img: "/assets/Slot/PP-SLOT-003.Hot-to-Burn-Hold-and-Spin.webp?v=1764383865298",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-003",
    platFormCode: "PP",
  },
  {
    name: "Hot to Burn Multiplier",
    img: "/assets/Slot/PP-SLOT-476.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-476",
    platFormCode: "PP",
  },
  {
    name: "Hotpot",
    img: "/assets/Slot/PG-SLOT-015.webp?v=1765933237761",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-015",
    platFormCode: "PG",
  },
  {
    name: "Huang Fei Hong",
    img: "/assets/Slot/zcw3utgfzk75o.Huang-Fei-Hong.webp?v=1765042003264",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-200",
    platFormCode: "JOKER",
  },
  {
    name: "Hugon Quest",
    img: "/assets/Slot/SG-SLOT-089.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-089",
    platFormCode: "SPADE",
  },
  {
    name: "Hulao Battle",
    img: "/assets/Slot/ACEWIN-SLOT-013.Hulao Battle.webp?v=1764854211448",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-013",
    platFormCode: "ACEWIN",
  },
  {
    name: "Hundreds and Thousands",
    img: "/assets/Slot/PP-SLOT-600.Hundreds and Thousands.webp?v=1764383716728",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-600",
    platFormCode: "PP",
  },
  {
    name: "Hungry Hungry Shark",
    img: "/assets/Slot/CG-SLOT-027.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-027",
    platFormCode: "CG",
  },
  {
    name: "Hunk Cai Shen",
    img: "/assets/Slot/KM-SLOT-019.Hunk Cai Shen.webp?v=1764861049911",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-019",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Hunters Moon",
    img: "/assets/Slot/YGG-SLOT-120.webp?v=1767056428457",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-120",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Huntress: Wild Vengeance",
    img: "/assets/Slot/RELAX-SLOT-144.webp?v=1761894446684",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-144",
    platFormCode: "RELAX",
  },
  {
    name: "Hustling",
    img: "/assets/Slot/RT-SLOT-173.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-173",
    platFormCode: "RT",
  },
  {
    name: "Hyper Burst",
    img: "/assets/Slot/JILI-SLOT-007.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-007",
    platFormCode: "JILI",
  },
  {
    name: "Hyper Respins",
    img: "/assets/Slot/YGG-SLOT-189.webp?v=1767056428527",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-189",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hyperburst",
    img: "/assets/Slot/YGG-SLOT-108.webp?v=1767056428446",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-108",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hypernova 10K Ways",
    img: "/assets/Slot/YGG-SLOT-119.webp?v=1767056428456",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-119",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Hypernova Megaways",
    img: "/assets/Slot/RELAX-SLOT-020.webp?v=1761894531669",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-020",
    platFormCode: "RELAX",
  },
  {
    name: "Ice Cave",
    img: "/assets/Slot/PT-SLOT-038.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-038",
    platFormCode: "PT",
  },
  {
    name: "Ice Ice Yeti",
    img: "/assets/Slot/NLC-SLOT-053.Ice Ice Yeti.webp?v=1764390005735",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-053",
    platFormCode: "NLC",
  },
  {
    name: "Ice Land",
    img: "/assets/Slot/P8-SLOT-018.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-018",
    platFormCode: "PLAY8",
  },
  {
    name: "Ice Lobster",
    img: "/assets/Slot/PP-SLOT-451.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-451",
    platFormCode: "PP",
  },
  {
    name: "Ice Mints",
    img: "/assets/Slot/PP-SLOT-588.Ice Mints.webp?v=1764383652966",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-588",
    platFormCode: "PP",
  },
  {
    name: "Ice Storm",
    img: "/assets/Slot/CG-SLOT-085.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-085",
    platFormCode: "CG",
  },
  {
    name: "Iceland SA",
    img: "/assets/Slot/SG-SLOT-023.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-023",
    platFormCode: "SPADE",
  },
  {
    name: "Icy Bar",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-048.icy-bar.webp?v=1765274321153",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-048",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Ignite The Night",
    img: "/assets/Slot/RELAX-SLOT-030.webp?v=1761894553402",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-030",
    platFormCode: "RELAX",
  },
  {
    name: "Immortal 5",
    img: "/assets/Slot/RELAX-SLOT-277.webp?v=1761894583746",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-277",
    platFormCode: "RELAX",
  },
  {
    name: "Immortal Fruits",
    img: "/assets/Slot/NLC-SLOT-034.Immortal Fruits.webp?v=1764389935820",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-034",
    platFormCode: "NLC",
  },
  {
    name: "Immortal Heroes",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-045.immortal-heroes.webp?v=1765274271380",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-045",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Immortal Ways Gallina Harvest",
    img: "/assets/Slot/PT-SLOT-435.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-435",
    platFormCode: "PT",
  },
  {
    name: "Immortal Ways Volcano",
    img: "/assets/Slot/PT-SLOT-446.webp?v=1753341257946",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-446",
    platFormCode: "PT",
  },
  {
    name: "Immortals",
    img: "/assets/Slot/qd1fcneqbhgy4.Immortals.webp?v=1765042198381",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-087",
    platFormCode: "JOKER",
  },
  {
    name: "In the Rabbit Hole",
    img: "/assets/Slot/RT-SLOT-227.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-227",
    platFormCode: "RT",
  },
  {
    name: "Incan Wonders",
    img: "/assets/Slot/PG-SLOT-152.webp?v=1765933237876",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-152",
    platFormCode: "PG",
  },
  {
    name: "Incinerator",
    img: "/assets/Slot/YGG-SLOT-023.webp?v=1767056428349",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-023",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Infectious 5 xWays",
    img: "/assets/Slot/NLC-SLOT-014.Infectious 5 xWays.webp?v=1764389891897",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-014",
    platFormCode: "NLC",
  },
  {
    name: "Infinity War",
    img: "/assets/Slot/CG-SLOT-059.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-059",
    platFormCode: "CG",
  },
  {
    name: "Irish Charms",
    img: "/assets/Slot/PP-SLOT-168.Irish Charms.webp?v=1764383543121",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-168",
    platFormCode: "PP",
  },
  {
    name: "Irish Crown",
    img: "/assets/Slot/PP-SLOT-537.Irish Crown.webp?v=1764383492057",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-537",
    platFormCode: "PP",
  },
  {
    name: "Irish Luck",
    img: "/assets/Slot/PT-SLOT-057.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-057",
    platFormCode: "PT",
  },
  {
    name: "Irish Pots MulitMax",
    img: "/assets/Slot/YGG-SLOT-319.webp?v=1767056428818",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-319",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Iron Bank",
    img: "/assets/Slot/RELAX-SLOT-031.webp?v=1761894611596",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-031",
    platFormCode: "RELAX",
  },
  {
    name: "Ishtar",
    img: "/assets/Slot/PT-SLOT-156.ishtar-power-zones.webp?v=1764330592030",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-156",
    platFormCode: "PT",
  },
  {
    name: "J Mania 3 Buffalo",
    img: "/assets/Slot/PT-SLOT-437.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-437",
    platFormCode: "PT",
  },
  {
    name: "J Mania Hot Asses",
    img: "/assets/Slot/PT-SLOT-464.J Mania Hot Asses.webp?v=1764326323632",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-464",
    platFormCode: "PT",
  },
  {
    name: "J Mania Loco Habanero",
    img: "/assets/Slot/PT-SLOT-432.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-432",
    platFormCode: "PT",
  },
  {
    name: "J Mania Lucky Pyggs",
    img: "/assets/Slot/PT-SLOT-475.J Mania Lucky Pyggs.webp?v=1764947276883",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-475",
    platFormCode: "PT",
  },
  {
    name: "J Mania Maniac",
    img: "/assets/Slot/PT-SLOT-473.J Mania Maniac.webp?v=1764941704311",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-473",
    platFormCode: "PT",
  },
  {
    name: "JILI CAISHEN",
    img: "/assets/Slot/JILI-SLOT-060.webp?v=1755509833526",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-060",
    platFormCode: "JILI",
  },
  {
    name: "JIN HOU YE",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-036.jin-hou-ye.webp?v=1765274221740",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-036",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "JIN JI MAHJONG",
    img: "/assets/Slot/2J-SLOT-024.JIN JI MAHJONG.webp?v=1763549252082",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-024",
    platFormCode: "JJ",
  },
  {
    name: "JIN LOONG",
    img: "/assets/Slot/2J-SLOT-033.JIN LOONG.webp?v=1763549150377",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-033",
    platFormCode: "JJ",
  },
  {
    name: "JJ 1000: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-104.JJ 1000 Hold & Win.webp?v=1764933564373",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-104",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "JUNGLE BANG BANG",
    img: "/assets/Slot/FC-SLOT-051.webp?v=1754025771055",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-051",
    platFormCode: "FC",
  },
  {
    name: "JUNGLE TIGER",
    img: "/assets/Slot/2J-SLOT-016.JUNGLE TIGER.webp?v=1763549051552",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-016",
    platFormCode: "JJ",
  },
  {
    name: "Jack Frost's Winter",
    img: "/assets/Slot/PG-SLOT-066.webp?v=1765933237801",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-066",
    platFormCode: "PG",
  },
  {
    name: "Jack Hammer™ 3: Diamond Affair",
    img: "/assets/Slot/NETENT-SLOT-188.Jack-Hammer-3-Diamond-Affair.webp?v=1764958842219",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-188",
    platFormCode: "NETENT",
  },
  {
    name: "Jack Hammer™ 4: Chasing the Dragon",
    img: "/assets/Slot/NETENT-SLOT-228.Jack Hammer™ 4_ Chasing the Dragon.webp?v=1764958815400",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-228",
    platFormCode: "NETENT",
  },
  {
    name: "Jack and the Beanstalk Remastered",
    img: "/assets/Slot/NETENT-SLOT-180.Jack-and-The-Beanstalk-Remastered.webp?v=1764958759213",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-180",
    platFormCode: "NETENT",
  },
  {
    name: "Jack the Giant Hunter",
    img: "/assets/Slot/PG-SLOT-158.webp?v=1765933237882",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-158",
    platFormCode: "PG",
  },
  {
    name: "Jackpot Blaze",
    img: "/assets/Slot/PP-SLOT-592.Jackpot Blaze.webp?v=1764383405184",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-592",
    platFormCode: "PP",
  },
  {
    name: "Jackpot District: City of Fortune",
    img: "/assets/Slot/OCTOPLAY-SLOT-103.Jackpot District City of Fortune.webp?v=1764933582186",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-103",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Jackpot Heist: Daylight Robbery",
    img: "/assets/Slot/OCTOPLAY-SLOT-054.jackpot Heist Daylight Robbery.webp?v=1764933619184",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-054",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Jackpot Hunter",
    img: "/assets/Slot/PP-SLOT-485.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-485",
    platFormCode: "PP",
  },
  {
    name: "Jackpot Joker",
    img: "/assets/Slot/JILI-SLOT-100.webp?v=1755510460455",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-100",
    platFormCode: "JILI",
  },
  {
    name: "Jackpot Joker FEVER",
    img: "/assets/Slot/JILI-SLOT-153.Jackpot Joker FEVER.webp?v=1764310802638",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-153",
    platFormCode: "JILI",
  },
  {
    name: "Jackrabbit Jackpots",
    img: "/assets/Slot/RT-SLOT-356.webp?v=1753341379060",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-356",
    platFormCode: "RT",
  },
  {
    name: "Jade Butterfly",
    img: "/assets/Slot/PP-SLOT-101.Jade-Butterfly.webp?v=1764383342378",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-101",
    platFormCode: "PP",
  },
  {
    name: "Jade Emperor Yu Huang Da Di",
    img: "/assets/Slot/PT-SLOT-050.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-050",
    platFormCode: "PT",
  },
  {
    name: "Jane Hunter and the Mask of Montezuma",
    img: "/assets/Slot/PP-SLOT-338.Jane-Hunter-and-the--Mask-of-Montezuma.webp?v=1764383289045",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-338",
    platFormCode: "PP",
  },
  {
    name: "Jane Jones In Book Of King 2",
    img: "/assets/Slot/PT-SLOT-172.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-172",
    platFormCode: "PT",
  },
  {
    name: "Jasmine Dreams",
    img: "/assets/Slot/PP-SLOT-341.Jasmine-Dreams.webp?v=1764383238622",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-341",
    platFormCode: "PP",
  },
  {
    name: "Jekyllz Wild UltraNudge",
    img: "/assets/Slot/YGG-SLOT-160.webp?v=1767056428491",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-160",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Jelly Belly Megaways",
    img: "/assets/Slot/NETENT-SLOT-183.Jelly-Belly-Megaways.webp?v=1764958682983",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-183",
    platFormCode: "NETENT",
  },
  {
    name: "Jelly Candy",
    img: "/assets/Slot/PP-SLOT-618.Jelly Candy.webp?v=1764383186997",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-618",
    platFormCode: "PP",
  },
  {
    name: "Jewel Rush",
    img: "/assets/Slot/PP-SLOT-353.Jewel-Rush.webp?v=1764383156731",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-353",
    platFormCode: "PP",
  },
  {
    name: "Jewel Scarabs",
    img: "/assets/Slot/RT-SLOT-153.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-153",
    platFormCode: "RT",
  },
  {
    name: "Jewels of Prosperity",
    img: "/assets/Slot/PG-SLOT-064.webp?v=1765933237799",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-064",
    platFormCode: "PG",
  },
  {
    name: "Jiang Shi Night",
    img: "/assets/Slot/of74x9z99u69r.Jiang Shi Night.webp?v=1765036185431",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-237",
    platFormCode: "JOKER",
  },
  {
    name: "Jin Fu Xing Yun",
    img: "/assets/Slot/ahf5icfts455e.Jin-Fu-Xing-Yun.webp?v=1765047099403",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-088",
    platFormCode: "JOKER",
  },
  {
    name: "Jin Qian Wa",
    img: "/assets/Slot/PT-SLOT-013.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-013",
    platFormCode: "PT",
  },
  {
    name: "Jin Qian Wa",
    img: "/assets/Slot/P8-SLOT-004.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-004",
    platFormCode: "PLAY8",
  },
  {
    name: "Jinfu Long",
    img: "/assets/Slot/PT-SLOT-029.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-029",
    platFormCode: "PT",
  },
  {
    name: "Jinfu Xingyun",
    img: "/assets/Slot/PT-SLOT-207.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-207",
    platFormCode: "PT",
  },
  {
    name: "Jingle Balls",
    img: "/assets/Slot/NLC-SLOT-079.Jingle Balls.webp?v=1764389846576",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-079",
    platFormCode: "NLC",
  },
  {
    name: "Jingle Bells Power Reels",
    img: "/assets/Slot/RT-SLOT-154.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-154",
    platFormCode: "RT",
  },
  {
    name: "Jinns Moon",
    img: "/assets/Slot/PT-SLOT-033.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-033",
    platFormCode: "PT",
  },
  {
    name: "Jo Blitz",
    img: "/assets/Slot/PT-SLOT-478.Jo Blitz.webp?v=1764996619837",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-478",
    platFormCode: "PT",
  },
  {
    name: "Jo ma ji",
    img: "/assets/Slot/CG-SLOT-028.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-028",
    platFormCode: "CG",
  },
  {
    name: "Joe Exotic",
    img: "/assets/Slot/RT-SLOT-201.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-201",
    platFormCode: "RT",
  },
  {
    name: "John Hunter & the Book of Tut Respin",
    img: "/assets/Slot/PP-SLOT-291.John-Hunter-and-The-Book-of-Tut-Respins.webp?v=1764383109976",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-291",
    platFormCode: "PP",
  },
  {
    name: "John Hunter and Galileo’s Secrets",
    img: "/assets/Slot/PP-SLOT-541.John Hunter and Galileo’s Secrets.webp?v=1764383046406",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-541",
    platFormCode: "PP",
  },
  {
    name: "John Hunter and the Aztec Treasure",
    img: "/assets/Slot/PP-SLOT-077.John-Hunter-and-the-Aztec-Treasure.webp?v=1764382997543",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-077",
    platFormCode: "PP",
  },
  {
    name: "John Hunter and the Book of Tut",
    img: "/assets/Slot/PP-SLOT-047.John-Hunter-and-The-Book-of-Tut.webp?v=1764382940236",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-047",
    platFormCode: "PP",
  },
  {
    name: "John Hunter and the Mayan Gods",
    img: "/assets/Slot/PP-SLOT-016.John-Hunter-and-The-Mayan-Gods.webp?v=1764845146009",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-016",
    platFormCode: "PP",
  },
  {
    name: "John Hunter and the Quest for Bermuda Riches",
    img: "/assets/Slot/PP-SLOT-208.John-Hunter-and-the-Quest-for-Bermuda-Riches.webp?v=1764845262912",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-208",
    platFormCode: "PP",
  },
  {
    name: "John Hunter and the Tomb of the Scarab Queen",
    img: "/assets/Slot/PP-SLOT-072.John-Hunter-and-the-Tomb-of-the-Scarab-Queen.webp?v=1764382885366",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-072",
    platFormCode: "PP",
  },
  {
    name: "Johnan Legendarian",
    img: "/assets/Slot/YGG-SLOT-009.webp?v=1767056428331",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-009",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Joker Coins",
    img: "/assets/Slot/JILI-SLOT-137.joker-coins.webp?v=1764311354099",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-137",
    platFormCode: "JILI",
  },
  {
    name: "Joker Jackpot",
    img: "/assets/Slot/RELAX-SLOT-070.webp?v=1761894638300",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-070",
    platFormCode: "RELAX",
  },
  {
    name: "Joker Jackpots: Prize Mania",
    img: "/assets/Slot/OCTOPLAY-SLOT-074.Joker Jackpots Prize Mania.webp?v=1764933703288",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-074",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Joker Jewels Dice",
    img: "/assets/Slot/PP-SLOT-398.Joker-Jewel-Dice.webp?v=1764382835566",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-398",
    platFormCode: "PP",
  },
  {
    name: "Joker King",
    img: "/assets/Slot/PP-SLOT-004.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-004",
    platFormCode: "PP",
  },
  {
    name: "Joker Madness",
    img: "/assets/Slot/gkubyu4cjibrg.Joker-Madness.webp?v=1765052117751",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-089",
    platFormCode: "JOKER",
  },
  {
    name: "Joker Race",
    img: "/assets/Slot/PP-SLOT-358.Joker-Race.webp?v=1764382766391",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-358",
    platFormCode: "PP",
  },
  {
    name: "Joker Rush",
    img: "/assets/Slot/PT-SLOT-108.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-108",
    platFormCode: "PT",
  },
  {
    name: "Joker Rush: Cash collect",
    img: "/assets/Slot/PT-SLOT-269.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-269",
    platFormCode: "PT",
  },
  {
    name: "Joker Split",
    img: "/assets/Slot/RELAX-SLOT-200.webp?v=1761894992287",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-200",
    platFormCode: "RELAX",
  },
  {
    name: "Joker Super Reels",
    img: "/assets/Slot/RELAX-SLOT-021.webp?v=1761895022095",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-021",
    platFormCode: "RELAX",
  },
  {
    name: "Joker's Jewels",
    img: "/assets/Slot/PP-SLOT-107.Joker_s-Jewels.webp?v=1764382719499",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-107",
    platFormCode: "PP",
  },
  {
    name: "Joker's Jewels Hot",
    img: "/assets/Slot/PP-SLOT-479.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-479",
    platFormCode: "PP",
  },
  {
    name: "Joker's Jewels Wild",
    img: "/assets/Slot/PP-SLOT-454.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-454",
    platFormCode: "PP",
  },
  {
    name: "Joker's Treasure Exclusive",
    img: "/assets/Slot/SG-SLOT-108.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-108",
    platFormCode: "SPADE",
  },
  {
    name: "Joker’s Jewels Cash",
    img: "/assets/Slot/PP-SLOT-557.webp?v=1755572073768",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-557",
    platFormCode: "PP",
  },
  {
    name: "Jokrz Wild UltraNudge",
    img: "/assets/Slot/YGG-SLOT-135.webp?v=1767056428470",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-135",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Jokrz Wild UltraNudge Gigablox",
    img: "/assets/Slot/YGG-SLOT-200.webp?v=1767056428550",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-200",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Journey To The Wealth",
    img: "/assets/Slot/PG-SLOT-037.webp?v=1765933237777",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-037",
    platFormCode: "PG",
  },
  {
    name: "Journey to the West",
    img: "/assets/Slot/PP-SLOT-135.Journey-to-the-West.webp?v=1764382625273",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-135",
    platFormCode: "PP",
  },
  {
    name: "Journey to the Wild",
    img: "/assets/Slot/SG-SLOT-113.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-113",
    platFormCode: "SPADE",
  },
  {
    name: "Juiced Duomax",
    img: "/assets/Slot/YGG-SLOT-226.webp?v=1767056428573",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-226",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Juicy Fruits",
    img: "/assets/Slot/PP-SLOT-172.Juicy Fruits.webp?v=1764382577553",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-172",
    platFormCode: "PP",
  },
  {
    name: "Juicy Fruits Multihold",
    img: "/assets/Slot/PP-SLOT-424.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-424",
    platFormCode: "PP",
  },
  {
    name: "Juicy Jelly Thunder Ways",
    img: "/assets/Slot/YGG-SLOT-353.webp?v=1767056428860",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-353",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Juicy Jewels Supercharged",
    img: "/assets/Slot/OCTOPLAY-SLOT-107.Juicy Jewels Supercharged.webp?v=1764933718420",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-107",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Juicy Market",
    img: "/assets/Slot/SG-SLOT-159.webp?v=1752734370556",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-159",
    platFormCode: "SPADE",
  },
  {
    name: "Juicy Rolls: Feature Frenzy",
    img: "/assets/Slot/OCTOPLAY-SLOT-060.Juicy Rolls Feature Frenzy.webp?v=1764933759672",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-060",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Jumanji",
    img: "/assets/Slot/NETENT-SLOT-034.Jumanji.webp?v=1764958474884",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-034",
    platFormCode: "NETENT",
  },
  {
    name: "Jumbo Jellies",
    img: "/assets/Slot/YGG-SLOT-128.webp?v=1767056428465",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-128",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Jumbo Safari",
    img: "/assets/Slot/PP-SLOT-566.Jumbo Safari.webp?v=1764338062124",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-566",
    platFormCode: "PP",
  },
  {
    name: "Jump For Richness",
    img: "/assets/Slot/ACEWIN-SLOT-017.Jump for Riches.webp?v=1764854230822",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-017",
    platFormCode: "ACEWIN",
  },
  {
    name: "Jungle",
    img: "/assets/Slot/P8-SLOT-030.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-030",
    platFormCode: "PLAY8",
  },
  {
    name: "Jungle Adventure",
    img: "/assets/Slot/ACEWIN-SLOT-027.Jungle Adventure.webp?v=1764854248202",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-027",
    platFormCode: "ACEWIN",
  },
  {
    name: "Jungle Books",
    img: "/assets/Slot/YGG-SLOT-031.webp?v=1767056428359",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-031",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Jungle Delight",
    img: "/assets/Slot/PG-SLOT-024.webp?v=1765933237769",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-024",
    platFormCode: "PG",
  },
  {
    name: "Jungle Giants",
    img: "/assets/Slot/PT-SLOT-131.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-131",
    platFormCode: "PT",
  },
  {
    name: "Jungle Gorilla",
    img: "/assets/Slot/PP-SLOT-034.Jungle Gorilla.webp?v=1764337965768",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-034",
    platFormCode: "PP",
  },
  {
    name: "Jungle Island",
    img: "/assets/Slot/xbxy1yegyhnyk.Jungle-Island.webp?v=1765054045115",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-091",
    platFormCode: "JOKER",
  },
  {
    name: "Jungle King",
    img: "/assets/Slot/JILI-SLOT-028.webp?v=1755509361885",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-028",
    platFormCode: "JILI",
  },
  {
    name: "Jungle King",
    img: "/assets/Slot/SG-SLOT-012.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-028",
    platFormCode: "JILI",
  },
  {
    name: "Jungle Pop",
    img: "/assets/Slot/YGG-SLOT-340.webp?v=1767056428837",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-340",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Jungle Smash",
    img: "/assets/Slot/YGG-SLOT-337.webp?v=1767056428835",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-337",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Jungle Spirit Megaways",
    img: "/assets/Slot/NETENT-SLOT-192.Jungle-Spirit-Megaways.webp?v=1764958384425",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-192",
    platFormCode: "NETENT",
  },
  {
    name: "Jurassic Island",
    img: "/assets/Slot/PT-SLOT-086.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-086",
    platFormCode: "PT",
  },
  {
    name: "Jurassic Island 2",
    img: "/assets/Slot/PT-SLOT-096.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-096",
    platFormCode: "PT",
  },
  {
    name: "Jurassic Kingdom",
    img: "/assets/Slot/PG-SLOT-079.webp?v=1765933237811",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-079",
    platFormCode: "PG",
  },
  {
    name: "Jurassic Park",
    img: "/assets/Slot/CG-SLOT-002.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-002",
    platFormCode: "CG",
  },
  {
    name: "Jurassic Party",
    img: "/assets/Slot/RELAX-SLOT-116.webp?v=1761895060574",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-116",
    platFormCode: "RELAX",
  },
  {
    name: "Just Jewels Deluxe",
    img: "/assets/Slot/satj3o6ya8dcq.Just-Jewels-Deluxe.webp?v=1765051047993",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-092",
    platFormCode: "JOKER",
  },
  {
    name: "KING KONG",
    img: "/assets/Slot/2J-SLOT-062.KING KONG.webp?v=1763548824745",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-062",
    platFormCode: "JJ",
  },
  {
    name: "Ka Ching Boom",
    img: "/assets/Slot/PT-SLOT-469.Ka Ching Boom.webp?v=1764326173864",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-469",
    platFormCode: "PT",
  },
  {
    name: "Karen Maneater",
    img: "/assets/Slot/NLC-SLOT-024.Karen Maneater.webp?v=1764389786878",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-024",
    platFormCode: "NLC",
  },
  {
    name: "Kawaii Princess",
    img: "/assets/Slot/OCTOPLAY-SLOT-073.Kawaii Princess.webp?v=1764933796364",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-073",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Kenneth Must Die",
    img: "/assets/Slot/NLC-SLOT-087.Kenneth Must Die.webp?v=1764389738129",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-087",
    platFormCode: "NLC",
  },
  {
    name: "Kill Em All",
    img: "/assets/Slot/NLC-SLOT-111.Kill Em All.webp?v=1764389175875",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-111",
    platFormCode: "NLC",
  },
  {
    name: "Killroad 66",
    img: "/assets/Slot/YGG-SLOT-323.webp?v=1767056428824",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-323",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Kimba",
    img: "/assets/Slot/CG-SLOT-105.Kimba.webp?v=1764666443515",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-105",
    platFormCode: "CG",
  },
  {
    name: "King Arthur",
    img: "/assets/Slot/JILI-SLOT-091.webp?v=1755510238924",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-091",
    platFormCode: "JILI",
  },
  {
    name: "King Arthur 10K Ways",
    img: "/assets/Slot/YGG-SLOT-238.webp?v=1767056428591",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-238",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "King Arthur Gold",
    img: "/assets/Slot/YesBingo-SLOT-017.King Arthur.webp?v=1765104056415",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-017",
    platFormCode: "YESBINGO",
  },
  {
    name: "King Kong",
    img: "/assets/Slot/SlotKingKong.KING KONG.webp?v=1764775649221",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-062",
    platFormCode: "JJ",
  },
  {
    name: "King Pharaoh",
    img: "/assets/Slot/SG-SLOT-034.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-034",
    platFormCode: "SPADE",
  },
  {
    name: "King Power",
    img: "/assets/Slot/YGG-SLOT-328.webp?v=1767056428828",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-328",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "King of Cats",
    img: "/assets/Slot/BTG-SLOT-045.webp?v=1756256536960",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-045",
    platFormCode: "BTG",
  },
  {
    name: "King of Giza: Mega Cash Collect & Link",
    img: "/assets/Slot/PT-SLOT-472.King of Giza Mega Cash Collect & Link.webp?v=1764941534935",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-472",
    platFormCode: "PT",
  },
  {
    name: "King of Kings",
    img: "/assets/Slot/RELAX-SLOT-032.webp?v=1761895127162",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-032",
    platFormCode: "RELAX",
  },
  {
    name: "King's Sword",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-070.king_s-sword.webp?v=1765274167674",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-070",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Kingdom of Asgard",
    img: "/assets/Slot/PP-SLOT-293.Kingdom of Asgard.webp?v=1764337821562",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-293",
    platFormCode: "PP",
  },
  {
    name: "Kingdom of The Dead",
    img: "/assets/Slot/PP-SLOT-340.Kingdom of The Dead.webp?v=1764337760653",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-340",
    platFormCode: "PP",
  },
  {
    name: "Kingmaker Fully Loaded",
    img: "/assets/Slot/BTG-SLOT-032.webp?v=1756256536950",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-032",
    platFormCode: "BTG",
  },
  {
    name: "Kingsman",
    img: "/assets/Slot/JDB-SLOT-033.kingsman.webp?v=1765262316072",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-033",
    platFormCode: "JDB",
  },
  {
    name: "Kiss My Chainsaw",
    img: "/assets/Slot/NLC-SLOT-066.Kiss My Chainsaw.webp?v=1764389122864",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-066",
    platFormCode: "NLC",
  },
  {
    name: "KittyGold",
    img: "/assets/Slot/YL-EGAME-019.webp?v=1751418030471",
    platForm: "YL",
    type: "slots",
    gameType: "EGAME",
    casinoType: "YL-EGAME-019",
    platFormCode: "YL",
  },
  {
    name: "Kleo Patra",
    img: "/assets/Slot/CG-SLOT-108.Kleo Patra.webp?v=1764666508017",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-108",
    platFormCode: "CG",
  },
  {
    name: "Kluster Krystals Megaclusters",
    img: "/assets/Slot/RELAX-SLOT-033.webp?v=1761895208920",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-033",
    platFormCode: "RELAX",
  },
  {
    name: "Knight Hot Spotz",
    img: "/assets/Slot/PP-SLOT-345.Knight Hot Spotz.webp?v=1764337693290",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-345",
    platFormCode: "PP",
  },
  {
    name: "Knights Of Avalon",
    img: "/assets/Slot/RT-SLOT-243.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-243",
    platFormCode: "RT",
  },
  {
    name: "Knockout Riches",
    img: "/assets/Slot/PG-SLOT-156.webp?v=1765933237880",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-156",
    platFormCode: "PG",
  },
  {
    name: "Koi Harmony",
    img: "/assets/Slot/PT-SLOT-106.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-106",
    platFormCode: "PT",
  },
  {
    name: "Koi Pond",
    img: "/assets/Slot/PP-SLOT-254.Koi Pond.webp?v=1764334416035",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-254",
    platFormCode: "PP",
  },
  {
    name: "Koi Trio",
    img: "/assets/Slot/JDB-SLOT-132.koi-trio.webp?v=1767691343947",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-132",
    platFormCode: "JDB",
  },
  {
    name: "Kong",
    img: "/assets/Slot/JDB-SLOT-094.kong.webp?v=1767691462828",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-094",
    platFormCode: "JDB",
  },
  {
    name: "Kraken Gold Rush",
    img: "/assets/Slot/PG-SLOT-164.webp?v=1765933237887",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-164",
    platFormCode: "PG",
  },
  {
    name: "Kraken Hunter",
    img: "/assets/Slot/ooekf9x16xaxn.Kraken-Hunter.webp?v=1765046689340",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-187",
    platFormCode: "JOKER",
  },
  {
    name: "Kraken's Sky Bounty",
    img: "/assets/Slot/PP-SLOT-361.Kraken_s Sky Bounty.webp?v=1764334358982",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-361",
    platFormCode: "PP",
  },
  {
    name: "Krazy Klimber",
    img: "/assets/Slot/YGG-SLOT-072.webp?v=1767056428409",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-072",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "LAND OF GEMS",
    img: "/assets/Slot/2J-SLOT-007.LAND OF GEMS.webp?v=1763548781190",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-007",
    platFormCode: "JJ",
  },
  {
    name: "LEGEND OF INCA",
    img: "/assets/Slot/FC-SLOT-034.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-034",
    platFormCode: "FC",
  },
  {
    name: "LEPPY LOOT",
    img: "/assets/Slot/KM-SLOT-009.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-009",
    platFormCode: "KINGMAKER",
  },
  {
    name: "LEPRECHAUN'S COIN",
    img: "/assets/Slot/2J-SLOT-020.LEPRECHAUN_S COIN.webp?v=1763548720024",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-020",
    platFormCode: "JJ",
  },
  {
    name: "LIGHT OF APOLLO",
    img: "/assets/Slot/YesBingo-SLOT-034.light-of-apollo.webp?v=1765103959102",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-034",
    platFormCode: "YESBINGO",
  },
  {
    name: "LONDON MYSTERY",
    img: "/assets/Slot/KM-SLOT-013.webp?v=1759831912160",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-013",
    platFormCode: "KINGMAKER",
  },
  {
    name: "LONER",
    img: "/assets/Slot/NLC-SLOT-088.LONER.webp?v=1764389064810",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-088",
    platFormCode: "NLC",
  },
  {
    name: "LU LING QI",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-041.lu-ling-qi.webp?v=1765274116844",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-041",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "LUCKY FORTUNES 3x3",
    img: "/assets/Slot/FC-SLOT-038.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-038",
    platFormCode: "FC",
  },
  {
    name: "LUXURY GOLDEN PANTHER",
    img: "/assets/Slot/FC-SLOT-012.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-012",
    platFormCode: "FC",
  },
  {
    name: "La Fiesta",
    img: "/assets/Slot/RELAX-SLOT-034.webp?v=1761895638812",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-034",
    platFormCode: "RELAX",
  },
  {
    name: "La Fiesta 10K",
    img: "/assets/Slot/RELAX-SLOT-236.webp?v=1761898913175",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-236",
    platFormCode: "RELAX",
  },
  {
    name: "La Fiesta 5K",
    img: "/assets/Slot/RELAX-SLOT-235.webp?v=1761898937646",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-235",
    platFormCode: "RELAX",
  },
  {
    name: "Lady Godiva",
    img: "/assets/Slot/PP-SLOT-144.Lady Godiva.webp?v=1764334289164",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-144",
    platFormCode: "PP",
  },
  {
    name: "Lady Hawk",
    img: "/assets/Slot/wcaadzg74mj7y.Lady-Hawk.webp?v=1765054921289",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-093",
    platFormCode: "JOKER",
  },
  {
    name: "Lady Merlin Lightning Chase",
    img: "/assets/Slot/YGG-SLOT-077.webp?v=1767056428417",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-077",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lady Merlin Multimax",
    img: "/assets/Slot/YGG-SLOT-178.webp?v=1767056428517",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-178",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lady Midas",
    img: "/assets/Slot/YGG-SLOT-385.webp?v=1767056428890",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-385",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lamp Of Infinity",
    img: "/assets/Slot/PP-SLOT-351.Lamp Of Infinity.webp?v=1764334213606",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-351",
    platFormCode: "PP",
  },
  {
    name: "Land Of The Free",
    img: "/assets/Slot/NLC-SLOT-080.Land Of The Free.webp?v=1764389000161",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-080",
    platFormCode: "NLC",
  },
  {
    name: "Land of Riches",
    img: "/assets/Slot/RT-SLOT-368.Land of Riches.webp?v=1765033371622",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-368",
    platFormCode: "RT",
  },
  {
    name: "LanternWealth",
    img: "/assets/Slot/JDB-SLOT-115.Lantern Wealth.webp?v=1767691598317",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-115",
    platFormCode: "JDB",
  },
  {
    name: "Last Chance Saloon",
    img: "/assets/Slot/RT-SLOT-176.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-176",
    platFormCode: "RT",
  },
  {
    name: "Lava Balls",
    img: "/assets/Slot/PP-SLOT-606.Lava Balls.webp?v=1764334148740",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-606",
    platFormCode: "PP",
  },
  {
    name: "Lava Joker",
    img: "/assets/Slot/RT-SLOT-364.Lava Joker.webp?v=1765033424509",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-364",
    platFormCode: "RT",
  },
  {
    name: "League Of Legends",
    img: "/assets/Slot/orm4x9z99u69r.League-Of-Legends.webp?v=1765052008270",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-094",
    platFormCode: "JOKER",
  },
  {
    name: "Legacy Of Kong Maxways",
    img: "/assets/Slot/SG-SLOT-116.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-116",
    platFormCode: "SPADE",
  },
  {
    name: "Legacy of Anubis",
    img: "/assets/Slot/YGG-SLOT-311.webp?v=1767056428811",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-311",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Legacy of Egypt",
    img: "/assets/Slot/JILI-SLOT-105.webp?v=1755510569232",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-105",
    platFormCode: "JILI",
  },
  {
    name: "Legacy of Ramakien",
    img: "/assets/Slot/SG-SLOT-160.Legacy of Ramakien.webp?v=1764326454754",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-160",
    platFormCode: "SPADE",
  },
  {
    name: "Legacy of the Tiger",
    img: "/assets/Slot/PT-SLOT-193.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-193",
    platFormCode: "PT",
  },
  {
    name: "Legacy of the Wild",
    img: "/assets/Slot/PT-SLOT-072.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-072",
    platFormCode: "PT",
  },
  {
    name: "Legacy of the Wilds 2",
    img: "/assets/Slot/PT-SLOT-188.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-188",
    platFormCode: "PT",
  },
  {
    name: "Legend Of Athena",
    img: "/assets/Slot/RT-SLOT-122.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-122",
    platFormCode: "RT",
  },
  {
    name: "Legend Of Persia",
    img: "/assets/Slot/1iz58azdhdo6c.Legend Of Persia.webp?v=1765041499423",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-216",
    platFormCode: "JOKER",
  },
  {
    name: "Legend of Dragon Wins",
    img: "/assets/Slot/YGG-SLOT-234.webp?v=1767056428586",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-234",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Legend of Hou Yi",
    img: "/assets/Slot/PG-SLOT-018.webp?v=1765933237764",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-018",
    platFormCode: "PG",
  },
  {
    name: "Legend of Hydra",
    img: "/assets/Slot/PT-SLOT-194.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-194",
    platFormCode: "PT",
  },
  {
    name: "Legend of Perseus",
    img: "/assets/Slot/PG-SLOT-103.webp?v=1765933237830",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-103",
    platFormCode: "PG",
  },
  {
    name: "Legend of the Golden Monkey",
    img: "/assets/Slot/YGG-SLOT-025.webp?v=1767056428352",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-025",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Legendary 5",
    img: "/assets/Slot/JDB-SLOT-044.legendary_5.webp?v=1765262084509",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-044",
    platFormCode: "JDB",
  },
  {
    name: "Legendary Excalibur",
    img: "/assets/Slot/RT-SLOT-155.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-155",
    platFormCode: "RT",
  },
  {
    name: "Legendary Monkey King",
    img: "/assets/Slot/PG-SLOT-086.webp?v=1765933237817",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-086",
    platFormCode: "PG",
  },
  {
    name: "Legends: Battle for Earth",
    img: "/assets/Slot/OCTOPLAY-SLOT-077.Legends Battle For Earth.webp?v=1764933839638",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-077",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Legion Hot1",
    img: "/assets/Slot/YGG-SLOT-066.webp?v=1767056428403",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-066",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Legion X",
    img: "/assets/Slot/NLC-SLOT-026.Legion X.webp?v=1764388955246",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-026",
    platFormCode: "NLC",
  },
  {
    name: "Leprechaun",
    img: "/assets/Slot/zezjtt6ras7ms.Leprechaun.webp?v=1765053994869",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-188",
    platFormCode: "JOKER",
  },
  {
    name: "Leprechaun Carol",
    img: "/assets/Slot/PP-SLOT-092.Leprechaun Carol.webp?v=1764334076892",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-092",
    platFormCode: "PP",
  },
  {
    name: "Leprechaun Riches",
    img: "/assets/Slot/PG-SLOT-038.webp?v=1765933237778",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-038",
    platFormCode: "PG",
  },
  {
    name: "Leprechaun Song",
    img: "/assets/Slot/PP-SLOT-100.Leprechaun Song.webp?v=1764334004090",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-100",
    platFormCode: "PP",
  },
  {
    name: "Leprechaun's Magic",
    img: "/assets/Slot/RT-SLOT-096.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-096",
    platFormCode: "RT",
  },
  {
    name: "Leprechauns Magic Megaways",
    img: "/assets/Slot/RT-SLOT-302.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-302",
    platFormCode: "RT",
  },
  {
    name: "Leprechauns Magic Power Reels",
    img: "/assets/Slot/RT-SLOT-303.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-303",
    platFormCode: "RT",
  },
  {
    name: "Let It Burn",
    img: "/assets/Slot/NETENT-SLOT-134.Let-It-Burn.webp?v=1764957934664",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-134",
    platFormCode: "NETENT",
  },
  {
    name: "Let's get ready to Rumble",
    img: "/assets/Slot/RELAX-SLOT-035.webp?v=1761898993409",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-035",
    platFormCode: "RELAX",
  },
  {
    name: "Lie Yan Zuan Shi",
    img: "/assets/Slot/PT-SLOT-031.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-031",
    platFormCode: "PT",
  },
  {
    name: "Life O'Riley",
    img: "/assets/Slot/YGG-SLOT-321.webp?v=1767056428822",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-321",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lightning God",
    img: "/assets/Slot/1ru5x5zx7us6r.Lightning-God.webp?v=1765045365800",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-095",
    platFormCode: "JOKER",
  },
  {
    name: "Lightning Joker",
    img: "/assets/Slot/YGG-SLOT-049.webp?v=1767056428378",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-049",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lights of Luck",
    img: "/assets/Slot/PT-SLOT-408.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-408",
    platFormCode: "PT",
  },
  {
    name: "Lil Demo Double Heat",
    img: "/assets/Slot/PT-SLOT-438.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-438",
    platFormCode: "PT",
  },
  {
    name: "Lil Demon: Mega Cash Collect",
    img: "/assets/Slot/PT-SLOT-361.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-361",
    platFormCode: "PT",
  },
  {
    name: "Lil Devil",
    img: "/assets/Slot/BTG-SLOT-036.webp?v=1756256536954",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-036",
    platFormCode: "BTG",
  },
  {
    name: "Lil Sphinx",
    img: "/assets/Slot/PT-SLOT-413.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-413",
    platFormCode: "PT",
  },
  {
    name: "Lion Dance",
    img: "/assets/Slot/CG-SLOT-066.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-066",
    platFormCode: "CG",
  },
  {
    name: "Lion Of The East",
    img: "/assets/Slot/ysj1ghuuqbazc.Lion-Of-The-East.webp?v=1765052238858",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-191",
    platFormCode: "JOKER",
  },
  {
    name: "Lion's Hoard",
    img: "/assets/Slot/RT-SLOT-215.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-215",
    platFormCode: "RT",
  },
  {
    name: "Lion2Dance",
    img: "/assets/Slot/ACEWIN-SLOT-031.Lion2 Dance.webp?v=1764854270962",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-031",
    platFormCode: "ACEWIN",
  },
  {
    name: "Lions Dance",
    img: "/assets/Slot/wtupmzq14xepn.Lions-Dance.webp?v=1765044187489",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-096",
    platFormCode: "JOKER",
  },
  {
    name: "Lions Gigablox",
    img: "/assets/Slot/YGG-SLOT-274.webp?v=1767056428781",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-274",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Little Bighorn",
    img: "/assets/Slot/NLC-SLOT-021.Little Bighorn.webp?v=1764388900025",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-021",
    platFormCode: "NLC",
  },
  {
    name: "Little Gem",
    img: "/assets/Slot/PP-SLOT-256.Little Gem.webp?v=1764333938705",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-256",
    platFormCode: "PP",
  },
  {
    name: "Llama Adventure",
    img: "/assets/Slot/JDB-SLOT-013.the_llama_adventure.webp?v=1765262020993",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-013",
    platFormCode: "JDB",
  },
  {
    name: "Lobster Bob's Crazy Crab Shack",
    img: "/assets/Slot/PP-SLOT-366.Lobster Bob_s Crazy Crab Shack.webp?v=1764333878794",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-366",
    platFormCode: "PP",
  },
  {
    name: "Lobster Bob's Sea Food and Win It",
    img: "/assets/Slot/PP-SLOT-456.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-456",
    platFormCode: "PP",
  },
  {
    name: "Lobster House",
    img: "/assets/Slot/PP-SLOT-595.Lobster House.webp?v=1764333785924",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-595",
    platFormCode: "PP",
  },
  {
    name: "Lock & Hit: Red Knight",
    img: "/assets/Slot/PT-SLOT-333.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-333",
    platFormCode: "PT",
  },
  {
    name: "Lock & Loot Gigablox",
    img: "/assets/Slot/YGG-SLOT-400.webp?v=1767056428910",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-400",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lock and Pop",
    img: "/assets/Slot/NETENT-SLOT-210.Lock-and-Pop.webp?v=1764957832881",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-210",
    platFormCode: "NETENT",
  },
  {
    name: "Lock ‘n Load",
    img: "/assets/Slot/YGG-SLOT-376.webp?v=1767056428882",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-376",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lockdown Loot",
    img: "/assets/Slot/PT-SLOT-325.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-325",
    platFormCode: "PT",
  },
  {
    name: "Lollicat",
    img: "/assets/Slot/OCTOPLAY-SLOT-011.lollicat.webp?v=1764933883036",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-011",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Lollipop Drop MultiMax",
    img: "/assets/Slot/YGG-SLOT-301.webp?v=1767056428803",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-301",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "London Tube",
    img: "/assets/Slot/RT-SLOT-264.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-264",
    platFormCode: "RT",
  },
  {
    name: "Long Long Long",
    img: "/assets/Slot/PT-SLOT-005.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-005",
    platFormCode: "PT",
  },
  {
    name: "Long Long Long",
    img: "/assets/Slot/CG-SLOT-019.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-019",
    platFormCode: "CG",
  },
  {
    name: "Looney Pop",
    img: "/assets/Slot/RELAX-SLOT-211.webp?v=1761899022345",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-211",
    platFormCode: "RELAX",
  },
  {
    name: "Lord Of The Ocean",
    img: "/assets/Slot/xmzfobaryz7xs.Lord-Of-The-Ocean.webp?v=1765046975297",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-097",
    platFormCode: "JOKER",
  },
  {
    name: "Lord of the Dunes",
    img: "/assets/Slot/OCTOPLAY-SLOT-044.Lord of the dunes.webp?v=1764933931507",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-044",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Los Muertos Locos",
    img: "/assets/Slot/RT-SLOT-329.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-329",
    platFormCode: "RT",
  },
  {
    name: "Lost City Of Gold",
    img: "/assets/Slot/CG-SLOT-086.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-086",
    platFormCode: "CG",
  },
  {
    name: "Lost Relics 2",
    img: "/assets/Slot/NETENT-SLOT-204.lost-relic-2.webp?v=1764957764750",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-204",
    platFormCode: "NETENT",
  },
  {
    name: "Lost in Egypt",
    img: "/assets/Slot/CG-SLOT-079.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-079",
    platFormCode: "CG",
  },
  {
    name: "Lotto Madness",
    img: "/assets/Slot/PT-SLOT-068.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-068",
    platFormCode: "PT",
  },
  {
    name: "Lotus Warrior",
    img: "/assets/Slot/YGG-SLOT-218.webp?v=1767056428565",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-218",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Love Idol",
    img: "/assets/Slot/SG-SLOT-093.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-093",
    platFormCode: "SPADE",
  },
  {
    name: "Love Letter",
    img: "/assets/Slot/nzzugaudcbosc.Love-Letter.webp?v=1765036098828",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-196",
    platFormCode: "JOKER",
  },
  {
    name: "Love and Thunder",
    img: "/assets/Slot/CG-SLOT-097.webp?v=1753843874012",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-097",
    platFormCode: "CG",
  },
  {
    name: "Lovefool",
    img: "/assets/Slot/PT-SLOT-176.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-176",
    platFormCode: "PT",
  },
  {
    name: "Lucha Maniacs",
    img: "/assets/Slot/YGG-SLOT-032.webp?v=1767056428360",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-032",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lucky Angler: A Snowy Catch",
    img: "/assets/Slot/NETENT-SLOT-168.Lucky-Angler-A-snowy-Catch.webp?v=1764957642450",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-168",
    platFormCode: "NETENT",
  },
  {
    name: "Lucky Ball",
    img: "/assets/Slot/JILI-SLOT-006.webp?v=1755509025363",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-006",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Bass: Mega Cash Collect",
    img: "/assets/Slot/PT-SLOT-358.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-358",
    platFormCode: "PT",
  },
  {
    name: "Lucky Bunny",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-085.Lucky-Bunny.webp?v=1765274068673",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-085",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Lucky Carnival",
    img: "/assets/Slot/RT-SLOT-304.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-304",
    platFormCode: "RT",
  },
  {
    name: "Lucky Cat Gala",
    img: "/assets/Slot/KM-SLOT-028.Lucky Cat Gala.webp?v=1764861284311",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-028",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Lucky Clover Riches",
    img: "/assets/Slot/PG-SLOT-119.webp?v=1765933237844",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-119",
    platFormCode: "PG",
  },
  {
    name: "Lucky Coming",
    img: "/assets/Slot/JILI-SLOT-037.webp?v=1755509404144",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-037",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Diamond",
    img: "/assets/Slot/JDB-SLOT-093.lucky-diamond.webp?v=1765261968639",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-093",
    platFormCode: "JDB",
  },
  {
    name: "Lucky Dice",
    img: "/assets/Slot/PP-SLOT-633.webp?v=1765433925096",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-633",
    platFormCode: "PP",
  },
  {
    name: "Lucky Dog",
    img: "/assets/Slot/PP-SLOT-620.Lucky Dog.webp?v=1764333698071",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-620",
    platFormCode: "PP",
  },
  {
    name: "Lucky Doggy",
    img: "/assets/Slot/JILI-SLOT-117.webp?v=1755510844322",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-117",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Dragon Ball",
    img: "/assets/Slot/PP-SLOT-053.Lucky Dragon Ball.webp?v=1764333652900",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-053",
    platFormCode: "PP",
  },
  {
    name: "Lucky Dragons",
    img: "/assets/Slot/PP-SLOT-137.Lucky Dragons.webp?v=1764333576491",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-137",
    platFormCode: "PP",
  },
  {
    name: "Lucky Dragons",
    img: "/assets/Slot/JDB-SLOT-045.Lucky Dragons.webp?v=1765261912825",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-045",
    platFormCode: "JDB",
  },
  {
    name: "Lucky Drum",
    img: "/assets/Slot/wpu7pzg74mj7y.Lucky-Drum.webp?v=1765044128151",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-098",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky Elephant X-Huge",
    img: "/assets/Slot/JDB-SLOT-135.Lucky-Elephant-X-Huge.webp?v=1767691375201",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-135",
    platFormCode: "JDB",
  },
  {
    name: "Lucky Emeralds",
    img: "/assets/Slot/PT-SLOT-216.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-216",
    platFormCode: "PT",
  },
  {
    name: "Lucky Feng Shui",
    img: "/assets/Slot/SG-SLOT-046.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-046",
    platFormCode: "SPADE",
  },
  {
    name: "Lucky Fishing Megaways",
    img: "/assets/Slot/PP-SLOT-305.Lucky Fishing Megaways.webp?v=1764333473740",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-305",
    platFormCode: "PP",
  },
  {
    name: "Lucky Fortune",
    img: "/assets/Slot/SlotTreasure.LUCKY FORTUNE.webp?v=1764775522679",
    platForm: "FASTSPIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FastSpin-SLOT-011",
    platFormCode: "FASTSPIN",
  },
  {
    name: "Lucky Fortunes",
    img: "/assets/Slot/FC-SLOT-021.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-021",
    platFormCode: "FC",
  },
  {
    name: "Lucky Fridays",
    img: "/assets/Slot/RT-SLOT-156.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-156",
    platFormCode: "RT",
  },
  {
    name: "Lucky God",
    img: "/assets/Slot/dhdirsn3m3xia.Lucky-God.webp?v=1765053131983",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-099",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky God Progressive",
    img: "/assets/Slot/ef1uyxt98o6ur.Lucky-God-Progressive.webp?v=1765046584054",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-100",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky God Progressive 2",
    img: "/assets/Slot/3hj4fkfji4z4a.Lucky God Progressive 2.webp?v=1765049938033",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-101",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky Goldbricks",
    img: "/assets/Slot/JILI-SLOT-024.webp?v=1755509341303",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-024",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Grace And Charm",
    img: "/assets/Slot/PP-SLOT-197.Lucky Grace And Charm.webp?v=1764333411373",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-197",
    platFormCode: "PP",
  },
  {
    name: "Lucky Jaguar",
    img: "/assets/Slot/JILI-SLOT-115.webp?v=1755510792534",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-115",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Joker",
    img: "/assets/Slot/r8oiyz19mtqir.Lucky-Joker.webp?v=1765048345898",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-102",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky Koi Exclusive",
    img: "/assets/Slot/SG-SLOT-107.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-107",
    platFormCode: "SPADE",
  },
  {
    name: "Lucky Lady Charm",
    img: "/assets/Slot/7f9h9fwz11kaw.Lucky-Lady-Charm.webp?v=1765048909737",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-103",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky Lightning",
    img: "/assets/Slot/PP-SLOT-192.Lucky Lightning.webp?v=1764333328592",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-192",
    platFormCode: "PP",
  },
  {
    name: "Lucky Little Devil",
    img: "/assets/Slot/RT-SLOT-196.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-196",
    platFormCode: "RT",
  },
  {
    name: "Lucky Macaw",
    img: "/assets/Slot/JILI-SLOT-158.Lucky Macaw.webp?v=1767014009352",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-158",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Meow",
    img: "/assets/Slot/YesBingo-SLOT-030.Lucky Meow.webp?v=1765103915132",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-030",
    platFormCode: "YESBINGO",
  },
  {
    name: "Lucky Meow",
    img: "/assets/Slot/SG-SLOT-060.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-030",
    platFormCode: "YESBINGO",
  },
  {
    name: "Lucky Money",
    img: "/assets/Slot/RELAX-SLOT-133.webp?v=1761899054427",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-133",
    platFormCode: "RELAX",
  },
  {
    name: "Lucky Monkey",
    img: "/assets/Slot/PP-SLOT-621.Lucky Monkey.webp?v=1764333244563",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-621",
    platFormCode: "PP",
  },
  {
    name: "Lucky Mouse",
    img: "/assets/Slot/PP-SLOT-616.Lucky Mouse.webp?v=1764333202125",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-616",
    platFormCode: "PP",
  },
  {
    name: "Lucky Neko",
    img: "/assets/Slot/PG-SLOT-065.webp?v=1765933237800",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-065",
    platFormCode: "PG",
  },
  {
    name: "Lucky Neko",
    img: "/assets/Slot/YGG-SLOT-095.webp?v=1767056428436",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-095",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Lucky New Year",
    img: "/assets/Slot/PP-SLOT-113.Lucky New Year.webp?v=1764333158638",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-113",
    platFormCode: "PP",
  },
  {
    name: "Lucky New Year - Tiger Treasures",
    img: "/assets/Slot/PP-SLOT-219.Lucky New Year - Tiger Treasures.webp?v=1764333086208",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-219",
    platFormCode: "PP",
  },
  {
    name: "Lucky Oktoberfest",
    img: "/assets/Slot/RT-SLOT-157.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-157",
    platFormCode: "RT",
  },
  {
    name: "Lucky Ox",
    img: "/assets/Slot/PP-SLOT-617.Lucky Ox.webp?v=1764333005705",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-617",
    platFormCode: "PP",
  },
  {
    name: "Lucky Panda",
    img: "/assets/Slot/PP-SLOT-635.Lucky Panda.webp?v=1764332951656",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-635",
    platFormCode: "PP",
  },
  {
    name: "Lucky Phoenix",
    img: "/assets/Slot/PP-SLOT-623.Lucky Phoenix.webp?v=1764332903682",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-623",
    platFormCode: "PP",
  },
  {
    name: "Lucky Pig",
    img: "/assets/Slot/CG-SLOT-046.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-046",
    platFormCode: "CG",
  },
  {
    name: "Lucky Piggy",
    img: "/assets/Slot/PG-SLOT-101.webp?v=1765933237829",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-101",
    platFormCode: "PG",
  },
  {
    name: "Lucky Riches",
    img: "/assets/Slot/ACEWIN-SLOT-004.Lucky Riches.webp?v=1764854291848",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-004",
    platFormCode: "ACEWIN",
  },
  {
    name: "Lucky Rooster",
    img: "/assets/Slot/7cz37fritkfao.Lucky-Rooster.webp?v=1765041190241",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-105",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky Seven",
    img: "/assets/Slot/JDB-SLOT-041.lucky_777.webp?v=1765261799146",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-041",
    platFormCode: "JDB",
  },
  {
    name: "Lucky Seven Spin",
    img: "/assets/Slot/OCTOPLAY-SLOT-063.Lucky seven spin.webp?v=1764934407216",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-063",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Lucky Snake Wheel",
    img: "/assets/Slot/SG-SLOT-152.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-152",
    platFormCode: "SPADE",
  },
  {
    name: "Lucky Streak",
    img: "/assets/Slot/3fx69pizs144w.Lucky-Streak.webp?v=1765052440747",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-106",
    platFormCode: "JOKER",
  },
  {
    name: "Lucky Streak Mk2",
    img: "/assets/Slot/BTG-SLOT-048.webp?v=1756256536963",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-048",
    platFormCode: "BTG",
  },
  {
    name: "Lucky Tiger",
    img: "/assets/Slot/JILI-SLOT-144.webp?v=1757596896725",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-144",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Tiger",
    img: "/assets/Slot/PP-SLOT-615.Lucky Tiger.webp?v=1764332863116",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-615",
    platFormCode: "PP",
  },
  {
    name: "Lucky Tiger 1000",
    img: "/assets/Slot/PP-SLOT-622.Lucky Tiger 1000.webp?v=1770095367588",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-622",
    platFormCode: "PP",
  },
  {
    name: "Lucky Twin Sea",
    img: "/assets/Slot/SG-SLOT-147.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-147",
    platFormCode: "SPADE",
  },
  {
    name: "Lucky Twins",
    img: "/assets/Slot/CG-SLOT-043.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-043",
    platFormCode: "CG",
  },
  {
    name: "Lucky's Wild Pub",
    img: "/assets/Slot/PP-SLOT-550.webp?v=1755571953063",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-550",
    platFormCode: "PP",
  },
  {
    name: "Luminous Life",
    img: "/assets/Slot/PT-SLOT-115.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-115",
    platFormCode: "PT",
  },
  {
    name: "Lure of Fortune",
    img: "/assets/Slot/RELAX-SLOT-206.webp?v=1761899234219",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-206",
    platFormCode: "RELAX",
  },
  {
    name: "MAGIC DROP",
    img: "/assets/Slot/2J-SLOT-063.MAGIC DROP.webp?v=1763548626862",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-063",
    platFormCode: "JJ",
  },
  {
    name: "MEDUSA UNLEASHED",
    img: "/assets/Slot/2J-SLOT-021.MEDUSA UNLEASHED.webp?v=1763548584178",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-021",
    platFormCode: "JJ",
  },
  {
    name: "MERGE MAGIC",
    img: "/assets/Slot/FC-SLOT-027.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-027",
    platFormCode: "FC",
  },
  {
    name: "MERLIN'S SAGA",
    img: "/assets/Slot/KM-SLOT-012.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-012",
    platFormCode: "KINGMAKER",
  },
  {
    name: "MERMAID'S DANCE",
    img: "/assets/Slot/2J-SLOT-013.MERMAID_S DANCE.webp?v=1763548540412",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-013",
    platFormCode: "JJ",
  },
  {
    name: "MONEY MANIA",
    img: "/assets/Slot/2J-SLOT-051.MONEY MANIA.webp?v=1769697769527",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-051",
    platFormCode: "JJ",
  },
  {
    name: "MR.FRANKENSTEIN",
    img: "/assets/Slot/2J-SLOT-017.MR.FRANKENSTEIN.webp?v=1763548433918",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-017",
    platFormCode: "JJ",
  },
  {
    name: "Macabra Linx",
    img: "/assets/Slot/PT-SLOT-318.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-318",
    platFormCode: "PT",
  },
  {
    name: "Macau Racing",
    img: "/assets/Slot/RT-SLOT-305.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-305",
    platFormCode: "RT",
  },
  {
    name: "Mad Hit Devil",
    img: "/assets/Slot/PT-SLOT-476.Mad Hit Devil.webp?v=1764947367250",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-476",
    platFormCode: "PT",
  },
  {
    name: "Mad Hit Diamonds",
    img: "/assets/Slot/PT-SLOT-424.mad,hit-diamonds.webp?v=1764333229292",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-424",
    platFormCode: "PT",
  },
  {
    name: "Mad Hit Gorillatron",
    img: "/assets/Slot/PT-SLOT-458.webp?v=1756275771676",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-458",
    platFormCode: "PT",
  },
  {
    name: "Mad Hit Jokester",
    img: "/assets/Slot/PT-SLOT-456.webp?v=1756275771672",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-456",
    platFormCode: "PT",
  },
  {
    name: "Mad Melons Chaos Reels",
    img: "/assets/Slot/OCTOPLAY-SLOT-056.mad melons chaos reels.webp?v=1764934475953",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-056",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Madame Destiny",
    img: "/assets/Slot/PP-SLOT-102.Madame Destiny.webp?v=1764332735480",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-102",
    platFormCode: "PP",
  },
  {
    name: "Madame Destiny Megaways",
    img: "/assets/Slot/PP-SLOT-008.Madame Destiny Megaways.webp?v=1764332673339",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-008",
    platFormCode: "PP",
  },
  {
    name: "Mafia Mayhem",
    img: "/assets/Slot/PG-SLOT-128.webp?v=1765933237852",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-128",
    platFormCode: "PG",
  },
  {
    name: "Mafioso",
    img: "/assets/Slot/YGG-SLOT-405.webp?v=1767056428915",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-405",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Magawa vs Mines",
    img: "/assets/Slot/RELAX-SLOT-275.webp?v=1761899266797",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-275",
    platFormCode: "RELAX",
  },
  {
    name: "Magic Ace",
    img: "/assets/Slot/JDB-SLOT-124.magic-ace.webp?v=1765261740202",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-124",
    platFormCode: "JDB",
  },
  {
    name: "Magic Ace WILD LOCK",
    img: "/assets/Slot/JDB-SLOT-127.magic-ace-wild-lock.webp?v=1765261701258",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-127",
    platFormCode: "JDB",
  },
  {
    name: "Magic Beans",
    img: "/assets/Slot/FC-SLOT-013.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-013",
    platFormCode: "FC",
  },
  {
    name: "Magic Candy",
    img: "/assets/Slot/CG-SLOT-074.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-074",
    platFormCode: "CG",
  },
  {
    name: "Magic Journey",
    img: "/assets/Slot/PP-SLOT-063.Magic Journey.webp?v=1764332608546",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-063",
    platFormCode: "PP",
  },
  {
    name: "Magic Kitty",
    img: "/assets/Slot/SG-SLOT-091.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-091",
    platFormCode: "SPADE",
  },
  {
    name: "Magic Lamp",
    img: "/assets/Slot/JILI-SLOT-046.webp?v=1755509653639",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-046",
    platFormCode: "JILI",
  },
  {
    name: "Magic Money Maze",
    img: "/assets/Slot/PP-SLOT-266.Magic Money Maze.webp?v=1764332552468",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-266",
    platFormCode: "PP",
  },
  {
    name: "Magic Portals",
    img: "/assets/Slot/NETENT-SLOT-135.Magic-Portal.webp?v=1764957553317",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-135",
    platFormCode: "NETENT",
  },
  {
    name: "Magic Powers Megaways",
    img: "/assets/Slot/RT-SLOT-242.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-242",
    platFormCode: "RT",
  },
  {
    name: "Magic Tricks",
    img: "/assets/Slot/RT-SLOT-265.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-265",
    platFormCode: "RT",
  },
  {
    name: "Magic lab",
    img: "/assets/Slot/NETENT-SLOT-193.Magic-Lab.webp?v=1764957519642",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-193",
    platFormCode: "NETENT",
  },
  {
    name: "MagicLamp",
    img: "/assets/Slot/YesBingo-SLOT-008.Magic Lamp.webp?v=1765103816236",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-008",
    platFormCode: "YESBINGO",
  },
  {
    name: "Magical Alchemist",
    img: "/assets/Slot/YesBingo-SLOT-035.magical-alchemist.webp?v=1765103712684",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-035",
    platFormCode: "YESBINGO",
  },
  {
    name: "Magician's Secrets",
    img: "/assets/Slot/PP-SLOT-223.Magician_s Secrets.webp?v=1764332474346",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-223",
    platFormCode: "PP",
  },
  {
    name: "Magikspell",
    img: "/assets/Slot/RELAX-SLOT-117.webp?v=1761899291993",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-117",
    platFormCode: "RELAX",
  },
  {
    name: "Mahjong",
    img: "/assets/Slot/JDB-SLOT-029.mahjong.webp?v=1765261645546",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-029",
    platFormCode: "JDB",
  },
  {
    name: "Mahjong Beauty",
    img: "/assets/Slot/KM-SLOT-027.Mahjong Beauty.webp?v=1764861348863",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-027",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Mahjong Dragon Ways",
    img: "/assets/Slot/KM-SLOT-026.Mahjong Dragon Ways.webp?v=1764861408775",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-026",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Mahjong King",
    img: "/assets/Slot/3r369pizs144w.Mahjong-King.webp?v=1765054583864",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-229",
    platFormCode: "JOKER",
  },
  {
    name: "Mahjong Panda",
    img: "/assets/Slot/PP-SLOT-260.Mahjong Panda.webp?v=1764332414621",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-260",
    platFormCode: "PP",
  },
  {
    name: "Mahjong Reactor",
    img: "/assets/Slot/o39k3h9o685xq.Mahjong Reactor.webp?v=1765048600711",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-208",
    platFormCode: "JOKER",
  },
  {
    name: "Mahjong Riches",
    img: "/assets/Slot/SG-SLOT-157.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-157",
    platFormCode: "SPADE",
  },
  {
    name: "Mahjong Ways",
    img: "/assets/Slot/PG-SLOT-041.webp?v=1765933237781",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-041",
    platFormCode: "PG",
  },
  {
    name: "Mahjong Ways 2",
    img: "/assets/Slot/PG-SLOT-050.webp?v=1765933237791",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-050",
    platFormCode: "PG",
  },
  {
    name: "Mahjong Win",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-075.mahjong-win.webp?v=1765274021549",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-075",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Mahjong Win 2",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-088.Mahjong Win 2.webp?v=1765273955378",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-088",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Mahjong Wins",
    img: "/assets/Slot/PP-SLOT-372.Mahjong Wins.webp?v=1764332353837",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-372",
    platFormCode: "PP",
  },
  {
    name: "Mahjong Wins Bonus",
    img: "/assets/Slot/PP-SLOT-413.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-413",
    platFormCode: "PP",
  },
  {
    name: "MahjongWays",
    img: "/assets/Slot/YL-EGAME-027.MahjongWays.webp?v=1764321043333",
    platForm: "YL",
    type: "slots",
    gameType: "EGAME",
    casinoType: "YL-EGAME-027",
    platFormCode: "YL",
  },
  {
    name: "Majapahit",
    img: "/assets/Slot/67s75yrbo4dae.Majapahit.webp?v=1765053285039",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-107",
    platFormCode: "JOKER",
  },
  {
    name: "Majestic Empire",
    img: "/assets/Slot/PG-SLOT-163.webp?v=1765933237887",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-163",
    platFormCode: "PG",
  },
  {
    name: "Majestic Treasures",
    img: "/assets/Slot/PG-SLOT-073.webp?v=1765933237806",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-073",
    platFormCode: "PG",
  },
  {
    name: "Major Miners",
    img: "/assets/Slot/YGG-SLOT-320.webp?v=1767056428821",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-320",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mammamia",
    img: "/assets/Slot/9xpa7brfxj7zo.Mammamia.webp?v=1765041607808",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-108",
    platFormCode: "JOKER",
  },
  {
    name: "Mammoth Gold Megaways",
    img: "/assets/Slot/PP-SLOT-314.Mammoth Gold Megaways.webp?v=1764332208859",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-314",
    platFormCode: "PP",
  },
  {
    name: "Manhattan Goes Wild",
    img: "/assets/Slot/NLC-SLOT-043.Manhattan Goes Wild.webp?v=1764388826509",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-043",
    platFormCode: "NLC",
  },
  {
    name: "Many Beauties",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-043.many-beauties.webp?v=1765273870262",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-043",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Maple Story",
    img: "/assets/Slot/CG-SLOT-054.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-054",
    platFormCode: "CG",
  },
  {
    name: "Marching Legions",
    img: "/assets/Slot/RELAX-SLOT-036.webp?v=1761899362153",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-036",
    platFormCode: "RELAX",
  },
  {
    name: "Marvel Tsum Tsum",
    img: "/assets/Slot/CG-SLOT-033.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-033",
    platFormCode: "CG",
  },
  {
    name: "MarvelousIV",
    img: "/assets/Slot/JDB-SLOT-098.Marvelous-Iv.webp?v=1767691480589",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-098",
    platFormCode: "JDB",
  },
  {
    name: "Mask Carnival",
    img: "/assets/Slot/PG-SLOT-091.webp?v=1765933237820",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-091",
    platFormCode: "PG",
  },
  {
    name: "Masquerade",
    img: "/assets/Slot/RT-SLOT-044.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-044",
    platFormCode: "RT",
  },
  {
    name: "Masskara Mania",
    img: "/assets/Slot/ACEWIN-SLOT-032.webp?v=1762477160143",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-032",
    platFormCode: "ACEWIN",
  },
  {
    name: "Master Chen's Fortune",
    img: "/assets/Slot/PP-SLOT-097.Master Chen_s Fortune.webp?v=1764332142577",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-097",
    platFormCode: "PP",
  },
  {
    name: "Master Gems",
    img: "/assets/Slot/PP-SLOT-628.Master Gems.webp?v=1764332068793",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-628",
    platFormCode: "PP",
  },
  {
    name: "Master Joker",
    img: "/assets/Slot/PP-SLOT-059.Master Joker.webp?v=1764332023845",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-059",
    platFormCode: "PP",
  },
  {
    name: "Master Tiger",
    img: "/assets/Slot/JILI-SLOT-077.webp?v=1755510054553",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-077",
    platFormCode: "JILI",
  },
  {
    name: "Max Megaways",
    img: "/assets/Slot/BTG-SLOT-019.Max Megaways.webp?v=1764409604798",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-019",
    platFormCode: "BTG",
  },
  {
    name: "Max Megaways 2",
    img: "/assets/Slot/BTG-SLOT-027.webp?v=1756256536947",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-027",
    platFormCode: "BTG",
  },
  {
    name: "Max Megaways 3",
    img: "/assets/Slot/BTG-SLOT-060.webp?v=1756256536972",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-060",
    platFormCode: "BTG",
  },
  {
    name: "Maximum Fish",
    img: "/assets/Slot/YGG-SLOT-392.webp?v=1767056428898",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-392",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Maya Gold Crazy",
    img: "/assets/Slot/JDB-SLOT-099.maya_gold_crazy.webp?v=1767691491091",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-099",
    platFormCode: "JDB",
  },
  {
    name: "Maya King",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-009.maya-king.webp?v=1765273721732",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-009",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Maya Ways",
    img: "/assets/Slot/d5uyes4amfxf6.Maya Ways.webp?v=1765049529186",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-234",
    platFormCode: "JOKER",
  },
  {
    name: "Mayan Blocks",
    img: "/assets/Slot/PT-SLOT-102.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-102",
    platFormCode: "PT",
  },
  {
    name: "Mayan Empire",
    img: "/assets/Slot/JILI-SLOT-058.webp?v=1755509793420",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-058",
    platFormCode: "JILI",
  },
  {
    name: "Mayan Empire",
    img: "/assets/Slot/ACEWIN-SLOT-020.Mayan Empire.webp?v=1764854406017",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-020",
    platFormCode: "ACEWIN",
  },
  {
    name: "Mayan Gems",
    img: "/assets/Slot/SG-SLOT-086.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-086",
    platFormCode: "SPADE",
  },
  {
    name: "Mayan Magic Wildfire",
    img: "/assets/Slot/NLC-SLOT-048.Mayan Magic Wildfire.webp?v=1764388732003",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-048",
    platFormCode: "NLC",
  },
  {
    name: "Mayan Temple Riches",
    img: "/assets/Slot/YGG-SLOT-278.webp?v=1767056428784",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-278",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mayhem",
    img: "/assets/Slot/RT-SLOT-181.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-181",
    platFormCode: "RT",
  },
  {
    name: "Maze Escape",
    img: "/assets/Slot/RELAX-SLOT-077.webp?v=1761899433574",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-077",
    platFormCode: "RELAX",
  },
  {
    name: "Medallion Megaways",
    img: "/assets/Slot/RELAX-SLOT-101.webp?v=1761899534946",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-101",
    platFormCode: "RELAX",
  },
  {
    name: "Medusa",
    img: "/assets/Slot/JILI-SLOT-050.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-050",
    platFormCode: "JILI",
  },
  {
    name: "Medusa",
    img: "/assets/Slot/PG-SLOT-006.webp?v=1765933237757",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-006",
    platFormCode: "PG",
  },
  {
    name: "Medusa Hot 1",
    img: "/assets/Slot/YGG-SLOT-084.webp?v=1767056428427",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-084",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Medusa2",
    img: "/assets/Slot/PG-SLOT-005.webp?v=1765933237756",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-005",
    platFormCode: "PG",
  },
  {
    name: "Mega Ace",
    img: "/assets/Slot/JILI-SLOT-051.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-051",
    platFormCode: "JILI",
  },
  {
    name: "Mega Cash Stacks",
    img: "/assets/Slot/YGG-SLOT-155.webp?v=1767056428487",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-155",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mega Dragon",
    img: "/assets/Slot/RT-SLOT-118.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-118",
    platFormCode: "RT",
  },
  {
    name: "Mega Fire Blaze Lucky Bass",
    img: "/assets/Slot/PT-SLOT-439.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-439",
    platFormCode: "PT",
  },
  {
    name: "Mega Fire Blaze: Big Circus!",
    img: "/assets/Slot/PT-SLOT-092.Mega Fire Blaze Big Circus!.webp?v=1764328409931",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-092",
    platFormCode: "PT",
  },
  {
    name: "Mega Fire Blaze: Emperor of Rome",
    img: "/assets/Slot/PT-SLOT-244.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-244",
    platFormCode: "PT",
  },
  {
    name: "Mega Fire Blaze: Khonsu God of Moon",
    img: "/assets/Slot/PT-SLOT-153.Mega Fire Blaze Khonsu God of Moon.webp?v=1764330881366",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-153",
    platFormCode: "PT",
  },
  {
    name: "Mega Fire Blaze: Wild Pistolero",
    img: "/assets/Slot/PT-SLOT-091.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-091",
    platFormCode: "PT",
  },
  {
    name: "Mega Flip",
    img: "/assets/Slot/RELAX-SLOT-037.webp?v=1761899598251",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-037",
    platFormCode: "RELAX",
  },
  {
    name: "Mega Heist",
    img: "/assets/Slot/RELAX-SLOT-177.webp?v=1761899679642",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-177",
    platFormCode: "RELAX",
  },
  {
    name: "Mega Masks",
    img: "/assets/Slot/RELAX-SLOT-038.webp?v=1761899749300",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-038",
    platFormCode: "RELAX",
  },
  {
    name: "Mega Mine",
    img: "/assets/Slot/RELAX-SLOT-068.webp?v=1761899801299",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-068",
    platFormCode: "RELAX",
  },
  {
    name: "Mega Money Machine",
    img: "/assets/Slot/YGG-SLOT-228.webp?v=1767056428577",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-228",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mega Pearl Gigablox",
    img: "/assets/Slot/YGG-SLOT-143.webp?v=1767056428477",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-143",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Megaways Mob",
    img: "/assets/Slot/RELAX-SLOT-118.webp?v=1761899888066",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-118",
    platFormCode: "RELAX",
  },
  {
    name: "Mental",
    img: "/assets/Slot/NLC-SLOT-002.Mental.webp?v=1764388684372",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-002",
    platFormCode: "NLC",
  },
  {
    name: "Mental 2",
    img: "/assets/Slot/NLC-SLOT-107.Mental 2.webp?v=1764388532125",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-107",
    platFormCode: "NLC",
  },
  {
    name: "Merlin's Beard",
    img: "/assets/Slot/YGG-SLOT-302.webp?v=1767056428804",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-302",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mermaid Riches",
    img: "/assets/Slot/PG-SLOT-081.webp?v=1765933237812",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-081",
    platFormCode: "PG",
  },
  {
    name: "Mermaid Slingo",
    img: "/assets/Slot/YesBingo-SLOT-021.Mermaid Slingo.webp?v=1765103682085",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-021",
    platFormCode: "YESBINGO",
  },
  {
    name: "Mermaid Treasure",
    img: "/assets/Slot/jxcs1pbifei1o.Mermaid-Treasure.webp?v=1765042319854",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-192",
    platFormCode: "JOKER",
  },
  {
    name: "MexoMax! Multimax",
    img: "/assets/Slot/YGG-SLOT-149.webp?v=1767056428482",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-149",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Miami",
    img: "/assets/Slot/tqi9778i7mi6o.Miami.webp?v=1765043074579",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-110",
    platFormCode: "JOKER",
  },
  {
    name: "Miami Rise",
    img: "/assets/Slot/RT-SLOT-354.Miami-Rise.webp?v=1765033526981",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-354",
    platFormCode: "RT",
  },
  {
    name: "Midas Fortune",
    img: "/assets/Slot/PG-SLOT-111.webp?v=1765933237837",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-111",
    platFormCode: "PG",
  },
  {
    name: "Midas Hand",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-079.midas-hand.webp?v=1765273674191",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-079",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Midas Moolah: Random Reels",
    img: "/assets/Slot/OCTOPLAY-SLOT-050.midas moolah random reels.webp?v=1764934535344",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-050",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Midas Touch",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-033.midas-touch.webp?v=1765273623637",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-033",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Midnight Marauder",
    img: "/assets/Slot/RELAX-SLOT-122.webp?v=1761899915379",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-122",
    platFormCode: "RELAX",
  },
  {
    name: "Midnight Romance",
    img: "/assets/Slot/RT-SLOT-288.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-288",
    platFormCode: "RT",
  },
  {
    name: "Midnight Thirst",
    img: "/assets/Slot/RT-SLOT-306.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-306",
    platFormCode: "RT",
  },
  {
    name: "Midnight Wilds",
    img: "/assets/Slot/PT-SLOT-203.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-203",
    platFormCode: "PT",
  },
  {
    name: "Might Magic",
    img: "/assets/Slot/CG-SLOT-073.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-073",
    platFormCode: "CG",
  },
  {
    name: "Might of Ra",
    img: "/assets/Slot/PP-SLOT-243.Might of Ra.webp?v=1764331796594",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-243",
    platFormCode: "PP",
  },
  {
    name: "Mighty Hat: Lamp of Gold",
    img: "/assets/Slot/PT-SLOT-105.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-105",
    platFormCode: "PT",
  },
  {
    name: "Mighty Kong",
    img: "/assets/Slot/PP-SLOT-143.Mighty Kong.webp?v=1764331740626",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-143",
    platFormCode: "PP",
  },
  {
    name: "Mighty Munching Melons",
    img: "/assets/Slot/PP-SLOT-432.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-432",
    platFormCode: "PP",
  },
  {
    name: "Military",
    img: "/assets/Slot/CG-SLOT-072.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-072",
    platFormCode: "CG",
  },
  {
    name: "Milkshake™ XXXtreme",
    img: "/assets/Slot/NETENT-SLOT-133.Milk-Shake-XXXtreme.webp?v=1764957345132",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-133",
    platFormCode: "NETENT",
  },
  {
    name: "Milky Ways",
    img: "/assets/Slot/NLC-SLOT-036.Milky Ways.webp?v=1764388436101",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-036",
    platFormCode: "NLC",
  },
  {
    name: "Millionaire Megaways",
    img: "/assets/Slot/BTG-SLOT-007.webp?v=1756256536930",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-007",
    platFormCode: "BTG",
  },
  {
    name: "Millionaire Mystery Box",
    img: "/assets/Slot/BTG-SLOT-052.webp?v=1756256536966",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-052",
    platFormCode: "BTG",
  },
  {
    name: "Millionaire Rush",
    img: "/assets/Slot/BTG-SLOT-018.webp?v=1756256536939",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-018",
    platFormCode: "BTG",
  },
  {
    name: "Millionaire Tapcards",
    img: "/assets/Slot/BTG-SLOT-066.webp?v=1756256536977",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-066",
    platFormCode: "BTG",
  },
  {
    name: "Mine & Melt",
    img: "/assets/Slot/PT-SLOT-455.webp?v=1756275771670",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-455",
    platFormCode: "PT",
  },
  {
    name: "Mine and Win",
    img: "/assets/Slot/YGG-SLOT-351.webp?v=1767056428857",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-351",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Miner Babe",
    img: "/assets/Slot/JDB-SLOT-085.miner_babe.webp?v=1765261482255",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-085",
    platFormCode: "JDB",
  },
  {
    name: "Mining Rush",
    img: "/assets/Slot/PP-SLOT-530.Mining Rush.webp?v=1764331665381",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-530",
    platFormCode: "PP",
  },
  {
    name: "Misery Mining",
    img: "/assets/Slot/NLC-SLOT-015.Misery Mining.webp?v=1764388366469",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-015",
    platFormCode: "NLC",
  },
  {
    name: "Miss Fortune",
    img: "/assets/Slot/PT-SLOT-065.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-065",
    platFormCode: "PT",
  },
  {
    name: "Mister Cashmore",
    img: "/assets/Slot/SG-SLOT-162.Mister Cashmore.webp?v=1764324663896",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-162",
    platFormCode: "SPADE",
  },
  {
    name: "Moji Mania",
    img: "/assets/Slot/SG-SLOT-127.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-127",
    platFormCode: "SPADE",
  },
  {
    name: "Mole Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-029.mole smash.webp?v=1764934750450",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-029",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Moleionaire",
    img: "/assets/Slot/PP-SLOT-517.Moleionaire.webp?v=1764331613784",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-517",
    platFormCode: "PP",
  },
  {
    name: "Moley Moolah",
    img: "/assets/Slot/YGG-SLOT-002.webp?v=1767056428320",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-002",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Money Cart",
    img: "/assets/Slot/RELAX-SLOT-098.webp?v=1761899984037",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-098",
    platFormCode: "RELAX",
  },
  {
    name: "Money Cart 2",
    img: "/assets/Slot/RELAX-SLOT-060.webp?v=1761900029089",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-060",
    platFormCode: "RELAX",
  },
  {
    name: "Money Cart 3",
    img: "/assets/Slot/RELAX-SLOT-173.webp?v=1761900092421",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-173",
    platFormCode: "RELAX",
  },
  {
    name: "Money Cart 4",
    img: "/assets/Slot/RELAX-SLOT-221.webp?v=1761900127418",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-221",
    platFormCode: "RELAX",
  },
  {
    name: "Money Coming 2",
    img: "/assets/Slot/JILI-SLOT-146.Money Coming 2.webp?v=1764311314408",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-146",
    platFormCode: "JILI",
  },
  {
    name: "Money Coming Expand Bets",
    img: "/assets/Slot/JILI-SLOT-107.webp?v=1755510617661",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-107",
    platFormCode: "JILI",
  },
  {
    name: "Money Farm",
    img: "/assets/Slot/CG-SLOT-048.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-048",
    platFormCode: "CG",
  },
  {
    name: "Money Farm 3",
    img: "/assets/Slot/CG-SLOT-040.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-040",
    platFormCode: "CG",
  },
  {
    name: "Money Flash",
    img: "/assets/Slot/YGG-SLOT-407.webp?v=1767056428917",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-407",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Money Mariachi Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-130.webp?v=1767056428466",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-130",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Money Money Money",
    img: "/assets/Slot/PP-SLOT-044.Money Money Money.webp?v=1764331552585",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-044",
    platFormCode: "PP",
  },
  {
    name: "Money Mouse",
    img: "/assets/Slot/PP-SLOT-064.Money Mouse.webp?v=1764331488672",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-064",
    platFormCode: "PP",
  },
  {
    name: "Money Mouse",
    img: "/assets/Slot/SG-SLOT-071.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-064",
    platFormCode: "PP",
  },
  {
    name: "Money Pot",
    img: "/assets/Slot/JILI-SLOT-112.webp?v=1755510742732",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-112",
    platFormCode: "JILI",
  },
  {
    name: "Money Pot Deluxe",
    img: "/assets/Slot/JILI-SLOT-162.Money Pot Deluxe.webp?v=1765786796320",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "TADA-SLOT-044",
    platFormCode: "TADA",
  },
  {
    name: "Money Roll",
    img: "/assets/Slot/PP-SLOT-166.Money Roll.webp?v=1764331432759",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-166",
    platFormCode: "PP",
  },
  {
    name: "Money Stacks",
    img: "/assets/Slot/PP-SLOT-482.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-482",
    platFormCode: "PP",
  },
  {
    name: "Money Stacks Megaways",
    img: "/assets/Slot/PP-SLOT-528.Money Stacks Megaways.webp?v=1764331340151",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-528",
    platFormCode: "PP",
  },
  {
    name: "Money Train",
    img: "/assets/Slot/RELAX-SLOT-039.webp?v=1761900159405",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-039",
    platFormCode: "RELAX",
  },
  {
    name: "Money Train 2",
    img: "/assets/Slot/RELAX-SLOT-040.webp?v=1761900222714",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-040",
    platFormCode: "RELAX",
  },
  {
    name: "Money Train 3",
    img: "/assets/Slot/RELAX-SLOT-137.webp?v=1761900384743",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-137",
    platFormCode: "RELAX",
  },
  {
    name: "Money Train 4",
    img: "/assets/Slot/RELAX-SLOT-198.webp?v=1761900420753",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-198",
    platFormCode: "RELAX",
  },
  {
    name: "Money Train Origins",
    img: "/assets/Slot/RELAX-SLOT-182.webp?v=1761900450117",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-182",
    platFormCode: "RELAX",
  },
  {
    name: "Money Vault",
    img: "/assets/Slot/oajk3h9o685xq.Money-Vault.webp?v=1765051105354",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-112",
    platFormCode: "JOKER",
  },
  {
    name: "MoneyBangBang",
    img: "/assets/Slot/k3anse3yrrunq.MoneyBangBang.webp?v=1765048779692",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-111",
    platFormCode: "JOKER",
  },
  {
    name: "Moneybags Man",
    img: "/assets/Slot/JDB-SLOT-086.Moneybags man.webp?v=1765261379490",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-086",
    platFormCode: "JDB",
  },
  {
    name: "Moneybags Man 2",
    img: "/assets/Slot/JDB-SLOT-108.moneybags-man-2.webp?v=1767691303754",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-108",
    platFormCode: "JDB",
  },
  {
    name: "Monkey King",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-019.monkey-king.webp?v=1765273500895",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-019",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Monkey Madness",
    img: "/assets/Slot/PP-SLOT-165.Monkey Madness.webp?v=1764331278584",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-165",
    platFormCode: "PP",
  },
  {
    name: "Monkey Warrior",
    img: "/assets/Slot/PP-SLOT-078.Monkey Warrior.webp?v=1764331220456",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-078",
    platFormCode: "PP",
  },
  {
    name: "Monkey and Rat",
    img: "/assets/Slot/PT-SLOT-152.monkey-and-rat.webp?v=1764331042322",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-152",
    platFormCode: "PT",
  },
  {
    name: "Monkey's Gold xPays",
    img: "/assets/Slot/NLC-SLOT-032.Monkey_s Gold xPays.webp?v=1764388311950",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-032",
    platFormCode: "NLC",
  },
  {
    name: "Monkeys Go Bananas",
    img: "/assets/Slot/YGG-SLOT-261.webp?v=1767056428769",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-261",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Monster Blox",
    img: "/assets/Slot/YGG-SLOT-124.webp?v=1767056428462",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-124",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Monster Multipliers",
    img: "/assets/Slot/PT-SLOT-110.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-110",
    platFormCode: "PT",
  },
  {
    name: "Monster Superlanche",
    img: "/assets/Slot/PP-SLOT-318.Monster Superlanche.webp?v=1764331158070",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-318",
    platFormCode: "PP",
  },
  {
    name: "Monsters Unchained",
    img: "/assets/Slot/RT-SLOT-266.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-266",
    platFormCode: "RT",
  },
  {
    name: "Monsters VS Gigablox",
    img: "/assets/Slot/YGG-SLOT-148.webp?v=1767056428482",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-148",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Moon Goddess",
    img: "/assets/Slot/y59nah5oqf58q.Moon Goddess.webp?v=1765041763960",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-235",
    platFormCode: "JOKER",
  },
  {
    name: "Moon Spell",
    img: "/assets/Slot/RT-SLOT-330.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-330",
    platFormCode: "RT",
  },
  {
    name: "Moonlight Treasure",
    img: "/assets/Slot/JDB-SLOT-028.moonlight_treasure.webp?v=1765261284043",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-028",
    platFormCode: "JDB",
  },
  {
    name: "Moonshine Riches",
    img: "/assets/Slot/NETENT-SLOT-170.Moonshine-Riches.webp?v=1764957264070",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-170",
    platFormCode: "NETENT",
  },
  {
    name: "Moonshot",
    img: "/assets/Slot/PP-SLOT-331.Moonshot.webp?v=1764331092443",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-331",
    platFormCode: "PP",
  },
  {
    name: "More Beauties",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-044.more-beauties.webp?v=1765273439645",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-044",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "More Turkey",
    img: "/assets/Slot/BTG-SLOT-046.webp?v=1756256536961",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-046",
    platFormCode: "BTG",
  },
  {
    name: "Mr Hallow-Jackpot!",
    img: "/assets/Slot/PG-SLOT-019.webp?v=1765933237765",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-019",
    platFormCode: "PG",
  },
  {
    name: "Mr Piggles",
    img: "/assets/Slot/OCTOPLAY-SLOT-012.Mr piggles.webp?v=1764934785965",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-012",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Mr. Cashback",
    img: "/assets/Slot/PT-SLOT-063.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-063",
    platFormCode: "PT",
  },
  {
    name: "Mr. Treasure’s Fortune",
    img: "/assets/Slot/PG-SLOT-153.webp?v=1765933237878",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-153",
    platFormCode: "PG",
  },
  {
    name: "Muay Thai",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-054.muay-thai.webp?v=1765273388819",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-054",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Muay Thai Champion",
    img: "/assets/Slot/PG-SLOT-039.webp?v=1765933237779",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-039",
    platFormCode: "PG",
  },
  {
    name: "Muay Thai Fighter",
    img: "/assets/Slot/SG-SLOT-097.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-097",
    platFormCode: "SPADE",
  },
  {
    name: "Much Richer",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-081.much-richer.webp?v=1765273341760",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-081",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Muertos Multiplier Megaways",
    img: "/assets/Slot/PP-SLOT-283.Muertos Multiplier Megaways.webp?v=1764331031355",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-283",
    platFormCode: "PP",
  },
  {
    name: "Mulan",
    img: "/assets/Slot/bcizh7dipjiso.Mulan.webp?v=1765047298172",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-114",
    platFormCode: "JOKER",
  },
  {
    name: "Multifly!",
    img: "/assets/Slot/YGG-SLOT-093.webp?v=1767056428435",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-093",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Multiplier Odyssey",
    img: "/assets/Slot/RELAX-SLOT-041.webp?v=1761900480080",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-041",
    platFormCode: "RELAX",
  },
  {
    name: "Multiplier Riches",
    img: "/assets/Slot/RT-SLOT-126.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-126",
    platFormCode: "RT",
  },
  {
    name: "Mummy Mia",
    img: "/assets/Slot/ACEWIN-SLOT-034.webp?v=1762477182129",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-034",
    platFormCode: "ACEWIN",
  },
  {
    name: "Munchies",
    img: "/assets/Slot/NLC-SLOT-099.Munchies.webp?v=1764388241547",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-099",
    platFormCode: "NLC",
  },
  {
    name: "Museum Wonders",
    img: "/assets/Slot/PG-SLOT-147.webp?v=1765933237872",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-147",
    platFormCode: "PG",
  },
  {
    name: "Mustang Gold",
    img: "/assets/Slot/PP-SLOT-093.Mustang Gold.webp?v=1764330884209",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-093",
    platFormCode: "PP",
  },
  {
    name: "Mustang Trail",
    img: "/assets/Slot/PP-SLOT-368.Mustang Trail.webp?v=1764330750601",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-368",
    platFormCode: "PP",
  },
  {
    name: "Mutagenes",
    img: "/assets/Slot/YGG-SLOT-275.webp?v=1767056428781",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-275",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mutant Potatoes",
    img: "/assets/Slot/OCTOPLAY-SLOT-013.Mutant Potatoes.webp?v=1764934823538",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-013",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Mutant Trawlers",
    img: "/assets/Slot/YGG-SLOT-259.webp?v=1767056428766",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-259",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mysterious",
    img: "/assets/Slot/PP-SLOT-057.Mysterious.webp?v=1764330689387",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-057",
    platFormCode: "PP",
  },
  {
    name: "Mysterious Egypt",
    img: "/assets/Slot/PP-SLOT-011.Mysterious Egypt.webp?v=1764330625310",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-011",
    platFormCode: "PP",
  },
  {
    name: "Mystery Mice",
    img: "/assets/Slot/PP-SLOT-496.Mystery Mice.webp?v=1764330561967",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-496",
    platFormCode: "PP",
  },
  {
    name: "Mystery Of The Orient",
    img: "/assets/Slot/PP-SLOT-326.Mystery Of The Orient.webp?v=1764330497787",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-326",
    platFormCode: "PP",
  },
  {
    name: "Mystery Reels Deluxe",
    img: "/assets/Slot/RT-SLOT-194.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-194",
    platFormCode: "RT",
  },
  {
    name: "Mystery Reels MegaWays",
    img: "/assets/Slot/RT-SLOT-051.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-051",
    platFormCode: "RT",
  },
  {
    name: "Mystery Reels Power Reels",
    img: "/assets/Slot/RT-SLOT-158.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-158",
    platFormCode: "RT",
  },
  {
    name: "Mystic Chief",
    img: "/assets/Slot/PP-SLOT-205.Mystic Chief.webp?v=1764330421690",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-205",
    platFormCode: "PP",
  },
  {
    name: "Mystic Magic",
    img: "/assets/Slot/YGG-SLOT-285.webp?v=1767056428790",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-285",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Mystic Mines",
    img: "/assets/Slot/PT-SLOT-461.Mystic Mines.webp?v=1764326414922",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-461",
    platFormCode: "PT",
  },
  {
    name: "Mystic Nine",
    img: "/assets/Slot/CG-SLOT-121.Mystic Nine.webp?v=1764666565160",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-121",
    platFormCode: "CG",
  },
  {
    name: "Mystic Potion",
    img: "/assets/Slot/PG-SLOT-137.webp?v=1765933237859",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-137",
    platFormCode: "PG",
  },
  {
    name: "Mystic Spells",
    img: "/assets/Slot/RELAX-SLOT-202.webp?v=1761900525094",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-202",
    platFormCode: "RELAX",
  },
  {
    name: "Mystic Staxx",
    img: "/assets/Slot/RT-SLOT-135.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-135",
    platFormCode: "RT",
  },
  {
    name: "Mystic Wishes",
    img: "/assets/Slot/PP-SLOT-632.Mystic Wishes.webp?v=1764330364181",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-632",
    platFormCode: "PP",
  },
  {
    name: "Mystic Witch",
    img: "/assets/Slot/CG-SLOT-116.Mystic Witch.webp?v=1764666615045",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-116",
    platFormCode: "CG",
  },
  {
    name: "Mystical Spirits",
    img: "/assets/Slot/PG-SLOT-117.webp?v=1765933237843",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-117",
    platFormCode: "PG",
  },
  {
    name: "Mythical Sand",
    img: "/assets/Slot/m94wkgy3daxta.Mythical-Sand.webp?v=1765047953874",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-115",
    platFormCode: "JOKER",
  },
  {
    name: "Mythological",
    img: "/assets/Slot/hb4cpgc6u6qj4.Mythological.webp?v=1765049251684",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-116",
    platFormCode: "JOKER",
  },
  {
    name: "NIGHT MARKET",
    img: "/assets/Slot/FC-SLOT-004.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-004",
    platFormCode: "FC",
  },
  {
    name: "NIGHT MARKET 2",
    img: "/assets/Slot/FC-SLOT-032.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-032",
    platFormCode: "FC",
  },
  {
    name: "Napoleon",
    img: "/assets/Slot/JDB-SLOT-048.napoleon.webp?v=1765261230832",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-048",
    platFormCode: "JDB",
  },
  {
    name: "Napoleon vs Rabbits",
    img: "/assets/Slot/RELAX-SLOT-155.webp?v=1761900555120",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-155",
    platFormCode: "RELAX",
  },
  {
    name: "Narcos Mexico",
    img: "/assets/Slot/RT-SLOT-222.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-222",
    platFormCode: "RT",
  },
  {
    name: "Nautical Treasures",
    img: "/assets/Slot/YGG-SLOT-350.webp?v=1767056428856",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-350",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Neko Fortune",
    img: "/assets/Slot/JILI-SLOT-071.webp?v=1755509899422",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-071",
    platFormCode: "JILI",
  },
  {
    name: "Neko Night",
    img: "/assets/Slot/RELAX-SLOT-169.webp?v=1761900578490",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-169",
    platFormCode: "RELAX",
  },
  {
    name: "Neko Treasures",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-089.Neko Treasures.webp?v=1765273280823",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-089",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Neon Links",
    img: "/assets/Slot/RT-SLOT-207.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-207",
    platFormCode: "RT",
  },
  {
    name: "Neon Rush: Splitz",
    img: "/assets/Slot/YGG-SLOT-046.webp?v=1767056428373",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-046",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Neon Villains DoubleMax",
    img: "/assets/Slot/YGG-SLOT-177.webp?v=1767056428516",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-177",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Neon West",
    img: "/assets/Slot/YGG-SLOT-412.webp?v=1767056428921",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-412",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Neptune Treasure",
    img: "/assets/Slot/5ii9zgw5unc3h.Neptune-Treasure.webp?v=1765042056370",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-117",
    platFormCode: "JOKER",
  },
  {
    name: "Neptune's Kingdom",
    img: "/assets/Slot/PT-SLOT-137.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-137",
    platFormCode: "PT",
  },
  {
    name: "Net Gains",
    img: "/assets/Slot/RELAX-SLOT-156.webp?v=1761900606138",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-156",
    platFormCode: "RELAX",
  },
  {
    name: "New Get Rich",
    img: "/assets/Slot/CG-SLOT-034.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-034",
    platFormCode: "CG",
  },
  {
    name: "New Year",
    img: "/assets/Slot/JDB-SLOT-016.New Year.webp?v=1765261180983",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-016",
    platFormCode: "JDB",
  },
  {
    name: "Ni Shu Shen Me",
    img: "/assets/Slot/PT-SLOT-022.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-022",
    platFormCode: "PT",
  },
  {
    name: "Nice Catch 2",
    img: "/assets/Slot/YGG-SLOT-237.webp?v=1767056428590",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-237",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Nice Catch Doublemax",
    img: "/assets/Slot/YGG-SLOT-193.webp?v=1767056428531",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-193",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Night City",
    img: "/assets/Slot/JILI-SLOT-090.webp?v=1755510225537",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-090",
    platFormCode: "JILI",
  },
  {
    name: "Night Roller",
    img: "/assets/Slot/RT-SLOT-202.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-202",
    platFormCode: "RT",
  },
  {
    name: "Nightfall Hunting",
    img: "/assets/Slot/JILI-SLOT-113.webp?v=1755510761502",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-113",
    platFormCode: "JILI",
  },
  {
    name: "Nightmare Family Megaways",
    img: "/assets/Slot/RT-SLOT-307.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-307",
    platFormCode: "RT",
  },
  {
    name: "Nile Fortune",
    img: "/assets/Slot/PP-SLOT-402.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-402",
    platFormCode: "PP",
  },
  {
    name: "Nine To Five",
    img: "/assets/Slot/NLC-SLOT-083.Nine To Five.webp?v=1764388140655",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-083",
    platFormCode: "NLC",
  },
  {
    name: "Ninja Raccoon Frenzy",
    img: "/assets/Slot/PG-SLOT-124.webp?v=1765933237848",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-124",
    platFormCode: "PG",
  },
  {
    name: "Ninja Warrior",
    img: "/assets/Slot/CG-SLOT-080.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-080",
    platFormCode: "CG",
  },
  {
    name: "Ninja vs Samurai",
    img: "/assets/Slot/PG-SLOT-040.webp?v=1765933237780",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-040",
    platFormCode: "PG",
  },
  {
    name: "Nirvana",
    img: "/assets/Slot/YGG-SLOT-022.webp?v=1767056428347",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-022",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "North Guardians",
    img: "/assets/Slot/PP-SLOT-253.North Guardians.webp?v=1764330217781",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-253",
    platFormCode: "PP",
  },
  {
    name: "Notre-Dame Tales",
    img: "/assets/Slot/YGG-SLOT-208.webp?v=1767056428557",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-208",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Nugget Hunter",
    img: "/assets/Slot/84igeq3a8r9d6.Nugget-Hunter.webp?v=1765045595141",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-119",
    platFormCode: "JOKER",
  },
  {
    name: "ORB OF GANESHA",
    img: "/assets/Slot/2J-SLOT-046.ORB OF GANESHA.webp?v=1763548390074",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-046",
    platFormCode: "JJ",
  },
  {
    name: "ORIENTAL RICHES",
    img: "/assets/Slot/2J-SLOT-032.ORIENTAL RICHES.webp?v=1763548337104",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-032",
    platFormCode: "JJ",
  },
  {
    name: "Oasis",
    img: "/assets/Slot/ggutqu1xjtgwr.Oasis.webp?v=1765048974787",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-120",
    platFormCode: "JOKER",
  },
  {
    name: "Ocean",
    img: "/assets/Slot/P8-SLOT-031.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-031",
    platFormCode: "PLAY8",
  },
  {
    name: "Ocean Frenzy",
    img: "/assets/Slot/PT-SLOT-423.ocean-frenzy.webp?v=1764333316474",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-423",
    platFormCode: "PT",
  },
  {
    name: "Ocean Paradise",
    img: "/assets/Slot/kf41ymtxfos1r.OceanParadise.webp?v=1765045184681",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-121",
    platFormCode: "JOKER",
  },
  {
    name: "Ocean Spray",
    img: "/assets/Slot/7b6c7rcs16kjk.Ocean-Spray.webp?v=1765049148923",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-122",
    platFormCode: "JOKER",
  },
  {
    name: "Octagon Gem",
    img: "/assets/Slot/4tyxfmpnwqokn.Octagon-Gem.webp?v=1765046429427",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-123",
    platFormCode: "JOKER",
  },
  {
    name: "Octagon Gem 2",
    img: "/assets/Slot/gsttgo1debywc.Octagon-Gem-2.webp?v=1765047210118",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-124",
    platFormCode: "JOKER",
  },
  {
    name: "Octobeer Fortunes",
    img: "/assets/Slot/PP-SLOT-271.Octobeer Fortunes.webp?v=1764330162055",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-271",
    platFormCode: "PP",
  },
  {
    name: "Odds On Winner",
    img: "/assets/Slot/PP-SLOT-458.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-458",
    platFormCode: "PP",
  },
  {
    name: "Odin",
    img: "/assets/Slot/CG-SLOT-078.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-078",
    platFormCode: "CG",
  },
  {
    name: "Odin Infinity Reels Megaways",
    img: "/assets/Slot/YGG-SLOT-010.webp?v=1767056428333",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-010",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Odin Lightning Blitz",
    img: "/assets/Slot/YGG-SLOT-282.webp?v=1767056428787",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-282",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Odin Territory",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-082.odin-territory.webp?v=1765273125862",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-082",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Of Sabers and Monsters Wild Fight",
    img: "/assets/Slot/YGG-SLOT-153.webp?v=1767056428486",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-153",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Oink Oink Oink",
    img: "/assets/Slot/PT-SLOT-319.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-319",
    platFormCode: "PT",
  },
  {
    name: "Oink Oink Oink Pharaohs",
    img: "/assets/Slot/PT-SLOT-440.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-440",
    platFormCode: "PT",
  },
  {
    name: "Oishi Delights",
    img: "/assets/Slot/PG-SLOT-146.webp?v=1765933237871",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-146",
    platFormCode: "PG",
  },
  {
    name: "Olympian Temple",
    img: "/assets/Slot/JDB-SLOT-020.Olympian Temple.webp?v=1765261129736",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-020",
    platFormCode: "JDB",
  },
  {
    name: "Olympig",
    img: "/assets/Slot/JDB-SLOT-134.Olympig.webp?v=1767691363730",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-134",
    platFormCode: "JDB",
  },
  {
    name: "Olympus Wins",
    img: "/assets/Slot/PP-SLOT-627.Olympus Wins.webp?v=1764330075250",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-627",
    platFormCode: "PP",
  },
  {
    name: "Ong Bak 2",
    img: "/assets/Slot/a7q65cfts455e.Ong-Bak-2.webp?v=1765046905822",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-125",
    platFormCode: "JOKER",
  },
  {
    name: "Ong Bak Deluxe",
    img: "/assets/Slot/bkxno75wqiigs.Ong-Bak-Deluxe.webp?v=1765053232919",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-126",
    platFormCode: "JOKER",
  },
  {
    name: "Onmyoji",
    img: "/assets/Slot/CG-SLOT-056.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-056",
    platFormCode: "CG",
  },
  {
    name: "Oodles of Noodles",
    img: "/assets/Slot/PP-SLOT-495.Oodles of Noodles.webp?v=1764330038719",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-495",
    platFormCode: "PP",
  },
  {
    name: "Opal Fruits",
    img: "/assets/Slot/BTG-SLOT-038.webp?v=1756256536955",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-038",
    platFormCode: "BTG",
  },
  {
    name: "Open Sesame",
    img: "/assets/Slot/JDB-SLOT-018.open_sesame.webp?v=1765261022548",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-018",
    platFormCode: "JDB",
  },
  {
    name: "Open Sesame II",
    img: "/assets/Slot/JDB-SLOT-051.open_sesame_II.webp?v=1765260983062",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-051",
    platFormCode: "JDB",
  },
  {
    name: "Open Sesame Mega",
    img: "/assets/Slot/JDB-SLOT-119.open-sesame-mega.webp?v=1765260943126",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-119",
    platFormCode: "JDB",
  },
  {
    name: "Opera Dynasty",
    img: "/assets/Slot/PG-SLOT-069.webp?v=1765933237803",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-069",
    platFormCode: "PG",
  },
  {
    name: "Oracle of Gold",
    img: "/assets/Slot/PP-SLOT-611.Oracle of Gold.webp?v=1764329923285",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-611",
    platFormCode: "PP",
  },
  {
    name: "Orca's Wild Bonanza",
    img: "/assets/Slot/YGG-SLOT-198.webp?v=1767056428548",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-198",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Ore Power",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-047.ore-power.webp?v=1765273075577",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-047",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Orient Animals",
    img: "/assets/Slot/JDB-SLOT-042.orient_animals.webp?v=1765260880285",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-042",
    platFormCode: "JDB",
  },
  {
    name: "Orient Express",
    img: "/assets/Slot/YGG-SLOT-056.webp?v=1767056428391",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-056",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Oriental Prosperity",
    img: "/assets/Slot/PG-SLOT-092.webp?v=1765933237821",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-092",
    platFormCode: "PG",
  },
  {
    name: "Out of The Ice",
    img: "/assets/Slot/RELAX-SLOT-120.webp?v=1761900631705",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-120",
    platFormCode: "RELAX",
  },
  {
    name: "Outlaw",
    img: "/assets/Slot/BTG-SLOT-023.webp?v=1756256536943",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-023",
    platFormCode: "BTG",
  },
  {
    name: "Outsourced",
    img: "/assets/Slot/NLC-SLOT-093.Outsourced.webp?v=1764388029111",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-093",
    platFormCode: "NLC",
  },
  {
    name: "Outsourced Payday",
    img: "/assets/Slot/NLC-SLOT-101.Outsourced Payday.webp?v=1764387977816",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-101",
    platFormCode: "NLC",
  },
  {
    name: "Over Dragon's Gate",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-012.over-dragon_s-gate.webp?v=1765272943523",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-012",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Over The Moon",
    img: "/assets/Slot/BTG-SLOT-013.webp?v=1756256536935",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-013",
    platFormCode: "BTG",
  },
  {
    name: "Overlord & Concubine",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-069.overlord-&-concubine.webp?v=1765272713324",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-069",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Owls",
    img: "/assets/Slot/NLC-SLOT-051.Owls.webp?v=1764387899277",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-051",
    platFormCode: "NLC",
  },
  {
    name: "Ox Riches",
    img: "/assets/Slot/PT-SLOT-037.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-037",
    platFormCode: "PT",
  },
  {
    name: "PANDA DRAGON BOAT",
    img: "/assets/Slot/FC-SLOT-006.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-006",
    platFormCode: "FC",
  },
  {
    name: "PHOENIX",
    img: "/assets/Slot/2J-SLOT-008.PHOENIX.webp?v=1763548287986",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-008",
    platFormCode: "JJ",
  },
  {
    name: "PIGGY BANKIN",
    img: "/assets/Slot/2J-SLOT-047.PIGGY BANKIN.webp?v=1763548244928",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-047",
    platFormCode: "JJ",
  },
  {
    name: "PIGGY HEIST",
    img: "/assets/Slot/KM-SLOT-011.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-011",
    platFormCode: "KINGMAKER",
  },
  {
    name: "PIRATE'S TREASURE",
    img: "/assets/Slot/KM-SLOT-015.webp?v=1759311949557",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-015",
    platFormCode: "KINGMAKER",
  },
  {
    name: "PIZZA! PIZZA? PIZZA!",
    img: "/assets/Slot/PP-SLOT-308.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-308",
    platFormCode: "PP",
  },
  {
    name: "POKER WIN",
    img: "/assets/Slot/FC-SLOT-044.poker-wins.webp?v=1764330167161",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-044",
    platFormCode: "FC",
  },
  {
    name: "POKER WIN 2",
    img: "/assets/Slot/FC-SLOT-057.POKER WIN 2.webp?v=1764940640691",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-057",
    platFormCode: "FC",
  },
  {
    name: "PONG PONG HU",
    img: "/assets/Slot/FC-SLOT-005.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-005",
    platFormCode: "FC",
  },
  {
    name: "POPMART",
    img: "/assets/Slot/CG-SLOT-093.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-093",
    platFormCode: "CG",
  },
  {
    name: "POWER OF KRAKEN",
    img: "/assets/Slot/2J-SLOT-061.POWER OF KRAKEN.webp?v=1763548202566",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-061",
    platFormCode: "JJ",
  },
  {
    name: "PUBG",
    img: "/assets/Slot/CG-SLOT-091.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-091",
    platFormCode: "CG",
  },
  {
    name: "PUMPKIN PARTY",
    img: "/assets/Slot/2J-SLOT-043.PUMPKIN PARTY.webp?v=1763548156918",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-043",
    platFormCode: "JJ",
  },
  {
    name: "Pan Jin Lian",
    img: "/assets/Slot/P8-SLOT-005.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-005",
    platFormCode: "PLAY8",
  },
  {
    name: "Pan Jin Lian 2",
    img: "/assets/Slot/c53raraonrmbq.Pan-Jian-Lian2.webp?v=1765043453463",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-128",
    platFormCode: "JOKER",
  },
  {
    name: "Panda Bills",
    img: "/assets/Slot/OCTOPLAY-SLOT-014.Panda Bills.webp?v=1764934862677",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-014",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Panda Chef",
    img: "/assets/Slot/f1hywikkjprr1.Panda-Chef.webp?v=1765053182661",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-193",
    platFormCode: "JOKER",
  },
  {
    name: "Panda Fortune 2",
    img: "/assets/Slot/PP-SLOT-178.Panda Fortune 2.webp?v=1764329853329",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-178",
    platFormCode: "PP",
  },
  {
    name: "Panda Luck",
    img: "/assets/Slot/PT-SLOT-197.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-197",
    platFormCode: "PT",
  },
  {
    name: "Panda Money",
    img: "/assets/Slot/BTG-SLOT-040.webp?v=1756256536956",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-040",
    platFormCode: "BTG",
  },
  {
    name: "Panda's Fortune",
    img: "/assets/Slot/PP-SLOT-116.Panda_s Fortune.webp?v=1764329790207",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-116",
    platFormCode: "PP",
  },
  {
    name: "Pandaria",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-038.pandaria.webp?v=1765272657405",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-038",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Pandemic Rising",
    img: "/assets/Slot/PP-SLOT-609.Pandemic Rising.webp?v=1764329726136",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-609",
    platFormCode: "PP",
  },
  {
    name: "Panther Moon",
    img: "/assets/Slot/PT-SLOT-041.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-041",
    platFormCode: "PT",
  },
  {
    name: "Panther Moon",
    img: "/assets/Slot/P8-SLOT-001.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-001",
    platFormCode: "PLAY8",
  },
  {
    name: "Panther Pays",
    img: "/assets/Slot/PT-SLOT-230.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-230",
    platFormCode: "PT",
  },
  {
    name: "Party Night",
    img: "/assets/Slot/JILI-SLOT-044.webp?v=1755509541823",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-044",
    platFormCode: "JILI",
  },
  {
    name: "Party Night",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-071.party-night.webp?v=1765272606601",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-071",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Party Star",
    img: "/assets/Slot/JILI-SLOT-104.webp?v=1755510546403",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-104",
    platFormCode: "JILI",
  },
  {
    name: "Path of Destiny",
    img: "/assets/Slot/RT-SLOT-125.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-125",
    platFormCode: "RT",
  },
  {
    name: "Pay Pig 10K WAYS",
    img: "/assets/Slot/RELAX-SLOT-269.webp?v=1761901145438",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-269",
    platFormCode: "RELAX",
  },
  {
    name: "Payday Megaways",
    img: "/assets/Slot/RELAX-SLOT-243.webp?v=1761901190255",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-243",
    platFormCode: "RELAX",
  },
  {
    name: "Peach Banquet",
    img: "/assets/Slot/s77hiogba5dhe.Peach-Banquet.webp?v=1765042562343",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-130",
    platFormCode: "JOKER",
  },
  {
    name: "Peak Power",
    img: "/assets/Slot/PP-SLOT-324.Peak Power.webp?v=1764329684742",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-324",
    platFormCode: "PP",
  },
  {
    name: "Pearl Harbor",
    img: "/assets/Slot/NLC-SLOT-018.Pearl Harbor.webp?v=1764387843128",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-018",
    platFormCode: "NLC",
  },
  {
    name: "Pearls Pearls Pearls",
    img: "/assets/Slot/PT-SLOT-178.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-178",
    platFormCode: "PT",
  },
  {
    name: "Pearly Shores",
    img: "/assets/Slot/OCTOPLAY-SLOT-015.Pearly Shores.webp?v=1764934910776",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-015",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Peggy Sweets",
    img: "/assets/Slot/RT-SLOT-137.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-137",
    platFormCode: "RT",
  },
  {
    name: "Peking Luck",
    img: "/assets/Slot/PP-SLOT-099.Peking Luck.webp?v=1764329614646",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-099",
    platFormCode: "PP",
  },
  {
    name: "Penguin City",
    img: "/assets/Slot/YGG-SLOT-034.webp?v=1767056428362",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-034",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Penguin Vacation",
    img: "/assets/Slot/PT-SLOT-121.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-121",
    platFormCode: "PT",
  },
  {
    name: "Penguins Christmas Party Time",
    img: "/assets/Slot/PP-SLOT-523.Penguins Christmas Party Time.webp?v=1764329560572",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-523",
    platFormCode: "PP",
  },
  {
    name: "Pharaoh Resort Hotel",
    img: "/assets/Slot/CG-SLOT-118.Pharaoh Resort Hotel.webp?v=1764666675610",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-118",
    platFormCode: "CG",
  },
  {
    name: "Pharaoh Royals",
    img: "/assets/Slot/PG-SLOT-165.webp?v=1765933237889",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-165",
    platFormCode: "PG",
  },
  {
    name: "Pharaoh Treasure",
    img: "/assets/Slot/JILI-SLOT-038.Pharaoh Treasure.webp?v=1764311424958",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-038",
    platFormCode: "JILI",
  },
  {
    name: "Pharaoh's Daughter",
    img: "/assets/Slot/PT-SLOT-213.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-213",
    platFormCode: "PT",
  },
  {
    name: "Pharaoh's Secrets",
    img: "/assets/Slot/PT-SLOT-126.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-126",
    platFormCode: "PT",
  },
  {
    name: "Pharaoh's Tomb",
    img: "/assets/Slot/kdn8ckjqfhsn4.Pharaoh_s-Tomb.webp?v=1765052181893",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-131",
    platFormCode: "JOKER",
  },
  {
    name: "Pharaoh’s Gaze DoubleMax",
    img: "/assets/Slot/YGG-SLOT-181.webp?v=1767056428519",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-181",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pharaoh’s Rage UltraSpinz",
    img: "/assets/Slot/YGG-SLOT-377.webp?v=1767056428883",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-377",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Phoenix",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-002.phoenix.webp?v=1765272552665",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-002",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Phoenix 888",
    img: "/assets/Slot/d8cso3u8ct1iw.Phoenix888.webp?v=1765041656119",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-132",
    platFormCode: "JOKER",
  },
  {
    name: "Phoenix Fever",
    img: "/assets/Slot/FC-SLOT-050.webp?v=1755511441120",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-050",
    platFormCode: "FC",
  },
  {
    name: "Phoenix Forge",
    img: "/assets/Slot/PP-SLOT-195.Phoenix Forge.webp?v=1764329487174",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-195",
    platFormCode: "PP",
  },
  {
    name: "Phoenix Rises",
    img: "/assets/Slot/PG-SLOT-053.webp?v=1765933237792",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-053",
    platFormCode: "PG",
  },
  {
    name: "Pig Farm",
    img: "/assets/Slot/PP-SLOT-625.Pig Farm.webp?v=1764329423607",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-625",
    platFormCode: "PP",
  },
  {
    name: "Pigeons from Space",
    img: "/assets/Slot/PT-SLOT-240.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-240",
    platFormCode: "PT",
  },
  {
    name: "Piggies and the Bank: Cash Collect & Link",
    img: "/assets/Slot/PT-SLOT-412.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-412",
    platFormCode: "PT",
  },
  {
    name: "Piggies and the Wolf",
    img: "/assets/Slot/PT-SLOT-140.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-140",
    platFormCode: "PT",
  },
  {
    name: "Piggy Bank",
    img: "/assets/Slot/JDB-SLOT-123.Piggy Bank.webp?v=1765260818460",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-123",
    platFormCode: "JDB",
  },
  {
    name: "Piggy Bank Bills",
    img: "/assets/Slot/PP-SLOT-202.Piggy Bank Bills.webp?v=1764329372086",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-202",
    platFormCode: "PP",
  },
  {
    name: "Piggy Bankers",
    img: "/assets/Slot/PP-SLOT-370.Piggy Bankers.webp?v=1764329295311",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-370",
    platFormCode: "PP",
  },
  {
    name: "Piggy Coin: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-099.Piggy Coin Hold & Win.webp?v=1764934930326",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-099",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Piggy Gold",
    img: "/assets/Slot/PG-SLOT-023.webp?v=1765933237768",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-023",
    platFormCode: "PG",
  },
  {
    name: "Piggy Mania",
    img: "/assets/Slot/PT-SLOT-433.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-433",
    platFormCode: "PT",
  },
  {
    name: "Piggy Riches™ 3: Hog Heaven",
    img: "/assets/Slot/NETENT-SLOT-231.Piggy Riches™ 3_ Hog Heaven.webp?v=1764956732132",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-231",
    platFormCode: "NETENT",
  },
  {
    name: "Piggy Staxx",
    img: "/assets/Slot/YGG-SLOT-419.webp?v=1767056428927",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-419",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pillage The Village 10K Ways",
    img: "/assets/Slot/YGG-SLOT-348.webp?v=1767056428853",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-348",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pinata Popper",
    img: "/assets/Slot/RELAX-SLOT-197.webp?v=1761901249674",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-197",
    platFormCode: "RELAX",
  },
  {
    name: "Pinata Wins",
    img: "/assets/Slot/PG-SLOT-136.webp?v=1765933237858",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-136",
    platFormCode: "PG",
  },
  {
    name: "Pinatas & Ponies",
    img: "/assets/Slot/RT-SLOT-229.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-229",
    platFormCode: "RT",
  },
  {
    name: "Pine of Plinko",
    img: "/assets/Slot/RELAX-SLOT-157.webp?v=1761901669358",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-157",
    platFormCode: "RELAX",
  },
  {
    name: "Pine of Plinko 2",
    img: "/assets/Slot/RELAX-SLOT-217.webp?v=1761901722427",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-217",
    platFormCode: "RELAX",
  },
  {
    name: "Ping Pong Panda",
    img: "/assets/Slot/SG-SLOT-164.Ping Pong Panda.webp?v=1764997112097",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-164",
    platFormCode: "SPADE",
  },
  {
    name: "Pinup Girls",
    img: "/assets/Slot/PP-SLOT-317.Pinup Girls.webp?v=1764329232396",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-317",
    platFormCode: "PP",
  },
  {
    name: "Pip & Pippa's Pots of Plenty",
    img: "/assets/Slot/OCTOPLAY-SLOT-084.pip & pippa_s pots of plenty.webp?v=1764934974291",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-084",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Pirate From the East",
    img: "/assets/Slot/NETENT-SLOT-172.Pirate-from-the-East.webp?v=1764956587611",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-172",
    platFormCode: "NETENT",
  },
  {
    name: "Pirate Gold",
    img: "/assets/Slot/PP-SLOT-084.Pirate Gold.webp?v=1764329176244",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-084",
    platFormCode: "PP",
  },
  {
    name: "Pirate Gold Deluxe",
    img: "/assets/Slot/PP-SLOT-020.Pirate Gold Deluxe.webp?v=1764329113559",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-020",
    platFormCode: "PP",
  },
  {
    name: "Pirate Golden Age",
    img: "/assets/Slot/PP-SLOT-300.Pirate Golden Age.webp?v=1764329015414",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-300",
    platFormCode: "PP",
  },
  {
    name: "Pirate King",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-010.pirate-king.webp?v=1765272477367",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-010",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Pirate Legends",
    img: "/assets/Slot/YesBingo-SLOT-037.Pirate Legends.webp?v=1764499845907",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-037",
    platFormCode: "YESBINGO",
  },
  {
    name: "Pirate Multi Coins",
    img: "/assets/Slot/RELAX-SLOT-232.webp?v=1761902011017",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-232",
    platFormCode: "RELAX",
  },
  {
    name: "Pirate Pays",
    img: "/assets/Slot/BTG-SLOT-029.webp?v=1756256536948",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-029",
    platFormCode: "BTG",
  },
  {
    name: "Pirate Queen",
    img: "/assets/Slot/JILI-SLOT-073.webp?v=1755509929136",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-073",
    platFormCode: "JILI",
  },
  {
    name: "Pirate Queen 2",
    img: "/assets/Slot/JILI-SLOT-135.pirate-queen-2.webp?v=1764311278002",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-135",
    platFormCode: "JILI",
  },
  {
    name: "Pirate Treasure",
    img: "/assets/Slot/SlotPirateTreasure.PIRATE TREASURE.webp?v=1764775084301",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-014",
    platFormCode: "ACEWIN",
  },
  {
    name: "Pirate Treasure",
    img: "/assets/Slot/ACEWIN-SLOT-014.Pirate Treasure.webp?v=1764854427116",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-014",
    platFormCode: "ACEWIN",
  },
  {
    name: "Pirates",
    img: "/assets/Slot/CG-SLOT-057.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-057",
    platFormCode: "CG",
  },
  {
    name: "Pirates 2: Mutiny",
    img: "/assets/Slot/YGG-SLOT-061.webp?v=1767056428399",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-061",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pirates Party",
    img: "/assets/Slot/NETENT-SLOT-182.pirates-party.webp?v=1764956509626",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-182",
    platFormCode: "NETENT",
  },
  {
    name: "Pirates Plenty MegaWays",
    img: "/assets/Slot/RT-SLOT-058.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-058",
    platFormCode: "RT",
  },
  {
    name: "Pirates Pub",
    img: "/assets/Slot/PP-SLOT-352.Pirates Pub.webp?v=1764328953716",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-352",
    platFormCode: "PP",
  },
  {
    name: "Pirates' Plenty",
    img: "/assets/Slot/RT-SLOT-140.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-140",
    platFormCode: "RT",
  },
  {
    name: "Pirates' Plenty Battle For Gold",
    img: "/assets/Slot/RT-SLOT-097.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-097",
    platFormCode: "RT",
  },
  {
    name: "Pirates: Smugglers Paradise",
    img: "/assets/Slot/YGG-SLOT-059.webp?v=1767056428396",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-059",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pixie Wings",
    img: "/assets/Slot/PP-SLOT-122.Pixie Wings.webp?v=1764328894863",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-122",
    platFormCode: "PP",
  },
  {
    name: "Pixies vs Pirates",
    img: "/assets/Slot/NLC-SLOT-044.Pixies vs Pirates.webp?v=1764387781673",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-044",
    platFormCode: "NLC",
  },
  {
    name: "Platinum",
    img: "/assets/Slot/CG-SLOT-012.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-012",
    platFormCode: "CG",
  },
  {
    name: "Play with the Devil",
    img: "/assets/Slot/RT-SLOT-282.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-282",
    platFormCode: "RT",
  },
  {
    name: "Plenty O'Fortune",
    img: "/assets/Slot/PT-SLOT-080.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-080",
    platFormCode: "PT",
  },
  {
    name: "Plunderland",
    img: "/assets/Slot/RELAX-SLOT-100.webp?v=1761902038551",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-100",
    platFormCode: "RELAX",
  },
  {
    name: "Plunderland 10K",
    img: "/assets/Slot/RELAX-SLOT-238.webp?v=1761902074045",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-238",
    platFormCode: "RELAX",
  },
  {
    name: "Plunderland 5K",
    img: "/assets/Slot/RELAX-SLOT-237.webp?v=1761902098090",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-237",
    platFormCode: "RELAX",
  },
  {
    name: "Plushie Frenzy",
    img: "/assets/Slot/PG-SLOT-012.webp?v=1765933237760",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-012",
    platFormCode: "PG",
  },
  {
    name: "Plushie Wins",
    img: "/assets/Slot/PP-SLOT-619.Plushie Wins.webp?v=1764328827453",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-619",
    platFormCode: "PP",
  },
  {
    name: "Poison Eve",
    img: "/assets/Slot/NLC-SLOT-040.Poison Eve.webp?v=1764387731500",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-040",
    platFormCode: "NLC",
  },
  {
    name: "Poker Ways",
    img: "/assets/Slot/SG-SLOT-095.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-095",
    platFormCode: "SPADE",
  },
  {
    name: "Pompeii Megareels Megaways",
    img: "/assets/Slot/PP-SLOT-429.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-429",
    platFormCode: "PP",
  },
  {
    name: "Pond of Plinko",
    img: "/assets/Slot/RELAX-SLOT-276.webp?v=1761902124322",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-276",
    platFormCode: "RELAX",
  },
  {
    name: "Pop",
    img: "/assets/Slot/BTG-SLOT-031.webp?v=1756256536950",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-031",
    platFormCode: "BTG",
  },
  {
    name: "Pop Pop Candy",
    img: "/assets/Slot/JDB-SLOT-120.pop-pop-candy.webp?v=1765260645147",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-120",
    platFormCode: "JDB",
  },
  {
    name: "Pop Pop Candy 1000",
    img: "/assets/Slot/JDB-SLOT-129.pop-pop-candy-1000.webp?v=1767691320993",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-129",
    platFormCode: "JDB",
  },
  {
    name: "PopNoir",
    img: "/assets/Slot/YGG-SLOT-358.webp?v=1767056428867",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-358",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Poseidon",
    img: "/assets/Slot/JILI-SLOT-121.webp?v=1755510861339",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-121",
    platFormCode: "JILI",
  },
  {
    name: "Possessed",
    img: "/assets/Slot/NLC-SLOT-081.Possessed.webp?v=1764387682408",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-081",
    platFormCode: "NLC",
  },
  {
    name: "Pot of Fortune",
    img: "/assets/Slot/PP-SLOT-442.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-442",
    platFormCode: "PP",
  },
  {
    name: "Potion Wizard",
    img: "/assets/Slot/JILI-SLOT-098.webp?v=1755510443991",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-098",
    platFormCode: "JILI",
  },
  {
    name: "Power Mask",
    img: "/assets/Slot/YesBingo-SLOT-006.Power Mask.webp?v=1765103279968",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-006",
    platFormCode: "YESBINGO",
  },
  {
    name: "Power Pack",
    img: "/assets/Slot/YGG-SLOT-390.webp?v=1767056428894",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-390",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Power Stars",
    img: "/assets/Slot/hcu3p8r71kj3y.Power-Star.webp?v=1765049203309",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-133",
    platFormCode: "JOKER",
  },
  {
    name: "Power Zones: Thunder Birds",
    img: "/assets/Slot/PT-SLOT-093.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-093",
    platFormCode: "PT",
  },
  {
    name: "Power of Merlin Megaways",
    img: "/assets/Slot/PP-SLOT-362.Power of Merlin Megaways.webp?v=1764328757279",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-362",
    platFormCode: "PP",
  },
  {
    name: "Power of Ninja",
    img: "/assets/Slot/PP-SLOT-435.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-435",
    platFormCode: "PP",
  },
  {
    name: "Power of Thor Megaways",
    img: "/assets/Slot/PP-SLOT-174.Power of Thor Megaways.webp?v=1764328684091",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-174",
    platFormCode: "PP",
  },
  {
    name: "Powerspin",
    img: "/assets/Slot/RELAX-SLOT-042.webp?v=1761902447681",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-042",
    platFormCode: "RELAX",
  },
  {
    name: "Primal Hunter Gigablox",
    img: "/assets/Slot/YGG-SLOT-249.webp?v=1767056428750",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-249",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Primal Spirits",
    img: "/assets/Slot/PT-SLOT-460.webp?v=1756275771680",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-460",
    platFormCode: "PT",
  },
  {
    name: "Primate King",
    img: "/assets/Slot/RT-SLOT-203.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-203",
    platFormCode: "RT",
  },
  {
    name: "Professor Clanks Combinator",
    img: "/assets/Slot/YGG-SLOT-146.webp?v=1767056428479",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-146",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Prosperity Fortune Tree",
    img: "/assets/Slot/PG-SLOT-106.webp?v=1765933237833",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-106",
    platFormCode: "PG",
  },
  {
    name: "Prosperity Lion",
    img: "/assets/Slot/PG-SLOT-020.webp?v=1765933237765",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-020",
    platFormCode: "PG",
  },
  {
    name: "Prosperity Tiger",
    img: "/assets/Slot/JDB-SLOT-100.prosperity_tiger.webp?v=1767691503426",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-100",
    platFormCode: "JDB",
  },
  {
    name: "Pub Kings",
    img: "/assets/Slot/PP-SLOT-371.Pub Kings.webp?v=1764328607139",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-371",
    platFormCode: "PP",
  },
  {
    name: "Pulled From The Deep UltraNudge",
    img: "/assets/Slot/YGG-SLOT-269.webp?v=1767056428777",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-269",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pumpkin Smash",
    img: "/assets/Slot/YGG-SLOT-101.webp?v=1767056428441",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-101",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Punk Rocker",
    img: "/assets/Slot/NLC-SLOT-012.Punk Rocker.webp?v=1764387631887",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-012",
    platFormCode: "NLC",
  },
  {
    name: "Punk Rocker 2",
    img: "/assets/Slot/NLC-SLOT-089.Punk Rocker 2.webp?v=1764387572692",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-089",
    platFormCode: "NLC",
  },
  {
    name: "Punk Toilet",
    img: "/assets/Slot/NLC-SLOT-003.Punk Toilet.webp?v=1764387522994",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-003",
    platFormCode: "NLC",
  },
  {
    name: "Purr Power",
    img: "/assets/Slot/RT-SLOT-317.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-317",
    platFormCode: "RT",
  },
  {
    name: "Purrfect Potions",
    img: "/assets/Slot/YGG-SLOT-192.webp?v=1767056428530",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-192",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pushy Cats",
    img: "/assets/Slot/YGG-SLOT-068.webp?v=1767056428406",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-068",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Pyramid",
    img: "/assets/Slot/P8-SLOT-032.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-032",
    platFormCode: "PLAY8",
  },
  {
    name: "Pyramid Bonanza",
    img: "/assets/Slot/PP-SLOT-187.Pyramid Bonanza.webp?v=1764328548763",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-187",
    platFormCode: "PP",
  },
  {
    name: "Pyramid King",
    img: "/assets/Slot/PP-SLOT-042.Pyramid King.webp?v=1764328423333",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-042",
    platFormCode: "PP",
  },
  {
    name: "Pyramid Linx",
    img: "/assets/Slot/PT-SLOT-418.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-418",
    platFormCode: "PT",
  },
  {
    name: "Pyramid Valley: Power Zones",
    img: "/assets/Slot/PT-SLOT-099.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-099",
    platFormCode: "PT",
  },
  {
    name: "Qatar 2022",
    img: "/assets/Slot/sco3dugpambhy.Qatar-2022.webp?v=1765043242029",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-134",
    platFormCode: "JOKER",
  },
  {
    name: "Qin",
    img: "/assets/Slot/P8-SLOT-033.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-033",
    platFormCode: "PLAY8",
  },
  {
    name: "Qin's Empire: Caishen's Temple",
    img: "/assets/Slot/PT-SLOT-234.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-234",
    platFormCode: "PT",
  },
  {
    name: "Quackin Reels",
    img: "/assets/Slot/RELAX-SLOT-265.webp?v=1761902476806",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-265",
    platFormCode: "RELAX",
  },
  {
    name: "Queen 2",
    img: "/assets/Slot/5bgx7epgw61kk.Queen-2.webp?v=1765042421237",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-136",
    platFormCode: "JOKER",
  },
  {
    name: "Queen Of Cash",
    img: "/assets/Slot/CG-SLOT-042.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-042",
    platFormCode: "CG",
  },
  {
    name: "Queen Of The Nile",
    img: "/assets/Slot/8nsbhokge7nrk.Queen-Of-The-Nile.webp?v=1765051678846",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-137",
    platFormCode: "JOKER",
  },
  {
    name: "Queen of Bounty",
    img: "/assets/Slot/PG-SLOT-063.webp?v=1765933237798",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-063",
    platFormCode: "PG",
  },
  {
    name: "Queen of Gods",
    img: "/assets/Slot/PP-SLOT-257.Queen of Gods.webp?v=1764328490097",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-257",
    platFormCode: "PP",
  },
  {
    name: "Queen of Riches",
    img: "/assets/Slot/BTG-SLOT-055.webp?v=1756256536968",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-055",
    platFormCode: "BTG",
  },
  {
    name: "Queen of Wands",
    img: "/assets/Slot/PT-SLOT-039.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-039",
    platFormCode: "PT",
  },
  {
    name: "Queen's Mystery",
    img: "/assets/Slot/PT-SLOT-355.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-355",
    platFormCode: "PT",
  },
  {
    name: "Queenie",
    img: "/assets/Slot/PP-SLOT-249.Queenie.webp?v=1764328365898",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-249",
    platFormCode: "PP",
  },
  {
    name: "Quest West",
    img: "/assets/Slot/PT-SLOT-192.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-192",
    platFormCode: "PT",
  },
  {
    name: "RAILROAD RICHES",
    img: "/assets/Slot/2J-SLOT-048.RAILROAD RICHES.webp?v=1763548087971",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-048",
    platFormCode: "JJ",
  },
  {
    name: "RAMPAGE BUFFALO",
    img: "/assets/Slot/2J-SLOT-011.RAMPAGE BUFFALO.webp?v=1763548025609",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-011",
    platFormCode: "JJ",
  },
  {
    name: "RICH MAN",
    img: "/assets/Slot/FC-SLOT-018.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-018",
    platFormCode: "FC",
  },
  {
    name: "RISING FORTUNES",
    img: "/assets/Slot/2J-SLOT-015.RISING FORTUNES.webp?v=1763547982916",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-015",
    platFormCode: "JJ",
  },
  {
    name: "ROMA",
    img: "/assets/Slot/2J-SLOT-023.ROMA.webp?v=1763547937423",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-023",
    platFormCode: "JJ",
  },
  {
    name: "ROMA GLADIATRIX",
    img: "/assets/Slot/FC-SLOT-042.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-042",
    platFormCode: "FC",
  },
  {
    name: "ROMA X 10000",
    img: "/assets/Slot/JILI-SLOT-155.ROMA X 10000.webp?v=1764310696688",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-155",
    platFormCode: "JILI",
  },
  {
    name: "ROME GLADIATOR",
    img: "/assets/Slot/KM-SLOT-018.ROME GLADIATOR.webp?v=1764861483470",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-018",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Rabbit Garden",
    img: "/assets/Slot/PP-SLOT-328.Rabbit Garden.webp?v=1764327637898",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-328",
    platFormCode: "PP",
  },
  {
    name: "Rabbit Riches",
    img: "/assets/Slot/SG-SLOT-120.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-120",
    platFormCode: "SPADE",
  },
  {
    name: "Rabid Randy",
    img: "/assets/Slot/NETENT-SLOT-216.Rabid-Randy.webp?v=1764956440220",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-216",
    platFormCode: "NETENT",
  },
  {
    name: "Rabid Randy Dark Trails",
    img: "/assets/Slot/NETENT-SLOT-234.Rabid Randy Dark Trails.webp?v=1764956406618",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-234",
    platFormCode: "NETENT",
  },
  {
    name: "Racing Lovers",
    img: "/assets/Slot/YGG-SLOT-255.webp?v=1767056428760",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-255",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Rage",
    img: "/assets/Slot/NETENT-SLOT-189.Rage.webp?v=1764956375480",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-189",
    platFormCode: "NETENT",
  },
  {
    name: "Raging Bull",
    img: "/assets/Slot/PP-SLOT-188.Raging Bull.webp?v=1764327582261",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-188",
    platFormCode: "PP",
  },
  {
    name: "Ragnarok : Thor VS Loki",
    img: "/assets/Slot/JDB-SLOT-133.Ragnarok-Thor-VS-Loki.webp?v=1767691354443",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-133",
    platFormCode: "JDB",
  },
  {
    name: "Ragnawolves",
    img: "/assets/Slot/YGG-SLOT-197.webp?v=1767056428546",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-197",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Raider Jane's Crypt of Fortune",
    img: "/assets/Slot/PG-SLOT-083.webp?v=1765933237813",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-083",
    platFormCode: "PG",
  },
  {
    name: "Rainbow Gold",
    img: "/assets/Slot/PP-SLOT-244.Rainbow Gold.webp?v=1764327511855",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-244",
    platFormCode: "PP",
  },
  {
    name: "Rainbow Jackpots MegaWays",
    img: "/assets/Slot/RT-SLOT-313.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-313",
    platFormCode: "RT",
  },
  {
    name: "Rainbow Jackpots Power Lines",
    img: "/assets/Slot/RT-SLOT-098.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-098",
    platFormCode: "RT",
  },
  {
    name: "Rainbow Power Potz UltraNudge",
    img: "/assets/Slot/YGG-SLOT-172.webp?v=1767056428510",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-172",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Rainbow Reels",
    img: "/assets/Slot/PP-SLOT-390.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-390",
    platFormCode: "PP",
  },
  {
    name: "Rainbow Ryan",
    img: "/assets/Slot/YGG-SLOT-079.webp?v=1767056428421",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-079",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Rainbow Ryan 2",
    img: "/assets/Slot/YGG-SLOT-244.webp?v=1767056428595",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-244",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Ramesses Gold 10K Ways",
    img: "/assets/Slot/YGG-SLOT-327.webp?v=1767056428827",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-327",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Ramses Retro",
    img: "/assets/Slot/YGG-SLOT-300.webp?v=1767056428802",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-300",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Ramses Revenge",
    img: "/assets/Slot/RELAX-SLOT-043.webp?v=1761902499587",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-043",
    platFormCode: "RELAX",
  },
  {
    name: "Rancher's Wealth",
    img: "/assets/Slot/e5jgac3ogr5dq.Rancher_s-Wealth.webp?v=1765045418559",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-138",
    platFormCode: "JOKER",
  },
  {
    name: "Rapid Gems 777",
    img: "/assets/Slot/JILI-SLOT-152.Rapid Gems 777.webp?v=1764311080125",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-152",
    platFormCode: "JILI",
  },
  {
    name: "Raptor Doublemax",
    img: "/assets/Slot/YGG-SLOT-054.webp?v=1767056428387",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-054",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Rasputin Megaways",
    img: "/assets/Slot/BTG-SLOT-003.webp?v=1756256536927",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-003",
    platFormCode: "BTG",
  },
  {
    name: "Rave Party Fever",
    img: "/assets/Slot/PG-SLOT-113.webp?v=1765933237839",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-113",
    platFormCode: "PG",
  },
  {
    name: "Reaction Link",
    img: "/assets/Slot/PT-SLOT-414.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-414",
    platFormCode: "PT",
  },
  {
    name: "Reactor",
    img: "/assets/Slot/RT-SLOT-062.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-062",
    platFormCode: "RT",
  },
  {
    name: "Ready to Blow Thundershots",
    img: "/assets/Slot/PT-SLOT-258.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-258",
    platFormCode: "PT",
  },
  {
    name: "Reapers",
    img: "/assets/Slot/RELAX-SLOT-154.webp?v=1761902524448",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-154",
    platFormCode: "RELAX",
  },
  {
    name: "Record Riches",
    img: "/assets/Slot/PT-SLOT-175.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-175",
    platFormCode: "PT",
  },
  {
    name: "Red Dragon’s Treasure",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-087.Red Dragon’s Treasure.webp?v=1765272427786",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-087",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Red Hot BBQ",
    img: "/assets/Slot/RT-SLOT-241.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-241",
    platFormCode: "RT",
  },
  {
    name: "Red Hot Slot",
    img: "/assets/Slot/RT-SLOT-309.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-309",
    platFormCode: "RT",
  },
  {
    name: "Redline Rush",
    img: "/assets/Slot/RT-SLOT-285.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-285",
    platFormCode: "RT",
  },
  {
    name: "Reel Banks",
    img: "/assets/Slot/PP-SLOT-309.Reel Banks.webp?v=1764327435327",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-309",
    platFormCode: "PP",
  },
  {
    name: "Reel Desire",
    img: "/assets/Slot/YGG-SLOT-104.webp?v=1767056428443",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-104",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Reel Keeper",
    img: "/assets/Slot/RT-SLOT-160.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-160",
    platFormCode: "RT",
  },
  {
    name: "Reel Keeper Power Reels",
    img: "/assets/Slot/RT-SLOT-240.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-240",
    platFormCode: "RT",
  },
  {
    name: "Reel King Mega",
    img: "/assets/Slot/RT-SLOT-130.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-130",
    platFormCode: "RT",
  },
  {
    name: "Reel Love",
    img: "/assets/Slot/PG-SLOT-044.webp?v=1765933237784",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-044",
    platFormCode: "PG",
  },
  {
    name: "Reel Rush 2",
    img: "/assets/Slot/NETENT-SLOT-123.Reel-Rush-2.webp?v=1764956207474",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-123",
    platFormCode: "NETENT",
  },
  {
    name: "Reel Rush XXXtreme",
    img: "/assets/Slot/NETENT-SLOT-229.Reel Rush XXXtreme.webp?v=1764956151039",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-229",
    platFormCode: "NETENT",
  },
  {
    name: "Reel The Groove",
    img: "/assets/Slot/YGG-SLOT-373.webp?v=1767056428880",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-373",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Regal Beasts",
    img: "/assets/Slot/RT-SLOT-161.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-161",
    platFormCode: "RT",
  },
  {
    name: "Regal Streak",
    img: "/assets/Slot/RT-SLOT-138.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-138",
    platFormCode: "RT",
  },
  {
    name: "Release the Bison",
    img: "/assets/Slot/PP-SLOT-446.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-446",
    platFormCode: "PP",
  },
  {
    name: "Release the Kraken",
    img: "/assets/Slot/PP-SLOT-061.Release the Kraken.webp?v=1764327351392",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-061",
    platFormCode: "PP",
  },
  {
    name: "Release the Kraken 2",
    img: "/assets/Slot/PP-SLOT-294.Release the Kraken 2.webp?v=1764327294936",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-294",
    platFormCode: "PP",
  },
  {
    name: "Remember Gulag",
    img: "/assets/Slot/NLC-SLOT-017.Remember Gulag.webp?v=1764387441846",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-017",
    platFormCode: "NLC",
  },
  {
    name: "Renegade Revengers",
    img: "/assets/Slot/YGG-SLOT-401.webp?v=1767056428911",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-401",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Reptizillions Power Reels",
    img: "/assets/Slot/RT-SLOT-204.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-204",
    platFormCode: "RT",
  },
  {
    name: "Respin Mania",
    img: "/assets/Slot/d5qfgs4amfxf6.Respin-Mania.webp?v=1765047789495",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-139",
    platFormCode: "JOKER",
  },
  {
    name: "Resurrecting Riches",
    img: "/assets/Slot/PP-SLOT-567.Resurrecting Riches.webp?v=1764327056704",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-567",
    platFormCode: "PP",
  },
  {
    name: "Retro Rush",
    img: "/assets/Slot/PT-SLOT-231.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-231",
    platFormCode: "PT",
  },
  {
    name: "Return of the Dead",
    img: "/assets/Slot/PP-SLOT-024.Return of the Dead.webp?v=1764326997309",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-024",
    platFormCode: "PP",
  },
  {
    name: "Return of the Valkyrie",
    img: "/assets/Slot/YGG-SLOT-136.webp?v=1767056428471",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-136",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Revenge of Loki Megaways",
    img: "/assets/Slot/PP-SLOT-462.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-462",
    platFormCode: "PP",
  },
  {
    name: "Ri Ri Jin Cai",
    img: "/assets/Slot/PT-SLOT-047.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-047",
    platFormCode: "PT",
  },
  {
    name: "Rich Caishen",
    img: "/assets/Slot/SG-SLOT-096.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-096",
    platFormCode: "SPADE",
  },
  {
    name: "Rich Dragon",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-035.rich-dragon.webp?v=1765272388095",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-035",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Rich Lion",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-018.rich-lion.webp?v=1765272326796",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-018",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Rich Now",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-005.rich-now.webp?v=1765272281480",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-005",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Rich Ox",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-059.rich-ox.webp?v=1765272232813",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-059",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Rich Piggies",
    img: "/assets/Slot/ACEWIN-SLOT-002.Rich Piggies.webp?v=1764854597417",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-002",
    platFormCode: "ACEWIN",
  },
  {
    name: "Rich Raptors",
    img: "/assets/Slot/RELAX-SLOT-186.webp?v=1761902548203",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-186",
    platFormCode: "RELAX",
  },
  {
    name: "Riches of Olympus",
    img: "/assets/Slot/YGG-SLOT-295.webp?v=1767056428798",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-295",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Richman",
    img: "/assets/Slot/CG-SLOT-001.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-001",
    platFormCode: "CG",
  },
  {
    name: "Riddle Of The Sphinx",
    img: "/assets/Slot/RT-SLOT-162.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-162",
    platFormCode: "RT",
  },
  {
    name: "Ride The Lightning",
    img: "/assets/Slot/PP-SLOT-558.webp?v=1755572094851",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-558",
    platFormCode: "PP",
  },
  {
    name: "Ring of Odin",
    img: "/assets/Slot/SlotRingOfOdin.RING OF ODIN.webp?v=1764775004957",
    platForm: "PLAYNGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PLAYNGO-SLOT-127",
    platFormCode: "PLAYNGO",
  },
  {
    name: "Rio Fantasia",
    img: "/assets/Slot/PG-SLOT-148.webp?v=1765933237873",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-148",
    platFormCode: "PG",
  },
  {
    name: "Rio Stars",
    img: "/assets/Slot/RT-SLOT-099.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-099",
    platFormCode: "RT",
  },
  {
    name: "Ripe Rewards",
    img: "/assets/Slot/PP-SLOT-449.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-449",
    platFormCode: "PP",
  },
  {
    name: "Rise Of Werewolves",
    img: "/assets/Slot/SG-SLOT-087.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-087",
    platFormCode: "SPADE",
  },
  {
    name: "Rise of Cleopatra",
    img: "/assets/Slot/RT-SLOT-351.Rise-of-Cleopatra.webp?v=1764349477897",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-351",
    platFormCode: "RT",
  },
  {
    name: "Rise of Giza PowerNudge",
    img: "/assets/Slot/PP-SLOT-186.Rise of Giza PowerNudge.webp?v=1764326895073",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-186",
    platFormCode: "PP",
  },
  {
    name: "Rise of Pyramids",
    img: "/assets/Slot/PP-SLOT-460.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-460",
    platFormCode: "PP",
  },
  {
    name: "Rise of Samurai",
    img: "/assets/Slot/PP-SLOT-027.Rise of Samurai.webp?v=1764326827318",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-027",
    platFormCode: "PP",
  },
  {
    name: "Rise of the Sun God",
    img: "/assets/Slot/PG-SLOT-078.webp?v=1765933237810",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-078",
    platFormCode: "PG",
  },
  {
    name: "Road Rage",
    img: "/assets/Slot/NLC-SLOT-019.Road Rage.webp?v=1764387390619",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-019",
    platFormCode: "NLC",
  },
  {
    name: "Roadkill",
    img: "/assets/Slot/NLC-SLOT-084.Roadkill.webp?v=1764387346419",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-084",
    platFormCode: "NLC",
  },
  {
    name: "Roamin' Romans UltraNudge",
    img: "/assets/Slot/YGG-SLOT-212.webp?v=1767056428560",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-212",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Roaming Wild Buffalo",
    img: "/assets/Slot/OCTOPLAY-SLOT-089.Roaming Wild Buffalo.webp?v=1764935034481",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-089",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Robber Strike",
    img: "/assets/Slot/PP-SLOT-349.Robber Strike.webp?v=1764326775556",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-349",
    platFormCode: "PP",
  },
  {
    name: "Robin Hood",
    img: "/assets/Slot/FC-SLOT-020.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-020",
    platFormCode: "FC",
  },
  {
    name: "Robin Hood's Wild Forest",
    img: "/assets/Slot/RT-SLOT-223.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-223",
    platFormCode: "RT",
  },
  {
    name: "Robin Nottingham Raiders",
    img: "/assets/Slot/YGG-SLOT-069.webp?v=1767056428407",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-069",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Robin Sherwood Marauders",
    img: "/assets/Slot/YGG-SLOT-013.webp?v=1767056428338",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-013",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Roby Dick",
    img: "/assets/Slot/YGG-SLOT-378.webp?v=1767056428884",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-378",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Rock Bottom",
    img: "/assets/Slot/NLC-SLOT-062.Rock Bottom.webp?v=1764387293630",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-062",
    platFormCode: "NLC",
  },
  {
    name: "Rock Star Santa",
    img: "/assets/Slot/YGG-SLOT-231.webp?v=1767056428580",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-231",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Rock Vegas",
    img: "/assets/Slot/PP-SLOT-229.Rock Vegas.webp?v=1764326724672",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-229",
    platFormCode: "PP",
  },
  {
    name: "Rock'n'Lock",
    img: "/assets/Slot/RT-SLOT-191.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-191",
    platFormCode: "RT",
  },
  {
    name: "Rocket Blast Megaways",
    img: "/assets/Slot/PP-SLOT-369.Rocket Blast Megaways.webp?v=1764326253702",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-369",
    platFormCode: "PP",
  },
  {
    name: "Roll in Money",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-066.roll-in-money.webp?v=1765272182963",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-066",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Rolling 7",
    img: "/assets/Slot/YesBingo-SLOT-011.Rolling 7.webp?v=1765101959406",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-011",
    platFormCode: "YESBINGO",
  },
  {
    name: "Rolling Fortune",
    img: "/assets/Slot/YesBingo-SLOT-020.Rolling Fortune.webp?v=1765101894909",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-020",
    platFormCode: "YESBINGO",
  },
  {
    name: "Roma",
    img: "/assets/Slot/SG-SLOT-102.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-102",
    platFormCode: "SPADE",
  },
  {
    name: "Roma Legacy",
    img: "/assets/Slot/ape6dxf7sk35y.Roma-Legacy.webp?v=1765041951576",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-142",
    platFormCode: "JOKER",
  },
  {
    name: "Roma Plus",
    img: "/assets/Slot/ACEWIN-SLOT-011.Roma Plus.webp?v=1764854671416",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-011",
    platFormCode: "ACEWIN",
  },
  {
    name: "Roma X Deluxe",
    img: "/assets/Slot/JILI-SLOT-124.webp?v=1755510880288",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-124",
    platFormCode: "JILI",
  },
  {
    name: "RomaX",
    img: "/assets/Slot/JILI-SLOT-040.webp?v=1755509635989",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-040",
    platFormCode: "JILI",
  },
  {
    name: "Roman",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-052.roman.webp?v=1765272133787",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-052",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Roman Emperors",
    img: "/assets/Slot/RT-SLOT-326.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-326",
    platFormCode: "RT",
  },
  {
    name: "RomeandGlory",
    img: "/assets/Slot/PT-SLOT-079.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-079",
    platFormCode: "PT",
  },
  {
    name: "Rooster Blitz",
    img: "/assets/Slot/KM-SLOT-005.webp?v=1759311863679",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-005",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Rooster In Love",
    img: "/assets/Slot/JDB-SLOT-026.rooster_in_love.webp?v=1765259983229",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-026",
    platFormCode: "JDB",
  },
  {
    name: "Rooster Rumble",
    img: "/assets/Slot/PG-SLOT-097.webp?v=1765933237825",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-097",
    platFormCode: "PG",
  },
  {
    name: "Rooster's Gold: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-109.Rooster_s Gold Hold & Win.webp?v=1764935058261",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-109",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Royal Ace",
    img: "/assets/Slot/YesBingo-SLOT-022.Royal Ace.webp?v=1765101849344",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-022",
    platFormCode: "YESBINGO",
  },
  {
    name: "Royal Dragon Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-016.webp?v=1767056428342",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-016",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Royal Family",
    img: "/assets/Slot/YGG-SLOT-058.webp?v=1767056428394",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-058",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Royal Hunter",
    img: "/assets/Slot/YesBingo-SLOT-031.Royal Hunter.webp?v=1765101737066",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-031",
    platFormCode: "YESBINGO",
  },
  {
    name: "Royal Katt",
    img: "/assets/Slot/SG-SLOT-098.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-098",
    platFormCode: "SPADE",
  },
  {
    name: "Royal Mint",
    img: "/assets/Slot/BTG-SLOT-020.webp?v=1756256536941",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-020",
    platFormCode: "BTG",
  },
  {
    name: "Royal Nuts",
    img: "/assets/Slot/NETENT-SLOT-207.royal-nuts.webp?v=1764955866440",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-207",
    platFormCode: "NETENT",
  },
  {
    name: "Royal Potato",
    img: "/assets/Slot/RELAX-SLOT-099.webp?v=1761902571823",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-099",
    platFormCode: "RELAX",
  },
  {
    name: "Royal Potato 2",
    img: "/assets/Slot/RELAX-SLOT-199.webp?v=1761902599834",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-199",
    platFormCode: "RELAX",
  },
  {
    name: "Royal Ribbit",
    img: "/assets/Slot/OCTOPLAY-SLOT-036.Royal ribbit.webp?v=1764935112319",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-036",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Royale House",
    img: "/assets/Slot/SG-SLOT-105.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-105",
    platFormCode: "SPADE",
  },
  {
    name: "Royale Vegas",
    img: "/assets/Slot/SG-SLOT-140.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-140",
    platFormCode: "SPADE",
  },
  {
    name: "Rudis",
    img: "/assets/Slot/YGG-SLOT-354.webp?v=1767056428861",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-354",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Rugby World Cup",
    img: "/assets/Slot/CG-SLOT-088.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-088",
    platFormCode: "CG",
  },
  {
    name: "Rujak Bonanza",
    img: "/assets/Slot/PP-SLOT-395.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-395",
    platFormCode: "PP",
  },
  {
    name: "Rune Raiders",
    img: "/assets/Slot/OCTOPLAY-SLOT-023.rune Raiders.webp?v=1764935156935",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-023",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Runes of Battle",
    img: "/assets/Slot/YGG-SLOT-368.webp?v=1767056428876",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-368",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Running Sushi",
    img: "/assets/Slot/PP-SLOT-483.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-483",
    platFormCode: "PP",
  },
  {
    name: "STARLIGHT PRINCESS 1000",
    img: "/assets/Slot/2J-SLOT-040.STARLIGHT PRINCESS 1000.webp?v=1763547895103",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-040",
    platFormCode: "JJ",
  },
  {
    name: "SUPER ACE",
    img: "/assets/Slot/2J-SLOT-037.SUPER ACE.webp?v=1763547852211",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-037",
    platFormCode: "JJ",
  },
  {
    name: "SWEET BONANZA 1000",
    img: "/assets/Slot/2J-SLOT-041.SWEET BONANZA 1000.webp?v=1763547803612",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-041",
    platFormCode: "JJ",
  },
  {
    name: "SWORD OF KING",
    img: "/assets/Slot/FC-SLOT-053.SWORD OF KING.webp?v=1764330268022",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-053",
    platFormCode: "FC",
  },
  {
    name: "Saber",
    img: "/assets/Slot/YGG-SLOT-344.webp?v=1767056428840",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-344",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Safari Heat",
    img: "/assets/Slot/PT-SLOT-016.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-016",
    platFormCode: "PT",
  },
  {
    name: "Safari Heat",
    img: "/assets/Slot/P8-SLOT-002.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-002",
    platFormCode: "PLAY8",
  },
  {
    name: "Safari King",
    img: "/assets/Slot/PP-SLOT-091.Safari King.webp?v=1764326178564",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-091",
    platFormCode: "PP",
  },
  {
    name: "Safari Life",
    img: "/assets/Slot/xtpy4bx49xhx1.Safari-Life.webp?v=1765051265818",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-144",
    platFormCode: "JOKER",
  },
  {
    name: "Safari Life 2",
    img: "/assets/Slot/1abm3a9yh8uqq.Safari-Life-2.webp?v=1765047846324",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-194",
    platFormCode: "JOKER",
  },
  {
    name: "Safari Mystery",
    img: "/assets/Slot/JILI-SLOT-123.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-123",
    platFormCode: "JILI",
  },
  {
    name: "Safari Sun",
    img: "/assets/Slot/RELAX-SLOT-193.webp?v=1761902653369",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-193",
    platFormCode: "RELAX",
  },
  {
    name: "Safari Wilds",
    img: "/assets/Slot/PG-SLOT-122.webp?v=1765933237847",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-122",
    platFormCode: "PG",
  },
  {
    name: "Sahara Nights",
    img: "/assets/Slot/YGG-SLOT-111.webp?v=1767056428448",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-111",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Sahara Riches MegaWays: Cash Collect",
    img: "/assets/Slot/PT-SLOT-235.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-235",
    platFormCode: "PT",
  },
  {
    name: "Sahara Riches: Cash Collect",
    img: "/assets/Slot/PT-SLOT-101.Sahara Riches Cash Collect.webp?v=1764329202579",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-101",
    platFormCode: "PT",
  },
  {
    name: "Sahara Riches: Cash Collect Max",
    img: "/assets/Slot/PT-SLOT-453.webp?v=1756275771667",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-453",
    platFormCode: "PT",
  },
  {
    name: "Sails of Fortune",
    img: "/assets/Slot/RELAX-SLOT-053.webp?v=1761902737399",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-053",
    platFormCode: "RELAX",
  },
  {
    name: "Sakura Fortune",
    img: "/assets/Slot/PT-SLOT-241.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-241",
    platFormCode: "PT",
  },
  {
    name: "Sakura Masks",
    img: "/assets/Slot/RT-SLOT-283.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-283",
    platFormCode: "RT",
  },
  {
    name: "Salmon King",
    img: "/assets/Slot/OCTOPLAY-SLOT-016.Salmon King.webp?v=1764935204368",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-016",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Salsa Fury",
    img: "/assets/Slot/KM-SLOT-021.Salsa Fury.webp?v=1764780014747",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-021",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Samba",
    img: "/assets/Slot/JILI-SLOT-070.webp?v=1755509882324",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-070",
    platFormCode: "JILI",
  },
  {
    name: "Samurai Code",
    img: "/assets/Slot/PP-SLOT-475.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-475",
    platFormCode: "PP",
  },
  {
    name: "San Quentin 2: Death Row",
    img: "/assets/Slot/NLC-SLOT-096.San Quentin 2_ Death Row.webp?v=1764387204688",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-096",
    platFormCode: "NLC",
  },
  {
    name: "San Quentin xWays",
    img: "/assets/Slot/NLC-SLOT-030.San Quentin xWays.webp?v=1764387146554",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-030",
    platFormCode: "NLC",
  },
  {
    name: "Sanctuary",
    img: "/assets/Slot/BTG-SLOT-039.webp?v=1756256536955",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-039",
    platFormCode: "BTG",
  },
  {
    name: "SangoWarlord",
    img: "/assets/Slot/P8-SLOT-034.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-034",
    platFormCode: "PLAY8",
  },
  {
    name: "Santa",
    img: "/assets/Slot/PP-SLOT-115.Santa.webp?v=1764326096250",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-115",
    platFormCode: "PP",
  },
  {
    name: "Santa Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-035.Santa Smash.webp?v=1764935261528",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-035",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Santa Spins",
    img: "/assets/Slot/RT-SLOT-106.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-106",
    platFormCode: "RT",
  },
  {
    name: "Santa Surprise",
    img: "/assets/Slot/PT-SLOT-056.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-056",
    platFormCode: "PT",
  },
  {
    name: "Santa Wild Drop",
    img: "/assets/Slot/SG-SLOT-151.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-151",
    platFormCode: "SPADE",
  },
  {
    name: "Santa's Great Gifts",
    img: "/assets/Slot/PP-SLOT-295.Santa_s Great Gifts.webp?v=1764326044876",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-295",
    platFormCode: "PP",
  },
  {
    name: "Santa's Stack",
    img: "/assets/Slot/RELAX-SLOT-095.webp?v=1761902854470",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-095",
    platFormCode: "RELAX",
  },
  {
    name: "Santa's Wonderland",
    img: "/assets/Slot/PP-SLOT-210.Santa_s Wonderland.webp?v=1764325984853",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-210",
    platFormCode: "PP",
  },
  {
    name: "Santas Gift Rush",
    img: "/assets/Slot/PG-SLOT-021.webp?v=1765933237766",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-021",
    platFormCode: "PG",
  },
  {
    name: "Santa’s Slay",
    img: "/assets/Slot/PP-SLOT-660.Santa’s Slay.webp?v=1764662968751",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-660",
    platFormCode: "PP",
  },
  {
    name: "Savage Frontier",
    img: "/assets/Slot/es9sgctugyauc.Savage Frontier.webp?v=1765049085784",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-224",
    platFormCode: "JOKER",
  },
  {
    name: "Savage Jungle",
    img: "/assets/Slot/PT-SLOT-220.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-220",
    platFormCode: "PT",
  },
  {
    name: "Savannah Gold: Coin of the Wild",
    img: "/assets/Slot/OCTOPLAY-SLOT-102.Savannah Gold Coin of the Wild.webp?v=1764935286211",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-102",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Savannah Legend",
    img: "/assets/Slot/PP-SLOT-542.Savannah Legend.webp?v=1764325652399",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-542",
    platFormCode: "PP",
  },
  {
    name: "Savannah Pride",
    img: "/assets/Slot/RT-SLOT-328.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-328",
    platFormCode: "RT",
  },
  {
    name: "Scara-Bucks",
    img: "/assets/Slot/YGG-SLOT-409.webp?v=1767056428918",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-409",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Scarab",
    img: "/assets/Slot/CG-SLOT-089.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-089",
    platFormCode: "CG",
  },
  {
    name: "Scatter Monsters",
    img: "/assets/Slot/PT-SLOT-463.Scatter Monsters.webp?v=1764326355085",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-463",
    platFormCode: "PT",
  },
  {
    name: "Scheherazade",
    img: "/assets/Slot/mur8wje4dccb1.SCHEHERAZA.webp?v=1765050898477",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-147",
    platFormCode: "JOKER",
  },
  {
    name: "Scudamore's Super Stakes",
    img: "/assets/Slot/NETENT-SLOT-101.Scudamore_s-Super-Stake.webp?v=1764955739902",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-101",
    platFormCode: "NETENT",
  },
  {
    name: "Sea Boat Adventure",
    img: "/assets/Slot/RT-SLOT-252.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-252",
    platFormCode: "RT",
  },
  {
    name: "Sea Captain",
    img: "/assets/Slot/P8-SLOT-014.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-014",
    platFormCode: "PLAY8",
  },
  {
    name: "Sea Fantasy",
    img: "/assets/Slot/PP-SLOT-419.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-419",
    platFormCode: "PP",
  },
  {
    name: "Seamen",
    img: "/assets/Slot/NLC-SLOT-116.Seamen.webp?v=1764387074068",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-116",
    platFormCode: "NLC",
  },
  {
    name: "Seasons",
    img: "/assets/Slot/YGG-SLOT-024.webp?v=1767056428351",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-024",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Secret City Gold",
    img: "/assets/Slot/PP-SLOT-316.Secret City Gold.webp?v=1764325586295",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-316",
    platFormCode: "PP",
  },
  {
    name: "Secret Riches of the Irish",
    img: "/assets/Slot/YGG-SLOT-265.webp?v=1767056428773",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-265",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Secret Treasure",
    img: "/assets/Slot/JILI-SLOT-039.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-039",
    platFormCode: "JILI",
  },
  {
    name: "Secret of Anubis DoubleMax",
    img: "/assets/Slot/YGG-SLOT-232.webp?v=1767056428582",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-232",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Secret of Cleopatra",
    img: "/assets/Slot/PG-SLOT-061.webp?v=1765933237797",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-061",
    platFormCode: "PG",
  },
  {
    name: "Secrets of Anubis",
    img: "/assets/Slot/SG-SLOT-144.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-144",
    platFormCode: "SPADE",
  },
  {
    name: "Secrets of the Amazon",
    img: "/assets/Slot/PT-SLOT-054.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-054",
    platFormCode: "PT",
  },
  {
    name: "Serendipity",
    img: "/assets/Slot/YGG-SLOT-122.webp?v=1767056428460",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-122",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Serial",
    img: "/assets/Slot/NLC-SLOT-004.Serial.webp?v=1764387035138",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-004",
    platFormCode: "NLC",
  },
  {
    name: "Serpent King",
    img: "/assets/Slot/RT-SLOT-348.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-348",
    platFormCode: "RT",
  },
  {
    name: "Serpent Shrine",
    img: "/assets/Slot/RELAX-SLOT-076.webp?v=1761902885817",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-076",
    platFormCode: "RELAX",
  },
  {
    name: "Seven Lucky God",
    img: "/assets/Slot/CG-SLOT-050.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-050",
    platFormCode: "CG",
  },
  {
    name: "Seven Seas",
    img: "/assets/Slot/mno8hejgrh1nk.Seven-Seas.webp?v=1765054648693",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-226",
    platFormCode: "JOKER",
  },
  {
    name: "SevenSevenSeven",
    img: "/assets/Slot/JILI-SLOT-013.SevenSevenSeven.webp?v=1764311390508",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-013",
    platFormCode: "JILI",
  },
  {
    name: "Sexy Joker",
    img: "/assets/Slot/YesBingo-SLOT-044.Sexy Joker.webp?v=1765101662613",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-044",
    platFormCode: "YESBINGO",
  },
  {
    name: "Sexy Vegas",
    img: "/assets/Slot/SG-SLOT-103.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-103",
    platFormCode: "SPADE",
  },
  {
    name: "Shadow Raiders MultiMax",
    img: "/assets/Slot/YGG-SLOT-190.webp?v=1767056428528",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-190",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Shadow Society",
    img: "/assets/Slot/RT-SLOT-225.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-225",
    platFormCode: "RT",
  },
  {
    name: "Shadow Summoner Elementals",
    img: "/assets/Slot/RELAX-SLOT-255.webp?v=1761902910067",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-255",
    platFormCode: "RELAX",
  },
  {
    name: "Shah Mat",
    img: "/assets/Slot/RT-SLOT-128.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-128",
    platFormCode: "RT",
  },
  {
    name: "Shaker Club",
    img: "/assets/Slot/YGG-SLOT-210.webp?v=1767056428558",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-210",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Shamrock Money Pot 10K Ways",
    img: "/assets/Slot/RELAX-SLOT-132.webp?v=1761902942186",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-132",
    platFormCode: "RELAX",
  },
  {
    name: "Shanghai Beauty",
    img: "/assets/Slot/JILI-SLOT-008.webp?v=1755509061892",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-008",
    platFormCode: "JILI",
  },
  {
    name: "Shaolin",
    img: "/assets/Slot/pd6rhresnhkbk.Shaolin.webp?v=1765045859779",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-148",
    platFormCode: "JOKER",
  },
  {
    name: "Shaolin Panda Chaos Reels",
    img: "/assets/Slot/OCTOPLAY-SLOT-045.Shaolin Panda Chaos reels.webp?v=1764935335988",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-045",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Shaolin Panda: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-101.Shaolin Panda Hold & Win.webp?v=1764935353894",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-101",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Shaolin Soccer",
    img: "/assets/Slot/PG-SLOT-046.webp?v=1765933237787",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-046",
    platFormCode: "PG",
  },
  {
    name: "Shark Bait",
    img: "/assets/Slot/YGG-SLOT-329.webp?v=1767056428829",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-329",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Shark Bounty",
    img: "/assets/Slot/PG-SLOT-142.webp?v=1765933237868",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-142",
    platFormCode: "PG",
  },
  {
    name: "Shark Wash",
    img: "/assets/Slot/RELAX-SLOT-183.webp?v=1761902973666",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-183",
    platFormCode: "RELAX",
  },
  {
    name: "Sheep Gone Wild",
    img: "/assets/Slot/RT-SLOT-239.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-239",
    platFormCode: "RT",
  },
  {
    name: "Sheep King",
    img: "/assets/Slot/OCTOPLAY-SLOT-022.Sheep King.webp?v=1764935399515",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-022",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Sherlock Bones",
    img: "/assets/Slot/RELAX-SLOT-072.webp?v=1761903001610",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-072",
    platFormCode: "RELAX",
  },
  {
    name: "Shield of Sparta",
    img: "/assets/Slot/PP-SLOT-302.Shield of Sparta.webp?v=1764325533401",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-302",
    platFormCode: "PP",
  },
  {
    name: "Shining Hot 100",
    img: "/assets/Slot/PP-SLOT-267.Shining Hot 100.webp?v=1764325481426",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-267",
    platFormCode: "PP",
  },
  {
    name: "Shining Hot 20",
    img: "/assets/Slot/PP-SLOT-269.Shining Hot 20.webp?v=1764325428308",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-269",
    platFormCode: "PP",
  },
  {
    name: "Shining Hot 40",
    img: "/assets/Slot/PP-SLOT-268.Shining Hot 40.webp?v=1764325342186",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-268",
    platFormCode: "PP",
  },
  {
    name: "Shining Hot 5",
    img: "/assets/Slot/PP-SLOT-270.Shining Hot 5.webp?v=1764324994758",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-270",
    platFormCode: "PP",
  },
  {
    name: "Shinobi Spirit",
    img: "/assets/Slot/RELAX-SLOT-188.webp?v=1761903033099",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-188",
    platFormCode: "RELAX",
  },
  {
    name: "Shipwrecked",
    img: "/assets/Slot/YGG-SLOT-294.webp?v=1767056428797",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-294",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Show Me The Honey",
    img: "/assets/Slot/YGG-SLOT-309.webp?v=1767056428810",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-309",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Shōgun",
    img: "/assets/Slot/JILI-SLOT-110.webp?v=1755510707688",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-110",
    platFormCode: "JILI",
  },
  {
    name: "Si Xiang",
    img: "/assets/Slot/PT-SLOT-040.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-040",
    platFormCode: "PT",
  },
  {
    name: "Sidewinder DoubleMax",
    img: "/assets/Slot/YGG-SLOT-236.webp?v=1767056428589",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-236",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Silent Samurai",
    img: "/assets/Slot/PT-SLOT-138.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-138",
    platFormCode: "PT",
  },
  {
    name: "Silent Samurai",
    img: "/assets/Slot/P8-SLOT-009.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-009",
    platFormCode: "PLAY8",
  },
  {
    name: "Silent Samurai: Mega cash collect",
    img: "/assets/Slot/PT-SLOT-270.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-270",
    platFormCode: "PT",
  },
  {
    name: "Silver Bullet",
    img: "/assets/Slot/PT-SLOT-135.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-135",
    platFormCode: "PT",
  },
  {
    name: "Silver Bullet Bandit: Cash Collect",
    img: "/assets/Slot/PT-SLOT-107.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-107",
    platFormCode: "PT",
  },
  {
    name: "Silver Hand",
    img: "/assets/Slot/htacf8c11qejn.Silver-Hand.webp?v=1765050734106",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-199",
    platFormCode: "JOKER",
  },
  {
    name: "Silver's Gold PowerLinks",
    img: "/assets/Slot/YGG-SLOT-293.webp?v=1767056428796",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-293",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "SilverBullet Progressive",
    img: "/assets/Slot/ruufkzk1kpefn.SilverBullet-Progressive.webp?v=1765048157426",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-150",
    platFormCode: "JOKER",
  },
  {
    name: "Sin City",
    img: "/assets/Slot/JILI-SLOT-089.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-089",
    platFormCode: "JILI",
  },
  {
    name: "Sinbad's Golden Voyage",
    img: "/assets/Slot/PT-SLOT-081.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-081",
    platFormCode: "PT",
  },
  {
    name: "Siren's Riches",
    img: "/assets/Slot/RT-SLOT-271.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-271",
    platFormCode: "RT",
  },
  {
    name: "Six Lions",
    img: "/assets/Slot/CG-SLOT-052.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-052",
    platFormCode: "CG",
  },
  {
    name: "Sizzling Hot",
    img: "/assets/Slot/ww3a8wsu4de7c.Sizzling-Hot.webp?v=1765037633224",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-151",
    platFormCode: "JOKER",
  },
  {
    name: "Skate or Die",
    img: "/assets/Slot/NLC-SLOT-095.Skate or Die.webp?v=1764386984614",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-095",
    platFormCode: "NLC",
  },
  {
    name: "Sky Queen",
    img: "/assets/Slot/PT-SLOT-007.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-007",
    platFormCode: "PT",
  },
  {
    name: "Skylantis 2",
    img: "/assets/Slot/YGG-SLOT-243.webp?v=1767056428594",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-243",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Skylight Wonders",
    img: "/assets/Slot/PG-SLOT-166.webp?v=1765933237889",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-166",
    platFormCode: "PG",
  },
  {
    name: "Slam Dunk",
    img: "/assets/Slot/CG-SLOT-098.Slam Dunk.webp?v=1764666733017",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-098",
    platFormCode: "CG",
  },
  {
    name: "Sleeping Dragon",
    img: "/assets/Slot/PP-SLOT-564.Sleeping Dragon.webp?v=1764324936267",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-564",
    platFormCode: "PP",
  },
  {
    name: "Sloth Tumble",
    img: "/assets/Slot/RELAX-SLOT-189.webp?v=1761903057813",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-189",
    platFormCode: "RELAX",
  },
  {
    name: "Smugglers Cove",
    img: "/assets/Slot/PP-SLOT-222.Smugglers Cove.webp?v=1764324881330",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-222",
    platFormCode: "PP",
  },
  {
    name: "Snake Arena",
    img: "/assets/Slot/RELAX-SLOT-044.webp?v=1761903080190",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-044",
    platFormCode: "RELAX",
  },
  {
    name: "Snake Of Fortune",
    img: "/assets/Slot/q1gfrdenycyyn.Snake Of Fortune.webp?v=1765048554042",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-211",
    platFormCode: "JOKER",
  },
  {
    name: "Snakes & Ladders - Snake Eyes",
    img: "/assets/Slot/PP-SLOT-285.Snakes & Ladders - Snake Eyes.webp?v=1764324826945",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-285",
    platFormCode: "PP",
  },
  {
    name: "Snakes Gold",
    img: "/assets/Slot/RELAX-SLOT-205.webp?v=1761903141402",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-205",
    platFormCode: "RELAX",
  },
  {
    name: "Snakes and Ladders Megadice",
    img: "/assets/Slot/PP-SLOT-246.Snakes and Ladders Megadice.webp?v=1764324766903",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-246",
    platFormCode: "PP",
  },
  {
    name: "Songkran Splash",
    img: "/assets/Slot/PG-SLOT-116.webp?v=1765933237842",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-116",
    platFormCode: "PG",
  },
  {
    name: "Sorcerer's Guild of Magic",
    img: "/assets/Slot/PT-SLOT-154.sorcerer_s-guild-of-magic.webp?v=1764330813986",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-154",
    platFormCode: "PT",
  },
  {
    name: "Sour Candy",
    img: "/assets/Slot/wixa8wsu4de7c.Sour-Candy.webp?v=1765054234871",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-195",
    platFormCode: "JOKER",
  },
  {
    name: "Space Conquest",
    img: "/assets/Slot/SG-SLOT-110.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-110",
    platFormCode: "SPADE",
  },
  {
    name: "Space Donkey",
    img: "/assets/Slot/NLC-SLOT-085.Space Donkey.webp?v=1764386931639",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-085",
    platFormCode: "NLC",
  },
  {
    name: "Space Miners",
    img: "/assets/Slot/RELAX-SLOT-105.webp?v=1761903170533",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-105",
    platFormCode: "RELAX",
  },
  {
    name: "Space Wars Megaways XXXtreme",
    img: "/assets/Slot/NETENT-SLOT-211.Space-Wars-Megaways-XXXTREME.webp?v=1764955158671",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-211",
    platFormCode: "NETENT",
  },
  {
    name: "Sparks",
    img: "/assets/Slot/NETENT-SLOT-167.Sparks.webp?v=1764955043464",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-167",
    platFormCode: "NETENT",
  },
  {
    name: "Spartacus 10K Ways",
    img: "/assets/Slot/YGG-SLOT-317.webp?v=1767056428817",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-317",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Spartan King",
    img: "/assets/Slot/PP-SLOT-017.Spartan King.webp?v=1764324717782",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-017",
    platFormCode: "PP",
  },
  {
    name: "Spartan Wildz",
    img: "/assets/Slot/RT-SLOT-370.Spartan Wildz.webp?v=1765033831478",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-370",
    platFormCode: "RT",
  },
  {
    name: "Special Chef",
    img: "/assets/Slot/CG-SLOT-035.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-035",
    platFormCode: "CG",
  },
  {
    name: "Speed Freaks",
    img: "/assets/Slot/YGG-SLOT-386.webp?v=1767056428891",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-386",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Speed Racing",
    img: "/assets/Slot/CG-SLOT-032.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-032",
    platFormCode: "CG",
  },
  {
    name: "Speed Winner",
    img: "/assets/Slot/PG-SLOT-102.webp?v=1765933237830",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-102",
    platFormCode: "PG",
  },
  {
    name: "Spell Master",
    img: "/assets/Slot/PP-SLOT-589.Spell Master.webp?v=1764324667538",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-589",
    platFormCode: "PP",
  },
  {
    name: "Spellbinding Mystery",
    img: "/assets/Slot/PP-SLOT-363.Spellbinding Mystery.webp?v=1764324615635",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-363",
    platFormCode: "PP",
  },
  {
    name: "Spellcast",
    img: "/assets/Slot/NETENT-SLOT-138.Spellcast.webp?v=1764955005712",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-138",
    platFormCode: "NETENT",
  },
  {
    name: "Sphere Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-041.Sphere smash.webp?v=1764935454527",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-041",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Spicy Meatballs",
    img: "/assets/Slot/BTG-SLOT-043.webp?v=1756256536958",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-043",
    platFormCode: "BTG",
  },
  {
    name: "Spin & Score Megaways",
    img: "/assets/Slot/PP-SLOT-290.Spin & Score Megaways.webp?v=1764324537575",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-290",
    platFormCode: "PP",
  },
  {
    name: "Spin of Fate",
    img: "/assets/Slot/ACEWIN-SLOT-007.Spin of Fate.webp?v=1764854700633",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-007",
    platFormCode: "ACEWIN",
  },
  {
    name: "Spina Colada",
    img: "/assets/Slot/YGG-SLOT-074.webp?v=1767056428413",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-074",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Spinata Grande",
    img: "/assets/Slot/NETENT-SLOT-104.Spinata-Grande.webp?v=1764954949863",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-104",
    platFormCode: "NETENT",
  },
  {
    name: "Spindrift",
    img: "/assets/Slot/JDB-SLOT-089.Spindrift 2.webp?v=1767691427130",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-089",
    platFormCode: "JDB",
  },
  {
    name: "Spindrift 2",
    img: "/assets/Slot/JDB-SLOT-090.spindrift_2.webp?v=1767691436175",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-090",
    platFormCode: "JDB",
  },
  {
    name: "Spinions Game Day",
    img: "/assets/Slot/PT-SLOT-462.Spinions Game Day.webp?v=1764326388136",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-462",
    platFormCode: "PT",
  },
  {
    name: "Spirit Blast",
    img: "/assets/Slot/OCTOPLAY-SLOT-017.spirit blast.webp?v=1764935498116",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-017",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Spirit of Adventure",
    img: "/assets/Slot/PP-SLOT-234.Spirit of Adventure.webp?v=1764324487714",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-234",
    platFormCode: "PP",
  },
  {
    name: "Spirit of The Beast",
    img: "/assets/Slot/RELAX-SLOT-056.webp?v=1761903198378",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-056",
    platFormCode: "RELAX",
  },
  {
    name: "Spirited Wonders",
    img: "/assets/Slot/PG-SLOT-087.webp?v=1765933237818",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-087",
    platFormCode: "PG",
  },
  {
    name: "Splendour Forest",
    img: "/assets/Slot/RELAX-SLOT-084.webp?v=1761903223893",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-084",
    platFormCode: "RELAX",
  },
  {
    name: "Spooky Carnival",
    img: "/assets/Slot/RT-SLOT-272.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-272",
    platFormCode: "RT",
  },
  {
    name: "St Louis 1904",
    img: "/assets/Slot/RELAX-SLOT-254.webp?v=1761903256315",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-254",
    platFormCode: "RELAX",
  },
  {
    name: "Stallion Strike",
    img: "/assets/Slot/PT-SLOT-200.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-200",
    platFormCode: "PT",
  },
  {
    name: "Stampede Rush Trident",
    img: "/assets/Slot/PT-SLOT-427.stampede-rush-trident.webp?v=1764332989353",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-427",
    platFormCode: "PT",
  },
  {
    name: "Star Bounty",
    img: "/assets/Slot/PP-SLOT-029.Star Bounty.webp?v=1764324270811",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-029",
    platFormCode: "PP",
  },
  {
    name: "Star Clusters",
    img: "/assets/Slot/BTG-SLOT-025.webp?v=1756256536945",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-025",
    platFormCode: "BTG",
  },
  {
    name: "Star Clusters 2",
    img: "/assets/Slot/BTG-SLOT-068.webp?v=1757921611296",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-068",
    platFormCode: "BTG",
  },
  {
    name: "Star Kingdom",
    img: "/assets/Slot/OCTOPLAY-SLOT-018.Star Kingdom.webp?v=1764935541742",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-018",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Star Pirates Code",
    img: "/assets/Slot/PP-SLOT-207.Star Pirates Code.webp?v=1764324027785",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-207",
    platFormCode: "PP",
  },
  {
    name: "Star Pops",
    img: "/assets/Slot/RELAX-SLOT-102.webp?v=1761903279983",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-102",
    platFormCode: "RELAX",
  },
  {
    name: "Starburst Galaxy",
    img: "/assets/Slot/NETENT-SLOT-220.Starburst-Galaxy.webp?v=1764954875741",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-220",
    platFormCode: "NETENT",
  },
  {
    name: "Starburst™ XXXtreme",
    img: "/assets/Slot/NETENT-SLOT-017.Starburst-XXXtreme.webp?v=1764954790743",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-017",
    platFormCode: "NETENT",
  },
  {
    name: "Starfire Fortunes Tophit",
    img: "/assets/Slot/YGG-SLOT-203.webp?v=1767056428553",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-203",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Starlight Archer 1000",
    img: "/assets/Slot/PP-SLOT-658.webp?v=1770095329095",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-658",
    platFormCode: "PP",
  },
  {
    name: "Starlight Christmas",
    img: "/assets/Slot/PP-SLOT-297.Starlight Christmas.webp?v=1764323979076",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-297",
    platFormCode: "PP",
  },
  {
    name: "Starlight Princess",
    img: "/assets/Slot/PP-SLOT-189.Starlight Princess.webp?v=1764323817551",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-189",
    platFormCode: "PP",
  },
  {
    name: "Starlight Princess 1000",
    img: "/assets/Slot/PP-SLOT-364.Starlight Princess 1000.webp?v=1764323760961",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-364",
    platFormCode: "PP",
  },
  {
    name: "Starlight Princess Pachi",
    img: "/assets/Slot/PP-SLOT-463.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-463",
    platFormCode: "PP",
  },
  {
    name: "Starlight Princess Super Scatter",
    img: "/assets/Slot/PP-SLOT-610.Starlight Princess Super Scatter.webp?v=1764323695636",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-610",
    platFormCode: "PP",
  },
  {
    name: "Starlight Wins",
    img: "/assets/Slot/PP-SLOT-624.Starlight Wins.webp?v=1764323661477",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-624",
    platFormCode: "PP",
  },
  {
    name: "Starmada Exiles",
    img: "/assets/Slot/PT-SLOT-227.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-227",
    platFormCode: "PT",
  },
  {
    name: "Starstruck",
    img: "/assets/Slot/NLC-SLOT-050.Starstruck.webp?v=1764386884106",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-050",
    platFormCode: "NLC",
  },
  {
    name: "Starz Megaways",
    img: "/assets/Slot/PP-SLOT-045.Starz Megaways.webp?v=1764323626226",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-045",
    platFormCode: "PP",
  },
  {
    name: "Sticky Bandits Thunder Rail",
    img: "/assets/Slot/PT-SLOT-434.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-434",
    platFormCode: "PT",
  },
  {
    name: "Sticky Bees",
    img: "/assets/Slot/PP-SLOT-348.Sticky Bees.webp?v=1764323577839",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-348",
    platFormCode: "PP",
  },
  {
    name: "Stockholm Syndrome",
    img: "/assets/Slot/NLC-SLOT-094.Stockholm Syndrome.webp?v=1764386831909",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-094",
    platFormCode: "NLC",
  },
  {
    name: "Stolen Treasures",
    img: "/assets/Slot/RT-SLOT-224.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-224",
    platFormCode: "RT",
  },
  {
    name: "Stone Hominid",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-030.stone-hominid.webp?v=1765272089064",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-030",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Strawberry Cocktail",
    img: "/assets/Slot/PP-SLOT-433.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-433",
    platFormCode: "PP",
  },
  {
    name: "Street Fighter™ II: The World Warrior Slot",
    img: "/assets/Slot/NETENT-SLOT-038.Street-Fighter-II.webp?v=1764954675780",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-038",
    platFormCode: "NETENT",
  },
  {
    name: "Street Ninja",
    img: "/assets/Slot/YGG-SLOT-341.webp?v=1767056428838",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-341",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Street Racer",
    img: "/assets/Slot/PP-SLOT-038.Street Racer.webp?v=1764323493082",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-038",
    platFormCode: "PP",
  },
  {
    name: "Streets Of Chicago",
    img: "/assets/Slot/h33c3rho1gmjq.Streets-Of-Chicago.webp?v=1765044349576",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-153",
    platFormCode: "JOKER",
  },
  {
    name: "Striking Hot 5",
    img: "/assets/Slot/PP-SLOT-286.Striking Hot 5.webp?v=1764323446179",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-286",
    platFormCode: "PP",
  },
  {
    name: "Sugar Blast",
    img: "/assets/Slot/KM-SLOT-001.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-001",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Sugar Blast Frenzy",
    img: "/assets/Slot/KM-SLOT-003.webp?v=1759311853103",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-003",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Sugar Bomb 2 MultiBoost",
    img: "/assets/Slot/YGG-SLOT-338.webp?v=1767056428836",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-338",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Sugar Bomb MultiBoost",
    img: "/assets/Slot/YGG-SLOT-250.webp?v=1767056428753",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-250",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Sugar Bonanza",
    img: "/assets/Slot/SG-SLOT-092.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-092",
    platFormCode: "SPADE",
  },
  {
    name: "Sugar Crush",
    img: "/assets/Slot/YesBingo-SLOT-027.Sugar Crush.webp?v=1765101587926",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-027",
    platFormCode: "YESBINGO",
  },
  {
    name: "Sugar Monster",
    img: "/assets/Slot/RT-SLOT-267.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-267",
    platFormCode: "RT",
  },
  {
    name: "Sugar Party",
    img: "/assets/Slot/SG-SLOT-115.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-115",
    platFormCode: "SPADE",
  },
  {
    name: "Sugar Rush",
    img: "/assets/Slot/PP-SLOT-245.Sugar Rush.webp?v=1764323391940",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-245",
    platFormCode: "PP",
  },
  {
    name: "Sugar Rush 1000",
    img: "/assets/Slot/PP-SLOT-443.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-443",
    platFormCode: "PP",
  },
  {
    name: "Sugar Rush Xmas",
    img: "/assets/Slot/PP-SLOT-403.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-403",
    platFormCode: "PP",
  },
  {
    name: "Sugar Splash",
    img: "/assets/Slot/OCTOPLAY-SLOT-070.suger splash.webp?v=1764935582372",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-070",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Sugar Supreme Powernudge",
    img: "/assets/Slot/PP-SLOT-397.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-397",
    platFormCode: "PP",
  },
  {
    name: "Sultan Spins",
    img: "/assets/Slot/RELAX-SLOT-229.webp?v=1761903302652",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-229",
    platFormCode: "RELAX",
  },
  {
    name: "Sumo Spins",
    img: "/assets/Slot/RT-SLOT-071.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-071",
    platFormCode: "RT",
  },
  {
    name: "Sumo Supreme Megaways",
    img: "/assets/Slot/PP-SLOT-480.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-480",
    platFormCode: "PP",
  },
  {
    name: "Sun Quest",
    img: "/assets/Slot/CG-SLOT-044.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-044",
    platFormCode: "CG",
  },
  {
    name: "Suncatcher Gigablox",
    img: "/assets/Slot/YGG-SLOT-053.webp?v=1767056428385",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-053",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Sunny Shores",
    img: "/assets/Slot/YGG-SLOT-098.webp?v=1767056428438",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-098",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Super 7s",
    img: "/assets/Slot/PP-SLOT-060.Super 7s.webp?v=1764322372309",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-060",
    platFormCode: "PP",
  },
  {
    name: "Super Ace Joker",
    img: "/assets/Slot/JILI-SLOT-118.webp?v=1755510853560",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-118",
    platFormCode: "JILI",
  },
  {
    name: "Super AceWin",
    img: "/assets/Slot/ACEWIN-SLOT-008.Super Ace Win.webp?v=1764854849943",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-008",
    platFormCode: "ACEWIN",
  },
  {
    name: "Super Boost",
    img: "/assets/Slot/RELAX-SLOT-071.webp?v=1761903328994",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-071",
    platFormCode: "RELAX",
  },
  {
    name: "Super Cash Drop Giga Blox",
    img: "/assets/Slot/YGG-SLOT-131.webp?v=1767056428467",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-131",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Super Cash: Three Little Wins",
    img: "/assets/Slot/OCTOPLAY-SLOT-112.Super Cash Three Little Wins.webp?v=1764935598397",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-112",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Super Crown 40",
    img: "/assets/Slot/YGG-SLOT-324.webp?v=1767056428825",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-324",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Super Egypt",
    img: "/assets/Slot/YesBingo-SLOT-025.Super Egypt.webp?v=1765101542912",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-025",
    platFormCode: "YESBINGO",
  },
  {
    name: "Super Fortune Crown",
    img: "/assets/Slot/r8poqz19mtqir.Super Fortune Crown.webp?v=1765053641600",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-236",
    platFormCode: "JOKER",
  },
  {
    name: "Super Golf Drive",
    img: "/assets/Slot/PG-SLOT-118.webp?v=1765933237844",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-118",
    platFormCode: "PG",
  },
  {
    name: "Super Grand Link Express: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-096.Super Grand Link Express Hold & Win.webp?v=1764935616486",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-096",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Super Gummy Strike",
    img: "/assets/Slot/PP-SLOT-659.webp?v=1765433889444",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-659",
    platFormCode: "PP",
  },
  {
    name: "Super Hoo Hey How",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-076.super-hoo-hey-how.webp?v=1765272040241",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-076",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Super JOKER",
    img: "/assets/Slot/PP-SLOT-071.Super JOKER.webp?v=1764322321008",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-071",
    platFormCode: "PP",
  },
  {
    name: "Super Niubi",
    img: "/assets/Slot/JDB-SLOT-070.Super Niubi.webp?v=1765259604212",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-070",
    platFormCode: "JDB",
  },
  {
    name: "Super Niubi Deluxe",
    img: "/assets/Slot/SlotSuperNiubi.SUPER NIUBU DELUXE.webp?v=1764774780412",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-077",
    platFormCode: "JDB",
  },
  {
    name: "Super Niubi Deluxe",
    img: "/assets/Slot/JDB-SLOT-077.super_niubi_deluxe.webp?v=1765259466514",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-077",
    platFormCode: "JDB",
  },
  {
    name: "Super Rich",
    img: "/assets/Slot/JILI-SLOT-041.webp?v=1755509521282",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-041",
    platFormCode: "JILI",
  },
  {
    name: "Super Seven Seas",
    img: "/assets/Slot/x4dkj69a989x6.Super Seven Seas.webp?v=1765046520727",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-233",
    platFormCode: "JOKER",
  },
  {
    name: "Super Stars",
    img: "/assets/Slot/b5ggg45epfzg6.Super-Stars.webp?v=1765047902823",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-154",
    platFormCode: "JOKER",
  },
  {
    name: "Super Sundae",
    img: "/assets/Slot/OCTOPLAY-SLOT-020.Super Sundae.webp?v=1764935656694",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-020",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Super Wild Watermelon",
    img: "/assets/Slot/9adne65axf986.Super Wild Watermelon.webp?v=1765035697591",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-223",
    platFormCode: "JOKER",
  },
  {
    name: "Super X",
    img: "/assets/Slot/PP-SLOT-218.Super X.webp?v=1764322273187",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-218",
    platFormCode: "PP",
  },
  {
    name: "SuperCash Drop",
    img: "/assets/Slot/YGG-SLOT-256.webp?v=1767056428763",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-256",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Supermarket Spree",
    img: "/assets/Slot/PG-SLOT-084.webp?v=1765933237814",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-084",
    platFormCode: "PG",
  },
  {
    name: "Supersonic Express: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-095.Supersonic Express Hold & Win.webp?v=1764935820760",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-095",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Superstars",
    img: "/assets/Slot/NETENT-SLOT-131.superstars.webp?v=1764954474202",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-131",
    platFormCode: "NETENT",
  },
  {
    name: "Supreme Caishen",
    img: "/assets/Slot/byz81hmsq748k.Supreme-Caishen.webp?v=1765054394194",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-155",
    platFormCode: "JOKER",
  },
  {
    name: "Sweet Bonanza",
    img: "/assets/Slot/PP-SLOT-082.Sweet-Bonanza.webp?v=1764322216438",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-082",
    platFormCode: "PP",
  },
  {
    name: "Sweet Bonanza 1000",
    img: "/assets/Slot/PP-SLOT-464.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-464",
    platFormCode: "PP",
  },
  {
    name: "Sweet Bonanza Dice",
    img: "/assets/Slot/PP-SLOT-388.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-388",
    platFormCode: "PP",
  },
  {
    name: "Sweet Bonanza Xmas",
    img: "/assets/Slot/PP-SLOT-067.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-067",
    platFormCode: "PP",
  },
  {
    name: "Sweet Kingdom",
    img: "/assets/Slot/PP-SLOT-473.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-473",
    platFormCode: "PP",
  },
  {
    name: "Sweet Land",
    img: "/assets/Slot/JILI-SLOT-079.webp?v=1755510114344",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-079",
    platFormCode: "JILI",
  },
  {
    name: "Sweet Magic",
    img: "/assets/Slot/JILI-SLOT-150.Sweet Magic.webp?v=1764311488694",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-150",
    platFormCode: "JILI",
  },
  {
    name: "Sweet Powernudge",
    img: "/assets/Slot/PP-SLOT-310.Sweet-Powernudge.webp?v=1764321833332",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-310",
    platFormCode: "PP",
  },
  {
    name: "Sweet Rush Bonanza",
    img: "/assets/Slot/PP-SLOT-601.Sweet Rush Bonanza.webp?v=1764321676782",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-601",
    platFormCode: "PP",
  },
  {
    name: "Sweet Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-028.Sweet Smash.webp?v=1764935863584",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-028",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Sweet Tooth",
    img: "/assets/Slot/ynknc6m6x7684.Sweet-Tooth.webp?v=1765044750767",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-190",
    platFormCode: "JOKER",
  },
  {
    name: "Sweet n' Juicy",
    img: "/assets/Slot/PT-SLOT-356.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-356",
    platFormCode: "PT",
  },
  {
    name: "Sweetie Crush",
    img: "/assets/Slot/bqc117dipjiso.Sweetie-Crush.webp?v=1765053947100",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-198",
    platFormCode: "JOKER",
  },
  {
    name: "Sweetopia Royale",
    img: "/assets/Slot/RELAX-SLOT-226.webp?v=1761903352995",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-226",
    platFormCode: "RELAX",
  },
  {
    name: "Swipe & Roll",
    img: "/assets/Slot/NETENT-SLOT-165.Swipe-&-Roll.webp?v=1764954364313",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-165",
    platFormCode: "NETENT",
  },
  {
    name: "Sword Stomp",
    img: "/assets/Slot/RT-SLOT-318.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-318",
    platFormCode: "RT",
  },
  {
    name: "Sword of Ares",
    img: "/assets/Slot/PP-SLOT-289.Sword of Ares.webp?v=1764321620624",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-289",
    platFormCode: "PP",
  },
  {
    name: "Sylvan Spirits",
    img: "/assets/Slot/RT-SLOT-163.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-163",
    platFormCode: "RT",
  },
  {
    name: "Symbols of Egypt",
    img: "/assets/Slot/PG-SLOT-025.webp?v=1765933237770",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-025",
    platFormCode: "PG",
  },
  {
    name: "Syncronite",
    img: "/assets/Slot/YGG-SLOT-113.webp?v=1767056428450",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-113",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "T-Rex",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-031.t-rex.webp?v=1765271936261",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-031",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "T-Rex",
    img: "/assets/Slot/P8-SLOT-019.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-019",
    platFormCode: "PLAY8",
  },
  {
    name: "THREE LITTLE PIGS",
    img: "/assets/Slot/FC-SLOT-002.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-002",
    platFormCode: "FC",
  },
  {
    name: "TIGER_TIGER",
    img: "/assets/Slot/YGG-SLOT-083.webp?v=1767056428426",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-083",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "TNT Tumble",
    img: "/assets/Slot/RELAX-SLOT-048.webp?v=1761903382661",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-048",
    platFormCode: "RELAX",
  },
  {
    name: "TNT Tumble 10K",
    img: "/assets/Slot/RELAX-SLOT-240.webp?v=1761903412881",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-240",
    platFormCode: "RELAX",
  },
  {
    name: "TNT Tumble 5K",
    img: "/assets/Slot/RELAX-SLOT-239.webp?v=1761903433660",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-239",
    platFormCode: "RELAX",
  },
  {
    name: "TREASURE CRUISE",
    img: "/assets/Slot/FC-SLOT-016.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-016",
    platFormCode: "FC",
  },
  {
    name: "TREASURE OF AZTEC",
    img: "/assets/Slot/2J-SLOT-036.TREASURE OF AZTEC.webp?v=1763547748187",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-036",
    platFormCode: "JJ",
  },
  {
    name: "TREASURES OF ODIN",
    img: "/assets/Slot/FC-SLOT-052.webp?v=1758878471324",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-052",
    platFormCode: "FC",
  },
  {
    name: "TRUMP IT",
    img: "/assets/Slot/2J-SLOT-056.TRUMP IT.webp?v=1763547692575",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-056",
    platFormCode: "JJ",
  },
  {
    name: "TWIN WINS",
    img: "/assets/Slot/JILI-SLOT-047.webp?v=1755509670427",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-047",
    platFormCode: "JILI",
  },
  {
    name: "Taco Fury XXXtreme",
    img: "/assets/Slot/NETENT-SLOT-174.Taco-Fury-XXXtreme.webp?v=1764954311475",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-174",
    platFormCode: "NETENT",
  },
  {
    name: "Tai Shang Lao Jun",
    img: "/assets/Slot/dxxsh3dfmjpio.Tai-Shang-Lao-Jun.webp?v=1765044848586",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-156",
    platFormCode: "JOKER",
  },
  {
    name: "Tai Wang Si Shen",
    img: "/assets/Slot/CG-SLOT-005.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-005",
    platFormCode: "CG",
  },
  {
    name: "Taiko Master",
    img: "/assets/Slot/CG-SLOT-055.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-055",
    platFormCode: "CG",
  },
  {
    name: "Take the Money",
    img: "/assets/Slot/RT-SLOT-365.Take the Money.webp?v=1764395370958",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-365",
    platFormCode: "RT",
  },
  {
    name: "Tally Ho",
    img: "/assets/Slot/P8-SLOT-020.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-020",
    platFormCode: "PLAY8",
  },
  {
    name: "Tanked",
    img: "/assets/Slot/NLC-SLOT-102.Tanked.webp?v=1764386775653",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-102",
    platFormCode: "NLC",
  },
  {
    name: "Tarasque",
    img: "/assets/Slot/RELAX-SLOT-225.webp?v=1761903460902",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-225",
    platFormCode: "RELAX",
  },
  {
    name: "Tarzan",
    img: "/assets/Slot/CG-SLOT-029.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-029",
    platFormCode: "CG",
  },
  {
    name: "Tarzan",
    img: "/assets/Slot/SlotTarzan.Tarzan.webp?v=1764774716184",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-029",
    platFormCode: "CG",
  },
  {
    name: "Teddy's Quest",
    img: "/assets/Slot/OCTOPLAY-SLOT-039.Teddy_s Quest.webp?v=1764935918809",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-039",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Tempered Steel",
    img: "/assets/Slot/YGG-SLOT-137.webp?v=1767056428472",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-137",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Templar Tumble",
    img: "/assets/Slot/RELAX-SLOT-045.webp?v=1761903495891",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-045",
    platFormCode: "RELAX",
  },
  {
    name: "Templar Tumble 2",
    img: "/assets/Slot/RELAX-SLOT-148.webp?v=1761903585193",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-148",
    platFormCode: "RELAX",
  },
  {
    name: "Temple Guardians",
    img: "/assets/Slot/PP-SLOT-573.webp?v=1755572539536",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-573",
    platFormCode: "PP",
  },
  {
    name: "Temple Quest Spinfinity",
    img: "/assets/Slot/BTG-SLOT-059.webp?v=1756256536971",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-059",
    platFormCode: "BTG",
  },
  {
    name: "Temple Stacks: Splitz",
    img: "/assets/Slot/YGG-SLOT-044.webp?v=1767056428371",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-044",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Temple Tumble",
    img: "/assets/Slot/RELAX-SLOT-046.webp?v=1761903610231",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-046",
    platFormCode: "RELAX",
  },
  {
    name: "Temple Tumble 2",
    img: "/assets/Slot/RELAX-SLOT-121.webp?v=1761903635366",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-121",
    platFormCode: "RELAX",
  },
  {
    name: "Temple of Fury",
    img: "/assets/Slot/RELAX-SLOT-195.webp?v=1761903703159",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-195",
    platFormCode: "RELAX",
  },
  {
    name: "Temple of Nudges",
    img: "/assets/Slot/NETENT-SLOT-130.Temple-of-Nudges.webp?v=1764954261825",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-130",
    platFormCode: "NETENT",
  },
  {
    name: "Temujin Treasures",
    img: "/assets/Slot/PP-SLOT-171.Temujin-Treasures.webp?v=1764321539608",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-171",
    platFormCode: "PP",
  },
  {
    name: "Ten Thousand Wonders Multimax",
    img: "/assets/Slot/YGG-SLOT-267.webp?v=1767056428775",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-267",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Ten Ton Ways Stampede",
    img: "/assets/Slot/PT-SLOT-445.webp?v=1753341236223",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-445",
    platFormCode: "PT",
  },
  {
    name: "Tesla Jolt",
    img: "/assets/Slot/NLC-SLOT-057.Tesla Jolt.webp?v=1764386726914",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-057",
    platFormCode: "NLC",
  },
  {
    name: "Thai Paradise",
    img: "/assets/Slot/P8-SLOT-011.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-011",
    platFormCode: "PLAY8",
  },
  {
    name: "Thai Paradise",
    img: "/assets/Slot/PT-SLOT-071.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-071",
    platFormCode: "PT",
  },
  {
    name: "Thai River Wonders",
    img: "/assets/Slot/PG-SLOT-060.webp?v=1765933237796",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-060",
    platFormCode: "PG",
  },
  {
    name: "The 4 Invention",
    img: "/assets/Slot/rqaonzn7kjjiy.The-4-Invention.webp?v=1765053337649",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-159",
    platFormCode: "JOKER",
  },
  {
    name: "The Alter Ego",
    img: "/assets/Slot/PP-SLOT-431.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-431",
    platFormCode: "PP",
  },
  {
    name: "The Big Bark: Golden Jackpots",
    img: "/assets/Slot/OCTOPLAY-SLOT-108.The Big Bark Golden Jackpots.webp?v=1764935943975",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-108",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "The Big Dawgs",
    img: "/assets/Slot/PP-SLOT-410.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-410",
    platFormCode: "PP",
  },
  {
    name: "The Border",
    img: "/assets/Slot/NLC-SLOT-022.The Border.webp?v=1764386672138",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-022",
    platFormCode: "NLC",
  },
  {
    name: "The Bounty Hunter",
    img: "/assets/Slot/YGG-SLOT-082.webp?v=1767056428425",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-082",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Cage",
    img: "/assets/Slot/NLC-SLOT-072.The Cage.webp?v=1764386622630",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-072",
    platFormCode: "NLC",
  },
  {
    name: "The Creepy Carnival",
    img: "/assets/Slot/NLC-SLOT-061.The Creepy Carnival.webp?v=1764386539788",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-061",
    platFormCode: "NLC",
  },
  {
    name: "The Crypt",
    img: "/assets/Slot/NLC-SLOT-073.The Crypt.webp?v=1764386492390",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-073",
    platFormCode: "NLC",
  },
  {
    name: "The Cursed Idol of Montezuma",
    img: "/assets/Slot/YGG-SLOT-396.webp?v=1767056428905",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-396",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Discovery",
    img: "/assets/Slot/P8-SLOT-008.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-008",
    platFormCode: "PLAY8",
  },
  {
    name: "The Dog House",
    img: "/assets/Slot/PP-SLOT-085.The-Dog-House.webp?v=1764321362361",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-085",
    platFormCode: "PP",
  },
  {
    name: "The Dog House - Muttley Crew",
    img: "/assets/Slot/PP-SLOT-500.The Dog House – Muttley Crew.webp?v=1764321304699",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-500",
    platFormCode: "PP",
  },
  {
    name: "The Dog House Dice Show",
    img: "/assets/Slot/PP-SLOT-416.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-416",
    platFormCode: "PP",
  },
  {
    name: "The Dog House Megaways",
    img: "/assets/Slot/PP-SLOT-036.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-036",
    platFormCode: "PP",
  },
  {
    name: "The Dog House Multihold",
    img: "/assets/Slot/PP-SLOT-327.The Dog House Multihold.webp?v=1764321158592",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-327",
    platFormCode: "PP",
  },
  {
    name: "The Dragon Tiger",
    img: "/assets/Slot/PP-SLOT-022.Dragon-Tiger.webp?v=1764320989065",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-022",
    platFormCode: "PP",
  },
  {
    name: "The Final Countdown",
    img: "/assets/Slot/BTG-SLOT-042.webp?v=1756256536957",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-042",
    platFormCode: "BTG",
  },
  {
    name: "The First Emperor",
    img: "/assets/Slot/ACEWIN-SLOT-003.The First Emperor.webp?v=1764854872373",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-003",
    platFormCode: "ACEWIN",
  },
  {
    name: "The Good Farmer",
    img: "/assets/Slot/YGG-SLOT-387.webp?v=1767056428892",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-387",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Good, The Bad and The Rich",
    img: "/assets/Slot/RT-SLOT-331.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-331",
    platFormCode: "RT",
  },
  {
    name: "The Great Chicken Escape",
    img: "/assets/Slot/PP-SLOT-074.The-Great-Chicken-Escape.webp?v=1764320909468",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-074",
    platFormCode: "PP",
  },
  {
    name: "The Great Icescape",
    img: "/assets/Slot/PG-SLOT-032.webp?v=1765933237773",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-032",
    platFormCode: "PG",
  },
  {
    name: "The Great Jackpot Expedition",
    img: "/assets/Slot/OCTOPLAY-SLOT-062.The great Jackpot Expedition.webp?v=1764935984069",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-062",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "The Great Pigsby",
    img: "/assets/Slot/RELAX-SLOT-047.webp?v=1761903731452",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-047",
    platFormCode: "RELAX",
  },
  {
    name: "The Great Pigsby Megaways",
    img: "/assets/Slot/RELAX-SLOT-145.webp?v=1761903755290",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-145",
    platFormCode: "RELAX",
  },
  {
    name: "The Great Stick-Up",
    img: "/assets/Slot/PP-SLOT-240.The-Great-Stick-Up.webp?v=1764320857457",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-240",
    platFormCode: "PP",
  },
  {
    name: "The Greed Machine",
    img: "/assets/Slot/OCTOPLAY-SLOT-116.The Greed Machine.webp?v=1764937691327",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-116",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "The Hand of Midas",
    img: "/assets/Slot/PP-SLOT-005.Hand-of-Midas.webp?v=1764320795978",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-005",
    platFormCode: "PP",
  },
  {
    name: "The Handsome Bandit",
    img: "/assets/Slot/YGG-SLOT-305.webp?v=1767056428807",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-305",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Hot Offer",
    img: "/assets/Slot/YGG-SLOT-017.webp?v=1767056428344",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-017",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Knight King",
    img: "/assets/Slot/PP-SLOT-330.The-Knight-King.webp?v=1764319559436",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-330",
    platFormCode: "PP",
  },
  {
    name: "The Legend Of White Snake",
    img: "/assets/Slot/3jxqtp7wssiks.The-Legend-Of-White-Snake.webp?v=1765051382831",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-160",
    platFormCode: "JOKER",
  },
  {
    name: "The Legend of Musashi",
    img: "/assets/Slot/YGG-SLOT-173.webp?v=1767056428512",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-173",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Magic Cauldron - Enchanted Brew",
    img: "/assets/Slot/PP-SLOT-181.The-Magic-Cauldron-Enchanted-Brew.webp?v=1764319404194",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-181",
    platFormCode: "PP",
  },
  {
    name: "The Money Men Megaways",
    img: "/assets/Slot/PP-SLOT-392.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-392",
    platFormCode: "PP",
  },
  {
    name: "The One Armed Bandit",
    img: "/assets/Slot/YGG-SLOT-107.webp?v=1767056428445",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-107",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Pig House",
    img: "/assets/Slot/JILI-SLOT-103.webp?v=1755510525001",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-103",
    platFormCode: "JILI",
  },
  {
    name: "The Queen's Banquet",
    img: "/assets/Slot/PG-SLOT-098.webp?v=1765933237826",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-098",
    platFormCode: "PG",
  },
  {
    name: "The Racaroon",
    img: "/assets/Slot/PT-SLOT-454.webp?v=1756275771668",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-454",
    platFormCode: "PT",
  },
  {
    name: "The Race",
    img: "/assets/Slot/BTG-SLOT-012.webp?v=1756256536934",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-012",
    platFormCode: "BTG",
  },
  {
    name: "The Rave",
    img: "/assets/Slot/NLC-SLOT-023.The Rave.webp?v=1764386438479",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-023",
    platFormCode: "NLC",
  },
  {
    name: "The Red Queen",
    img: "/assets/Slot/PP-SLOT-332.The-Red-Queen.webp?v=1764319323135",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-332",
    platFormCode: "PP",
  },
  {
    name: "The Riches of Don Quixote",
    img: "/assets/Slot/PT-SLOT-052.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-052",
    platFormCode: "PT",
  },
  {
    name: "The Runemakers DoubleMax",
    img: "/assets/Slot/YGG-SLOT-242.webp?v=1767056428593",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-242",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Tiger Warrior",
    img: "/assets/Slot/PP-SLOT-037.Tiger-Warrior.webp?v=1764319271411",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-037",
    platFormCode: "PP",
  },
  {
    name: "The Tumbles",
    img: "/assets/Slot/RELAX-SLOT-262.webp?v=1761903801762",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-262",
    platFormCode: "RELAX",
  },
  {
    name: "The Tweety House",
    img: "/assets/Slot/PP-SLOT-206.The-Tweety-House.webp?v=1764319204116",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-206",
    platFormCode: "PP",
  },
  {
    name: "The Ultimate 5",
    img: "/assets/Slot/PP-SLOT-231.The-Ultimate-5.webp?v=1764319103542",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-231",
    platFormCode: "PP",
  },
  {
    name: "The Vigilantes",
    img: "/assets/Slot/YGG-SLOT-360.webp?v=1767056428868",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-360",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "The Wild Drifter",
    img: "/assets/Slot/RELAX-SLOT-233.webp?v=1761903851278",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-233",
    platFormCode: "RELAX",
  },
  {
    name: "The Wild Gang",
    img: "/assets/Slot/PP-SLOT-422.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-422",
    platFormCode: "PP",
  },
  {
    name: "The Wild Hatter",
    img: "/assets/Slot/RT-SLOT-164.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-164",
    platFormCode: "RT",
  },
  {
    name: "The Wild Kiss",
    img: "/assets/Slot/RT-SLOT-284.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-284",
    platFormCode: "RT",
  },
  {
    name: "The Wild Machine",
    img: "/assets/Slot/PP-SLOT-055.The-Wild-Machine.webp?v=1764319141457",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-055",
    platFormCode: "PP",
  },
  {
    name: "The Wisecracker Lightning",
    img: "/assets/Slot/RT-SLOT-209.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-209",
    platFormCode: "RT",
  },
  {
    name: "The Wizard of OZ",
    img: "/assets/Slot/CG-SLOT-115.The Wizard of OZ.webp?v=1764666815986",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-115",
    platFormCode: "CG",
  },
  {
    name: "Theme Park Tickets of Fortune",
    img: "/assets/Slot/NETENT-SLOT-160.Theme-Park-Tickets-of-Fortune.webp?v=1764953837548",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-160",
    platFormCode: "NETENT",
  },
  {
    name: "Third Prince's Journey",
    img: "/assets/Slot/bzgza4umpbwsh.Third-Prince_s-journey.webp?v=1765047620041",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-161",
    platFormCode: "JOKER",
  },
  {
    name: "Thor Fortune",
    img: "/assets/Slot/YesBingo-SLOT-012.Thor Fortune.webp?v=1765101497893",
    platForm: "YESBINGO",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-012",
    platFormCode: "YESBINGO",
  },
  {
    name: "Thor Infinity Reels",
    img: "/assets/Slot/RELAX-SLOT-096.webp?v=1761903882640",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-096",
    platFormCode: "RELAX",
  },
  {
    name: "Thor Infinity Reels",
    img: "/assets/Slot/YGG-SLOT-011.webp?v=1767056428335",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-011",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Thor X",
    img: "/assets/Slot/JILI-SLOT-052.webp?v=1755509710532",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-052",
    platFormCode: "JILI",
  },
  {
    name: "Thor's Hammer Time",
    img: "/assets/Slot/YGG-SLOT-325.webp?v=1767056428825",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-325",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Thor's Rage",
    img: "/assets/Slot/RT-SLOT-360.Thor_s-Rage.webp?v=1765033913260",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-360",
    platFormCode: "RT",
  },
  {
    name: "Thor's Vengeance",
    img: "/assets/Slot/RT-SLOT-165.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-165",
    platFormCode: "RT",
  },
  {
    name: "Thor: Hammer Time",
    img: "/assets/Slot/NLC-SLOT-046.Thor_ Hammer Time.webp?v=1764386215749",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-046",
    platFormCode: "NLC",
  },
  {
    name: "Three Crazy Piggies",
    img: "/assets/Slot/PG-SLOT-145.webp?v=1765933237871",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-145",
    platFormCode: "PG",
  },
  {
    name: "Three Kingdoms",
    img: "/assets/Slot/RT-SLOT-197.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-197",
    platFormCode: "RT",
  },
  {
    name: "Three Kingdoms 2",
    img: "/assets/Slot/yqe1n9d7qj3zy.Three-Kingdoms-2.webp?v=1765045113149",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-162",
    platFormCode: "JOKER",
  },
  {
    name: "Three Kingdoms Quest",
    img: "/assets/Slot/fwria11mjbrwh.Three-Kingdoms-Quest.webp?v=1765037105265",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-163",
    platFormCode: "JOKER",
  },
  {
    name: "Three Musketeers",
    img: "/assets/Slot/RT-SLOT-077.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-077",
    platFormCode: "RT",
  },
  {
    name: "Three Star Fortune",
    img: "/assets/Slot/PP-SLOT-048.Three-Star-Fortune.webp?v=1764318976338",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-048",
    platFormCode: "PP",
  },
  {
    name: "Thug Life",
    img: "/assets/Slot/b1cnw7mkppwg1.Thug-Life.webp?v=1765048404830",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-164",
    platFormCode: "JOKER",
  },
  {
    name: "Thunder Hog Chaos Reels",
    img: "/assets/Slot/OCTOPLAY-SLOT-080.Thunder Hog Chaos Reels.webp?v=1764938018871",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-080",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "ThunderOfThor",
    img: "/assets/Slot/YGG-SLOT-127.webp?v=1767056428464",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-127",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Thunderhawk",
    img: "/assets/Slot/YGG-SLOT-204.webp?v=1767056428554",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-204",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Tic Tac Take",
    img: "/assets/Slot/PP-SLOT-248.Tic-Tac-Take.webp?v=1764318927408",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-248",
    platFormCode: "PP",
  },
  {
    name: "Ticket To Fortune",
    img: "/assets/Slot/RELAX-SLOT-171.webp?v=1761903917896",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-171",
    platFormCode: "RELAX",
  },
  {
    name: "Ticket To Wild",
    img: "/assets/Slot/NETENT-SLOT-213.Ticket-to-Wild.webp?v=1764953731795",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-213",
    platFormCode: "NETENT",
  },
  {
    name: "Tiger Claw",
    img: "/assets/Slot/PT-SLOT-117.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-117",
    platFormCode: "PT",
  },
  {
    name: "Tiger Dance",
    img: "/assets/Slot/SG-SLOT-104.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-104",
    platFormCode: "SPADE",
  },
  {
    name: "Tiger Kingdom Infinity Reels",
    img: "/assets/Slot/RELAX-SLOT-107.webp?v=1761903940174",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-107",
    platFormCode: "RELAX",
  },
  {
    name: "Tiger Lord",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-027.tiger-lord.webp?v=1765271879744",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-027",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Tiger Stacks",
    img: "/assets/Slot/PT-SLOT-208.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-208",
    platFormCode: "PT",
  },
  {
    name: "Tigers Lair",
    img: "/assets/Slot/y5n8sh5oqf58q.Tigers-Lair.webp?v=1765050611383",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-166",
    platFormCode: "JOKER",
  },
  {
    name: "Tiki Fruits Totem Frenzy",
    img: "/assets/Slot/RT-SLOT-205.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-205",
    platFormCode: "RT",
  },
  {
    name: "Tiki Infinity Reels Megaways",
    img: "/assets/Slot/YGG-SLOT-062.webp?v=1767056428400",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-062",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Tiki Runner 2 DoubleMax",
    img: "/assets/Slot/YGG-SLOT-134.webp?v=1767056428470",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-134",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Tiki Runner Clusters",
    img: "/assets/Slot/YGG-SLOT-379.webp?v=1767056428885",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-379",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Tiki Runner GigaBlox",
    img: "/assets/Slot/YGG-SLOT-240.webp?v=1767056428592",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-240",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Timber Stacks",
    img: "/assets/Slot/PP-SLOT-400.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-400",
    platFormCode: "PP",
  },
  {
    name: "Time Travel Tigers",
    img: "/assets/Slot/YGG-SLOT-038.webp?v=1767056428364",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-038",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Tiny Toads",
    img: "/assets/Slot/PP-SLOT-526.Tiny Toads.webp?v=1764318806675",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-526",
    platFormCode: "PP",
  },
  {
    name: "Tip Top Totems",
    img: "/assets/Slot/PT-SLOT-212.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-212",
    platFormCode: "PT",
  },
  {
    name: "Titan Clash",
    img: "/assets/Slot/YGG-SLOT-372.webp?v=1767056428879",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-372",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Titan Strike",
    img: "/assets/Slot/RELAX-SLOT-201.webp?v=1761903964533",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-201",
    platFormCode: "RELAX",
  },
  {
    name: "Toad's Gift",
    img: "/assets/Slot/PT-SLOT-177.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-177",
    platFormCode: "PT",
  },
  {
    name: "Tomb",
    img: "/assets/Slot/CG-SLOT-069.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-069",
    platFormCode: "CG",
  },
  {
    name: "Tomb of Akhenaten",
    img: "/assets/Slot/NLC-SLOT-005.Tomb of Akhenaten.webp?v=1764386161875",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-005",
    platFormCode: "NLC",
  },
  {
    name: "Tomb of Nefertiti",
    img: "/assets/Slot/NLC-SLOT-042.Tomb of Nefertiti.webp?v=1764386045394",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-042",
    platFormCode: "NLC",
  },
  {
    name: "Tombstone",
    img: "/assets/Slot/NLC-SLOT-049.Tombstone.webp?v=1764385910310",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-049",
    platFormCode: "NLC",
  },
  {
    name: "Tombstone No Mercy",
    img: "/assets/Slot/NLC-SLOT-082.Tombstone No Mercy.webp?v=1764385855419",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-082",
    platFormCode: "NLC",
  },
  {
    name: "Tombstone RIP",
    img: "/assets/Slot/NLC-SLOT-006.Tombstone RIP.webp?v=1764385806996",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-006",
    platFormCode: "NLC",
  },
  {
    name: "Tombstone Slaughter",
    img: "/assets/Slot/NLC-SLOT-104.Tombstone Slaughter.webp?v=1764385757007",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-104",
    platFormCode: "NLC",
  },
  {
    name: "Tons Of Money",
    img: "/assets/Slot/ACEWIN-SLOT-024.Tons of Money.webp?v=1764854929526",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-024",
    platFormCode: "ACEWIN",
  },
  {
    name: "Top Dawg$",
    img: "/assets/Slot/RELAX-SLOT-055.webp?v=1761903997495",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-055",
    platFormCode: "RELAX",
  },
  {
    name: "Torii Tumble",
    img: "/assets/Slot/RELAX-SLOT-194.webp?v=1761904046101",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-194",
    platFormCode: "RELAX",
  },
  {
    name: "Totem Guardians",
    img: "/assets/Slot/RELAX-SLOT-259.webp?v=1761904077811",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-259",
    platFormCode: "RELAX",
  },
  {
    name: "Totem Wonders",
    img: "/assets/Slot/PG-SLOT-107.webp?v=1765933237834",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-107",
    platFormCode: "PG",
  },
  {
    name: "Toucan Mania",
    img: "/assets/Slot/PT-SLOT-467.Toucan Mania.webp?v=1764326239769",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-467",
    platFormCode: "PT",
  },
  {
    name: "Tower Tumble",
    img: "/assets/Slot/RELAX-SLOT-049.webp?v=1761904100564",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-049",
    platFormCode: "RELAX",
  },
  {
    name: "Towering Fortunes",
    img: "/assets/Slot/PP-SLOT-298.Towering-Fortunes.webp?v=1764318751703",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-298",
    platFormCode: "PP",
  },
  {
    name: "Towering Pays Excalibur",
    img: "/assets/Slot/YGG-SLOT-088.webp?v=1767056428430",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-088",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Towering Pays Valhalla",
    img: "/assets/Slot/YGG-SLOT-080.webp?v=1767056428422",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-080",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Tractor Beam",
    img: "/assets/Slot/NLC-SLOT-047.Tractor Beam.webp?v=1764385701300",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-047",
    platFormCode: "NLC",
  },
  {
    name: "Transylvanian: Night of Blood",
    img: "/assets/Slot/RT-SLOT-237.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-237",
    platFormCode: "RT",
  },
  {
    name: "Travel Frog",
    img: "/assets/Slot/CG-SLOT-061.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-061",
    platFormCode: "CG",
  },
  {
    name: "Treasure Bowl",
    img: "/assets/Slot/JDB-SLOT-075.treasure_bowl.webp?v=1765259421924",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-075",
    platFormCode: "JDB",
  },
  {
    name: "Treasure Frog",
    img: "/assets/Slot/CG-SLOT-102.Treasure Frog.webp?v=1764666882959",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-102",
    platFormCode: "CG",
  },
  {
    name: "Treasure Horse",
    img: "/assets/Slot/PP-SLOT-090.Treasure-Horse.webp?v=1764318704229",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-090",
    platFormCode: "PP",
  },
  {
    name: "Treasure Journey: Genie`s Gold",
    img: "/assets/Slot/OCTOPLAY-SLOT-065.Treasure Journey Genie`s Gold.webp?v=1764938076453",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-065",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Treasure Quest",
    img: "/assets/Slot/JILI-SLOT-114.webp?v=1755510777621",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-114",
    platFormCode: "JILI",
  },
  {
    name: "Treasure Wild",
    img: "/assets/Slot/PP-SLOT-200.Treasure-Wild.webp?v=1764318655083",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-200",
    platFormCode: "PP",
  },
  {
    name: "TreasureIsland",
    img: "/assets/Slot/CG-SLOT-111.TreasureIsland.webp?v=1764666937423",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-111",
    platFormCode: "CG",
  },
  {
    name: "Treasures of Aztec",
    img: "/assets/Slot/PG-SLOT-058.webp?v=1765933237795",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-058",
    platFormCode: "PG",
  },
  {
    name: "Treasures of Olympus 1000",
    img: "/assets/Slot/KM-SLOT-023.Treasures of Olympus 1000.webp?v=1764779734865",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-023",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Treasures of the Lamps",
    img: "/assets/Slot/PT-SLOT-114.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-114",
    platFormCode: "PT",
  },
  {
    name: "Tree Wishes",
    img: "/assets/Slot/PT-SLOT-407.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-407",
    platFormCode: "PT",
  },
  {
    name: "Tree of Fortune",
    img: "/assets/Slot/PG-SLOT-013.webp?v=1765933237760",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-013",
    platFormCode: "PG",
  },
  {
    name: "Tree of Riches",
    img: "/assets/Slot/PP-SLOT-073.Tree-of-Riches.webp?v=1764318594665",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-073",
    platFormCode: "PP",
  },
  {
    name: "Trees of Treasure",
    img: "/assets/Slot/PP-SLOT-425.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-425",
    platFormCode: "PP",
  },
  {
    name: "Trial of Phoenix",
    img: "/assets/Slot/JILI-SLOT-084.webp?v=1755510180079",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-084",
    platFormCode: "JILI",
  },
  {
    name: "TrialByViking",
    img: "/assets/Slot/CG-SLOT-103.TrialByViking.webp?v=1764666999674",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-103",
    platFormCode: "CG",
  },
  {
    name: "Trick of the Dead Wild Candies Megaways",
    img: "/assets/Slot/RT-SLOT-341.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-341",
    platFormCode: "RT",
  },
  {
    name: "Tricks and Treats",
    img: "/assets/Slot/RT-SLOT-139.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-139",
    platFormCode: "RT",
  },
  {
    name: "Trickstar Spins",
    img: "/assets/Slot/YGG-SLOT-330.webp?v=1767056428830",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-330",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Trigger Happy",
    img: "/assets/Slot/BTG-SLOT-047.webp?v=1756256536962",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-047",
    platFormCode: "BTG",
  },
  {
    name: "Trillionaire",
    img: "/assets/Slot/RT-SLOT-166.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-166",
    platFormCode: "RT",
  },
  {
    name: "Triple Dragons",
    img: "/assets/Slot/PP-SLOT-094.Triple-Dragons.webp?v=1764318525538",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-094",
    platFormCode: "PP",
  },
  {
    name: "Triple King Kong",
    img: "/assets/Slot/JDB-SLOT-043.Triple King Kong.webp?v=1765259375669",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-043",
    platFormCode: "JDB",
  },
  {
    name: "Triple Monkey",
    img: "/assets/Slot/PT-SLOT-001.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-001",
    platFormCode: "PT",
  },
  {
    name: "Triple Monkey",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-039.triple-monkey.webp?v=1765271829378",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-039",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Triple Monkey",
    img: "/assets/Slot/CG-SLOT-120.Triple Monkey.webp?v=1764667086141",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-120",
    platFormCode: "CG",
  },
  {
    name: "Triple Pot Gold",
    img: "/assets/Slot/PP-SLOT-553.webp?v=1755571977968",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-553",
    platFormCode: "PP",
  },
  {
    name: "Triple Stop: Mermaids Find",
    img: "/assets/Slot/PT-SLOT-243.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-243",
    platFormCode: "PT",
  },
  {
    name: "Triple Tigers",
    img: "/assets/Slot/PP-SLOT-164.Triple Tigers.webp?v=1764318457365",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-164",
    platFormCode: "PP",
  },
  {
    name: "Triple Twister",
    img: "/assets/Slot/P8-SLOT-016.webp?v=1751418030453",
    platForm: "PLAY8",
    type: "slots",
    gameType: "SLOT",
    casinoType: "P8-SLOT-016",
    platFormCode: "PLAY8",
  },
  {
    name: "Troll's Gold",
    img: "/assets/Slot/RELAX-SLOT-062.webp?v=1761904174056",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-062",
    platFormCode: "RELAX",
  },
  {
    name: "Trolls Bridge",
    img: "/assets/Slot/YGG-SLOT-057.webp?v=1767056428392",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-057",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Trolls Frenzy",
    img: "/assets/Slot/YGG-SLOT-399.webp?v=1767056428909",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-399",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Trophy Fish",
    img: "/assets/Slot/RT-SLOT-343.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-343",
    platFormCode: "RT",
  },
  {
    name: "Tropical Crush",
    img: "/assets/Slot/cuarr8e1ncebn.Tropical-Crush.webp?v=1765050794781",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-167",
    platFormCode: "JOKER",
  },
  {
    name: "Tropical Island",
    img: "/assets/Slot/CG-SLOT-076.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-076",
    platFormCode: "CG",
  },
  {
    name: "Tropical Tiki",
    img: "/assets/Slot/PP-SLOT-262.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-262",
    platFormCode: "PP",
  },
  {
    name: "True Grit Redemption",
    img: "/assets/Slot/NLC-SLOT-025.True Grit Redemption.webp?v=1764385653893",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-025",
    platFormCode: "NLC",
  },
  {
    name: "True Love",
    img: "/assets/Slot/PT-SLOT-139.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-139",
    platFormCode: "PT",
  },
  {
    name: "True Zhao Cai Jin Bao",
    img: "/assets/Slot/CG-SLOT-047.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-047",
    platFormCode: "CG",
  },
  {
    name: "True kult",
    img: "/assets/Slot/NLC-SLOT-074.True kult.webp?v=1764385595847",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-074",
    platFormCode: "NLC",
  },
  {
    name: "Trump Card",
    img: "/assets/Slot/JDB-SLOT-107.trump-card.webp?v=1767691547415",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-107",
    platFormCode: "JDB",
  },
  {
    name: "Tsai Shen 10K Ways",
    img: "/assets/Slot/RELAX-SLOT-168.webp?v=1761904194893",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-168",
    platFormCode: "RELAX",
  },
  {
    name: "Tsai Shen's Gift",
    img: "/assets/Slot/PT-SLOT-210.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-210",
    platFormCode: "PT",
  },
  {
    name: "Tsar Treasures",
    img: "/assets/Slot/PG-SLOT-129.webp?v=1765933237853",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-129",
    platFormCode: "PG",
  },
  {
    name: "Tsar Wars",
    img: "/assets/Slot/NLC-SLOT-115.Tsar Wars.webp?v=1764385549400",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-115",
    platFormCode: "NLC",
  },
  {
    name: "Tumble in the Jungle Wild Fight",
    img: "/assets/Slot/YGG-SLOT-251.webp?v=1767056428755",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-251",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Turbo Diamonds: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-117.Turbo Diamonds Hold & Win.webp?v=1764938122751",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-117",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Turtle Paradise",
    img: "/assets/Slot/RT-SLOT-325.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-325",
    platFormCode: "RT",
  },
  {
    name: "TutsTwister",
    img: "/assets/Slot/YGG-SLOT-033.webp?v=1767056428361",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-033",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Twice as Nice",
    img: "/assets/Slot/OCTOPLAY-SLOT-019.Twice as Nice.webp?v=1764938161146",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-019",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Twilight Princess",
    img: "/assets/Slot/PP-SLOT-394.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-394",
    platFormCode: "PP",
  },
  {
    name: "Twin Cash: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-061.Twin Cash Hold & Win.webp?v=1764938204846",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-061",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Twin Spin Deluxe",
    img: "/assets/Slot/NETENT-SLOT-136.Twin-Spin-Deluxe.webp?v=1764953525483",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-136",
    platFormCode: "NETENT",
  },
  {
    name: "Twin Spin XXXtreme",
    img: "/assets/Slot/NETENT-SLOT-175.Twin-$pin-XXXtreme.webp?v=1764953486196",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-175",
    platFormCode: "NETENT",
  },
  {
    name: "Twisted Turbine",
    img: "/assets/Slot/RELAX-SLOT-075.webp?v=1761904234376",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-075",
    platFormCode: "RELAX",
  },
  {
    name: "Twister",
    img: "/assets/Slot/NETENT-SLOT-223.Twister.webp?v=1764953176186",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-223",
    platFormCode: "NETENT",
  },
  {
    name: "Ugga Bugga",
    img: "/assets/Slot/PT-SLOT-015.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-015",
    platFormCode: "PT",
  },
  {
    name: "Ugliest Catch",
    img: "/assets/Slot/NLC-SLOT-086.Ugliest Catch.webp?v=1764385511995",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-086",
    platFormCode: "NLC",
  },
  {
    name: "Ultimate Striker",
    img: "/assets/Slot/PG-SLOT-125.webp?v=1765933237849",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-125",
    platFormCode: "PG",
  },
  {
    name: "Ultra Burn",
    img: "/assets/Slot/PP-SLOT-043.Ultra-Burn.webp?v=1764317323117",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-043",
    platFormCode: "PP",
  },
  {
    name: "Ultra Hold and Spin",
    img: "/assets/Slot/PP-SLOT-032.Ultra-Hold-and-Spin.webp?v=1764317274039",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-032",
    platFormCode: "PP",
  },
  {
    name: "Ultra Hotfire",
    img: "/assets/Slot/YGG-SLOT-276.webp?v=1767056428782",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-276",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Ultra Rich",
    img: "/assets/Slot/RT-SLOT-320.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-320",
    platFormCode: "RT",
  },
  {
    name: "Ultra Treasure",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-014.ultra-treasure.webp?v=1765271766554",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-014",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Vacation Station",
    img: "/assets/Slot/PT-SLOT-118.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-118",
    platFormCode: "PT",
  },
  {
    name: "Vacation Station Deluxe",
    img: "/assets/Slot/PT-SLOT-024.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-024",
    platFormCode: "PT",
  },
  {
    name: "Valkyries",
    img: "/assets/Slot/YGG-SLOT-091.webp?v=1767056428433",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-091",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Valley of the Dead",
    img: "/assets/Slot/YGG-SLOT-306.webp?v=1767056428808",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-306",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Valley of the Gods",
    img: "/assets/Slot/YGG-SLOT-086.webp?v=1767056428429",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-086",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Valley of the Gods 2",
    img: "/assets/Slot/YGG-SLOT-092.webp?v=1767056428434",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-092",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vampire Riches",
    img: "/assets/Slot/YGG-SLOT-221.webp?v=1767056428568",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-221",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vampire's Charm",
    img: "/assets/Slot/PG-SLOT-062.webp?v=1765933237798",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-062",
    platFormCode: "PG",
  },
  {
    name: "Vampires VS Wolves",
    img: "/assets/Slot/PP-SLOT-075.Vampires-vs-Wolves.webp?v=1764317184649",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-075",
    platFormCode: "PP",
  },
  {
    name: "Vampy Party",
    img: "/assets/Slot/PP-SLOT-505.Vampy Party.webp?v=1764317130724",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-505",
    platFormCode: "PP",
  },
  {
    name: "Vault Blast Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-049.Vault Blast Hold & Win.webp?v=1764938263629",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-049",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Vault Cracker",
    img: "/assets/Slot/RT-SLOT-167.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-167",
    platFormCode: "RT",
  },
  {
    name: "Vault Raiders DoubleMax",
    img: "/assets/Slot/YGG-SLOT-418.webp?v=1767056428926",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-418",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vault of Anubis",
    img: "/assets/Slot/RT-SLOT-100.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-100",
    platFormCode: "RT",
  },
  {
    name: "Vault of Fortune",
    img: "/assets/Slot/YGG-SLOT-048.webp?v=1767056428377",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-048",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vegas Blitz: Hold & Win",
    img: "/assets/Slot/OCTOPLAY-SLOT-094.Vegas Blitz Hold & Win.webp?v=1764938285612",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-094",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Vegas Magic",
    img: "/assets/Slot/PP-SLOT-096.Vegas-Magic.webp?v=1764317077585",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-096",
    platFormCode: "PP",
  },
  {
    name: "Vegas Megaways",
    img: "/assets/Slot/BTG-SLOT-024.webp?v=1756256536944",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-024",
    platFormCode: "BTG",
  },
  {
    name: "Vegas Nights",
    img: "/assets/Slot/PP-SLOT-119.Vegas-Night.webp?v=1764317030749",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-119",
    platFormCode: "PP",
  },
  {
    name: "Vegas Rush",
    img: "/assets/Slot/BTG-SLOT-014.webp?v=1756256536936",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-014",
    platFormCode: "BTG",
  },
  {
    name: "Vegas is Dead: Battle Arena",
    img: "/assets/Slot/OCTOPLAY-SLOT-110.Vegas is Dead Battle Arena.webp?v=1764938305451",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-110",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Viking Forge",
    img: "/assets/Slot/PP-SLOT-396.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-396",
    platFormCode: "PP",
  },
  {
    name: "Viking Glory",
    img: "/assets/Slot/ACEWIN-SLOT-033.webp?v=1762477170478",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-033",
    platFormCode: "ACEWIN",
  },
  {
    name: "Vikings Go Berzerk",
    img: "/assets/Slot/YGG-SLOT-109.webp?v=1767056428447",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-109",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vikings Go Berzerk: Reloaded",
    img: "/assets/Slot/YGG-SLOT-121.webp?v=1767056428459",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-121",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vikings Go To Egypt",
    img: "/assets/Slot/YGG-SLOT-266.webp?v=1767056428774",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-266",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vikings go Wild",
    img: "/assets/Slot/YGG-SLOT-110.webp?v=1767056428447",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-110",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vikings go to Hell",
    img: "/assets/Slot/YGG-SLOT-089.webp?v=1767056428431",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-089",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Vikings go to Valhalla",
    img: "/assets/Slot/YGG-SLOT-051.webp?v=1767056428382",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-051",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Viral Spiral",
    img: "/assets/Slot/RT-SLOT-132.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-132",
    platFormCode: "RT",
  },
  {
    name: "Volatile Egypt",
    img: "/assets/Slot/RELAX-SLOT-162.webp?v=1761904259838",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-162",
    platFormCode: "RELAX",
  },
  {
    name: "Volatile Vikings",
    img: "/assets/Slot/RELAX-SLOT-066.webp?v=1761904287172",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-066",
    platFormCode: "RELAX",
  },
  {
    name: "Volatile Vikings 2",
    img: "/assets/Slot/RELAX-SLOT-143.webp?v=1761904313475",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-143",
    platFormCode: "RELAX",
  },
  {
    name: "Volcanic Legend",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-086.Volcanic Legend.webp?v=1765271719135",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-086",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Volcano Goddess",
    img: "/assets/Slot/PP-SLOT-551.Volcano Goddess.webp?v=1764316944398",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-551",
    platFormCode: "PP",
  },
  {
    name: "Voodoo Hex",
    img: "/assets/Slot/YGG-SLOT-157.webp?v=1767056428489",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-157",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Voodoo Magic",
    img: "/assets/Slot/PP-SLOT-013.Voodoo-Magic.webp?v=1764316779634",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-013",
    platFormCode: "PP",
  },
  {
    name: "WAR OF THE UNIVERSE",
    img: "/assets/Slot/FC-SLOT-015.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-015",
    platFormCode: "FC",
  },
  {
    name: "WARRIORS TEMPLE",
    img: "/assets/Slot/KM-SLOT-008.webp?v=1759311882463",
    platForm: "KINGMAKER",
    type: "slots",
    gameType: "SLOT",
    casinoType: "KM-SLOT-008",
    platFormCode: "KINGMAKER",
  },
  {
    name: "WILD VEGAS",
    img: "/assets/Slot/2J-SLOT-006.WILD VEGAS.webp?v=1763547643573",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-006",
    platFormCode: "JJ",
  },
  {
    name: "WIN WIN NEKO",
    img: "/assets/Slot/FC-SLOT-030.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-030",
    platFormCode: "FC",
  },
  {
    name: "Walk of Shame",
    img: "/assets/Slot/NLC-SLOT-063.Walk of Shame.webp?v=1764385461384",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-063",
    platFormCode: "NLC",
  },
  {
    name: "Walrus King",
    img: "/assets/Slot/OCTOPLAY-SLOT-079.Walrus King.webp?v=1764938350494",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-079",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Wanted Wildz",
    img: "/assets/Slot/RT-SLOT-280.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-280",
    platFormCode: "RT",
  },
  {
    name: "Wanted Wildz Extreme",
    img: "/assets/Slot/RT-SLOT-310.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-310",
    platFormCode: "RT",
  },
  {
    name: "War Hammer 40K",
    img: "/assets/Slot/CG-SLOT-060.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-060",
    platFormCode: "CG",
  },
  {
    name: "War Of Dragons",
    img: "/assets/Slot/JILI-SLOT-004.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-004",
    platFormCode: "JILI",
  },
  {
    name: "War of Gods",
    img: "/assets/Slot/RT-SLOT-168.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-168",
    platFormCode: "RT",
  },
  {
    name: "WarShip Girls",
    img: "/assets/Slot/CG-SLOT-058.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-058",
    platFormCode: "CG",
  },
  {
    name: "Warrior",
    img: "/assets/Slot/qmufydacbwbyg.Warrior.webp?v=1765050507623",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-189",
    platFormCode: "JOKER",
  },
  {
    name: "Warrior Graveyard xNudge",
    img: "/assets/Slot/NLC-SLOT-031.Warrior Graveyard xNudge.webp?v=1764385397609",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-031",
    platFormCode: "NLC",
  },
  {
    name: "Water Blox",
    img: "/assets/Slot/YGG-SLOT-142.webp?v=1767056428476",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-142",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Water Margin",
    img: "/assets/Slot/foff4ikkjprr1.Water-Margin.webp?v=1765044402124",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-169",
    platFormCode: "JOKER",
  },
  {
    name: "Water Reel",
    img: "/assets/Slot/5ypkuepgw61kk.Water-reel.webp?v=1765040929603",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-170",
    platFormCode: "JOKER",
  },
  {
    name: "Waves of Poseidon",
    img: "/assets/Slot/PP-SLOT-578.Waves of Poseidon.webp?v=1764316712637",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-578",
    platFormCode: "PP",
  },
  {
    name: "Ways of the Phoenix",
    img: "/assets/Slot/PT-SLOT-116.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-116",
    platFormCode: "PT",
  },
  {
    name: "Ways of the Qilin",
    img: "/assets/Slot/PG-SLOT-076.webp?v=1765933237808",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-076",
    platFormCode: "PG",
  },
  {
    name: "Wealth God",
    img: "/assets/Slot/e9qs4cbtga5ue.Wealth-God.webp?v=1765046784919",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-171",
    platFormCode: "JOKER",
  },
  {
    name: "Wealthway",
    img: "/assets/Slot/JDB-SLOT-122.wealthway.webp?v=1765259266525",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-122",
    platFormCode: "JDB",
  },
  {
    name: "Wealthy Frog",
    img: "/assets/Slot/PP-SLOT-613.Wealthy Frog.webp?v=1764316659958",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-613",
    platFormCode: "PP",
  },
  {
    name: "Well Of Wishes",
    img: "/assets/Slot/RT-SLOT-169.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-169",
    platFormCode: "RT",
  },
  {
    name: "Well of Wilds MegaWays + PowerWheel",
    img: "/assets/Slot/RT-SLOT-214.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-214",
    platFormCode: "RT",
  },
  {
    name: "Werewolf's Hunt",
    img: "/assets/Slot/PG-SLOT-130.webp?v=1765933237853",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-130",
    platFormCode: "PG",
  },
  {
    name: "Whacked",
    img: "/assets/Slot/NLC-SLOT-068.Whacked.webp?v=1764385326004",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-068",
    platFormCode: "NLC",
  },
  {
    name: "What The Fox MegaWays",
    img: "/assets/Slot/RT-SLOT-206.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-206",
    platFormCode: "RT",
  },
  {
    name: "What The Fruit!",
    img: "/assets/Slot/YGG-SLOT-424.webp?v=1767056428932",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-424",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wheels of Flame",
    img: "/assets/Slot/PT-SLOT-242.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-242",
    platFormCode: "PT",
  },
  {
    name: "White King",
    img: "/assets/Slot/PT-SLOT-055.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-055",
    platFormCode: "PT",
  },
  {
    name: "White King II",
    img: "/assets/Slot/PT-SLOT-125.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-125",
    platFormCode: "PT",
  },
  {
    name: "White Rabbit",
    img: "/assets/Slot/BTG-SLOT-006.webp?v=1756256536929",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-006",
    platFormCode: "BTG",
  },
  {
    name: "WiXX",
    img: "/assets/Slot/NLC-SLOT-060.WiXX.webp?v=1764385271223",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-060",
    platFormCode: "NLC",
  },
  {
    name: "Wild Ace",
    img: "/assets/Slot/JILI-SLOT-075.webp?v=1755509985334",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-075",
    platFormCode: "JILI",
  },
  {
    name: "Wild Bandito",
    img: "/assets/Slot/PG-SLOT-075.webp?v=1765933237807",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-075",
    platFormCode: "PG",
  },
  {
    name: "Wild Bison Charge",
    img: "/assets/Slot/PP-SLOT-343.Wild-Bison-Charge.webp?v=1764316562740",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-343",
    platFormCode: "PP",
  },
  {
    name: "Wild Booster",
    img: "/assets/Slot/PP-SLOT-173.Wild-Booster.webp?v=1764316482856",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-173",
    platFormCode: "PP",
  },
  {
    name: "Wild Bounty Showdown",
    img: "/assets/Slot/PG-SLOT-105.webp?v=1765933237832",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-105",
    platFormCode: "PG",
  },
  {
    name: "Wild Buccaneers Megaways",
    img: "/assets/Slot/RELAX-SLOT-136.webp?v=1761904345177",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-136",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Cats Multiline",
    img: "/assets/Slot/RT-SLOT-101.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-101",
    platFormCode: "RT",
  },
  {
    name: "Wild Celebrity Bus Megaways",
    img: "/assets/Slot/PP-SLOT-337.Wild-Celebrity-Bus-Megaways.webp?v=1764316439500",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-337",
    platFormCode: "PP",
  },
  {
    name: "Wild Chapo",
    img: "/assets/Slot/RELAX-SLOT-054.webp?v=1761904377844",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-054",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Chapo 10K",
    img: "/assets/Slot/RELAX-SLOT-242.webp?v=1761904440810",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-242",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Chapo 2",
    img: "/assets/Slot/RELAX-SLOT-165.webp?v=1761904474696",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-165",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Chapo 5K",
    img: "/assets/Slot/RELAX-SLOT-241.webp?v=1761904504533",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-241",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Chips",
    img: "/assets/Slot/ACEWIN-SLOT-010.Wild Chips.webp?v=1764854957931",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-010",
    platFormCode: "ACEWIN",
  },
  {
    name: "Wild Circus",
    img: "/assets/Slot/RT-SLOT-083.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-083",
    platFormCode: "RT",
  },
  {
    name: "Wild Coaster",
    img: "/assets/Slot/PG-SLOT-104.webp?v=1765933237831",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-104",
    platFormCode: "PG",
  },
  {
    name: "Wild Depths",
    img: "/assets/Slot/PP-SLOT-225.Wild-Depths.webp?v=1764316392665",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-225",
    platFormCode: "PP",
  },
  {
    name: "Wild Donuts",
    img: "/assets/Slot/RELAX-SLOT-140.webp?v=1761904528924",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-140",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Duel",
    img: "/assets/Slot/YGG-SLOT-138.webp?v=1767056428473",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-138",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Elements",
    img: "/assets/Slot/RT-SLOT-198.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-198",
    platFormCode: "RT",
  },
  {
    name: "Wild Esqueleto Lightning Chase",
    img: "/assets/Slot/RELAX-SLOT-112.webp?v=1761904551091",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-112",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Expedition",
    img: "/assets/Slot/RT-SLOT-218.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-218",
    platFormCode: "RT",
  },
  {
    name: "Wild Fairies",
    img: "/assets/Slot/1wt58azdhdo6c.Wild-Fairies.webp?v=1765044294801",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-173",
    platFormCode: "JOKER",
  },
  {
    name: "Wild Fireworks",
    img: "/assets/Slot/PG-SLOT-055.webp?v=1765933237794",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-055",
    platFormCode: "PG",
  },
  {
    name: "Wild Fishin' Wild Ways",
    img: "/assets/Slot/YGG-SLOT-163.webp?v=1767056428501",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-163",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Flower",
    img: "/assets/Slot/BTG-SLOT-030.webp?v=1756256536949",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-030",
    platFormCode: "BTG",
  },
  {
    name: "Wild Gangs",
    img: "/assets/Slot/YGG-SLOT-403.webp?v=1767056428914",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-403",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Giant Panda",
    img: "/assets/Slot/q9gi4yybyadoe.Wild-Giant-Panda.webp?v=1765049426838",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-174",
    platFormCode: "JOKER",
  },
  {
    name: "Wild Heist Cashout",
    img: "/assets/Slot/PG-SLOT-126.webp?v=1765933237850",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-126",
    platFormCode: "PG",
  },
  {
    name: "Wild Hike",
    img: "/assets/Slot/RELAX-SLOT-164.webp?v=1761904584790",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-164",
    platFormCode: "RELAX",
  },
  {
    name: "Wild Hop & Drop",
    img: "/assets/Slot/PP-SLOT-287.Wild-Hop-&-Drop.webp?v=1764316272123",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-287",
    platFormCode: "PP",
  },
  {
    name: "Wild Hot Chilli Reels",
    img: "/assets/Slot/RT-SLOT-208.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-208",
    platFormCode: "RT",
  },
  {
    name: "Wild Joker Blitz",
    img: "/assets/Slot/YGG-SLOT-347.webp?v=1767056428851",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-347",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Joker Stacks",
    img: "/assets/Slot/YGG-SLOT-015.webp?v=1767056428341",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-015",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Lava",
    img: "/assets/Slot/PT-SLOT-184.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-184",
    platFormCode: "PT",
  },
  {
    name: "Wild Lava Scratch",
    img: "/assets/Slot/PT-SLOT-246.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-246",
    platFormCode: "PT",
  },
  {
    name: "Wild Linx",
    img: "/assets/Slot/PT-SLOT-159.Wild Linx.webp?v=1764329922948",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-159",
    platFormCode: "PT",
  },
  {
    name: "Wild Mining XXXtreme",
    img: "/assets/Slot/NETENT-SLOT-225.wild-ming-xxxtreme.webp?v=1764952730254",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-225",
    platFormCode: "NETENT",
  },
  {
    name: "Wild O'Clock",
    img: "/assets/Slot/RT-SLOT-199.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-199",
    platFormCode: "RT",
  },
  {
    name: "Wild One",
    img: "/assets/Slot/YGG-SLOT-152.webp?v=1767056428485",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-152",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Pixies",
    img: "/assets/Slot/PP-SLOT-081.Wild-Pixies.webp?v=1764316207870",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-081",
    platFormCode: "PP",
  },
  {
    name: "Wild Portals",
    img: "/assets/Slot/BTG-SLOT-026.webp?v=1756256536946",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-026",
    platFormCode: "BTG",
  },
  {
    name: "Wild Racer",
    img: "/assets/Slot/JILI-SLOT-072.webp?v=1755509913162",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-072",
    platFormCode: "JILI",
  },
  {
    name: "Wild Robo Factory",
    img: "/assets/Slot/YGG-SLOT-041.webp?v=1767056428368",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-041",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Roll",
    img: "/assets/Slot/PT-SLOT-419.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-419",
    platFormCode: "PT",
  },
  {
    name: "Wild Spells",
    img: "/assets/Slot/PP-SLOT-120.Wild-Spells.webp?v=1764315650040",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-120",
    platFormCode: "PP",
  },
  {
    name: "Wild Spirit",
    img: "/assets/Slot/itzp5iqk3xrc1.Wild-Spirit.webp?v=1765052305671",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-175",
    platFormCode: "JOKER",
  },
  {
    name: "Wild Stack Frenzy",
    img: "/assets/Slot/YGG-SLOT-224.webp?v=1767056428570",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-224",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Storm Legionnaire",
    img: "/assets/Slot/YGG-SLOT-270.webp?v=1767056428777",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-270",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wild Touchdown Megaways",
    img: "/assets/Slot/RT-SLOT-340.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-340",
    platFormCode: "RT",
  },
  {
    name: "Wild Tundra",
    img: "/assets/Slot/RT-SLOT-189.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-189",
    platFormCode: "RT",
  },
  {
    name: "Wild Unicorns",
    img: "/assets/Slot/BTG-SLOT-033.webp?v=1756256536952",
    platForm: "BTG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "BTG-SLOT-033",
    platFormCode: "BTG",
  },
  {
    name: "Wild Walker",
    img: "/assets/Slot/PP-SLOT-026.Wild-Walker.webp?v=1764315595466",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-026",
    platFormCode: "PP",
  },
  {
    name: "Wild Watermelon",
    img: "/assets/Slot/gdrbc1kqj7gr4.Wild Watermelon.webp?v=1765036546156",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-206",
    platFormCode: "JOKER",
  },
  {
    name: "Wild West Duels",
    img: "/assets/Slot/PP-SLOT-325.Wild-West-Duels.webp?v=1764315479816",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-325",
    platFormCode: "PP",
  },
  {
    name: "Wild West Gold",
    img: "/assets/Slot/PP-SLOT-052.Wild-West-Gold.webp?v=1764315365149",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-052",
    platFormCode: "PP",
  },
  {
    name: "Wild West Gold Blazing Bounty",
    img: "/assets/Slot/PP-SLOT-576.webp?v=1755572567040",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-576",
    platFormCode: "PP",
  },
  {
    name: "Wild West Gold Megaways",
    img: "/assets/Slot/PP-SLOT-233.Wild-West-Gold-Megaways.webp?v=1764315130088",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-233",
    platFormCode: "PP",
  },
  {
    name: "Wild West Wilds",
    img: "/assets/Slot/PT-SLOT-201.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-201",
    platFormCode: "PT",
  },
  {
    name: "Wild Wet Win",
    img: "/assets/Slot/SG-SLOT-099.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-099",
    platFormCode: "SPADE",
  },
  {
    name: "Wild White Rhino",
    img: "/assets/Slot/OCTOPLAY-SLOT-082.Wild White Rhino.webp?v=1764938399840",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-082",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Wild Wild Bananas",
    img: "/assets/Slot/PP-SLOT-315.Wild-Wild-Bananas.webp?v=1764315021279",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-315",
    platFormCode: "PP",
  },
  {
    name: "Wild Wild Joker",
    img: "/assets/Slot/PP-SLOT-549.webp?v=1755571945294",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-549",
    platFormCode: "PP",
  },
  {
    name: "Wild Wild Pearls",
    img: "/assets/Slot/PP-SLOT-536.Wild Wild Pearls.webp?v=1764314880438",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-536",
    platFormCode: "PP",
  },
  {
    name: "Wild Wild Riches",
    img: "/assets/Slot/PP-SLOT-031.Wild-Wild-Riches.webp?v=1764314774949",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-031",
    platFormCode: "PP",
  },
  {
    name: "Wild Wild Riches Megaways",
    img: "/assets/Slot/PP-SLOT-323.Wild-Wild-Riches-Megaways.webp?v=1764314674837",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-323",
    platFormCode: "PP",
  },
  {
    name: "Wild Wild Riches Returns",
    img: "/assets/Slot/PP-SLOT-655.Wild Wild Riches Returns.webp?v=1764314541906",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-655",
    platFormCode: "PP",
  },
  {
    name: "Wild Wildebeest Wins",
    img: "/assets/Slot/PP-SLOT-538.Wild Wildebeest Wins.webp?v=1764314457356",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-538",
    platFormCode: "PP",
  },
  {
    name: "Wild Yield",
    img: "/assets/Slot/RELAX-SLOT-151.webp?v=1761904610936",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-151",
    platFormCode: "RELAX",
  },
  {
    name: "Wildchemy",
    img: "/assets/Slot/RELAX-SLOT-050.webp?v=1761904640663",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-050",
    platFormCode: "RELAX",
  },
  {
    name: "Wildies",
    img: "/assets/Slot/PP-SLOT-465.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-465",
    platFormCode: "PP",
  },
  {
    name: "Wildman Super Bonanza",
    img: "/assets/Slot/PP-SLOT-280.Wildman-Super-Bonanza.webp?v=1764314324997",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-280",
    platFormCode: "PP",
  },
  {
    name: "Wilfred's Wheel",
    img: "/assets/Slot/OCTOPLAY-SLOT-037.Wilfred_s Wheel.webp?v=1764938451378",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-037",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Wilhelm Tell",
    img: "/assets/Slot/YGG-SLOT-039.webp?v=1767056428365",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-039",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Win Drop",
    img: "/assets/Slot/JILI-SLOT-061.webp?v=1751418030805",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-061",
    platFormCode: "JILI",
  },
  {
    name: "Win Escalator",
    img: "/assets/Slot/RT-SLOT-195.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-195",
    platFormCode: "RT",
  },
  {
    name: "Win Win Fish Prawn Crab",
    img: "/assets/Slot/PG-SLOT-100.webp?v=1765933237828",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-100",
    platFormCode: "PG",
  },
  {
    name: "Win Win Won",
    img: "/assets/Slot/PG-SLOT-011.webp?v=1766369839569",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-011",
    platFormCode: "PG",
  },
  {
    name: "Win-O-Mart",
    img: "/assets/Slot/RELAX-SLOT-261.webp?v=1761904663223",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-261",
    platFormCode: "RELAX",
  },
  {
    name: "Winds Of Wealth",
    img: "/assets/Slot/9rb79bw8o1nzw.Winds Of Wealth.webp?v=1765051801263",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-217",
    platFormCode: "JOKER",
  },
  {
    name: "Wings Of Ra",
    img: "/assets/Slot/RT-SLOT-141.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-141",
    platFormCode: "RT",
  },
  {
    name: "Wings of Iguazu",
    img: "/assets/Slot/PG-SLOT-144.webp?v=1765933237870",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-144",
    platFormCode: "PG",
  },
  {
    name: "Winning Mask",
    img: "/assets/Slot/JDB-SLOT-011.Winning Mask.webp?v=1765259218237",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-011",
    platFormCode: "JDB",
  },
  {
    name: "WinningMask II",
    img: "/assets/Slot/JDB-SLOT-050.Winning Mask 2.webp?v=1765259150809",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-050",
    platFormCode: "JDB",
  },
  {
    name: "Wins of Mermaid Multipower",
    img: "/assets/Slot/RELAX-SLOT-223.webp?v=1761904686213",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-223",
    platFormCode: "RELAX",
  },
  {
    name: "Wins of Winter",
    img: "/assets/Slot/RELAX-SLOT-152.webp?v=1761904708622",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-152",
    platFormCode: "RELAX",
  },
  {
    name: "Winter Champions",
    img: "/assets/Slot/RELAX-SLOT-272.webp?v=1761904731511",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-272",
    platFormCode: "RELAX",
  },
  {
    name: "Winter Sweets",
    img: "/assets/Slot/ipz77igi3mfho.Winter-Sweets.webp?v=1765047729065",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-176",
    platFormCode: "JOKER",
  },
  {
    name: "Winterberries",
    img: "/assets/Slot/YGG-SLOT-090.webp?v=1767056428433",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-090",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Winterberries 2",
    img: "/assets/Slot/YGG-SLOT-179.webp?v=1767056428517",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-179",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wisdom of Athena",
    img: "/assets/Slot/PP-SLOT-354.Wisdom-of-Athena.webp?v=1764314161067",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-354",
    platFormCode: "PP",
  },
  {
    name: "Wisdom of Athena 1000",
    img: "/assets/Slot/PP-SLOT-499.Wisdom-of-Athena-1000.webp?v=1764314033462",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-499",
    platFormCode: "PP",
  },
  {
    name: "Wisdom of Athena 1000 Xmas",
    img: "/assets/Slot/PP-SLOT-662.Wisdom of Athena 1000 Xmas.webp?v=1764940501677",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-662",
    platFormCode: "PP",
  },
  {
    name: "Wish for a Cash Star",
    img: "/assets/Slot/OCTOPLAY-SLOT-071.Wish for a Cash Star.webp?v=1764938531346",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-071",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Witch's Brew",
    img: "/assets/Slot/bmr8675wqiigs.Witch_s-Brew.webp?v=1765051614214",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-177",
    platFormCode: "JOKER",
  },
  {
    name: "Witchcraft Academy",
    img: "/assets/Slot/NETENT-SLOT-161.Witchcraft-Academy.webp?v=1764951845520",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-161",
    platFormCode: "NETENT",
  },
  {
    name: "Witches Night",
    img: "/assets/Slot/JILI-SLOT-095.webp?v=1755510381182",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-095",
    platFormCode: "JILI",
  },
  {
    name: "Witches: Cash Collect",
    img: "/assets/Slot/PT-SLOT-337.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-337",
    platFormCode: "PT",
  },
  {
    name: "Witchy Poppins",
    img: "/assets/Slot/RELAX-SLOT-271.webp?v=1761904801337",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-271",
    platFormCode: "RELAX",
  },
  {
    name: "Wizard Deluxe",
    img: "/assets/Slot/pz7wsnombyroh.Wizard-Deluxe.webp?v=1765046489887",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-178",
    platFormCode: "JOKER",
  },
  {
    name: "Wizzy Trix",
    img: "/assets/Slot/PT-SLOT-457.webp?v=1756275771674",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-457",
    platFormCode: "PT",
  },
  {
    name: "Wolf Gold",
    img: "/assets/Slot/PP-SLOT-127.Wolf-Gold.webp?v=1764313763918",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-127",
    platFormCode: "PP",
  },
  {
    name: "Wolf Gold 4 Pack",
    img: "/assets/Slot/PP-SLOT-584.Wolf Gold 4 Pack.webp?v=1764313647716",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-584",
    platFormCode: "PP",
  },
  {
    name: "Wolf Gold Ultimate",
    img: "/assets/Slot/PP-SLOT-518.Wolf Gold Ultimate.webp?v=1764313546580",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-518",
    platFormCode: "PP",
  },
  {
    name: "Wolf Hunters",
    img: "/assets/Slot/YGG-SLOT-035.webp?v=1767056428363",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-035",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Wolf Legend",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-024.wolf-legend.webp?v=1765271684044",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-024",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Wolf Stacks MegaWays",
    img: "/assets/Slot/RT-SLOT-344.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-344",
    platFormCode: "RT",
  },
  {
    name: "Wolfkin",
    img: "/assets/Slot/RT-SLOT-244.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-244",
    platFormCode: "RT",
  },
  {
    name: "Wonder Elephant",
    img: "/assets/Slot/JDB-SLOT-097.elephant_wonder.webp?v=1767691470889",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-097",
    platFormCode: "JDB",
  },
  {
    name: "Wonderful Christmas",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-072.wonderful-christmas.webp?v=1765269986116",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-072",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Wonderland Protector",
    img: "/assets/Slot/NETENT-SLOT-171.Wonderland-Protector.webp?v=1764951767857",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-171",
    platFormCode: "NETENT",
  },
  {
    name: "Wonders of Christmas",
    img: "/assets/Slot/NETENT-SLOT-132.Wonders-of-Christmas.webp?v=1764951697787",
    platForm: "NETENT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-132",
    platFormCode: "NETENT",
  },
  {
    name: "World Cup",
    img: "/assets/Slot/JILI-SLOT-063.webp?v=1755509865312",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-063",
    platFormCode: "JILI",
  },
  {
    name: "World Of Emoji",
    img: "/assets/Slot/sbrjp1qq39gc4.World Of Emoji.webp?v=1765028880999",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-215",
    platFormCode: "JOKER",
  },
  {
    name: "Worldie",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-067.worldie.webp?v=1765269887317",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-067",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Wrigley's World",
    img: "/assets/Slot/RT-SLOT-238.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-238",
    platFormCode: "RT",
  },
  {
    name: "Wu Long",
    img: "/assets/Slot/PT-SLOT-123.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-123",
    platFormCode: "PT",
  },
  {
    name: "Wu Lu Cai Shen",
    img: "/assets/Slot/CG-SLOT-036.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-036",
    platFormCode: "CG",
  },
  {
    name: "Wu Zi Ci Mile",
    img: "/assets/Slot/CG-SLOT-051.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-051",
    platFormCode: "CG",
  },
  {
    name: "Wu kong",
    img: "/assets/Slot/JDB-SLOT-012.wukong.webp?v=1765259033775",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-012",
    platFormCode: "JDB",
  },
  {
    name: "Wukong",
    img: "/assets/Slot/texkt79w6ziqs.Wukong.webp?v=1765028783982",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-179",
    platFormCode: "JOKER",
  },
  {
    name: "Wushu Punch",
    img: "/assets/Slot/PT-SLOT-233.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-233",
    platFormCode: "PT",
  },
  {
    name: "X-PLOSIVE ROCK",
    img: "/assets/Slot/2J-SLOT-054.X-PLOSIVE ROCK.webp?v=1763547602776",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-054",
    platFormCode: "JJ",
  },
  {
    name: "Xi Yang Yang",
    img: "/assets/Slot/JDB-SLOT-054.xi_yangyang.webp?v=1765258980724",
    platForm: "JDB",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-054",
    platFormCode: "JDB",
  },
  {
    name: "XiYangYang",
    img: "/assets/Slot/JILI-SLOT-018.webp?v=1755509281708",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-018",
    platFormCode: "JILI",
  },
  {
    name: "Xibalba",
    img: "/assets/Slot/YGG-SLOT-071.webp?v=1767056428408",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-071",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Xmas Pop Delight",
    img: "/assets/Slot/YGG-SLOT-313.webp?v=1767056428813",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-313",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Xtreme Fire Blaze Roulette",
    img: "/assets/Slot/PT-SLOT-353.Xtreme Fire Blaze Roulette.webp?v=1762321214585",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-353",
    platFormCode: "PT",
  },
  {
    name: "Xuan Pu Lian Huan",
    img: "/assets/Slot/c41bsraonrmbq.Xuan-Pu-Lian-Huan.webp?v=1765036589922",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-180",
    platFormCode: "JOKER",
  },
  {
    name: "Y-PLOSIVE ROCK",
    img: "/assets/Slot/2J-SLOT-055.Y-PLOSIVE ROCK.webp?v=1763547560362",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-055",
    platFormCode: "JJ",
  },
  {
    name: "Yakuza",
    img: "/assets/Slot/y4jnah5oqf58q.Yakuza.webp?v=1765054085763",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-181",
    platFormCode: "JOKER",
  },
  {
    name: "Yakuza Honor",
    img: "/assets/Slot/PG-SLOT-143.webp?v=1765933237869",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-143",
    platFormCode: "PG",
  },
  {
    name: "Year of Olympia",
    img: "/assets/Slot/YGG-SLOT-263.webp?v=1767056428771",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-263",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Year of the Dragon King",
    img: "/assets/Slot/PP-SLOT-406.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-406",
    platFormCode: "PP",
  },
  {
    name: "Year-Round Riches Clusterbuster",
    img: "/assets/Slot/RT-SLOT-269.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-269",
    platFormCode: "RT",
  },
  {
    name: "Yeh Hsien Deluxe",
    img: "/assets/Slot/uygm7axgh91qk.Yeh-Hsien-Deluxe.webp?v=1765027277133",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-182",
    platFormCode: "JOKER",
  },
  {
    name: "Yeti Quest",
    img: "/assets/Slot/PP-SLOT-484.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-484",
    platFormCode: "PP",
  },
  {
    name: "Yggdrasil",
    img: "/assets/Slot/9ii7s6u5xbhzh.Yggdrasil.webp?v=1765027217185",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-183",
    platFormCode: "JOKER",
  },
  {
    name: "Yokozuna Clash",
    img: "/assets/Slot/YGG-SLOT-042.webp?v=1767056428369",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-042",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "You Can Piggy Bank On It",
    img: "/assets/Slot/PP-SLOT-581.You Can Piggy Bank On It.webp?v=1764313366066",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-581",
    platFormCode: "PP",
  },
  {
    name: "You Will Win",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-057.you-will-win.webp?v=1765269722250",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-057",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Your Own Island",
    img: "/assets/Slot/YGG-SLOT-414.webp?v=1767056428923",
    platForm: "YGGDRASIL",
    type: "slots",
    gameType: "SLOT",
    casinoType: "YGG-SLOT-414",
    platFormCode: "YGGDRASIL",
  },
  {
    name: "Yu Tu Jin Cai: Cash Collect",
    img: "/assets/Slot/PT-SLOT-237.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-237",
    platFormCode: "PT",
  },
  {
    name: "Yucatan's Mystery",
    img: "/assets/Slot/RT-SLOT-170.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-170",
    platFormCode: "RT",
  },
  {
    name: "Yun Cong Long",
    img: "/assets/Slot/PT-SLOT-028.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-028",
    platFormCode: "PT",
  },
  {
    name: "ZEUS",
    img: "/assets/Slot/FC-SLOT-029.webp?v=1751418030798",
    platForm: "FC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "FC-SLOT-029",
    platFormCode: "FC",
  },
  {
    name: "ZEUS",
    img: "/assets/Slot/SG-SLOT-016.webp?v=1751418030688",
    platForm: "SPADE",
    type: "slots",
    gameType: "SLOT",
    casinoType: "SG-SLOT-016",
    platFormCode: "SPADE",
  },
  {
    name: "ZEUS POWER",
    img: "/assets/Slot/2J-SLOT-010.ZEUS POWER.webp?v=1763547486878",
    platForm: "JJ",
    type: "slots",
    gameType: "SLOT",
    casinoType: "2J-SLOT-010",
    platFormCode: "JJ",
  },
  {
    name: "ZHAO YUN",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-040.zhao-yun.webp?v=1765269664592",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-040",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Zaida's Fortune",
    img: "/assets/Slot/RT-SLOT-186.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-186",
    platFormCode: "RT",
  },
  {
    name: "Zeus",
    img: "/assets/Slot/JILI-SLOT-097.webp?v=1755510412638",
    platForm: "JILI",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-097",
    platFormCode: "JILI",
  },
  {
    name: "Zeus",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-028.zeus.webp?v=1765269616841",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-028",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Zeus",
    img: "/assets/Slot/ACEWIN-SLOT-019.Zeus.webp?v=1764854976529",
    platForm: "ACEWIN",
    type: "slots",
    gameType: "SLOT",
    casinoType: "ACEWIN-SLOT-019",
    platFormCode: "ACEWIN",
  },
  {
    name: "Zeus Smash",
    img: "/assets/Slot/OCTOPLAY-SLOT-027.Zeus Smash.webp?v=1764938620276",
    platForm: "OCTOPLAY",
    type: "slots",
    gameType: "SLOT",
    casinoType: "OCTOPLAY-SLOT-027",
    platFormCode: "OCTOPLAY",
  },
  {
    name: "Zeus vs Hades - Gods of War",
    img: "/assets/Slot/PP-SLOT-346.Zeus-vs-Hades-Gods-of-War.webp?v=1764312948793",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-346",
    platFormCode: "PP",
  },
  {
    name: "Zeus vs Typhon",
    img: "/assets/Slot/PP-SLOT-661.Zeus vs Typhon.webp?v=1764940343737",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-661",
    platFormCode: "PP",
  },
  {
    name: "Zhao Cai Jin Bao",
    img: "/assets/Slot/PT-SLOT-012.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-012",
    platFormCode: "PT",
  },
  {
    name: "Zhao Cai Jin Bao",
    img: "/assets/Slot/CG-SLOT-039.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-039",
    platFormCode: "CG",
  },
  {
    name: "Zhao Cai Jin Bao 2",
    img: "/assets/Slot/PT-SLOT-180.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-180",
    platFormCode: "PT",
  },
  {
    name: "Zhao Cai Tong Zi",
    img: "/assets/Slot/PT-SLOT-014.webp?v=1751418030707",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-014",
    platFormCode: "PT",
  },
  {
    name: "Zhao Cai Tong Zi",
    img: "/assets/Slot/CG-SLOT-038.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-038",
    platFormCode: "CG",
  },
  {
    name: "Zhen Long Ju Bao",
    img: "/assets/Slot/DRAGOONSOFT-SLOT-083.zhen-long-ju-bao.webp?v=1765269571651",
    platForm: "DRAGOONSOFT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-083",
    platFormCode: "DRAGOONSOFT",
  },
  {
    name: "Zillard King",
    img: "/assets/Slot/RT-SLOT-102.webp?v=1751418030566",
    platForm: "RT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RT-SLOT-102",
    platFormCode: "RT",
  },
  {
    name: "Zodiac Charms",
    img: "/assets/Slot/PT-SLOT-164.zodiac-charms.webp?v=1764328328357",
    platForm: "PT",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PT-SLOT-164",
    platFormCode: "PT",
  },
  {
    name: "Zodiac Deluxe",
    img: "/assets/Slot/hj5cb8hhusjjg.Zodiac-Deluxe.webp?v=1765027088280",
    platForm: "Joker",
    type: "slots",
    gameType: "SLOT",
    casinoType: "JOKER-SLOT-185",
    platFormCode: "JOKER",
  },
  {
    name: "Zombie Carnival",
    img: "/assets/Slot/PP-SLOT-252.Zombie-Carnival.webp?v=1764312762518",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-252",
    platFormCode: "PP",
  },
  {
    name: "Zombie Circus",
    img: "/assets/Slot/RELAX-SLOT-051.webp?v=1761883852180",
    platForm: "RELAX",
    type: "slots",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-051",
    platFormCode: "RELAX",
  },
  {
    name: "Zombie Hunter",
    img: "/assets/Slot/CG-SLOT-063.webp?v=1751418030825",
    platForm: "CG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "CG-SLOT-063",
    platFormCode: "CG",
  },
  {
    name: "Zombie Outbreak",
    img: "/assets/Slot/PG-SLOT-139.webp?v=1765933237861",
    platForm: "PG",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PG-SLOT-139",
    platFormCode: "PG",
  },
  {
    name: "Zombie School Megaways",
    img: "/assets/Slot/PP-SLOT-590.Zombie School Megaways.webp?v=1764312646566",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-590",
    platFormCode: "PP",
  },
  {
    name: "Zombie Train",
    img: "/assets/Slot/PP-SLOT-437.webp?v=1751418030744",
    platForm: "PP",
    type: "slots",
    gameType: "SLOT",
    casinoType: "PP-SLOT-437",
    platFormCode: "PP",
  },
  {
    name: "gluttony",
    img: "/assets/Slot/NLC-SLOT-069.gluttony.webp?v=1764385221886",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-069",
    platFormCode: "NLC",
  },
  {
    name: "xWays Hoarder 2",
    img: "/assets/Slot/NLC-SLOT-105.xWays Hoarder 2.webp?v=1764385160819",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-105",
    platFormCode: "NLC",
  },
  {
    name: "xWays Hoarder xSplit",
    img: "/assets/Slot/NLC-SLOT-013.xWays Hoarder xSplit.webp?v=1764385111260",
    platForm: "NLC",
    type: "slots",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-013",
    platFormCode: "NLC",
  },
];
export const TableNew = [
  {
    name: "32 Cards",
    img: "/assets/Table/KM-TABLE-039.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-039",
    platFormCode: "KINGMAKER",
  },
  {
    name: "7 Up 7 Down",
    img: "/assets/Table/KM-TABLE-028.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-028",
    platFormCode: "KINGMAKER",
  },
  {
    name: "7 Up 7 Down Rush",
    img: "/assets/Table/KM-TABLE-088.webp?v=1755671744847",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-088",
    platFormCode: "KINGMAKER",
  },
  {
    name: "7up7down",
    img: "/assets/Table/JILI-TABLE-011.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-011",
    platFormCode: "JILI",
  },
  {
    name: "AK47",
    img: "/assets/Table/JILI-TABLE-002.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-002",
    platFormCode: "JILI",
  },
  {
    name: "American Roulette",
    img: "/assets/Table/NETENT-SLOT-057.American-Roulette.webp?v=1764967478385",
    platForm: "NETENT",
    type: "table",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-057",
    platFormCode: "NETENT",
  },
  {
    name: "Andar Bahar",
    img: "/assets/Table/JILI-TABLE-003.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-003",
    platFormCode: "JILI",
  },
  {
    name: "Andar Bahar",
    img: "/assets/Table/KM-TABLE-032.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-032",
    platFormCode: "KINGMAKER",
  },
  {
    name: "BURMESE 6 ANIMALS",
    img: "/assets/Table/KM-TABLE-083.burmese-6-animals.webp?v=1764374606150",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-083",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Baccarat",
    img: "/assets/Table/JILI-TABLE-014.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-014",
    platFormCode: "JILI",
  },
  {
    name: "Baccarat",
    img: "/assets/Table/KM-TABLE-026.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-026",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Baccarat Deluxe",
    img: "/assets/Table/PG-TABLE-001.webp?v=1765933237892",
    platForm: "PG",
    type: "table",
    gameType: "TABLE",
    casinoType: "PG-TABLE-001",
    platFormCode: "PG",
  },
  {
    name: "Bai Buu",
    img: "/assets/Table/KM-TABLE-029.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-029",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Bai Cao Mystic Four",
    img: "/assets/Table/KM-TABLE-093.Bai Cao Mystic Four.webp?v=1764374636676",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-093",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Bicho",
    img: "/assets/Table/KM-TABLE-082.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-082",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Big Small Casino Royale",
    img: "/assets/Table/JILI-TABLE-084.Big Small Casino Royale.webp?v=1764317293719",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-084",
    platFormCode: "JILI",
  },
  {
    name: "Big small",
    img: "/assets/Table/JILI-TABLE-007.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-007",
    platFormCode: "JILI",
  },
  {
    name: "Blackjack",
    img: "/assets/Table/JILI-TABLE-044.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-044",
    platFormCode: "JILI",
  },
  {
    name: "Blackjack",
    img: "/assets/Table/KM-TABLE-038.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-038",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Blackjack Lucky Ladies",
    img: "/assets/Table/JILI-TABLE-046.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-046",
    platFormCode: "JILI",
  },
  {
    name: "Blackjack Neo",
    img: "/assets/Table/RELAX-TABLE-001.webp?v=1761912826597",
    platForm: "RELAX",
    type: "table",
    gameType: "TABLE",
    casinoType: "RELAX-TABLE-001",
    platFormCode: "RELAX",
  },
  {
    name: "BolaTangkas",
    img: "/assets/Table/KM-TABLE-052.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-052",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Bonus Dice",
    img: "/assets/Table/KM-TABLE-043.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-043",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Boxing Extravaganza",
    img: "/assets/Table/JILI-TABLE-062.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-062",
    platFormCode: "JILI",
  },
  {
    name: "CHICKEN CROSSY",
    img: "/assets/Table/KM-TABLE-086.webp?v=1753843874004",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-086",
    platFormCode: "KINGMAKER",
  },
  {
    name: "COLOR GAME MEGA BONUS",
    img: "/assets/Table/KM-TABLE-087.webp?v=1754449929400",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-087",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Callbreak",
    img: "/assets/Table/JILI-TABLE-009.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-009",
    platFormCode: "JILI",
  },
  {
    name: "Callbreak Quick",
    img: "/assets/Table/JILI-TABLE-013.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-013",
    platFormCode: "JILI",
  },
  {
    name: "Card Matka",
    img: "/assets/Table/KM-TABLE-022.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-022",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Cards Hi Lo",
    img: "/assets/Table/KM-TABLE-037.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-037",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Caribbean Stud Poker",
    img: "/assets/Table/JILI-TABLE-049.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-049",
    platFormCode: "JILI",
  },
  {
    name: "Casino Hold'em",
    img: "/assets/Table/NETENT-SLOT-088.casino-hold_em.webp?v=1764967428210",
    platForm: "NETENT",
    type: "table",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-088",
    platFormCode: "NETENT",
  },
  {
    name: "Coin Toss",
    img: "/assets/Table/JILI-TABLE-095.webp?v=1769054172945",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-036",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Coin Toss",
    img: "/assets/Table/KM-TABLE-036.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-036",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Color Game",
    img: "/assets/Table/JILI-TABLE-023.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-023",
    platFormCode: "JILI",
  },
  {
    name: "Color Game Extreme",
    img: "/assets/Table/JILI-TABLE-078.color-game-extreme.webp?v=1764316569053",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-078",
    platFormCode: "JILI",
  },
  {
    name: "Color Prediction",
    img: "/assets/Table/JILI-TABLE-039.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-039",
    platFormCode: "JILI",
  },
  {
    name: "Cricket Roulette",
    img: "/assets/Table/JILI-TABLE-060.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-060",
    platFormCode: "JILI",
  },
  {
    name: "Cricket War",
    img: "/assets/Table/JILI-TABLE-069.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-069",
    platFormCode: "JILI",
  },
  {
    name: "Dice",
    img: "/assets/Table/SPRIBE-EGAME-003.dice.webp?v=1765114677781",
    platForm: "SPRIBE",
    type: "table",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-003",
    platFormCode: "SPRIBE",
  },
  {
    name: "Dice Duet",
    img: "/assets/Table/KM-TABLE-078.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-078",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Domino Go",
    img: "/assets/Table/JILI-TABLE-073.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-073",
    platFormCode: "JILI",
  },
  {
    name: "Dota Hi-Lo",
    img: "/assets/Table/KM-TABLE-044.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-044",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Dragon & Tiger",
    img: "/assets/Table/JILI-TABLE-012.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-012",
    platFormCode: "JILI",
  },
  {
    name: "Drop Ball",
    img: "/assets/Table/JILI-TABLE-086.Drop Ball.webp?v=1764317471656",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-086",
    platFormCode: "JILI",
  },
  {
    name: "Egyptian Mines",
    img: "/assets/Table/KM-TABLE-081.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-081",
    platFormCode: "KINGMAKER",
  },
  {
    name: "European Roulette",
    img: "/assets/Table/NETENT-SLOT-064.Europea Roulette.webp?v=1764967376456",
    platForm: "NETENT",
    type: "table",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-064",
    platFormCode: "NETENT",
  },
  {
    name: "European Roulette",
    img: "/assets/Table/JILI-TABLE-053.european-roulette.webp?v=1764313414861",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-053",
    platFormCode: "JILI",
  },
  {
    name: "European Roulette",
    img: "/assets/Table/KM-TABLE-027.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-027",
    platFormCode: "KINGMAKER",
  },
  {
    name: "FAN TAN",
    img: "/assets/Table/FanTan.FAN TAN.webp?v=1764777395859",
    platForm: "EVOLUTION",
    type: "table",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-178",
    platFormCode: "EVOLUTION",
  },
  {
    name: "Fish Prawn Crab",
    img: "/assets/Table/JILI-TABLE-057.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-057",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Gems Scratch",
    img: "/assets/Table/JILI-TABLE-068.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-068",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Roulette",
    img: "/assets/Table/JILI-TABLE-066.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-066",
    platFormCode: "JILI",
  },
  {
    name: "French Roulette",
    img: "/assets/Table/NETENT-SLOT-066.french-roulette.webp?v=1764967325547",
    platForm: "NETENT",
    type: "table",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-066",
    platFormCode: "NETENT",
  },
  {
    name: "Fruit Roulette",
    img: "/assets/Table/KM-TABLE-025.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-025",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Gallina Fortunata",
    img: "/assets/Table/JILI-TABLE-083.Gallina Fortunata.webp?v=1764317568104",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-083",
    platFormCode: "JILI",
  },
  {
    name: "Go For Champion",
    img: "/assets/Table/JILI-TABLE-067.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-067",
    platFormCode: "JILI",
  },
  {
    name: "Goal",
    img: "/assets/Table/SPRIBE-EGAME-002.goal.webp?v=1765114630544",
    platForm: "SPRIBE",
    type: "table",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-002",
    platFormCode: "SPRIBE",
  },
  {
    name: "Golden Land",
    img: "/assets/Table/JILI-TABLE-027.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-027",
    platFormCode: "JILI",
  },
  {
    name: "Golden Treasure",
    img: "/assets/Table/JILI-TABLE-077.golden-treasure.webp?v=1764313354710",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-077",
    platFormCode: "JILI",
  },
  {
    name: "Golden Treasure Lightning",
    img: "/assets/Table/JILI-TABLE-079.webp?v=1752129354267",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-079",
    platFormCode: "JILI",
  },
  {
    name: "HILO",
    img: "/assets/Table/JILI-TABLE-032.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-032",
    platFormCode: "JILI",
  },
  {
    name: "Heist",
    img: "/assets/Table/KM-TABLE-047.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-047",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Hilo",
    img: "/assets/Table/SPRIBE-EGAME-006.hilo.webp?v=1765114410878",
    platForm: "SPRIBE",
    type: "table",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-006",
    platFormCode: "SPRIBE",
  },
  {
    name: "HorseRacing",
    img: "/assets/Table/KM-TABLE-048.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-048",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Hotline",
    img: "/assets/Table/SPRIBE-EGAME-009.hotline.webp?v=1765114368680",
    platForm: "SPRIBE",
    type: "table",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-009",
    platFormCode: "SPRIBE",
  },
  {
    name: "Jhandi Munda",
    img: "/assets/Table/JILI-TABLE-056.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-056",
    platFormCode: "JILI",
  },
  {
    name: "Jogo de Bozó",
    img: "/assets/Table/KM-TABLE-080.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-080",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Keno",
    img: "/assets/Table/SPRIBE-EGAME-007.keno.webp?v=1765113944421",
    platForm: "SPRIBE",
    type: "table",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-007",
    platFormCode: "SPRIBE",
  },
  {
    name: "Keno Bonus Number",
    img: "/assets/Table/JILI-TABLE-065.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-065",
    platFormCode: "JILI",
  },
  {
    name: "Keno Super Chance",
    img: "/assets/Table/JILI-TABLE-071.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-071",
    platFormCode: "JILI",
  },
  {
    name: "LADDER GAME",
    img: "/assets/Table/KM-TABLE-079.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-079",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Ludo Quick",
    img: "/assets/Table/JILI-TABLE-021.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-021",
    platFormCode: "JILI",
  },
  {
    name: "MINI FLUSH",
    img: "/assets/Table/JILI-TABLE-042.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-042",
    platFormCode: "JILI",
  },
  {
    name: "Marble Knockout",
    img: "/assets/Table/KM-TABLE-053.km-marble-knockout.webp?v=1764375069188",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-053",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Mines",
    img: "/assets/Table/SPRIBE-EGAME-005.mines.webp?v=1765113907918",
    platForm: "SPRIBE",
    type: "table",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-005",
    platFormCode: "SPRIBE",
  },
  {
    name: "Mines",
    img: "/assets/Table/JILI-TABLE-033.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-033",
    platFormCode: "JILI",
  },
  {
    name: "Mines Cricket",
    img: "/assets/Table/JILI-TABLE-080.webp?v=1756286271107",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-080",
    platFormCode: "JILI",
  },
  {
    name: "Mines Gold",
    img: "/assets/Table/JILI-TABLE-037.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-037",
    platFormCode: "JILI",
  },
  {
    name: "Mines Grand",
    img: "/assets/Table/JILI-TABLE-076.mines-grand.webp?v=1764316483044",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-076",
    platFormCode: "JILI",
  },
  {
    name: "Minesweeper",
    img: "/assets/Table/KM-TABLE-042.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-042",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Mini Roulette",
    img: "/assets/Table/SPRIBE-EGAME-008.mini-roulette.webp?v=1765113868731",
    platForm: "SPRIBE",
    type: "table",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-008",
    platFormCode: "SPRIBE",
  },
  {
    name: "Money Wheel Deluxe",
    img: "/assets/Table/KM-TABLE-090.Money Wheel Deluxe.webp?v=1764375105044",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-090",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Monkey King Roulette",
    img: "/assets/Table/KM-TABLE-045.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-045",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Number Matka",
    img: "/assets/Table/KM-TABLE-021.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-021",
    platFormCode: "KINGMAKER",
  },
  {
    name: "PAPPU",
    img: "/assets/Table/JILI-TABLE-028.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-028",
    platFormCode: "JILI",
  },
  {
    name: "Plinko",
    img: "/assets/Table/SPRIBE-EGAME-004.plinko.webp?v=1765113820905",
    platForm: "SPRIBE",
    type: "table",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-004",
    platFormCode: "SPRIBE",
  },
  {
    name: "Plinko",
    img: "/assets/Table/JILI-TABLE-041.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-041",
    platFormCode: "JILI",
  },
  {
    name: "Plinko of Mine",
    img: "/assets/Table/JILI-TABLE-085.Plinko of Mine.webp?v=1764317365027",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-085",
    platFormCode: "JILI",
  },
  {
    name: "Poker King",
    img: "/assets/Table/JILI-TABLE-006.poker-king.webp?v=1764315831214",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-006",
    platFormCode: "JILI",
  },
  {
    name: "Pool Rummy",
    img: "/assets/Table/JILI-TABLE-048.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-048",
    platFormCode: "JILI",
  },
  {
    name: "Pusoy",
    img: "/assets/Table/KM-TABLE-065.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-065",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Pusoy Go",
    img: "/assets/Table/JILI-TABLE-038.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-038",
    platFormCode: "JILI",
  },
  {
    name: "Roulette Nouveau",
    img: "/assets/Table/RELAX-TABLE-002.webp?v=1761912866430",
    platForm: "RELAX",
    type: "table",
    gameType: "TABLE",
    casinoType: "RELAX-TABLE-002",
    platFormCode: "RELAX",
  },
  {
    name: "Roulette Touch",
    img: "/assets/Table/NETENT-SLOT-122.Roulette-Touch.webp?v=1764962963927",
    platForm: "NETENT",
    type: "table",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-122",
    platFormCode: "NETENT",
  },
  {
    name: "Rummy",
    img: "/assets/Table/JILI-TABLE-004.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-004",
    platFormCode: "JILI",
  },
  {
    name: "Rummy",
    img: "/assets/Table/JDB-TABLE-009.Rummy.webp?v=1765264905170",
    platForm: "JDB",
    type: "table",
    gameType: "TABLE",
    casinoType: "JDB-TABLE-009",
    platFormCode: "JDB",
  },
  {
    name: "Sic Bo",
    img: "/assets/Table/JILI-TABLE-017.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-017",
    platFormCode: "JILI",
  },
  {
    name: "Speed Baccarat",
    img: "/assets/Table/JILI-TABLE-054.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-054",
    platFormCode: "JILI",
  },
  {
    name: "Speedy Andar Bahar",
    img: "/assets/Table/KM-TABLE-084.speedy-andar-bahar.webp?v=1764375151820",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-084",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Streak of Luck: Double Dice",
    img: "/assets/Table/PT-SLOT-411.webp?v=1751418030707",
    platForm: "PT",
    type: "table",
    gameType: "SLOT",
    casinoType: "PT-SLOT-411",
    platFormCode: "PT",
  },
  {
    name: "Super Ace Scratch",
    img: "/assets/Table/JILI-TABLE-059.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-059",
    platFormCode: "JILI",
  },
  {
    name: "Super E-Sabong",
    img: "/assets/Table/JILI-TABLE-064.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-064",
    platFormCode: "JILI",
  },
  {
    name: "Tai Xiu",
    img: "/assets/Table/KM-TABLE-017.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "LIVE",
    casinoType: "VIACASINO-LIVE-009",
    platFormCode: "VIACASINO",
  },
  {
    name: "Teen Patti",
    img: "/assets/Table/JILI-TABLE-001.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-001",
    platFormCode: "JILI",
  },
  {
    name: "Teen Patti",
    img: "/assets/Table/KM-TABLE-046.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-046",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Teen Patti Blitz",
    img: "/assets/Table/KM-TABLE-085.webp?v=1754449904343",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-085",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Teen Patti Versus",
    img: "/assets/Table/KM-TABLE-092.Teen Patti Versus.webp?v=1764375221654",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-092",
    platFormCode: "KINGMAKER",
  },
  {
    name: "TeenPatti 20-20",
    img: "/assets/Table/JILI-TABLE-016.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-016",
    platFormCode: "JILI",
  },
  {
    name: "TeenPatti Joker",
    img: "/assets/Table/JILI-TABLE-010.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-010",
    platFormCode: "JILI",
  },
  {
    name: "Thai Fish Prawn Crab GO!",
    img: "/assets/Table/KM-TABLE-089.webp?v=1768441520884",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-089",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Thai Hilo",
    img: "/assets/Table/JILI-TABLE-063.thai_hilo.webp?v=1764313584669",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-063",
    platFormCode: "JILI",
  },
  {
    name: "Three Dice",
    img: "/assets/Table/ShaiZiSanGong.THREE DICE.webp?v=1764777136882",
    platForm: "RICH88",
    type: "table",
    gameType: "TABLE",
    casinoType: "JJ-TABLE-006",
    platFormCode: "JJ",
  },
  {
    name: "Tongits",
    img: "/assets/Table/KM-TABLE-063.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-063",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Tongits Go",
    img: "/assets/Table/JILI-TABLE-025.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-025",
    platFormCode: "JILI",
  },
  {
    name: "Tower",
    img: "/assets/Table/JILI-TABLE-031.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-031",
    platFormCode: "JILI",
  },
  {
    name: "Ultimate Texas Hold'em",
    img: "/assets/Table/JILI-TABLE-061.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-061",
    platFormCode: "JILI",
  },
  {
    name: "Video Poker",
    img: "/assets/Table/JILI-TABLE-050.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-050",
    platFormCode: "JILI",
  },
  {
    name: "Vietnam Rock Paper Scissors",
    img: "/assets/Table/KM-TABLE-094.Vietnam Rock Paper Scissors.webp?v=1764489210136",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-094",
    platFormCode: "KINGMAKER",
  },
  {
    name: "video-poker",
    img: "/assets/Table/KM-TABLE-073.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "table",
    gameType: "TABLE",
    casinoType: "KM-TABLE-073",
    platFormCode: "KINGMAKER",
  },
  {
    name: "wheel",
    img: "/assets/Table/JILI-TABLE-036.webp?v=1751418030805",
    platForm: "JILI",
    type: "table",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-036",
    platFormCode: "JILI",
  },

  {
    name: "Baccarat",
    img: "/assets/Table/HACKSAW-EGAME-011.Baccarat.webp?v=1764853592199",
    platForm: "HACKSAW",
    type: "table",
    gameType: "EGAME",
    casinoType: "HACKSAW-EGAME-011",
    platFormCode: "HACKSAW",
  },

  {
    name: "Twenty-one",
    img: "/assets/Table/HACKSAW-EGAME-010.Twenty-one.webp?v=1764853608079",
    type: "table",
    platForm: "HACKSAW",
    gameType: "EGAME",
    casinoType: "HACKSAW-EGAME-010",
    platFormCode: "HACKSAW",
  },
];

export const CarshNew = [
  {
    name: "1000x Busta",
    img: "/assets/Crash/RELAX-EGAME-001.1000x Busta.webp?v=1763104813861",
    platForm: "RELAX",
    type: "crash",
    gameType: "EGAME",
    casinoType: "RELAX-EGAME-001",
    platFormCode: "RELAX",
  },
  {
    name: "Angry Birds",
    img: "/assets/Crash/CG-EGAME-018.webp?v=1751418030825",
    platForm: "CG",
    type: "crash",
    gameType: "EGAME",
    casinoType: "CG-EGAME-018",
    platFormCode: "CG",
  },
  {
    name: "Astronaut",
    img: "/assets/Crash/CG-EGAME-019.webp?v=1751418030825",
    platForm: "CG",
    type: "crash",
    gameType: "EGAME",
    casinoType: "CG-EGAME-019",
    platFormCode: "CG",
  },
  {
    name: "Aviator",
    img: "/assets/Crash/SPRIBE-EGAME-001.aviator.webp?v=1765113760470",
    platForm: "SPRIBE",
    type: "crash",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
    platFormCode: "SPRIBE",
  },
  {
    name: "Aviator",
    img: "/assets/Crash/YL-EGAME-026.Aviator.webp?v=1764321492032",
    platForm: "YL",
    type: "crash",
    gameType: "EGAME",
    casinoType: "YL-EGAME-026",
    platFormCode: "YL",
  },
  {
    name: "Aviator Extra Bet",
    img: "/assets/Crash/JDB-EGAME-022.AVIATOR EXTRA BET.webp?v=1765184197361",
    platForm: "JDB",
    type: "crash",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-022",
    platFormCode: "JDB",
  },
  {
    name: "Big Bass Crash",
    img: "/assets/Crash/PP-EGAME-009.webp?v=1751418030744",
    platForm: "PP",
    type: "crash",
    gameType: "EGAME",
    casinoType: "PP-EGAME-009",
    platFormCode: "PP",
  },
  {
    name: "CRICKET BURST",
    img: "/assets/Crash/JDB-EGAME-021.Cricket Burst.webp?v=1765209022274",
    platForm: "JDB",
    type: "crash",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-021",
    platFormCode: "JDB",
  },
  {
    name: "Cash Rocket",
    img: "/assets/Crash/KM-TABLE-041.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "crash",
    gameType: "TABLE",
    casinoType: "KM-TABLE-041",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Crash",
    img: "/assets/Crash/YL-EGAME-016.webp?v=1751418030471",
    platForm: "YL",
    type: "crash",
    gameType: "EGAME",
    casinoType: "YL-EGAME-016",
    platFormCode: "YL",
  },
  {
    name: "Crash Bonus",
    img: "/assets/Crash/JILI-TABLE-047.webp?v=1751418030805",
    platForm: "JILI",
    type: "crash",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-047",
    platFormCode: "JILI",
  },
  {
    name: "Crash Cricket",
    img: "/assets/Crash/JILI-TABLE-058.webp?v=1751418030805",
    platForm: "JILI",
    type: "crash",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-058",
    platFormCode: "JILI",
  },
  {
    name: "Crash Goal",
    img: "/assets/Crash/JILI-TABLE-055.webp?v=1766118035068",
    platForm: "JILI",
    type: "crash",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-055",
    platFormCode: "JILI",
  },
  {
    name: "Crash Puck",
    img: "/assets/Crash/JILI-TABLE-081.Crash Puck.webp?v=1764312766073",
    platForm: "JILI",
    type: "crash",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-081",
    platFormCode: "JILI",
  },
  {
    name: "Crash Touchdown",
    img: "/assets/Crash/JILI-TABLE-070.webp?v=1751418030805",
    platForm: "JILI",
    type: "crash",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-070",
    platFormCode: "JILI",
  },
  {
    name: "Crash Trader",
    img: "/assets/Crash/JILI-TABLE-087.Crash Trader.webp?v=1767014117109",
    platForm: "JILI",
    type: "crash",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-087",
    platFormCode: "JILI",
  },
  {
    name: "CrossyRoad Crash",
    img: "/assets/Crash/CG-EGAME-017.webp?v=1751418030825",
    platForm: "CG",
    type: "crash",
    gameType: "EGAME",
    casinoType: "CG-EGAME-017",
    platFormCode: "CG",
  },
  {
    name: "Diamonds",
    img: "/assets/Crash/CRASH88-EGAME-006.webp?v=1767056428306",
    platForm: "CRASH88",
    type: "crash",
    gameType: "SLOT",
    casinoType: "RELAX-SLOT-141",
    platFormCode: "RELAX",
  },
  {
    name: "Elite Aviator Club",
    img: "/assets/Crash/KM-TABLE-069.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "crash",
    gameType: "TABLE",
    casinoType: "KM-TABLE-069",
    platFormCode: "KINGMAKER",
  },
  {
    name: "FIREWORK BURST",
    img: "/assets/Crash/JDB-EGAME-014.FIREWORK BURST.webp?v=1765184237824",
    platForm: "JDB",
    type: "crash",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-014",
    platFormCode: "JDB",
  },
  {
    name: "GO GO RISE",
    img: "/assets/Crash/FC-EGAME-006.webp?v=1751418030798",
    platForm: "FC",
    type: "crash",
    gameType: "EGAME",
    casinoType: "FC-EGAME-006",
    platFormCode: "FC",
  },
  {
    name: "Galaxy Burst",
    img: "/assets/Crash/JDB-EGAME-012.GALAXY BURST.webp?v=1765184271876",
    platForm: "JDB",
    type: "crash",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-012",
    platFormCode: "JDB",
  },
  {
    name: "Go Rush",
    img: "/assets/Crash/JILI-TABLE-030.webp?v=1751418030805",
    platForm: "JILI",
    type: "crash",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-030",
    platFormCode: "JILI",
  },
  {
    name: "High Flyer",
    img: "/assets/Crash/PP-EGAME-008.webp?v=1751418030744",
    platForm: "PP",
    type: "crash",
    gameType: "EGAME",
    casinoType: "PP-EGAME-008",
    platFormCode: "PP",
  },
  {
    name: "Interstellar Run",
    img: "/assets/Crash/KM-TABLE-070.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "crash",
    gameType: "TABLE",
    casinoType: "KM-TABLE-070",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Iron Dome",
    img: "/assets/Crash/KM-TABLE-075.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "crash",
    gameType: "TABLE",
    casinoType: "KM-TABLE-075",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Kart Crash",
    img: "/assets/Crash/CG-EGAME-015.webp?v=1751418030825",
    platForm: "CG",
    type: "crash",
    gameType: "EGAME",
    casinoType: "CG-EGAME-015",
    platFormCode: "CG",
  },
  {
    name: "Limbo",
    img: "/assets/Crash/JILI-TABLE-035.webp?v=1751418030805",
    platForm: "JILI",
    type: "crash",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-035",
    platFormCode: "JILI",
  },
  {
    name: "Mini Roulette",
    img: "/assets/Crash/CRASH88-EGAME-009.webp?v=1767056428310",
    platForm: "CRASH88",
    type: "crash",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-008",
    platFormCode: "SPRIBE",
  },
  {
    name: "Spaceman",
    img: "/assets/Crash/PP-EGAME-001.Spaceman.webp?v=1764412050949",
    platForm: "PP",
    type: "crash",
    gameType: "EGAME",
    casinoType: "PP-EGAME-001",
    platFormCode: "PP",
  },
  {
    name: "TOON CRASH",
    img: "/assets/Crash/KM-TABLE-076.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "crash",
    gameType: "TABLE",
    casinoType: "KM-TABLE-076",
    platFormCode: "KINGMAKER",
  },
];

export const FishingNew = [
  {
    name: "Aladdin Adventure",
    img: "/assets/Fishing/ACEWIN-FISH-003.Aladdin Adventure.webp?v=1764855214634",
    platForm: "ACEWIN",
    type: "fishing",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-003",
    platFormCode: "ACEWIN",
  },
  {
    name: "Alien Hunter",
    img: "/assets/Fishing/SG-FISH-003.webp?v=1751418030688",
    platForm: "SPADE",
    type: "fishing",
    gameType: "FH",
    casinoType: "SG-FISH-003",
    platFormCode: "SPADE",
  },
  {
    name: "All-star Fishing",
    img: "/assets/Fishing/JILI-FISH-009.all_star_fishing.webp?v=1764312947680",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-009",
    platFormCode: "JILI",
  },
  {
    name: "Bao Chuan Fishing",
    img: "/assets/Fishing/FC-FISH-002.webp?v=1751418030798",
    platForm: "FC",
    type: "fishing",
    gameType: "FH",
    casinoType: "FC-FISH-002",
    platFormCode: "FC",
  },
  {
    name: "Bombing Fishing",
    img: "/assets/Fishing/JILI-FISH-002.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-002",
    platFormCode: "JILI",
  },
  {
    name: "Boom Legend",
    img: "/assets/Fishing/JILI-FISH-008.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-008",
    platFormCode: "JILI",
  },
  {
    name: "Cai Shen Fishing",
    img: "/assets/Fishing/JDB-FISH-008.CAI SHEN FISHING.webp?v=1765206423243",
    platForm: "JDB",
    type: "fishing",
    gameType: "FH",
    casinoType: "JDB-FISH-008",
    platFormCode: "JDB",
  },
  {
    name: "Circus",
    img: "/assets/Fishing/ACEWIN-FISH-002.Circus.webp?v=1764855285805",
    platForm: "ACEWIN",
    type: "fishing",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-002",
    platFormCode: "ACEWIN",
  },
  {
    name: "Circus Jackpot",
    img: "/assets/Fishing/JILI-FISH-015.webp?v=1765360805430",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-015",
    platFormCode: "JILI",
  },
  {
    name: "Crazy Hunter",
    img: "/assets/Fishing/JILI-SLOT-045.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-045",
    platFormCode: "JILI",
  },
  {
    name: "Crazy Hunter 2",
    img: "/assets/Fishing/JILI-SLOT-099.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-099",
    platFormCode: "JILI",
  },
  {
    name: "Dinosaur Tycoon",
    img: "/assets/Fishing/JILI-FISH-004.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-004",
    platFormCode: "JILI",
  },
  {
    name: "Dinosaur Tycoon II",
    img: "/assets/Fishing/JILI-FISH-011.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-011",
    platFormCode: "JILI",
  },
  {
    name: "Dragon Fishing",
    img: "/assets/Fishing/JDB-FISH-016.DRAGON FISHING.webp?v=1765206543009",
    platForm: "JDB",
    type: "fishing",
    gameType: "FH",
    casinoType: "JDB-FISH-016",
    platFormCode: "JDB",
  },
  {
    name: "Dragon Fishing II",
    img: "/assets/Fishing/JDB-FISH-015.DRAGIN FISHING II.webp?v=1765206639360",
    platForm: "JDB",
    type: "fishing",
    gameType: "FH",
    casinoType: "JDB-FISH-015",
    platFormCode: "JDB",
  },
  {
    name: "Dragon Fortune",
    img: "/assets/Fishing/JILI-FISH-006.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-006",
    platFormCode: "JILI",
  },
  {
    name: "Dragon Master",
    img: "/assets/Fishing/JDB-FISH-011.DRAGON MASTER.webp?v=1765206689248",
    platForm: "JDB",
    type: "fishing",
    gameType: "FH",
    casinoType: "JDB-FISH-011",
    platFormCode: "JDB",
  },
  {
    name: "Dragon of Demons",
    img: "/assets/Fishing/JDB-FISH-017.DRAGON OF DEMONS.webp?v=1765206805146",
    platForm: "JDB",
    type: "fishing",
    gameType: "FH",
    casinoType: "JDB-FISH-017",
    platFormCode: "JDB",
  },
  {
    name: "FIERCE FISHING",
    img: "/assets/Fishing/FC-FISH-004.webp?v=1751418030798",
    platForm: "FC",
    type: "fishing",
    gameType: "FH",
    casinoType: "FC-FISH-004",
    platFormCode: "FC",
  },
  {
    name: "FORTUNE ZOMBIE",
    img: "/assets/Fishing/JILI-FISH-014.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-014",
    platFormCode: "JILI",
  },
  {
    name: "Fighter Fire",
    img: "/assets/Fishing/JDB-FISH-014.FIGHTER FIRE.webp?v=1765206856660",
    platForm: "JDB",
    type: "fishing",
    gameType: "FH",
    casinoType: "JDB-FISH-014",
    platFormCode: "JDB",
  },
  {
    name: "Fishing Disco",
    img: "/assets/Fishing/JDB-FISH-012.FISHING DISCO.webp?v=1765206990477",
    platForm: "JDB",
    type: "fishing",
    gameType: "FH",
    casinoType: "JDB-FISH-012",
    platFormCode: "JDB",
  },
  {
    name: "Fishing God",
    img: "/assets/Fishing/SG-FISH-001.webp?v=1751418030688",
    platForm: "SPADE",
    type: "fishing",
    gameType: "FH",
    casinoType: "SG-FISH-001",
    platFormCode: "SPADE",
  },
  {
    name: "Fishing Legend",
    img: "/assets/Fishing/SG-FISH-005.webp?v=1751418030688",
    platForm: "SPADE",
    type: "fishing",
    gameType: "FH",
    casinoType: "SG-FISH-005",
    platFormCode: "SPADE",
  },
  {
    name: "Fishing War",
    img: "/assets/Fishing/SG-FISH-002.webp?v=1751418030688",
    platForm: "SPADE",
    type: "fishing",
    gameType: "FH",
    casinoType: "SG-FISH-002",
    platFormCode: "SPADE",
  },
  {
    name: "Fortune King Jackpot",
    img: "/assets/Fishing/JILI-FISH-013.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-013",
    platFormCode: "JILI",
  },
  {
    name: "GODS GRANT FORTUNE",
    img: "/assets/Fishing/FC-FISH-006.webp?v=1751418030798",
    platForm: "FC",
    type: "fishing",
    gameType: "FH",
    casinoType: "FC-FISH-006",
    platFormCode: "FC",
  },
  {
    name: "Happy Fishing",
    img: "/assets/Fishing/JILI-FISH-005.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-005",
    platFormCode: "JILI",
  },
  {
    name: "ICE & FIRE",
    img: "/assets/Fishing/ACEWIN-FISH-009.Ice and Fire.webp?v=1764855312781",
    platForm: "ACEWIN",
    type: "fishing",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-009",
    platFormCode: "ACEWIN",
  },
  {
    name: "Jackpot Fishing",
    img: "/assets/Fishing/JILI-FISH-003.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-003",
    platFormCode: "JILI",
  },
  {
    name: "Jackypot Frenzy",
    img: "/assets/Fishing/ACEWIN-FISH-007.Jackpot Frenzy.webp?v=1764855332532",
    platForm: "ACEWIN",
    type: "fishing",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-007",
    platFormCode: "ACEWIN",
  },
  {
    name: "Lucky Buddha",
    img: "/assets/Fishing/ACEWIN-FISH-004.Lucky Buddha.webp?v=1764855353280",
    platForm: "ACEWIN",
    type: "fishing",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-004",
    platFormCode: "ACEWIN",
  },
  {
    name: "Mega Fishing",
    img: "/assets/Fishing/JILI-FISH-007.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-007",
    platFormCode: "JILI",
  },
  {
    name: "Money Tree",
    img: "/assets/Fishing/ACEWIN-FISH-005.Money Tree.webp?v=1764855593811",
    platForm: "ACEWIN",
    type: "fishing",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-005",
    platFormCode: "ACEWIN",
  },
  {
    name: "Monkey King Fishing",
    img: "/assets/Fishing/FC-FISH-001.webp?v=1751418030798",
    platForm: "FC",
    type: "fishing",
    gameType: "FH",
    casinoType: "FC-FISH-001",
    platFormCode: "FC",
  },
  {
    name: "Mr Fortune",
    img: "/assets/Fishing/ACEWIN-FISH-006.Mister Fortune.webp?v=1764855563782",
    platForm: "ACEWIN",
    type: "fishing",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-006",
    platFormCode: "ACEWIN",
  },
  {
    name: "Ocean King Jackpot",
    img: "/assets/Fishing/JILI-FISH-012.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-012",
    platFormCode: "JILI",
  },
  {
    name: "Ocean Pioneers",
    img: "/assets/Fishing/ACEWIN-FISH-008.Ocean Pioneers.webp?v=1764855526874",
    platForm: "ACEWIN",
    type: "fishing",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-008",
    platFormCode: "ACEWIN",
  },
  {
    name: "OceanPhoenix",
    img: "/assets/Fishing/YesBingo-FH-001.Ocean Phonix.webp?v=1765098731730",
    platForm: "YESBINGO",
    type: "fishing",
    gameType: "FH",
    casinoType: "YesBingo-FH-001",
    platFormCode: "YESBINGO",
  },
  {
    name: "Royal Fishing",
    img: "/assets/Fishing/JILI-FISH-001.webp?v=1751418030805",
    platForm: "JILI",
    type: "fishing",
    gameType: "FH",
    casinoType: "JILI-FISH-001",
    platFormCode: "JILI",
  },
  {
    name: "STAR HUNTER",
    img: "/assets/Fishing/FC-FISH-005.star_hunter.webp?v=1764330443831",
    platForm: "FC",
    type: "fishing",
    gameType: "FH",
    casinoType: "FC-FISH-005",
    platFormCode: "FC",
  },
  {
    name: "Shade Dragons Fishing",
    img: "/assets/Fishing/JDB-FISH-009.SHADE DRAGONS FISHING.webp?v=1765207135966",
    platForm: "JDB",
    type: "fishing",
    gameType: "FH",
    casinoType: "JDB-FISH-009",
    platFormCode: "JDB",
  },
  {
    name: "Spirit Tide Legend",
    img: "/assets/Fishing/JDB-FISH-013.Spirit Tide Legend.webp?v=1765264799632",
    platForm: "JDB",
    type: "fishing",
    gameType: "FH",
    casinoType: "JDB-FISH-013",
    platFormCode: "JDB",
  },
  {
    name: "SuperStar",
    img: "/assets/Fishing/ACEWIN-FISH-001.Super Star.webp?v=1764855546330",
    platForm: "ACEWIN",
    type: "fishing",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-001",
    platFormCode: "ACEWIN",
  },
  {
    name: "Zombie Party",
    img: "/assets/Fishing/SG-FISH-004.webp?v=1751418030688",
    platForm: "SPADE",
    type: "fishing",
    gameType: "FH",
    casinoType: "SG-FISH-004",
    platFormCode: "SPADE",
  },
  {
    name: "ZombieAwaken",
    img: "/assets/Fishing/ACEWIN-FISH-010.Zombie Awaken.webp?v=1764855561553",
    platForm: "ACEWIN",
    type: "fishing",
    gameType: "FISH",
    casinoType: "ACEWIN-FISH-010",
    platFormCode: "ACEWIN",
  },

  {
    name: "Ocean Carnival",
    img: "/assets/Fishing/FastSpin-FISH-002.ocean-carnival.webp?v=1765112789238",

    platForm: "FASTSPIN",
    type: "fishing",

    gameType: "FH",
    casinoType: "FastSpin-FISH-002",

    platFormCode: "FASTSPIN",
  },
  {
    name: "Fishing Treasure",
    img: "/assets/Fishing/FastSpin-FISH-001.fishing-treasure.webp?v=1765112363149",
    platForm: "FASTSPIN",
    type: "fishing",

    gameType: "FH",
    casinoType: "FastSpin-FISH-001",

    platFormCode: "FASTSPIN",
  },

  {
    name: "Fishdom",
    img: "/assets/Fishing/2J-FISH-002.FISHDOM.webp?v=1763542203455",
    platForm: "JJ",
    type: "fishing",
    platFormCode: "JJ",
    casinoType: "2J-FISH-002",
    gameType: "FISH",
  },

  {
    name: "Fishing",
    img: "/assets/Fishing/2J-FISH-001.FISHING.webp?v=1763542163535",
    platForm: "JJ",
    type: "fishing",
    platFormCode: "JJ",
    casinoType: "2J-FISH-001",

    gameType: "FISH",
  },
];

export const AracadeNew = [
  {
    name: "Chicken Dash",
    img: "/assets/Arcade/JILI-TABLE-082.Chicken Dash.webp?v=1764312059216",
    platForm: "JILI",
    type: "arcade",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-082",
    platFormCode: "JILI",
  },
  {
    name: "Mines+",
    img: "/assets/Arcade/PP-EGAME-014.Mines+.webp?v=1764411627450",
    platForm: "PP",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "PP-EGAME-014",
    platFormCode: "PP",
  },
  {
    name: "Plinko+",
    img: "/assets/Arcade/PP-EGAME-012.Plinko+.webp?v=1764411560549",
    platForm: "PP",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "PP-EGAME-012",
    platFormCode: "PP",
  },
  {
    name: "Force 1",
    img: "/assets/Arcade/PP-EGAME-006.webp?v=1752734370540",
    platForm: "PP",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "PP-EGAME-006",
    platFormCode: "PP",
  },
  {
    name: "100 Bit Dice",
    img: "/assets/Arcade/RELAX-EGAME-002.webp?v=1761913298290",
    platForm: "RELAX",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "RELAX-EGAME-002",
    platFormCode: "RELAX",
  },
  {
    name: "2024CyclingTrack",
    img: "/assets/Arcade/CG-EGAME-028.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-028",
    platFormCode: "CG",
  },
  {
    name: "2024Hockey2024",
    img: "/assets/Arcade/CG-EGAME-029.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-029",
    platFormCode: "CG",
  },
  {
    name: "2024Volleyball",
    img: "/assets/Arcade/CG-EGAME-031.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-031",
    platFormCode: "CG",
  },
  {
    name: "2024Weightlifting",
    img: "/assets/Arcade/CG-EGAME-032.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-032",
    platFormCode: "CG",
  },
  {
    name: "Beer Tycoon",
    img: "/assets/Arcade/JDB-EGAME-010.Beer Tycoon.webp?v=1765265981495",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-010",
    platFormCode: "JDB",
  },
  {
    name: "Benz BMW",
    img: "/assets/Arcade/CG-EGAME-007.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-007",
    platFormCode: "CG",
  },
  {
    name: "Birds and Animals",
    img: "/assets/Arcade/JDB-EGAME-003.Birds and Animals.webp?v=1765265948251",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-003",
    platFormCode: "JDB",
  },
  {
    name: "CAISHEN PARTY",
    img: "/assets/Arcade/JDB-EGAME-005.CAISHEN PARTY.webp?v=1765265911872",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-005",
    platFormCode: "JDB",
  },
  {
    name: "Captain Tsubasa",
    img: "/assets/Arcade/CG-EGAME-013.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-013",
    platFormCode: "CG",
  },
  {
    name: "Cash Stack",
    img: "/assets/Arcade/JILI-TABLE-090.webp?v=1769666965733",
    platForm: "JILI",
    type: "arcade",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-090",
    platFormCode: "JILI",
  },
  {
    name: "Chicky Run",
    img: "/assets/Arcade/PG-SLOT-140.webp?v=1765933237862",
    platForm: "PG",
    type: "arcade",
    gameType: "SLOT",
    casinoType: "PG-SLOT-140",
    platFormCode: "PG",
  },
  {
    name: "Circus Dozer",
    img: "/assets/Arcade/FC-EGAME-003.webp?v=1751418030798",
    platForm: "FC",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "FC-EGAME-003",
    platFormCode: "FC",
  },
  {
    name: "Classic Mario",
    img: "/assets/Arcade/JDB-EGAME-009.Classic Mario.webp?v=1765265865929",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-009",
    platFormCode: "JDB",
  },
  {
    name: "Cockfighting",
    img: "/assets/Arcade/CockFighting.COCKFIGHTING.webp?v=1764778695480",
    platForm: "RICH88",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-006",
    platFormCode: "YL",
  },
  {
    name: "Cockfighting",
    img: "/assets/Arcade/YL-EGAME-006.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-006",
    platFormCode: "YL",
  },
  {
    name: "Cockfighting Arena",
    img: "/assets/Arcade/KM-TABLE-067.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "arcade",
    gameType: "TABLE",
    casinoType: "KM-TABLE-067",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Coin Pusher",
    img: "/assets/Arcade/KM-TABLE-066.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "arcade",
    gameType: "TABLE",
    casinoType: "KM-TABLE-066",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Crazy King Kong",
    img: "/assets/Arcade/JDB-EGAME-001.Crazy King Kong.webp?v=1765265808009",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-001",
    platFormCode: "JDB",
  },
  {
    name: "Darts",
    img: "/assets/Arcade/PP-EGAME-007.webp?v=1752734370543",
    platForm: "PP",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "PP-EGAME-007",
    platFormCode: "PP",
  },
  {
    name: "DiamondDeal",
    img: "/assets/Arcade/YL-EGAME-010.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-010",
    platFormCode: "YL",
  },
  {
    name: "Dice",
    img: "/assets/Arcade/YL-EGAME-017.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-017",
    platFormCode: "YL",
  },
  {
    name: "Dice",
    img: "/assets/Arcade/JDB-EGAME-018.Dice.webp?v=1765265739394",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-018",
    platFormCode: "JDB",
  },
  {
    name: "DragonBallXV2",
    img: "/assets/Arcade/CG-EGAME-033.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-033",
    platFormCode: "CG",
  },
  {
    name: "FA CHAI DOZER",
    img: "/assets/Arcade/FC-EGAME-002.webp?v=1751418030798",
    platForm: "FC",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "FC-EGAME-002",
    platFormCode: "FC",
  },
  {
    name: "Fantastic League",
    img: "/assets/Arcade/PP-EGAME-004.webp?v=1752734370534",
    platForm: "PP",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "PP-EGAME-004",
    platFormCode: "PP",
  },
  {
    name: "Forest Dance",
    img: "/assets/Arcade/YL-EGAME-004.Forest Dance.webp?v=1764321380611",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-004",
    platFormCode: "YL",
  },
  {
    name: "Frog Dash",
    img: "/assets/Arcade/JILI-TABLE-088.Frog Dash.webp?v=1764312167697",
    platForm: "JILI",
    type: "arcade",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-088",
    platFormCode: "JILI",
  },
  {
    name: "Fruit",
    img: "/assets/Arcade/YL-EGAME-001.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-001",
    platFormCode: "YL",
  },
  {
    name: "GOAL",
    img: "/assets/Arcade/JDB-EGAME-015.GOAL.webp?v=1765265696976",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-015",
    platFormCode: "JDB",
  },
  {
    name: "Gems Miner",
    img: "/assets/Arcade/YL-EGAME-020.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-020",
    platFormCode: "YL",
  },
  {
    name: "Gold Shark",
    img: "/assets/Arcade/YL-EGAME-002.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-002",
    platFormCode: "YL",
  },
  {
    name: "Greyhound Racing",
    img: "/assets/Arcade/PP-EGAME-005.webp?v=1752734370536",
    platForm: "PP",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "PP-EGAME-005",
    platFormCode: "PP",
  },
  {
    name: "Guess",
    img: "/assets/Arcade/YL-EGAME-012.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-012",
    platFormCode: "YL",
  },
  {
    name: "HILO",
    img: "/assets/Arcade/YL-EGAME-022.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-022",
    platFormCode: "YL",
  },
  {
    name: "HILO",
    img: "/assets/Arcade/JDB-EGAME-016.HILO.webp?v=1765265652795",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-016",
    platFormCode: "JDB",
  },
  {
    name: "Happy Fruit",
    img: "/assets/Arcade/YL-EGAME-005.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-005",
    platFormCode: "YL",
  },
  {
    name: "Happy New Year",
    img: "/assets/Arcade/JDB-EGAME-004.Happy New Year.webp?v=1765265612281",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-004",
    platFormCode: "JDB",
  },
  {
    name: "Horse Racing",
    img: "/assets/Arcade/PP-EGAME-003.webp?v=1752734370532",
    platForm: "PP",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "PP-EGAME-003",
    platFormCode: "PP",
  },
  {
    name: "Huaguoshan Legends",
    img: "/assets/Arcade/JDB-EGAME-008.Huaguoshan Legends.webp?v=1765265566801",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-008",
    platFormCode: "JDB",
  },
  {
    name: "JOJO",
    img: "/assets/Arcade/CG-EGAME-020.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-020",
    platFormCode: "CG",
  },
  {
    name: "Jogo Do Bicho",
    img: "/assets/Arcade/JDB-EGAME-011.Jogo Do Bicho.webp?v=1765265533244",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-011",
    platFormCode: "JDB",
  },
  {
    name: "Jogo do Bicho",
    img: "/assets/Arcade/JILI-TABLE-052.jogo-do-bicho.webp?v=1764312345994",
    platForm: "JILI",
    type: "arcade",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-052",
    platFormCode: "JILI",
  },
  {
    name: "Jump Force",
    img: "/assets/Arcade/CG-EGAME-021.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-021",
    platFormCode: "CG",
  },
  {
    name: "KM Virtual Animal Race",
    img: "/assets/Arcade/KM-TABLE-062.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "arcade",
    gameType: "TABLE",
    casinoType: "KM-TABLE-062",
    platFormCode: "KINGMAKER",
  },
  {
    name: "KM Virtual Treadmill Racing",
    img: "/assets/Arcade/KM-TABLE-058.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "arcade",
    gameType: "TABLE",
    casinoType: "KM-TABLE-058",
    platFormCode: "KINGMAKER",
  },
  {
    name: "KOFXV",
    img: "/assets/Arcade/CG-EGAME-012.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-012",
    platFormCode: "CG",
  },
  {
    name: "King Of Football",
    img: "/assets/Arcade/JDB-EGAME-006.King Of Football.webp?v=1765265493611",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-006",
    platFormCode: "JDB",
  },
  {
    name: "LIGHTNING BOMB",
    img: "/assets/Arcade/FC-EGAME-004.webp?v=1751418030798",
    platForm: "FC",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "FC-EGAME-004",
    platFormCode: "FC",
  },
  {
    name: "Little Mary",
    img: "/assets/Arcade/CG-EGAME-008.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-008",
    platFormCode: "CG",
  },
  {
    name: "Lucky Color Game",
    img: "/assets/Arcade/JDB-EGAME-002.Lucky Color Game.webp?v=1765265437302",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-002",
    platFormCode: "JDB",
  },
  {
    name: "Lucky five",
    img: "/assets/Arcade/YL-EGAME-008.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-008",
    platFormCode: "YL",
  },
  {
    name: "MINES",
    img: "/assets/Arcade/FC-EGAME-007.webp?v=1751418030798",
    platForm: "FC",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "FC-EGAME-007",
    platFormCode: "FC",
  },
  {
    name: "MINES",
    img: "/assets/Arcade/JDB-EGAME-013.MINES.webp?v=1765265405115",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-013",
    platFormCode: "JDB",
  },
  {
    name: "MINES 2",
    img: "/assets/Arcade/JDB-EGAME-019.MINES 2.webp?v=1765265344883",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-019",
    platFormCode: "JDB",
  },
  {
    name: "MONEY TREE DOZER",
    img: "/assets/Arcade/FC-EGAME-001.webp?v=1751418030798",
    platForm: "FC",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "FC-EGAME-001",
    platFormCode: "FC",
  },
  {
    name: "Mariokart 8",
    img: "/assets/Arcade/CG-EGAME-014.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-014",
    platFormCode: "CG",
  },
  {
    name: "Mercedes-Benz BMW",
    img: "/assets/Arcade/YL-EGAME-011.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-011",
    platFormCode: "YL",
  },
  {
    name: "Mines",
    img: "/assets/Arcade/YL-EGAME-013.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-013",
    platFormCode: "YL",
  },
  {
    name: "Mole Crash",
    img: "/assets/Arcade/JDB-EGAME-020.Mole Crash.webp?v=1765265297228",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-020",
    platFormCode: "JDB",
  },
  {
    name: "NARUTO4",
    img: "/assets/Arcade/CG-EGAME-026.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-026",
    platFormCode: "CG",
  },
  {
    name: "Ojisan",
    img: "/assets/Arcade/YL-EGAME-015.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-015",
    platFormCode: "YL",
  },
  {
    name: "Olympus Glory",
    img: "/assets/Arcade/KM-TABLE-071.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "arcade",
    gameType: "TABLE",
    casinoType: "KM-TABLE-071",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Penalty Kick",
    img: "/assets/Arcade/JILI-TABLE-072.webp?v=1751418030805",
    platForm: "JILI",
    type: "arcade",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-072",
    platFormCode: "JILI",
  },
  {
    name: "Penalty Shootout",
    img: "/assets/Arcade/PP-EGAME-002.webp?v=1752734370528",
    platForm: "PP",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "PP-EGAME-002",
    platFormCode: "PP",
  },
  {
    name: "Penalty Shootout Live",
    img: "/assets/Arcade/PP-EGAME-011.webp?v=1752050295122",
    platForm: "PP",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "PP-EGAME-011",
    platFormCode: "PP",
  },
  {
    name: "Pig Racing",
    img: "/assets/Arcade/CG-EGAME-005.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-005",
    platFormCode: "CG",
  },
  {
    name: "Piggy Bank TapTap",
    img: "/assets/Arcade/JDB-EGAME-023.Piggy Bank TapTap.webp?v=1765207862433",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-023",
    platFormCode: "JDB",
  },
  {
    name: "Pikachu Volleyball",
    img: "/assets/Arcade/CG-EGAME-011.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-011",
    platFormCode: "CG",
  },
  {
    name: "Plinko",
    img: "/assets/Arcade/YL-EGAME-018.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-018",
    platFormCode: "YL",
  },
  {
    name: "Plinko",
    img: "/assets/Arcade/KM-TABLE-040.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "arcade",
    gameType: "TABLE",
    casinoType: "KM-TABLE-040",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Plinko",
    img: "/assets/Arcade/JDB-EGAME-017.Plinko.webp?v=1765265214253",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-017",
    platFormCode: "JDB",
  },
  {
    name: "PokerGo",
    img: "/assets/Arcade/YL-EGAME-009.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-009",
    platFormCode: "YL",
  },
  {
    name: "Rich Runner",
    img: "/assets/Arcade/CG-EGAME-004.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-004",
    platFormCode: "CG",
  },
  {
    name: "Richman Crash",
    img: "/assets/Arcade/CG-EGAME-016.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-016",
    platFormCode: "CG",
  },
  {
    name: "RoosterFightingClub",
    img: "/assets/Arcade/CG-EGAME-023.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-023",
    platFormCode: "CG",
  },
  {
    name: "Royal Quest",
    img: "/assets/Arcade/JILI-TABLE-089.Royal Quest.webp?v=1764656976056",
    platForm: "JILI",
    type: "arcade",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-089",
    platFormCode: "JILI",
  },
  {
    name: "Shark",
    img: "/assets/Arcade/YL-EGAME-003.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-003",
    platFormCode: "YL",
  },
  {
    name: "Solo king",
    img: "/assets/Arcade/YL-EGAME-007.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-007",
    platFormCode: "YL",
  },
  {
    name: "Steeplechase",
    img: "/assets/Arcade/PP-EGAME-010.webp?v=1752050295121",
    platForm: "PP",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "PP-EGAME-010",
    platFormCode: "PP",
  },
  {
    name: "Street Fighter 6",
    img: "/assets/Arcade/CG-EGAME-022.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-022",
    platFormCode: "CG",
  },
  {
    name: "Street Fighter V",
    img: "/assets/Arcade/CG-EGAME-009.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-009",
    platFormCode: "CG",
  },
  {
    name: "Super Color Game",
    img: "/assets/Arcade/FC-EGAME-005.webp?v=1751418030798",
    platForm: "FC",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "FC-EGAME-005",
    platFormCode: "FC",
  },
  {
    name: "Super Super Fruit",
    img: "/assets/Arcade/JDB-EGAME-007.Super Super Fruit.webp?v=1765265149693",
    platForm: "JDB",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-007",
    platFormCode: "JDB",
  },
  {
    name: "TEKKEN7",
    img: "/assets/Arcade/CG-EGAME-025.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-025",
    platFormCode: "CG",
  },
  {
    name: "TOWER",
    img: "/assets/Arcade/FC-EGAME-008.webp?v=1751418030798",
    platForm: "FC",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "FC-EGAME-008",
    platFormCode: "FC",
  },
  {
    name: "Thai HILO",
    img: "/assets/Arcade/YL-EGAME-024.webp?v=1761467366594",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-024",
    platFormCode: "YL",
  },
  {
    name: "Tower",
    img: "/assets/Arcade/YL-EGAME-014.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-014",
    platFormCode: "YL",
  },
  {
    name: "Tower2",
    img: "/assets/Arcade/YL-EGAME-023.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-023",
    platFormCode: "YL",
  },
  {
    name: "Wheel",
    img: "/assets/Arcade/YL-EGAME-021.webp?v=1751418030471",
    platForm: "YL",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "YL-EGAME-021",
    platFormCode: "YL",
  },
  {
    name: "plinko",
    img: "/assets/Arcade/CG-EGAME-010.webp?v=1751418030825",
    platForm: "CG",
    type: "arcade",
    gameType: "EGAME",
    casinoType: "CG-EGAME-010",
    platFormCode: "CG",
  },
];

export const LottoNew = [
  {
    name: "Beasty Bingo",
    img: "/assets/Lotto/YesBingo-BINGO-006.Beasty Bingo.webp?v=1765101079795",
    platForm: "YESBINGO",
    type: "lottery",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-006",
    platFormCode: "YESBINGO",
  },
  {
    name: "Bingo Adventure",
    img: "/assets/Lotto/JILI-TABLE-034.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-034",
    platFormCode: "JILI",
  },
  {
    name: "Bingo Carnaval",
    img: "/assets/Lotto/JILI-TABLE-019.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-019",
    platFormCode: "JILI",
  },
  {
    name: "BingoBingo",
    img: "/assets/Lotto/YesBingo-BINGO-004.Bingo Bingo.webp?v=1765101008531",
    platForm: "YESBINGO",
    type: "lottery",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-004",
    platFormCode: "YESBINGO",
  },
  {
    name: "BingoBonanza",
    img: "/assets/Lotto/YesBingo-BINGO-003.Bingo Bonanza.webp?v=1765100939168",
    platForm: "YESBINGO",
    type: "lottery",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-003",
    platFormCode: "YESBINGO",
  },
  {
    name: "Calaca Bingo",
    img: "/assets/Lotto/JILI-TABLE-026.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-026",
    platFormCode: "JILI",
  },
  {
    name: "Candyland Bingo",
    img: "/assets/Lotto/JILI-TABLE-043.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-043",
    platFormCode: "JILI",
  },
  {
    name: "EZ Bingo",
    img: "/assets/Lotto/YesBingo-BINGO-011.Ez Bingo.webp?v=1765100854656",
    platForm: "YESBINGO",
    type: "lottery",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-011",
    platFormCode: "YESBINGO",
  },
  {
    name: "Fortune Bingo",
    img: "/assets/Lotto/JILI-TABLE-015.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-015",
    platFormCode: "JILI",
  },
  {
    name: "Go Goal Bingo",
    img: "/assets/Lotto/JILI-TABLE-022.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-022",
    platFormCode: "JILI",
  },
  {
    name: "Heat Bingo",
    img: "/assets/Lotto/YesBingo-BINGO-008.Heat Bingo.webp?v=1765100718756",
    platForm: "YESBINGO",
    type: "lottery",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-008",
    platFormCode: "YESBINGO",
  },
  {
    name: "Jackpot Bingo",
    img: "/assets/Lotto/JILI-TABLE-024.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-024",
    platFormCode: "JILI",
  },
  {
    name: "Joy Bingo",
    img: "/assets/Lotto/YesBingo-BINGO-010.Joy Bingo.webp?v=1765100610444",
    platForm: "YESBINGO",
    type: "lottery",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-010",
    platFormCode: "YESBINGO",
  },
  {
    name: "KM Power Ball",
    img: "/assets/Lotto/KM-TABLE-051.webp?v=1751418030734",
    platForm: "KINGMAKER",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "KM-TABLE-051",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Keno",
    img: "/assets/Lotto/JILI-TABLE-040.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-040",
    platFormCode: "JILI",
  },
  {
    name: "Keno Extra Bet",
    img: "/assets/Lotto/JILI-TABLE-074.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-074",
    platFormCode: "JILI",
  },
  {
    name: "Lightning Bingo",
    img: "/assets/Lotto/YesBingo-BINGO-009.Lightning Bingo.webp?v=1765099968131",
    platForm: "YESBINGO",
    type: "lottery",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-009",
    platFormCode: "YESBINGO",
  },
  {
    name: "Lucky Bingo",
    img: "/assets/Lotto/JILI-TABLE-020.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-020",
    platFormCode: "JILI",
  },
  {
    name: "Magic Lamp Bingo",
    img: "/assets/Lotto/JILI-TABLE-045.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-045",
    platFormCode: "JILI",
  },
  {
    name: "OpenSesame",
    img: "/assets/Lotto/YesBingo-BINGO-002.Open Sesame.webp?v=1765099009412",
    platForm: "YESBINGO",
    type: "lottery",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-002",
    platFormCode: "YESBINGO",
  },
  {
    name: "Pearls of Bingo",
    img: "/assets/Lotto/JILI-TABLE-051.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-051",
    platFormCode: "JILI",
  },
  {
    name: "Super 30 BINGO",
    img: "/assets/Lotto/YesBingo-BINGO-012.super-30-bingo.webp?v=1765098943597",
    platForm: "YESBINGO",
    type: "lottery",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-012",
    platFormCode: "YESBINGO",
  },
  {
    name: "Super Bingo",
    img: "/assets/Lotto/JILI-TABLE-018.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-018",
    platFormCode: "JILI",
  },
  {
    name: "West Hunter Bingo",
    img: "/assets/Lotto/JILI-TABLE-029.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-029",
    platFormCode: "JILI",
  },
  {
    name: "iRich Bingo",
    img: "/assets/Lotto/JILI-TABLE-008.webp?v=1751418030805",
    platForm: "JILI",
    type: "lottery",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-008",
    platFormCode: "JILI",
  },
];
